/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */
const demoMetagotchiPlugin = `;(function(){var s=document.createElement("style");s.setAttribute("data-inline","metagotchi");s.textContent=".plugin-container{padding:1rem;font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,sans-serif}.scope-section{margin-bottom:1.5rem;padding:1rem;background:#f9f9f9;border-radius:8px;border:1px solid #e0e0e0}.scope-section h2{margin-top:0;margin-bottom:1rem;font-size:1.1rem;color:#333}.scope-display{margin-bottom:.75rem;padding:.5rem;background:#fff;border-radius:4px;border:1px solid #e0e0e0}.scope-display label{font-weight:600;margin-right:.5rem;color:#555}.scope-display span{color:#666}.scope-controls{margin-top:1rem}.scope-controls h3{margin-top:0;margin-bottom:.75rem;font-size:1rem;color:#444}.scope-button{margin-right:.5rem;margin-bottom:.5rem;padding:.5rem 1rem;background:#007bff;color:#fff;border:none;border-radius:4px;cursor:pointer;font-size:.9rem;transition:background-color .2s}.scope-button:hover{background:#0056b3}.scope-button:active{background:#004085}\\n";document.head.appendChild(s);}());
var R4 = Object.defineProperty;
var Z4 = (e, t, n) => t in e ? R4(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Q1 = (e, t, n) => Z4(e, typeof t != "symbol" ? t + "" : t, n);
function F4(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var m5 = { exports: {} }, k7 = {}, g5 = { exports: {} }, F = {};
var fe = Symbol.for("react.element"), D4 = Symbol.for("react.portal"), V4 = Symbol.for("react.fragment"), U4 = Symbol.for("react.strict_mode"), O4 = Symbol.for("react.profiler"), W4 = Symbol.for("react.provider"), H4 = Symbol.for("react.context"), I4 = Symbol.for("react.forward_ref"), X4 = Symbol.for("react.suspense"), G4 = Symbol.for("react.memo"), Q4 = Symbol.for("react.lazy"), n6 = Symbol.iterator;
function Y4(e) {
  return e === null || typeof e != "object" ? null : (e = n6 && e[n6] || e["@@iterator"], typeof e == "function" ? e : null);
}
var y5 = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, x5 = Object.assign, w5 = {};
function k9(e, t, n) {
  this.props = e, this.context = t, this.refs = w5, this.updater = n || y5;
}
k9.prototype.isReactComponent = {};
k9.prototype.setState = function(e, t) {
  if (typeof e != "object" && typeof e != "function" && e != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, e, t, "setState");
};
k9.prototype.forceUpdate = function(e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function k5() {
}
k5.prototype = k9.prototype;
function s8(e, t, n) {
  this.props = e, this.context = t, this.refs = w5, this.updater = n || y5;
}
var u8 = s8.prototype = new k5();
u8.constructor = s8;
x5(u8, k9.prototype);
u8.isPureReactComponent = !0;
var r6 = Array.isArray, S5 = Object.prototype.hasOwnProperty, a8 = { current: null }, E5 = { key: !0, ref: !0, __self: !0, __source: !0 };
function j5(e, t, n) {
  var r, l = {}, i = null, s = null;
  if (t != null) for (r in t.ref !== void 0 && (s = t.ref), t.key !== void 0 && (i = "" + t.key), t) S5.call(t, r) && !E5.hasOwnProperty(r) && (l[r] = t[r]);
  var u = arguments.length - 2;
  if (u === 1) l.children = n;
  else if (1 < u) {
    for (var a = Array(u), c = 0; c < u; c++) a[c] = arguments[c + 2];
    l.children = a;
  }
  if (e && e.defaultProps) for (r in u = e.defaultProps, u) l[r] === void 0 && (l[r] = u[r]);
  return { $$typeof: fe, type: e, key: i, ref: s, props: l, _owner: a8.current };
}
function q4(e, t) {
  return { $$typeof: fe, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
}
function c8(e) {
  return typeof e == "object" && e !== null && e.$$typeof === fe;
}
function K4(e) {
  var t = { "=": "=0", ":": "=2" };
  return "$" + e.replace(/[=:]/g, function(n) {
    return t[n];
  });
}
var l6 = /\\/+/g;
function U7(e, t) {
  return typeof e == "object" && e !== null && e.key != null ? K4("" + e.key) : t.toString(36);
}
function Oe(e, t, n, r, l) {
  var i = typeof e;
  (i === "undefined" || i === "boolean") && (e = null);
  var s = !1;
  if (e === null) s = !0;
  else switch (i) {
    case "string":
    case "number":
      s = !0;
      break;
    case "object":
      switch (e.$$typeof) {
        case fe:
        case D4:
          s = !0;
      }
  }
  if (s) return s = e, l = l(s), e = r === "" ? "." + U7(s, 0) : r, r6(l) ? (n = "", e != null && (n = e.replace(l6, "$&/") + "/"), Oe(l, t, n, "", function(c) {
    return c;
  })) : l != null && (c8(l) && (l = q4(l, n + (!l.key || s && s.key === l.key ? "" : ("" + l.key).replace(l6, "$&/") + "/") + e)), t.push(l)), 1;
  if (s = 0, r = r === "" ? "." : r + ":", r6(e)) for (var u = 0; u < e.length; u++) {
    i = e[u];
    var a = r + U7(i, u);
    s += Oe(i, t, n, a, l);
  }
  else if (a = Y4(e), typeof a == "function") for (e = a.call(e), u = 0; !(i = e.next()).done; ) i = i.value, a = r + U7(i, u++), s += Oe(i, t, n, a, l);
  else if (i === "object") throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
  return s;
}
function me(e, t, n) {
  if (e == null) return e;
  var r = [], l = 0;
  return Oe(e, r, "", "", function(i) {
    return t.call(n, i, l++);
  }), r;
}
function J4(e) {
  if (e._status === -1) {
    var t = e._result;
    t = t(), t.then(function(n) {
      (e._status === 0 || e._status === -1) && (e._status = 1, e._result = n);
    }, function(n) {
      (e._status === 0 || e._status === -1) && (e._status = 2, e._result = n);
    }), e._status === -1 && (e._status = 0, e._result = t);
  }
  if (e._status === 1) return e._result.default;
  throw e._result;
}
var m1 = { current: null }, We = { transition: null }, b4 = { ReactCurrentDispatcher: m1, ReactCurrentBatchConfig: We, ReactCurrentOwner: a8 };
function L5() {
  throw Error("act(...) is not supported in production builds of React.");
}
F.Children = { map: me, forEach: function(e, t, n) {
  me(e, function() {
    t.apply(this, arguments);
  }, n);
}, count: function(e) {
  var t = 0;
  return me(e, function() {
    t++;
  }), t;
}, toArray: function(e) {
  return me(e, function(t) {
    return t;
  }) || [];
}, only: function(e) {
  if (!c8(e)) throw Error("React.Children.only expected to receive a single React element child.");
  return e;
} };
F.Component = k9;
F.Fragment = V4;
F.Profiler = O4;
F.PureComponent = s8;
F.StrictMode = U4;
F.Suspense = X4;
F.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = b4;
F.act = L5;
F.cloneElement = function(e, t, n) {
  if (e == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
  var r = x5({}, e.props), l = e.key, i = e.ref, s = e._owner;
  if (t != null) {
    if (t.ref !== void 0 && (i = t.ref, s = a8.current), t.key !== void 0 && (l = "" + t.key), e.type && e.type.defaultProps) var u = e.type.defaultProps;
    for (a in t) S5.call(t, a) && !E5.hasOwnProperty(a) && (r[a] = t[a] === void 0 && u !== void 0 ? u[a] : t[a]);
  }
  var a = arguments.length - 2;
  if (a === 1) r.children = n;
  else if (1 < a) {
    u = Array(a);
    for (var c = 0; c < a; c++) u[c] = arguments[c + 2];
    r.children = u;
  }
  return { $$typeof: fe, type: e.type, key: l, ref: i, props: r, _owner: s };
};
F.createContext = function(e) {
  return e = { $$typeof: H4, _currentValue: e, _currentValue2: e, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, e.Provider = { $$typeof: W4, _context: e }, e.Consumer = e;
};
F.createElement = j5;
F.createFactory = function(e) {
  var t = j5.bind(null, e);
  return t.type = e, t;
};
F.createRef = function() {
  return { current: null };
};
F.forwardRef = function(e) {
  return { $$typeof: I4, render: e };
};
F.isValidElement = c8;
F.lazy = function(e) {
  return { $$typeof: Q4, _payload: { _status: -1, _result: e }, _init: J4 };
};
F.memo = function(e, t) {
  return { $$typeof: G4, type: e, compare: t === void 0 ? null : t };
};
F.startTransition = function(e) {
  var t = We.transition;
  We.transition = {};
  try {
    e();
  } finally {
    We.transition = t;
  }
};
F.unstable_act = L5;
F.useCallback = function(e, t) {
  return m1.current.useCallback(e, t);
};
F.useContext = function(e) {
  return m1.current.useContext(e);
};
F.useDebugValue = function() {
};
F.useDeferredValue = function(e) {
  return m1.current.useDeferredValue(e);
};
F.useEffect = function(e, t) {
  return m1.current.useEffect(e, t);
};
F.useId = function() {
  return m1.current.useId();
};
F.useImperativeHandle = function(e, t, n) {
  return m1.current.useImperativeHandle(e, t, n);
};
F.useInsertionEffect = function(e, t) {
  return m1.current.useInsertionEffect(e, t);
};
F.useLayoutEffect = function(e, t) {
  return m1.current.useLayoutEffect(e, t);
};
F.useMemo = function(e, t) {
  return m1.current.useMemo(e, t);
};
F.useReducer = function(e, t, n) {
  return m1.current.useReducer(e, t, n);
};
F.useRef = function(e) {
  return m1.current.useRef(e);
};
F.useState = function(e) {
  return m1.current.useState(e);
};
F.useSyncExternalStore = function(e, t, n) {
  return m1.current.useSyncExternalStore(e, t, n);
};
F.useTransition = function() {
  return m1.current.useTransition();
};
F.version = "18.3.1";
g5.exports = F;
var H = g5.exports;
const I = /* @__PURE__ */ F4(H);
var _4 = H, $4 = Symbol.for("react.element"), et = Symbol.for("react.fragment"), tt = Object.prototype.hasOwnProperty, nt = _4.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, rt = { key: !0, ref: !0, __self: !0, __source: !0 };
function M5(e, t, n) {
  var r, l = {}, i = null, s = null;
  n !== void 0 && (i = "" + n), t.key !== void 0 && (i = "" + t.key), t.ref !== void 0 && (s = t.ref);
  for (r in t) tt.call(t, r) && !rt.hasOwnProperty(r) && (l[r] = t[r]);
  if (e && e.defaultProps) for (r in t = e.defaultProps, t) l[r] === void 0 && (l[r] = t[r]);
  return { $$typeof: $4, type: e, key: i, ref: s, props: l, _owner: nt.current };
}
k7.Fragment = et;
k7.jsx = M5;
k7.jsxs = M5;
m5.exports = k7;
var o = m5.exports, z5 = { exports: {} }, z1 = {}, A5 = { exports: {} }, B5 = {};
(function(e) {
  function t(E, T) {
    var B = E.length;
    E.push(T);
    e: for (; 0 < B; ) {
      var q = B - 1 >>> 1, r1 = E[q];
      if (0 < l(r1, T)) E[q] = T, E[B] = r1, B = q;
      else break e;
    }
  }
  function n(E) {
    return E.length === 0 ? null : E[0];
  }
  function r(E) {
    if (E.length === 0) return null;
    var T = E[0], B = E.pop();
    if (B !== T) {
      E[0] = B;
      e: for (var q = 0, r1 = E.length, G2 = r1 >>> 1; q < G2; ) {
        var X1 = 2 * (q + 1) - 1, j9 = E[X1], a2 = X1 + 1, Q2 = E[a2];
        if (0 > l(j9, B)) a2 < r1 && 0 > l(Q2, j9) ? (E[q] = Q2, E[a2] = B, q = a2) : (E[q] = j9, E[X1] = B, q = X1);
        else if (a2 < r1 && 0 > l(Q2, B)) E[q] = Q2, E[a2] = B, q = a2;
        else break e;
      }
    }
    return T;
  }
  function l(E, T) {
    var B = E.sortIndex - T.sortIndex;
    return B !== 0 ? B : E.id - T.id;
  }
  if (typeof performance == "object" && typeof performance.now == "function") {
    var i = performance;
    e.unstable_now = function() {
      return i.now();
    };
  } else {
    var s = Date, u = s.now();
    e.unstable_now = function() {
      return s.now() - u;
    };
  }
  var a = [], c = [], p = 1, h = null, v = 3, g = !1, w = !1, y = !1, N = typeof setTimeout == "function" ? setTimeout : null, f = typeof clearTimeout == "function" ? clearTimeout : null, C = typeof setImmediate < "u" ? setImmediate : null;
  typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function d(E) {
    for (var T = n(c); T !== null; ) {
      if (T.callback === null) r(c);
      else if (T.startTime <= E) r(c), T.sortIndex = T.expirationTime, t(a, T);
      else break;
      T = n(c);
    }
  }
  function m(E) {
    if (y = !1, d(E), !w) if (n(a) !== null) w = !0, O(k);
    else {
      var T = n(c);
      T !== null && I1(m, T.startTime - E);
    }
  }
  function k(E, T) {
    w = !1, y && (y = !1, f(S), S = -1), g = !0;
    var B = v;
    try {
      for (d(T), h = n(a); h !== null && (!(h.expirationTime > T) || E && !z()); ) {
        var q = h.callback;
        if (typeof q == "function") {
          h.callback = null, v = h.priorityLevel;
          var r1 = q(h.expirationTime <= T);
          T = e.unstable_now(), typeof r1 == "function" ? h.callback = r1 : h === n(a) && r(a), d(T);
        } else r(a);
        h = n(a);
      }
      if (h !== null) var G2 = !0;
      else {
        var X1 = n(c);
        X1 !== null && I1(m, X1.startTime - T), G2 = !1;
      }
      return G2;
    } finally {
      h = null, v = B, g = !1;
    }
  }
  var j = !1, L = null, S = -1, U = 5, Z = -1;
  function z() {
    return !(e.unstable_now() - Z < U);
  }
  function P() {
    if (L !== null) {
      var E = e.unstable_now();
      Z = E;
      var T = !0;
      try {
        T = L(!0, E);
      } finally {
        T ? A() : (j = !1, L = null);
      }
    } else j = !1;
  }
  var A;
  if (typeof C == "function") A = function() {
    C(P);
  };
  else if (typeof MessageChannel < "u") {
    var D = new MessageChannel(), G = D.port2;
    D.port1.onmessage = P, A = function() {
      G.postMessage(null);
    };
  } else A = function() {
    N(P, 0);
  };
  function O(E) {
    L = E, j || (j = !0, A());
  }
  function I1(E, T) {
    S = N(function() {
      E(e.unstable_now());
    }, T);
  }
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(E) {
    E.callback = null;
  }, e.unstable_continueExecution = function() {
    w || g || (w = !0, O(k));
  }, e.unstable_forceFrameRate = function(E) {
    0 > E || 125 < E ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : U = 0 < E ? Math.floor(1e3 / E) : 5;
  }, e.unstable_getCurrentPriorityLevel = function() {
    return v;
  }, e.unstable_getFirstCallbackNode = function() {
    return n(a);
  }, e.unstable_next = function(E) {
    switch (v) {
      case 1:
      case 2:
      case 3:
        var T = 3;
        break;
      default:
        T = v;
    }
    var B = v;
    v = T;
    try {
      return E();
    } finally {
      v = B;
    }
  }, e.unstable_pauseExecution = function() {
  }, e.unstable_requestPaint = function() {
  }, e.unstable_runWithPriority = function(E, T) {
    switch (E) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        E = 3;
    }
    var B = v;
    v = E;
    try {
      return T();
    } finally {
      v = B;
    }
  }, e.unstable_scheduleCallback = function(E, T, B) {
    var q = e.unstable_now();
    switch (typeof B == "object" && B !== null ? (B = B.delay, B = typeof B == "number" && 0 < B ? q + B : q) : B = q, E) {
      case 1:
        var r1 = -1;
        break;
      case 2:
        r1 = 250;
        break;
      case 5:
        r1 = 1073741823;
        break;
      case 4:
        r1 = 1e4;
        break;
      default:
        r1 = 5e3;
    }
    return r1 = B + r1, E = { id: p++, callback: T, priorityLevel: E, startTime: B, expirationTime: r1, sortIndex: -1 }, B > q ? (E.sortIndex = B, t(c, E), n(a) === null && E === n(c) && (y ? (f(S), S = -1) : y = !0, I1(m, B - q))) : (E.sortIndex = r1, t(a, E), w || g || (w = !0, O(k))), E;
  }, e.unstable_shouldYield = z, e.unstable_wrapCallback = function(E) {
    var T = v;
    return function() {
      var B = v;
      v = T;
      try {
        return E.apply(this, arguments);
      } finally {
        v = B;
      }
    };
  };
})(B5);
A5.exports = B5;
var lt = A5.exports;
var it = H, M1 = lt;
function x(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var T5 = /* @__PURE__ */ new Set(), K9 = {};
function I2(e, t) {
  h9(e, t), h9(e + "Capture", t);
}
function h9(e, t) {
  for (K9[e] = t, e = 0; e < t.length; e++) T5.add(t[e]);
}
var l2 = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), h3 = Object.prototype.hasOwnProperty, ot = /^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$/, i6 = {}, o6 = {};
function st(e) {
  return h3.call(o6, e) ? !0 : h3.call(i6, e) ? !1 : ot.test(e) ? o6[e] = !0 : (i6[e] = !0, !1);
}
function ut(e, t, n, r) {
  if (n !== null && n.type === 0) return !1;
  switch (typeof t) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return r ? !1 : n !== null ? !n.acceptsBooleans : (e = e.toLowerCase().slice(0, 5), e !== "data-" && e !== "aria-");
    default:
      return !1;
  }
}
function at(e, t, n, r) {
  if (t === null || typeof t > "u" || ut(e, t, n, r)) return !0;
  if (r) return !1;
  if (n !== null) switch (n.type) {
    case 3:
      return !t;
    case 4:
      return t === !1;
    case 5:
      return isNaN(t);
    case 6:
      return isNaN(t) || 1 > t;
  }
  return !1;
}
function g1(e, t, n, r, l, i, s) {
  this.acceptsBooleans = t === 2 || t === 3 || t === 4, this.attributeName = r, this.attributeNamespace = l, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = i, this.removeEmptyString = s;
}
var c1 = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
  c1[e] = new g1(e, 0, !1, e, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
  var t = e[0];
  c1[t] = new g1(t, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
  c1[e] = new g1(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
  c1[e] = new g1(e, 2, !1, e, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
  c1[e] = new g1(e, 3, !1, e.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function(e) {
  c1[e] = new g1(e, 3, !0, e, null, !1, !1);
});
["capture", "download"].forEach(function(e) {
  c1[e] = new g1(e, 4, !1, e, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function(e) {
  c1[e] = new g1(e, 6, !1, e, null, !1, !1);
});
["rowSpan", "start"].forEach(function(e) {
  c1[e] = new g1(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var C8 = /[\\-:]([a-z])/g;
function f8(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
  var t = e.replace(
    C8,
    f8
  );
  c1[t] = new g1(t, 1, !1, e, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
  var t = e.replace(C8, f8);
  c1[t] = new g1(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(e) {
  var t = e.replace(C8, f8);
  c1[t] = new g1(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function(e) {
  c1[e] = new g1(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
c1.xlinkHref = new g1("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function(e) {
  c1[e] = new g1(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function d8(e, t, n, r) {
  var l = c1.hasOwnProperty(t) ? c1[t] : null;
  (l !== null ? l.type !== 0 : r || !(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (at(t, n, l, r) && (n = null), r || l === null ? st(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : l.mustUseProperty ? e[l.propertyName] = n === null ? l.type === 3 ? !1 : "" : n : (t = l.attributeName, r = l.attributeNamespace, n === null ? e.removeAttribute(t) : (l = l.type, n = l === 3 || l === 4 && n === !0 ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
}
var u2 = it.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ge = Symbol.for("react.element"), b2 = Symbol.for("react.portal"), _2 = Symbol.for("react.fragment"), p8 = Symbol.for("react.strict_mode"), v3 = Symbol.for("react.profiler"), P5 = Symbol.for("react.provider"), N5 = Symbol.for("react.context"), h8 = Symbol.for("react.forward_ref"), m3 = Symbol.for("react.suspense"), g3 = Symbol.for("react.suspense_list"), v8 = Symbol.for("react.memo"), C2 = Symbol.for("react.lazy"), R5 = Symbol.for("react.offscreen"), s6 = Symbol.iterator;
function L9(e) {
  return e === null || typeof e != "object" ? null : (e = s6 && e[s6] || e["@@iterator"], typeof e == "function" ? e : null);
}
var _ = Object.assign, O7;
function F9(e) {
  if (O7 === void 0) try {
    throw Error();
  } catch (n) {
    var t = n.stack.trim().match(/\\n( *(at )?)/);
    O7 = t && t[1] || "";
  }
  return \`
\` + O7 + e;
}
var W7 = !1;
function H7(e, t) {
  if (!e || W7) return "";
  W7 = !0;
  var n = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (t) if (t = function() {
      throw Error();
    }, Object.defineProperty(t.prototype, "props", { set: function() {
      throw Error();
    } }), typeof Reflect == "object" && Reflect.construct) {
      try {
        Reflect.construct(t, []);
      } catch (c) {
        var r = c;
      }
      Reflect.construct(e, [], t);
    } else {
      try {
        t.call();
      } catch (c) {
        r = c;
      }
      e.call(t.prototype);
    }
    else {
      try {
        throw Error();
      } catch (c) {
        r = c;
      }
      e();
    }
  } catch (c) {
    if (c && r && typeof c.stack == "string") {
      for (var l = c.stack.split(\`
\`), i = r.stack.split(\`
\`), s = l.length - 1, u = i.length - 1; 1 <= s && 0 <= u && l[s] !== i[u]; ) u--;
      for (; 1 <= s && 0 <= u; s--, u--) if (l[s] !== i[u]) {
        if (s !== 1 || u !== 1)
          do
            if (s--, u--, 0 > u || l[s] !== i[u]) {
              var a = \`
\` + l[s].replace(" at new ", " at ");
              return e.displayName && a.includes("<anonymous>") && (a = a.replace("<anonymous>", e.displayName)), a;
            }
          while (1 <= s && 0 <= u);
        break;
      }
    }
  } finally {
    W7 = !1, Error.prepareStackTrace = n;
  }
  return (e = e ? e.displayName || e.name : "") ? F9(e) : "";
}
function ct(e) {
  switch (e.tag) {
    case 5:
      return F9(e.type);
    case 16:
      return F9("Lazy");
    case 13:
      return F9("Suspense");
    case 19:
      return F9("SuspenseList");
    case 0:
    case 2:
    case 15:
      return e = H7(e.type, !1), e;
    case 11:
      return e = H7(e.type.render, !1), e;
    case 1:
      return e = H7(e.type, !0), e;
    default:
      return "";
  }
}
function y3(e) {
  if (e == null) return null;
  if (typeof e == "function") return e.displayName || e.name || null;
  if (typeof e == "string") return e;
  switch (e) {
    case _2:
      return "Fragment";
    case b2:
      return "Portal";
    case v3:
      return "Profiler";
    case p8:
      return "StrictMode";
    case m3:
      return "Suspense";
    case g3:
      return "SuspenseList";
  }
  if (typeof e == "object") switch (e.$$typeof) {
    case N5:
      return (e.displayName || "Context") + ".Consumer";
    case P5:
      return (e._context.displayName || "Context") + ".Provider";
    case h8:
      var t = e.render;
      return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
    case v8:
      return t = e.displayName || null, t !== null ? t : y3(e.type) || "Memo";
    case C2:
      t = e._payload, e = e._init;
      try {
        return y3(e(t));
      } catch {
      }
  }
  return null;
}
function Ct(e) {
  var t = e.type;
  switch (e.tag) {
    case 24:
      return "Cache";
    case 9:
      return (t.displayName || "Context") + ".Consumer";
    case 10:
      return (t._context.displayName || "Context") + ".Provider";
    case 18:
      return "DehydratedFragment";
    case 11:
      return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
    case 7:
      return "Fragment";
    case 5:
      return t;
    case 4:
      return "Portal";
    case 3:
      return "Root";
    case 6:
      return "Text";
    case 16:
      return y3(t);
    case 8:
      return t === p8 ? "StrictMode" : "Mode";
    case 22:
      return "Offscreen";
    case 12:
      return "Profiler";
    case 21:
      return "Scope";
    case 13:
      return "Suspense";
    case 19:
      return "SuspenseList";
    case 25:
      return "TracingMarker";
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if (typeof t == "function") return t.displayName || t.name || null;
      if (typeof t == "string") return t;
  }
  return null;
}
function j2(e) {
  switch (typeof e) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return e;
    case "object":
      return e;
    default:
      return "";
  }
}
function Z5(e) {
  var t = e.type;
  return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
}
function ft(e) {
  var t = Z5(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), r = "" + e[t];
  if (!e.hasOwnProperty(t) && typeof n < "u" && typeof n.get == "function" && typeof n.set == "function") {
    var l = n.get, i = n.set;
    return Object.defineProperty(e, t, { configurable: !0, get: function() {
      return l.call(this);
    }, set: function(s) {
      r = "" + s, i.call(this, s);
    } }), Object.defineProperty(e, t, { enumerable: n.enumerable }), { getValue: function() {
      return r;
    }, setValue: function(s) {
      r = "" + s;
    }, stopTracking: function() {
      e._valueTracker = null, delete e[t];
    } };
  }
}
function ye(e) {
  e._valueTracker || (e._valueTracker = ft(e));
}
function F5(e) {
  if (!e) return !1;
  var t = e._valueTracker;
  if (!t) return !0;
  var n = t.getValue(), r = "";
  return e && (r = Z5(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n ? (t.setValue(e), !0) : !1;
}
function _e(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function x3(e, t) {
  var n = t.checked;
  return _({}, t, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: n ?? e._wrapperState.initialChecked });
}
function u6(e, t) {
  var n = t.defaultValue == null ? "" : t.defaultValue, r = t.checked != null ? t.checked : t.defaultChecked;
  n = j2(t.value != null ? t.value : n), e._wrapperState = { initialChecked: r, initialValue: n, controlled: t.type === "checkbox" || t.type === "radio" ? t.checked != null : t.value != null };
}
function D5(e, t) {
  t = t.checked, t != null && d8(e, "checked", t, !1);
}
function w3(e, t) {
  D5(e, t);
  var n = j2(t.value), r = t.type;
  if (n != null) r === "number" ? (n === 0 && e.value === "" || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);
  else if (r === "submit" || r === "reset") {
    e.removeAttribute("value");
    return;
  }
  t.hasOwnProperty("value") ? k3(e, t.type, n) : t.hasOwnProperty("defaultValue") && k3(e, t.type, j2(t.defaultValue)), t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
}
function a6(e, t, n) {
  if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
    var r = t.type;
    if (!(r !== "submit" && r !== "reset" || t.value !== void 0 && t.value !== null)) return;
    t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
  }
  n = e.name, n !== "" && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, n !== "" && (e.name = n);
}
function k3(e, t, n) {
  (t !== "number" || _e(e.ownerDocument) !== e) && (n == null ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
}
var D9 = Array.isArray;
function a9(e, t, n, r) {
  if (e = e.options, t) {
    t = {};
    for (var l = 0; l < n.length; l++) t["$" + n[l]] = !0;
    for (n = 0; n < e.length; n++) l = t.hasOwnProperty("$" + e[n].value), e[n].selected !== l && (e[n].selected = l), l && r && (e[n].defaultSelected = !0);
  } else {
    for (n = "" + j2(n), t = null, l = 0; l < e.length; l++) {
      if (e[l].value === n) {
        e[l].selected = !0, r && (e[l].defaultSelected = !0);
        return;
      }
      t !== null || e[l].disabled || (t = e[l]);
    }
    t !== null && (t.selected = !0);
  }
}
function S3(e, t) {
  if (t.dangerouslySetInnerHTML != null) throw Error(x(91));
  return _({}, t, { value: void 0, defaultValue: void 0, children: "" + e._wrapperState.initialValue });
}
function c6(e, t) {
  var n = t.value;
  if (n == null) {
    if (n = t.children, t = t.defaultValue, n != null) {
      if (t != null) throw Error(x(92));
      if (D9(n)) {
        if (1 < n.length) throw Error(x(93));
        n = n[0];
      }
      t = n;
    }
    t == null && (t = ""), n = t;
  }
  e._wrapperState = { initialValue: j2(n) };
}
function V5(e, t) {
  var n = j2(t.value), r = j2(t.defaultValue);
  n != null && (n = "" + n, n !== e.value && (e.value = n), t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)), r != null && (e.defaultValue = "" + r);
}
function C6(e) {
  var t = e.textContent;
  t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
}
function U5(e) {
  switch (e) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function E3(e, t) {
  return e == null || e === "http://www.w3.org/1999/xhtml" ? U5(t) : e === "http://www.w3.org/2000/svg" && t === "foreignObject" ? "http://www.w3.org/1999/xhtml" : e;
}
var xe, O5 = function(e) {
  return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, n, r, l) {
    MSApp.execUnsafeLocalFunction(function() {
      return e(t, n, r, l);
    });
  } : e;
}(function(e, t) {
  if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e) e.innerHTML = t;
  else {
    for (xe = xe || document.createElement("div"), xe.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = xe.firstChild; e.firstChild; ) e.removeChild(e.firstChild);
    for (; t.firstChild; ) e.appendChild(t.firstChild);
  }
});
function J9(e, t) {
  if (t) {
    var n = e.firstChild;
    if (n && n === e.lastChild && n.nodeType === 3) {
      n.nodeValue = t;
      return;
    }
  }
  e.textContent = t;
}
var O9 = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, dt = ["Webkit", "ms", "Moz", "O"];
Object.keys(O9).forEach(function(e) {
  dt.forEach(function(t) {
    t = t + e.charAt(0).toUpperCase() + e.substring(1), O9[t] = O9[e];
  });
});
function W5(e, t, n) {
  return t == null || typeof t == "boolean" || t === "" ? "" : n || typeof t != "number" || t === 0 || O9.hasOwnProperty(e) && O9[e] ? ("" + t).trim() : t + "px";
}
function H5(e, t) {
  e = e.style;
  for (var n in t) if (t.hasOwnProperty(n)) {
    var r = n.indexOf("--") === 0, l = W5(n, t[n], r);
    n === "float" && (n = "cssFloat"), r ? e.setProperty(n, l) : e[n] = l;
  }
}
var pt = _({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function j3(e, t) {
  if (t) {
    if (pt[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error(x(137, e));
    if (t.dangerouslySetInnerHTML != null) {
      if (t.children != null) throw Error(x(60));
      if (typeof t.dangerouslySetInnerHTML != "object" || !("__html" in t.dangerouslySetInnerHTML)) throw Error(x(61));
    }
    if (t.style != null && typeof t.style != "object") throw Error(x(62));
  }
}
function L3(e, t) {
  if (e.indexOf("-") === -1) return typeof t.is == "string";
  switch (e) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var M3 = null;
function m8(e) {
  return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
}
var z3 = null, c9 = null, C9 = null;
function f6(e) {
  if (e = he(e)) {
    if (typeof z3 != "function") throw Error(x(280));
    var t = e.stateNode;
    t && (t = M7(t), z3(e.stateNode, e.type, t));
  }
}
function I5(e) {
  c9 ? C9 ? C9.push(e) : C9 = [e] : c9 = e;
}
function X5() {
  if (c9) {
    var e = c9, t = C9;
    if (C9 = c9 = null, f6(e), t) for (e = 0; e < t.length; e++) f6(t[e]);
  }
}
function G5(e, t) {
  return e(t);
}
function Q5() {
}
var I7 = !1;
function Y5(e, t, n) {
  if (I7) return e(t, n);
  I7 = !0;
  try {
    return G5(e, t, n);
  } finally {
    I7 = !1, (c9 !== null || C9 !== null) && (Q5(), X5());
  }
}
function b9(e, t) {
  var n = e.stateNode;
  if (n === null) return null;
  var r = M7(n);
  if (r === null) return null;
  n = r[t];
  e: switch (t) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
      break e;
    default:
      e = !1;
  }
  if (e) return null;
  if (n && typeof n != "function") throw Error(x(231, t, typeof n));
  return n;
}
var A3 = !1;
if (l2) try {
  var M9 = {};
  Object.defineProperty(M9, "passive", { get: function() {
    A3 = !0;
  } }), window.addEventListener("test", M9, M9), window.removeEventListener("test", M9, M9);
} catch {
  A3 = !1;
}
function ht(e, t, n, r, l, i, s, u, a) {
  var c = Array.prototype.slice.call(arguments, 3);
  try {
    t.apply(n, c);
  } catch (p) {
    this.onError(p);
  }
}
var W9 = !1, $e = null, e7 = !1, B3 = null, vt = { onError: function(e) {
  W9 = !0, $e = e;
} };
function mt(e, t, n, r, l, i, s, u, a) {
  W9 = !1, $e = null, ht.apply(vt, arguments);
}
function gt(e, t, n, r, l, i, s, u, a) {
  if (mt.apply(this, arguments), W9) {
    if (W9) {
      var c = $e;
      W9 = !1, $e = null;
    } else throw Error(x(198));
    e7 || (e7 = !0, B3 = c);
  }
}
function X2(e) {
  var t = e, n = e;
  if (e.alternate) for (; t.return; ) t = t.return;
  else {
    e = t;
    do
      t = e, t.flags & 4098 && (n = t.return), e = t.return;
    while (e);
  }
  return t.tag === 3 ? n : null;
}
function q5(e) {
  if (e.tag === 13) {
    var t = e.memoizedState;
    if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
  }
  return null;
}
function d6(e) {
  if (X2(e) !== e) throw Error(x(188));
}
function yt(e) {
  var t = e.alternate;
  if (!t) {
    if (t = X2(e), t === null) throw Error(x(188));
    return t !== e ? null : e;
  }
  for (var n = e, r = t; ; ) {
    var l = n.return;
    if (l === null) break;
    var i = l.alternate;
    if (i === null) {
      if (r = l.return, r !== null) {
        n = r;
        continue;
      }
      break;
    }
    if (l.child === i.child) {
      for (i = l.child; i; ) {
        if (i === n) return d6(l), e;
        if (i === r) return d6(l), t;
        i = i.sibling;
      }
      throw Error(x(188));
    }
    if (n.return !== r.return) n = l, r = i;
    else {
      for (var s = !1, u = l.child; u; ) {
        if (u === n) {
          s = !0, n = l, r = i;
          break;
        }
        if (u === r) {
          s = !0, r = l, n = i;
          break;
        }
        u = u.sibling;
      }
      if (!s) {
        for (u = i.child; u; ) {
          if (u === n) {
            s = !0, n = i, r = l;
            break;
          }
          if (u === r) {
            s = !0, r = i, n = l;
            break;
          }
          u = u.sibling;
        }
        if (!s) throw Error(x(189));
      }
    }
    if (n.alternate !== r) throw Error(x(190));
  }
  if (n.tag !== 3) throw Error(x(188));
  return n.stateNode.current === n ? e : t;
}
function K5(e) {
  return e = yt(e), e !== null ? J5(e) : null;
}
function J5(e) {
  if (e.tag === 5 || e.tag === 6) return e;
  for (e = e.child; e !== null; ) {
    var t = J5(e);
    if (t !== null) return t;
    e = e.sibling;
  }
  return null;
}
var b5 = M1.unstable_scheduleCallback, p6 = M1.unstable_cancelCallback, xt = M1.unstable_shouldYield, wt = M1.unstable_requestPaint, e1 = M1.unstable_now, kt = M1.unstable_getCurrentPriorityLevel, g8 = M1.unstable_ImmediatePriority, _5 = M1.unstable_UserBlockingPriority, t7 = M1.unstable_NormalPriority, St = M1.unstable_LowPriority, $5 = M1.unstable_IdlePriority, S7 = null, b1 = null;
function Et(e) {
  if (b1 && typeof b1.onCommitFiberRoot == "function") try {
    b1.onCommitFiberRoot(S7, e, void 0, (e.current.flags & 128) === 128);
  } catch {
  }
}
var O1 = Math.clz32 ? Math.clz32 : Mt, jt = Math.log, Lt = Math.LN2;
function Mt(e) {
  return e >>>= 0, e === 0 ? 32 : 31 - (jt(e) / Lt | 0) | 0;
}
var we = 64, ke = 4194304;
function V9(e) {
  switch (e & -e) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return e & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return e & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return e;
  }
}
function n7(e, t) {
  var n = e.pendingLanes;
  if (n === 0) return 0;
  var r = 0, l = e.suspendedLanes, i = e.pingedLanes, s = n & 268435455;
  if (s !== 0) {
    var u = s & ~l;
    u !== 0 ? r = V9(u) : (i &= s, i !== 0 && (r = V9(i)));
  } else s = n & ~l, s !== 0 ? r = V9(s) : i !== 0 && (r = V9(i));
  if (r === 0) return 0;
  if (t !== 0 && t !== r && !(t & l) && (l = r & -r, i = t & -t, l >= i || l === 16 && (i & 4194240) !== 0)) return t;
  if (r & 4 && (r |= n & 16), t = e.entangledLanes, t !== 0) for (e = e.entanglements, t &= r; 0 < t; ) n = 31 - O1(t), l = 1 << n, r |= e[n], t &= ~l;
  return r;
}
function zt(e, t) {
  switch (e) {
    case 1:
    case 2:
    case 4:
      return t + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return t + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function At(e, t) {
  for (var n = e.suspendedLanes, r = e.pingedLanes, l = e.expirationTimes, i = e.pendingLanes; 0 < i; ) {
    var s = 31 - O1(i), u = 1 << s, a = l[s];
    a === -1 ? (!(u & n) || u & r) && (l[s] = zt(u, t)) : a <= t && (e.expiredLanes |= u), i &= ~u;
  }
}
function T3(e) {
  return e = e.pendingLanes & -1073741825, e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
}
function e0() {
  var e = we;
  return we <<= 1, !(we & 4194240) && (we = 64), e;
}
function X7(e) {
  for (var t = [], n = 0; 31 > n; n++) t.push(e);
  return t;
}
function de(e, t, n) {
  e.pendingLanes |= t, t !== 536870912 && (e.suspendedLanes = 0, e.pingedLanes = 0), e = e.eventTimes, t = 31 - O1(t), e[t] = n;
}
function Bt(e, t) {
  var n = e.pendingLanes & ~t;
  e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
  var r = e.eventTimes;
  for (e = e.expirationTimes; 0 < n; ) {
    var l = 31 - O1(n), i = 1 << l;
    t[l] = 0, r[l] = -1, e[l] = -1, n &= ~i;
  }
}
function y8(e, t) {
  var n = e.entangledLanes |= t;
  for (e = e.entanglements; n; ) {
    var r = 31 - O1(n), l = 1 << r;
    l & t | e[r] & t && (e[r] |= t), n &= ~l;
  }
}
var W = 0;
function t0(e) {
  return e &= -e, 1 < e ? 4 < e ? e & 268435455 ? 16 : 536870912 : 4 : 1;
}
var n0, x8, r0, l0, i0, P3 = !1, Se = [], m2 = null, g2 = null, y2 = null, _9 = /* @__PURE__ */ new Map(), $9 = /* @__PURE__ */ new Map(), d2 = [], Tt = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function h6(e, t) {
  switch (e) {
    case "focusin":
    case "focusout":
      m2 = null;
      break;
    case "dragenter":
    case "dragleave":
      g2 = null;
      break;
    case "mouseover":
    case "mouseout":
      y2 = null;
      break;
    case "pointerover":
    case "pointerout":
      _9.delete(t.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      $9.delete(t.pointerId);
  }
}
function z9(e, t, n, r, l, i) {
  return e === null || e.nativeEvent !== i ? (e = { blockedOn: t, domEventName: n, eventSystemFlags: r, nativeEvent: i, targetContainers: [l] }, t !== null && (t = he(t), t !== null && x8(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, l !== null && t.indexOf(l) === -1 && t.push(l), e);
}
function Pt(e, t, n, r, l) {
  switch (t) {
    case "focusin":
      return m2 = z9(m2, e, t, n, r, l), !0;
    case "dragenter":
      return g2 = z9(g2, e, t, n, r, l), !0;
    case "mouseover":
      return y2 = z9(y2, e, t, n, r, l), !0;
    case "pointerover":
      var i = l.pointerId;
      return _9.set(i, z9(_9.get(i) || null, e, t, n, r, l)), !0;
    case "gotpointercapture":
      return i = l.pointerId, $9.set(i, z9($9.get(i) || null, e, t, n, r, l)), !0;
  }
  return !1;
}
function o0(e) {
  var t = N2(e.target);
  if (t !== null) {
    var n = X2(t);
    if (n !== null) {
      if (t = n.tag, t === 13) {
        if (t = q5(n), t !== null) {
          e.blockedOn = t, i0(e.priority, function() {
            r0(n);
          });
          return;
        }
      } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
        e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
        return;
      }
    }
  }
  e.blockedOn = null;
}
function He(e) {
  if (e.blockedOn !== null) return !1;
  for (var t = e.targetContainers; 0 < t.length; ) {
    var n = N3(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
    if (n === null) {
      n = e.nativeEvent;
      var r = new n.constructor(n.type, n);
      M3 = r, n.target.dispatchEvent(r), M3 = null;
    } else return t = he(n), t !== null && x8(t), e.blockedOn = n, !1;
    t.shift();
  }
  return !0;
}
function v6(e, t, n) {
  He(e) && n.delete(t);
}
function Nt() {
  P3 = !1, m2 !== null && He(m2) && (m2 = null), g2 !== null && He(g2) && (g2 = null), y2 !== null && He(y2) && (y2 = null), _9.forEach(v6), $9.forEach(v6);
}
function A9(e, t) {
  e.blockedOn === t && (e.blockedOn = null, P3 || (P3 = !0, M1.unstable_scheduleCallback(M1.unstable_NormalPriority, Nt)));
}
function ee(e) {
  function t(l) {
    return A9(l, e);
  }
  if (0 < Se.length) {
    A9(Se[0], e);
    for (var n = 1; n < Se.length; n++) {
      var r = Se[n];
      r.blockedOn === e && (r.blockedOn = null);
    }
  }
  for (m2 !== null && A9(m2, e), g2 !== null && A9(g2, e), y2 !== null && A9(y2, e), _9.forEach(t), $9.forEach(t), n = 0; n < d2.length; n++) r = d2[n], r.blockedOn === e && (r.blockedOn = null);
  for (; 0 < d2.length && (n = d2[0], n.blockedOn === null); ) o0(n), n.blockedOn === null && d2.shift();
}
var f9 = u2.ReactCurrentBatchConfig, r7 = !0;
function Rt(e, t, n, r) {
  var l = W, i = f9.transition;
  f9.transition = null;
  try {
    W = 1, w8(e, t, n, r);
  } finally {
    W = l, f9.transition = i;
  }
}
function Zt(e, t, n, r) {
  var l = W, i = f9.transition;
  f9.transition = null;
  try {
    W = 4, w8(e, t, n, r);
  } finally {
    W = l, f9.transition = i;
  }
}
function w8(e, t, n, r) {
  if (r7) {
    var l = N3(e, t, n, r);
    if (l === null) e3(e, t, r, l7, n), h6(e, r);
    else if (Pt(l, e, t, n, r)) r.stopPropagation();
    else if (h6(e, r), t & 4 && -1 < Tt.indexOf(e)) {
      for (; l !== null; ) {
        var i = he(l);
        if (i !== null && n0(i), i = N3(e, t, n, r), i === null && e3(e, t, r, l7, n), i === l) break;
        l = i;
      }
      l !== null && r.stopPropagation();
    } else e3(e, t, r, null, n);
  }
}
var l7 = null;
function N3(e, t, n, r) {
  if (l7 = null, e = m8(r), e = N2(e), e !== null) if (t = X2(e), t === null) e = null;
  else if (n = t.tag, n === 13) {
    if (e = q5(t), e !== null) return e;
    e = null;
  } else if (n === 3) {
    if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
    e = null;
  } else t !== e && (e = null);
  return l7 = e, null;
}
function s0(e) {
  switch (e) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;
    case "message":
      switch (kt()) {
        case g8:
          return 1;
        case _5:
          return 4;
        case t7:
        case St:
          return 16;
        case $5:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var h2 = null, k8 = null, Ie = null;
function u0() {
  if (Ie) return Ie;
  var e, t = k8, n = t.length, r, l = "value" in h2 ? h2.value : h2.textContent, i = l.length;
  for (e = 0; e < n && t[e] === l[e]; e++) ;
  var s = n - e;
  for (r = 1; r <= s && t[n - r] === l[i - r]; r++) ;
  return Ie = l.slice(e, 1 < r ? 1 - r : void 0);
}
function Xe(e) {
  var t = e.keyCode;
  return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
}
function Ee() {
  return !0;
}
function m6() {
  return !1;
}
function A1(e) {
  function t(n, r, l, i, s) {
    this._reactName = n, this._targetInst = l, this.type = r, this.nativeEvent = i, this.target = s, this.currentTarget = null;
    for (var u in e) e.hasOwnProperty(u) && (n = e[u], this[u] = n ? n(i) : i[u]);
    return this.isDefaultPrevented = (i.defaultPrevented != null ? i.defaultPrevented : i.returnValue === !1) ? Ee : m6, this.isPropagationStopped = m6, this;
  }
  return _(t.prototype, { preventDefault: function() {
    this.defaultPrevented = !0;
    var n = this.nativeEvent;
    n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = Ee);
  }, stopPropagation: function() {
    var n = this.nativeEvent;
    n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = Ee);
  }, persist: function() {
  }, isPersistent: Ee }), t;
}
var S9 = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e) {
  return e.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 }, S8 = A1(S9), pe = _({}, S9, { view: 0, detail: 0 }), Ft = A1(pe), G7, Q7, B9, E7 = _({}, pe, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: E8, button: 0, buttons: 0, relatedTarget: function(e) {
  return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
}, movementX: function(e) {
  return "movementX" in e ? e.movementX : (e !== B9 && (B9 && e.type === "mousemove" ? (G7 = e.screenX - B9.screenX, Q7 = e.screenY - B9.screenY) : Q7 = G7 = 0, B9 = e), G7);
}, movementY: function(e) {
  return "movementY" in e ? e.movementY : Q7;
} }), g6 = A1(E7), Dt = _({}, E7, { dataTransfer: 0 }), Vt = A1(Dt), Ut = _({}, pe, { relatedTarget: 0 }), Y7 = A1(Ut), Ot = _({}, S9, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Wt = A1(Ot), Ht = _({}, S9, { clipboardData: function(e) {
  return "clipboardData" in e ? e.clipboardData : window.clipboardData;
} }), It = A1(Ht), Xt = _({}, S9, { data: 0 }), y6 = A1(Xt), Gt = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, Qt = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, Yt = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function qt(e) {
  var t = this.nativeEvent;
  return t.getModifierState ? t.getModifierState(e) : (e = Yt[e]) ? !!t[e] : !1;
}
function E8() {
  return qt;
}
var Kt = _({}, pe, { key: function(e) {
  if (e.key) {
    var t = Gt[e.key] || e.key;
    if (t !== "Unidentified") return t;
  }
  return e.type === "keypress" ? (e = Xe(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? Qt[e.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: E8, charCode: function(e) {
  return e.type === "keypress" ? Xe(e) : 0;
}, keyCode: function(e) {
  return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
}, which: function(e) {
  return e.type === "keypress" ? Xe(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
} }), Jt = A1(Kt), bt = _({}, E7, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), x6 = A1(bt), _t = _({}, pe, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: E8 }), $t = A1(_t), en = _({}, S9, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), tn = A1(en), nn = _({}, E7, {
  deltaX: function(e) {
    return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
  },
  deltaY: function(e) {
    return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}), rn = A1(nn), ln = [9, 13, 27, 32], j8 = l2 && "CompositionEvent" in window, H9 = null;
l2 && "documentMode" in document && (H9 = document.documentMode);
var on = l2 && "TextEvent" in window && !H9, a0 = l2 && (!j8 || H9 && 8 < H9 && 11 >= H9), w6 = " ", k6 = !1;
function c0(e, t) {
  switch (e) {
    case "keyup":
      return ln.indexOf(t.keyCode) !== -1;
    case "keydown":
      return t.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;
    default:
      return !1;
  }
}
function C0(e) {
  return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
}
var $2 = !1;
function sn(e, t) {
  switch (e) {
    case "compositionend":
      return C0(t);
    case "keypress":
      return t.which !== 32 ? null : (k6 = !0, w6);
    case "textInput":
      return e = t.data, e === w6 && k6 ? null : e;
    default:
      return null;
  }
}
function un(e, t) {
  if ($2) return e === "compositionend" || !j8 && c0(e, t) ? (e = u0(), Ie = k8 = h2 = null, $2 = !1, e) : null;
  switch (e) {
    case "paste":
      return null;
    case "keypress":
      if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
        if (t.char && 1 < t.char.length) return t.char;
        if (t.which) return String.fromCharCode(t.which);
      }
      return null;
    case "compositionend":
      return a0 && t.locale !== "ko" ? null : t.data;
    default:
      return null;
  }
}
var an = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
function S6(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t === "input" ? !!an[e.type] : t === "textarea";
}
function f0(e, t, n, r) {
  I5(r), t = i7(t, "onChange"), 0 < t.length && (n = new S8("onChange", "change", null, n, r), e.push({ event: n, listeners: t }));
}
var I9 = null, te = null;
function cn(e) {
  S0(e, 0);
}
function j7(e) {
  var t = n9(e);
  if (F5(t)) return e;
}
function Cn(e, t) {
  if (e === "change") return t;
}
var d0 = !1;
if (l2) {
  var q7;
  if (l2) {
    var K7 = "oninput" in document;
    if (!K7) {
      var E6 = document.createElement("div");
      E6.setAttribute("oninput", "return;"), K7 = typeof E6.oninput == "function";
    }
    q7 = K7;
  } else q7 = !1;
  d0 = q7 && (!document.documentMode || 9 < document.documentMode);
}
function j6() {
  I9 && (I9.detachEvent("onpropertychange", p0), te = I9 = null);
}
function p0(e) {
  if (e.propertyName === "value" && j7(te)) {
    var t = [];
    f0(t, te, e, m8(e)), Y5(cn, t);
  }
}
function fn(e, t, n) {
  e === "focusin" ? (j6(), I9 = t, te = n, I9.attachEvent("onpropertychange", p0)) : e === "focusout" && j6();
}
function dn(e) {
  if (e === "selectionchange" || e === "keyup" || e === "keydown") return j7(te);
}
function pn(e, t) {
  if (e === "click") return j7(t);
}
function hn(e, t) {
  if (e === "input" || e === "change") return j7(t);
}
function vn(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var H1 = typeof Object.is == "function" ? Object.is : vn;
function ne(e, t) {
  if (H1(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (r = 0; r < n.length; r++) {
    var l = n[r];
    if (!h3.call(t, l) || !H1(e[l], t[l])) return !1;
  }
  return !0;
}
function L6(e) {
  for (; e && e.firstChild; ) e = e.firstChild;
  return e;
}
function M6(e, t) {
  var n = L6(e);
  e = 0;
  for (var r; n; ) {
    if (n.nodeType === 3) {
      if (r = e + n.textContent.length, e <= t && r >= t) return { node: n, offset: t - e };
      e = r;
    }
    e: {
      for (; n; ) {
        if (n.nextSibling) {
          n = n.nextSibling;
          break e;
        }
        n = n.parentNode;
      }
      n = void 0;
    }
    n = L6(n);
  }
}
function h0(e, t) {
  return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? h0(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
}
function v0() {
  for (var e = window, t = _e(); t instanceof e.HTMLIFrameElement; ) {
    try {
      var n = typeof t.contentWindow.location.href == "string";
    } catch {
      n = !1;
    }
    if (n) e = t.contentWindow;
    else break;
    t = _e(e.document);
  }
  return t;
}
function L8(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
}
function mn(e) {
  var t = v0(), n = e.focusedElem, r = e.selectionRange;
  if (t !== n && n && n.ownerDocument && h0(n.ownerDocument.documentElement, n)) {
    if (r !== null && L8(n)) {
      if (t = r.start, e = r.end, e === void 0 && (e = t), "selectionStart" in n) n.selectionStart = t, n.selectionEnd = Math.min(e, n.value.length);
      else if (e = (t = n.ownerDocument || document) && t.defaultView || window, e.getSelection) {
        e = e.getSelection();
        var l = n.textContent.length, i = Math.min(r.start, l);
        r = r.end === void 0 ? i : Math.min(r.end, l), !e.extend && i > r && (l = r, r = i, i = l), l = M6(n, i);
        var s = M6(
          n,
          r
        );
        l && s && (e.rangeCount !== 1 || e.anchorNode !== l.node || e.anchorOffset !== l.offset || e.focusNode !== s.node || e.focusOffset !== s.offset) && (t = t.createRange(), t.setStart(l.node, l.offset), e.removeAllRanges(), i > r ? (e.addRange(t), e.extend(s.node, s.offset)) : (t.setEnd(s.node, s.offset), e.addRange(t)));
      }
    }
    for (t = [], e = n; e = e.parentNode; ) e.nodeType === 1 && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
    for (typeof n.focus == "function" && n.focus(), n = 0; n < t.length; n++) e = t[n], e.element.scrollLeft = e.left, e.element.scrollTop = e.top;
  }
}
var gn = l2 && "documentMode" in document && 11 >= document.documentMode, e9 = null, R3 = null, X9 = null, Z3 = !1;
function z6(e, t, n) {
  var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
  Z3 || e9 == null || e9 !== _e(r) || (r = e9, "selectionStart" in r && L8(r) ? r = { start: r.selectionStart, end: r.selectionEnd } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = { anchorNode: r.anchorNode, anchorOffset: r.anchorOffset, focusNode: r.focusNode, focusOffset: r.focusOffset }), X9 && ne(X9, r) || (X9 = r, r = i7(R3, "onSelect"), 0 < r.length && (t = new S8("onSelect", "select", null, t, n), e.push({ event: t, listeners: r }), t.target = e9)));
}
function je(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
}
var t9 = { animationend: je("Animation", "AnimationEnd"), animationiteration: je("Animation", "AnimationIteration"), animationstart: je("Animation", "AnimationStart"), transitionend: je("Transition", "TransitionEnd") }, J7 = {}, m0 = {};
l2 && (m0 = document.createElement("div").style, "AnimationEvent" in window || (delete t9.animationend.animation, delete t9.animationiteration.animation, delete t9.animationstart.animation), "TransitionEvent" in window || delete t9.transitionend.transition);
function L7(e) {
  if (J7[e]) return J7[e];
  if (!t9[e]) return e;
  var t = t9[e], n;
  for (n in t) if (t.hasOwnProperty(n) && n in m0) return J7[e] = t[n];
  return e;
}
var g0 = L7("animationend"), y0 = L7("animationiteration"), x0 = L7("animationstart"), w0 = L7("transitionend"), k0 = /* @__PURE__ */ new Map(), A6 = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function M2(e, t) {
  k0.set(e, t), I2(t, [e]);
}
for (var b7 = 0; b7 < A6.length; b7++) {
  var _7 = A6[b7], yn = _7.toLowerCase(), xn = _7[0].toUpperCase() + _7.slice(1);
  M2(yn, "on" + xn);
}
M2(g0, "onAnimationEnd");
M2(y0, "onAnimationIteration");
M2(x0, "onAnimationStart");
M2("dblclick", "onDoubleClick");
M2("focusin", "onFocus");
M2("focusout", "onBlur");
M2(w0, "onTransitionEnd");
h9("onMouseEnter", ["mouseout", "mouseover"]);
h9("onMouseLeave", ["mouseout", "mouseover"]);
h9("onPointerEnter", ["pointerout", "pointerover"]);
h9("onPointerLeave", ["pointerout", "pointerover"]);
I2("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
I2("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
I2("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
I2("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
I2("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
I2("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var U9 = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), wn = new Set("cancel close invalid load scroll toggle".split(" ").concat(U9));
function B6(e, t, n) {
  var r = e.type || "unknown-event";
  e.currentTarget = n, gt(r, t, void 0, e), e.currentTarget = null;
}
function S0(e, t) {
  t = (t & 4) !== 0;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], l = r.event;
    r = r.listeners;
    e: {
      var i = void 0;
      if (t) for (var s = r.length - 1; 0 <= s; s--) {
        var u = r[s], a = u.instance, c = u.currentTarget;
        if (u = u.listener, a !== i && l.isPropagationStopped()) break e;
        B6(l, u, c), i = a;
      }
      else for (s = 0; s < r.length; s++) {
        if (u = r[s], a = u.instance, c = u.currentTarget, u = u.listener, a !== i && l.isPropagationStopped()) break e;
        B6(l, u, c), i = a;
      }
    }
  }
  if (e7) throw e = B3, e7 = !1, B3 = null, e;
}
function Q(e, t) {
  var n = t[O3];
  n === void 0 && (n = t[O3] = /* @__PURE__ */ new Set());
  var r = e + "__bubble";
  n.has(r) || (E0(t, e, 2, !1), n.add(r));
}
function $7(e, t, n) {
  var r = 0;
  t && (r |= 4), E0(n, e, r, t);
}
var Le = "_reactListening" + Math.random().toString(36).slice(2);
function re(e) {
  if (!e[Le]) {
    e[Le] = !0, T5.forEach(function(n) {
      n !== "selectionchange" && (wn.has(n) || $7(n, !1, e), $7(n, !0, e));
    });
    var t = e.nodeType === 9 ? e : e.ownerDocument;
    t === null || t[Le] || (t[Le] = !0, $7("selectionchange", !1, t));
  }
}
function E0(e, t, n, r) {
  switch (s0(t)) {
    case 1:
      var l = Rt;
      break;
    case 4:
      l = Zt;
      break;
    default:
      l = w8;
  }
  n = l.bind(null, t, n, e), l = void 0, !A3 || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (l = !0), r ? l !== void 0 ? e.addEventListener(t, n, { capture: !0, passive: l }) : e.addEventListener(t, n, !0) : l !== void 0 ? e.addEventListener(t, n, { passive: l }) : e.addEventListener(t, n, !1);
}
function e3(e, t, n, r, l) {
  var i = r;
  if (!(t & 1) && !(t & 2) && r !== null) e: for (; ; ) {
    if (r === null) return;
    var s = r.tag;
    if (s === 3 || s === 4) {
      var u = r.stateNode.containerInfo;
      if (u === l || u.nodeType === 8 && u.parentNode === l) break;
      if (s === 4) for (s = r.return; s !== null; ) {
        var a = s.tag;
        if ((a === 3 || a === 4) && (a = s.stateNode.containerInfo, a === l || a.nodeType === 8 && a.parentNode === l)) return;
        s = s.return;
      }
      for (; u !== null; ) {
        if (s = N2(u), s === null) return;
        if (a = s.tag, a === 5 || a === 6) {
          r = i = s;
          continue e;
        }
        u = u.parentNode;
      }
    }
    r = r.return;
  }
  Y5(function() {
    var c = i, p = m8(n), h = [];
    e: {
      var v = k0.get(e);
      if (v !== void 0) {
        var g = S8, w = e;
        switch (e) {
          case "keypress":
            if (Xe(n) === 0) break e;
          case "keydown":
          case "keyup":
            g = Jt;
            break;
          case "focusin":
            w = "focus", g = Y7;
            break;
          case "focusout":
            w = "blur", g = Y7;
            break;
          case "beforeblur":
          case "afterblur":
            g = Y7;
            break;
          case "click":
            if (n.button === 2) break e;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            g = g6;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            g = Vt;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            g = $t;
            break;
          case g0:
          case y0:
          case x0:
            g = Wt;
            break;
          case w0:
            g = tn;
            break;
          case "scroll":
            g = Ft;
            break;
          case "wheel":
            g = rn;
            break;
          case "copy":
          case "cut":
          case "paste":
            g = It;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            g = x6;
        }
        var y = (t & 4) !== 0, N = !y && e === "scroll", f = y ? v !== null ? v + "Capture" : null : v;
        y = [];
        for (var C = c, d; C !== null; ) {
          d = C;
          var m = d.stateNode;
          if (d.tag === 5 && m !== null && (d = m, f !== null && (m = b9(C, f), m != null && y.push(le(C, m, d)))), N) break;
          C = C.return;
        }
        0 < y.length && (v = new g(v, w, null, n, p), h.push({ event: v, listeners: y }));
      }
    }
    if (!(t & 7)) {
      e: {
        if (v = e === "mouseover" || e === "pointerover", g = e === "mouseout" || e === "pointerout", v && n !== M3 && (w = n.relatedTarget || n.fromElement) && (N2(w) || w[i2])) break e;
        if ((g || v) && (v = p.window === p ? p : (v = p.ownerDocument) ? v.defaultView || v.parentWindow : window, g ? (w = n.relatedTarget || n.toElement, g = c, w = w ? N2(w) : null, w !== null && (N = X2(w), w !== N || w.tag !== 5 && w.tag !== 6) && (w = null)) : (g = null, w = c), g !== w)) {
          if (y = g6, m = "onMouseLeave", f = "onMouseEnter", C = "mouse", (e === "pointerout" || e === "pointerover") && (y = x6, m = "onPointerLeave", f = "onPointerEnter", C = "pointer"), N = g == null ? v : n9(g), d = w == null ? v : n9(w), v = new y(m, C + "leave", g, n, p), v.target = N, v.relatedTarget = d, m = null, N2(p) === c && (y = new y(f, C + "enter", w, n, p), y.target = d, y.relatedTarget = N, m = y), N = m, g && w) t: {
            for (y = g, f = w, C = 0, d = y; d; d = K2(d)) C++;
            for (d = 0, m = f; m; m = K2(m)) d++;
            for (; 0 < C - d; ) y = K2(y), C--;
            for (; 0 < d - C; ) f = K2(f), d--;
            for (; C--; ) {
              if (y === f || f !== null && y === f.alternate) break t;
              y = K2(y), f = K2(f);
            }
            y = null;
          }
          else y = null;
          g !== null && T6(h, v, g, y, !1), w !== null && N !== null && T6(h, N, w, y, !0);
        }
      }
      e: {
        if (v = c ? n9(c) : window, g = v.nodeName && v.nodeName.toLowerCase(), g === "select" || g === "input" && v.type === "file") var k = Cn;
        else if (S6(v)) if (d0) k = hn;
        else {
          k = dn;
          var j = fn;
        }
        else (g = v.nodeName) && g.toLowerCase() === "input" && (v.type === "checkbox" || v.type === "radio") && (k = pn);
        if (k && (k = k(e, c))) {
          f0(h, k, n, p);
          break e;
        }
        j && j(e, v, c), e === "focusout" && (j = v._wrapperState) && j.controlled && v.type === "number" && k3(v, "number", v.value);
      }
      switch (j = c ? n9(c) : window, e) {
        case "focusin":
          (S6(j) || j.contentEditable === "true") && (e9 = j, R3 = c, X9 = null);
          break;
        case "focusout":
          X9 = R3 = e9 = null;
          break;
        case "mousedown":
          Z3 = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Z3 = !1, z6(h, n, p);
          break;
        case "selectionchange":
          if (gn) break;
        case "keydown":
        case "keyup":
          z6(h, n, p);
      }
      var L;
      if (j8) e: {
        switch (e) {
          case "compositionstart":
            var S = "onCompositionStart";
            break e;
          case "compositionend":
            S = "onCompositionEnd";
            break e;
          case "compositionupdate":
            S = "onCompositionUpdate";
            break e;
        }
        S = void 0;
      }
      else $2 ? c0(e, n) && (S = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (S = "onCompositionStart");
      S && (a0 && n.locale !== "ko" && ($2 || S !== "onCompositionStart" ? S === "onCompositionEnd" && $2 && (L = u0()) : (h2 = p, k8 = "value" in h2 ? h2.value : h2.textContent, $2 = !0)), j = i7(c, S), 0 < j.length && (S = new y6(S, e, null, n, p), h.push({ event: S, listeners: j }), L ? S.data = L : (L = C0(n), L !== null && (S.data = L)))), (L = on ? sn(e, n) : un(e, n)) && (c = i7(c, "onBeforeInput"), 0 < c.length && (p = new y6("onBeforeInput", "beforeinput", null, n, p), h.push({ event: p, listeners: c }), p.data = L));
    }
    S0(h, t);
  });
}
function le(e, t, n) {
  return { instance: e, listener: t, currentTarget: n };
}
function i7(e, t) {
  for (var n = t + "Capture", r = []; e !== null; ) {
    var l = e, i = l.stateNode;
    l.tag === 5 && i !== null && (l = i, i = b9(e, n), i != null && r.unshift(le(e, i, l)), i = b9(e, t), i != null && r.push(le(e, i, l))), e = e.return;
  }
  return r;
}
function K2(e) {
  if (e === null) return null;
  do
    e = e.return;
  while (e && e.tag !== 5);
  return e || null;
}
function T6(e, t, n, r, l) {
  for (var i = t._reactName, s = []; n !== null && n !== r; ) {
    var u = n, a = u.alternate, c = u.stateNode;
    if (a !== null && a === r) break;
    u.tag === 5 && c !== null && (u = c, l ? (a = b9(n, i), a != null && s.unshift(le(n, a, u))) : l || (a = b9(n, i), a != null && s.push(le(n, a, u)))), n = n.return;
  }
  s.length !== 0 && e.push({ event: t, listeners: s });
}
var kn = /\\r\\n?/g, Sn = /\\u0000|\\uFFFD/g;
function P6(e) {
  return (typeof e == "string" ? e : "" + e).replace(kn, \`
\`).replace(Sn, "");
}
function Me(e, t, n) {
  if (t = P6(t), P6(e) !== t && n) throw Error(x(425));
}
function o7() {
}
var F3 = null, D3 = null;
function V3(e, t) {
  return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
}
var U3 = typeof setTimeout == "function" ? setTimeout : void 0, En = typeof clearTimeout == "function" ? clearTimeout : void 0, N6 = typeof Promise == "function" ? Promise : void 0, jn = typeof queueMicrotask == "function" ? queueMicrotask : typeof N6 < "u" ? function(e) {
  return N6.resolve(null).then(e).catch(Ln);
} : U3;
function Ln(e) {
  setTimeout(function() {
    throw e;
  });
}
function t3(e, t) {
  var n = t, r = 0;
  do {
    var l = n.nextSibling;
    if (e.removeChild(n), l && l.nodeType === 8) if (n = l.data, n === "/$") {
      if (r === 0) {
        e.removeChild(l), ee(t);
        return;
      }
      r--;
    } else n !== "$" && n !== "$?" && n !== "$!" || r++;
    n = l;
  } while (n);
  ee(t);
}
function x2(e) {
  for (; e != null; e = e.nextSibling) {
    var t = e.nodeType;
    if (t === 1 || t === 3) break;
    if (t === 8) {
      if (t = e.data, t === "$" || t === "$!" || t === "$?") break;
      if (t === "/$") return null;
    }
  }
  return e;
}
function R6(e) {
  e = e.previousSibling;
  for (var t = 0; e; ) {
    if (e.nodeType === 8) {
      var n = e.data;
      if (n === "$" || n === "$!" || n === "$?") {
        if (t === 0) return e;
        t--;
      } else n === "/$" && t++;
    }
    e = e.previousSibling;
  }
  return null;
}
var E9 = Math.random().toString(36).slice(2), J1 = "__reactFiber$" + E9, ie = "__reactProps$" + E9, i2 = "__reactContainer$" + E9, O3 = "__reactEvents$" + E9, Mn = "__reactListeners$" + E9, zn = "__reactHandles$" + E9;
function N2(e) {
  var t = e[J1];
  if (t) return t;
  for (var n = e.parentNode; n; ) {
    if (t = n[i2] || n[J1]) {
      if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = R6(e); e !== null; ) {
        if (n = e[J1]) return n;
        e = R6(e);
      }
      return t;
    }
    e = n, n = e.parentNode;
  }
  return null;
}
function he(e) {
  return e = e[J1] || e[i2], !e || e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3 ? null : e;
}
function n9(e) {
  if (e.tag === 5 || e.tag === 6) return e.stateNode;
  throw Error(x(33));
}
function M7(e) {
  return e[ie] || null;
}
var W3 = [], r9 = -1;
function z2(e) {
  return { current: e };
}
function Y(e) {
  0 > r9 || (e.current = W3[r9], W3[r9] = null, r9--);
}
function X(e, t) {
  r9++, W3[r9] = e.current, e.current = t;
}
var L2 = {}, p1 = z2(L2), w1 = z2(!1), V2 = L2;
function v9(e, t) {
  var n = e.type.contextTypes;
  if (!n) return L2;
  var r = e.stateNode;
  if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
  var l = {}, i;
  for (i in n) l[i] = t[i];
  return r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = l), l;
}
function k1(e) {
  return e = e.childContextTypes, e != null;
}
function s7() {
  Y(w1), Y(p1);
}
function Z6(e, t, n) {
  if (p1.current !== L2) throw Error(x(168));
  X(p1, t), X(w1, n);
}
function j0(e, t, n) {
  var r = e.stateNode;
  if (t = t.childContextTypes, typeof r.getChildContext != "function") return n;
  r = r.getChildContext();
  for (var l in r) if (!(l in t)) throw Error(x(108, Ct(e) || "Unknown", l));
  return _({}, n, r);
}
function u7(e) {
  return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || L2, V2 = p1.current, X(p1, e), X(w1, w1.current), !0;
}
function F6(e, t, n) {
  var r = e.stateNode;
  if (!r) throw Error(x(169));
  n ? (e = j0(e, t, V2), r.__reactInternalMemoizedMergedChildContext = e, Y(w1), Y(p1), X(p1, e)) : Y(w1), X(w1, n);
}
var e2 = null, z7 = !1, n3 = !1;
function L0(e) {
  e2 === null ? e2 = [e] : e2.push(e);
}
function An(e) {
  z7 = !0, L0(e);
}
function A2() {
  if (!n3 && e2 !== null) {
    n3 = !0;
    var e = 0, t = W;
    try {
      var n = e2;
      for (W = 1; e < n.length; e++) {
        var r = n[e];
        do
          r = r(!0);
        while (r !== null);
      }
      e2 = null, z7 = !1;
    } catch (l) {
      throw e2 !== null && (e2 = e2.slice(e + 1)), b5(g8, A2), l;
    } finally {
      W = t, n3 = !1;
    }
  }
  return null;
}
var l9 = [], i9 = 0, a7 = null, c7 = 0, B1 = [], T1 = 0, U2 = null, t2 = 1, n2 = "";
function T2(e, t) {
  l9[i9++] = c7, l9[i9++] = a7, a7 = e, c7 = t;
}
function M0(e, t, n) {
  B1[T1++] = t2, B1[T1++] = n2, B1[T1++] = U2, U2 = e;
  var r = t2;
  e = n2;
  var l = 32 - O1(r) - 1;
  r &= ~(1 << l), n += 1;
  var i = 32 - O1(t) + l;
  if (30 < i) {
    var s = l - l % 5;
    i = (r & (1 << s) - 1).toString(32), r >>= s, l -= s, t2 = 1 << 32 - O1(t) + l | n << l | r, n2 = i + e;
  } else t2 = 1 << i | n << l | r, n2 = e;
}
function M8(e) {
  e.return !== null && (T2(e, 1), M0(e, 1, 0));
}
function z8(e) {
  for (; e === a7; ) a7 = l9[--i9], l9[i9] = null, c7 = l9[--i9], l9[i9] = null;
  for (; e === U2; ) U2 = B1[--T1], B1[T1] = null, n2 = B1[--T1], B1[T1] = null, t2 = B1[--T1], B1[T1] = null;
}
var L1 = null, j1 = null, K = !1, U1 = null;
function z0(e, t) {
  var n = P1(5, null, null, 0);
  n.elementType = "DELETED", n.stateNode = t, n.return = e, t = e.deletions, t === null ? (e.deletions = [n], e.flags |= 16) : t.push(n);
}
function D6(e, t) {
  switch (e.tag) {
    case 5:
      var n = e.type;
      return t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t, t !== null ? (e.stateNode = t, L1 = e, j1 = x2(t.firstChild), !0) : !1;
    case 6:
      return t = e.pendingProps === "" || t.nodeType !== 3 ? null : t, t !== null ? (e.stateNode = t, L1 = e, j1 = null, !0) : !1;
    case 13:
      return t = t.nodeType !== 8 ? null : t, t !== null ? (n = U2 !== null ? { id: t2, overflow: n2 } : null, e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }, n = P1(18, null, null, 0), n.stateNode = t, n.return = e, e.child = n, L1 = e, j1 = null, !0) : !1;
    default:
      return !1;
  }
}
function H3(e) {
  return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function I3(e) {
  if (K) {
    var t = j1;
    if (t) {
      var n = t;
      if (!D6(e, t)) {
        if (H3(e)) throw Error(x(418));
        t = x2(n.nextSibling);
        var r = L1;
        t && D6(e, t) ? z0(r, n) : (e.flags = e.flags & -4097 | 2, K = !1, L1 = e);
      }
    } else {
      if (H3(e)) throw Error(x(418));
      e.flags = e.flags & -4097 | 2, K = !1, L1 = e;
    }
  }
}
function V6(e) {
  for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; ) e = e.return;
  L1 = e;
}
function ze(e) {
  if (e !== L1) return !1;
  if (!K) return V6(e), K = !0, !1;
  var t;
  if ((t = e.tag !== 3) && !(t = e.tag !== 5) && (t = e.type, t = t !== "head" && t !== "body" && !V3(e.type, e.memoizedProps)), t && (t = j1)) {
    if (H3(e)) throw A0(), Error(x(418));
    for (; t; ) z0(e, t), t = x2(t.nextSibling);
  }
  if (V6(e), e.tag === 13) {
    if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(x(317));
    e: {
      for (e = e.nextSibling, t = 0; e; ) {
        if (e.nodeType === 8) {
          var n = e.data;
          if (n === "/$") {
            if (t === 0) {
              j1 = x2(e.nextSibling);
              break e;
            }
            t--;
          } else n !== "$" && n !== "$!" && n !== "$?" || t++;
        }
        e = e.nextSibling;
      }
      j1 = null;
    }
  } else j1 = L1 ? x2(e.stateNode.nextSibling) : null;
  return !0;
}
function A0() {
  for (var e = j1; e; ) e = x2(e.nextSibling);
}
function m9() {
  j1 = L1 = null, K = !1;
}
function A8(e) {
  U1 === null ? U1 = [e] : U1.push(e);
}
var Bn = u2.ReactCurrentBatchConfig;
function T9(e, t, n) {
  if (e = n.ref, e !== null && typeof e != "function" && typeof e != "object") {
    if (n._owner) {
      if (n = n._owner, n) {
        if (n.tag !== 1) throw Error(x(309));
        var r = n.stateNode;
      }
      if (!r) throw Error(x(147, e));
      var l = r, i = "" + e;
      return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === i ? t.ref : (t = function(s) {
        var u = l.refs;
        s === null ? delete u[i] : u[i] = s;
      }, t._stringRef = i, t);
    }
    if (typeof e != "string") throw Error(x(284));
    if (!n._owner) throw Error(x(290, e));
  }
  return e;
}
function Ae(e, t) {
  throw e = Object.prototype.toString.call(t), Error(x(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
}
function U6(e) {
  var t = e._init;
  return t(e._payload);
}
function B0(e) {
  function t(f, C) {
    if (e) {
      var d = f.deletions;
      d === null ? (f.deletions = [C], f.flags |= 16) : d.push(C);
    }
  }
  function n(f, C) {
    if (!e) return null;
    for (; C !== null; ) t(f, C), C = C.sibling;
    return null;
  }
  function r(f, C) {
    for (f = /* @__PURE__ */ new Map(); C !== null; ) C.key !== null ? f.set(C.key, C) : f.set(C.index, C), C = C.sibling;
    return f;
  }
  function l(f, C) {
    return f = E2(f, C), f.index = 0, f.sibling = null, f;
  }
  function i(f, C, d) {
    return f.index = d, e ? (d = f.alternate, d !== null ? (d = d.index, d < C ? (f.flags |= 2, C) : d) : (f.flags |= 2, C)) : (f.flags |= 1048576, C);
  }
  function s(f) {
    return e && f.alternate === null && (f.flags |= 2), f;
  }
  function u(f, C, d, m) {
    return C === null || C.tag !== 6 ? (C = a3(d, f.mode, m), C.return = f, C) : (C = l(C, d), C.return = f, C);
  }
  function a(f, C, d, m) {
    var k = d.type;
    return k === _2 ? p(f, C, d.props.children, m, d.key) : C !== null && (C.elementType === k || typeof k == "object" && k !== null && k.$$typeof === C2 && U6(k) === C.type) ? (m = l(C, d.props), m.ref = T9(f, C, d), m.return = f, m) : (m = be(d.type, d.key, d.props, null, f.mode, m), m.ref = T9(f, C, d), m.return = f, m);
  }
  function c(f, C, d, m) {
    return C === null || C.tag !== 4 || C.stateNode.containerInfo !== d.containerInfo || C.stateNode.implementation !== d.implementation ? (C = c3(d, f.mode, m), C.return = f, C) : (C = l(C, d.children || []), C.return = f, C);
  }
  function p(f, C, d, m, k) {
    return C === null || C.tag !== 7 ? (C = D2(d, f.mode, m, k), C.return = f, C) : (C = l(C, d), C.return = f, C);
  }
  function h(f, C, d) {
    if (typeof C == "string" && C !== "" || typeof C == "number") return C = a3("" + C, f.mode, d), C.return = f, C;
    if (typeof C == "object" && C !== null) {
      switch (C.$$typeof) {
        case ge:
          return d = be(C.type, C.key, C.props, null, f.mode, d), d.ref = T9(f, null, C), d.return = f, d;
        case b2:
          return C = c3(C, f.mode, d), C.return = f, C;
        case C2:
          var m = C._init;
          return h(f, m(C._payload), d);
      }
      if (D9(C) || L9(C)) return C = D2(C, f.mode, d, null), C.return = f, C;
      Ae(f, C);
    }
    return null;
  }
  function v(f, C, d, m) {
    var k = C !== null ? C.key : null;
    if (typeof d == "string" && d !== "" || typeof d == "number") return k !== null ? null : u(f, C, "" + d, m);
    if (typeof d == "object" && d !== null) {
      switch (d.$$typeof) {
        case ge:
          return d.key === k ? a(f, C, d, m) : null;
        case b2:
          return d.key === k ? c(f, C, d, m) : null;
        case C2:
          return k = d._init, v(
            f,
            C,
            k(d._payload),
            m
          );
      }
      if (D9(d) || L9(d)) return k !== null ? null : p(f, C, d, m, null);
      Ae(f, d);
    }
    return null;
  }
  function g(f, C, d, m, k) {
    if (typeof m == "string" && m !== "" || typeof m == "number") return f = f.get(d) || null, u(C, f, "" + m, k);
    if (typeof m == "object" && m !== null) {
      switch (m.$$typeof) {
        case ge:
          return f = f.get(m.key === null ? d : m.key) || null, a(C, f, m, k);
        case b2:
          return f = f.get(m.key === null ? d : m.key) || null, c(C, f, m, k);
        case C2:
          var j = m._init;
          return g(f, C, d, j(m._payload), k);
      }
      if (D9(m) || L9(m)) return f = f.get(d) || null, p(C, f, m, k, null);
      Ae(C, m);
    }
    return null;
  }
  function w(f, C, d, m) {
    for (var k = null, j = null, L = C, S = C = 0, U = null; L !== null && S < d.length; S++) {
      L.index > S ? (U = L, L = null) : U = L.sibling;
      var Z = v(f, L, d[S], m);
      if (Z === null) {
        L === null && (L = U);
        break;
      }
      e && L && Z.alternate === null && t(f, L), C = i(Z, C, S), j === null ? k = Z : j.sibling = Z, j = Z, L = U;
    }
    if (S === d.length) return n(f, L), K && T2(f, S), k;
    if (L === null) {
      for (; S < d.length; S++) L = h(f, d[S], m), L !== null && (C = i(L, C, S), j === null ? k = L : j.sibling = L, j = L);
      return K && T2(f, S), k;
    }
    for (L = r(f, L); S < d.length; S++) U = g(L, f, S, d[S], m), U !== null && (e && U.alternate !== null && L.delete(U.key === null ? S : U.key), C = i(U, C, S), j === null ? k = U : j.sibling = U, j = U);
    return e && L.forEach(function(z) {
      return t(f, z);
    }), K && T2(f, S), k;
  }
  function y(f, C, d, m) {
    var k = L9(d);
    if (typeof k != "function") throw Error(x(150));
    if (d = k.call(d), d == null) throw Error(x(151));
    for (var j = k = null, L = C, S = C = 0, U = null, Z = d.next(); L !== null && !Z.done; S++, Z = d.next()) {
      L.index > S ? (U = L, L = null) : U = L.sibling;
      var z = v(f, L, Z.value, m);
      if (z === null) {
        L === null && (L = U);
        break;
      }
      e && L && z.alternate === null && t(f, L), C = i(z, C, S), j === null ? k = z : j.sibling = z, j = z, L = U;
    }
    if (Z.done) return n(
      f,
      L
    ), K && T2(f, S), k;
    if (L === null) {
      for (; !Z.done; S++, Z = d.next()) Z = h(f, Z.value, m), Z !== null && (C = i(Z, C, S), j === null ? k = Z : j.sibling = Z, j = Z);
      return K && T2(f, S), k;
    }
    for (L = r(f, L); !Z.done; S++, Z = d.next()) Z = g(L, f, S, Z.value, m), Z !== null && (e && Z.alternate !== null && L.delete(Z.key === null ? S : Z.key), C = i(Z, C, S), j === null ? k = Z : j.sibling = Z, j = Z);
    return e && L.forEach(function(P) {
      return t(f, P);
    }), K && T2(f, S), k;
  }
  function N(f, C, d, m) {
    if (typeof d == "object" && d !== null && d.type === _2 && d.key === null && (d = d.props.children), typeof d == "object" && d !== null) {
      switch (d.$$typeof) {
        case ge:
          e: {
            for (var k = d.key, j = C; j !== null; ) {
              if (j.key === k) {
                if (k = d.type, k === _2) {
                  if (j.tag === 7) {
                    n(f, j.sibling), C = l(j, d.props.children), C.return = f, f = C;
                    break e;
                  }
                } else if (j.elementType === k || typeof k == "object" && k !== null && k.$$typeof === C2 && U6(k) === j.type) {
                  n(f, j.sibling), C = l(j, d.props), C.ref = T9(f, j, d), C.return = f, f = C;
                  break e;
                }
                n(f, j);
                break;
              } else t(f, j);
              j = j.sibling;
            }
            d.type === _2 ? (C = D2(d.props.children, f.mode, m, d.key), C.return = f, f = C) : (m = be(d.type, d.key, d.props, null, f.mode, m), m.ref = T9(f, C, d), m.return = f, f = m);
          }
          return s(f);
        case b2:
          e: {
            for (j = d.key; C !== null; ) {
              if (C.key === j) if (C.tag === 4 && C.stateNode.containerInfo === d.containerInfo && C.stateNode.implementation === d.implementation) {
                n(f, C.sibling), C = l(C, d.children || []), C.return = f, f = C;
                break e;
              } else {
                n(f, C);
                break;
              }
              else t(f, C);
              C = C.sibling;
            }
            C = c3(d, f.mode, m), C.return = f, f = C;
          }
          return s(f);
        case C2:
          return j = d._init, N(f, C, j(d._payload), m);
      }
      if (D9(d)) return w(f, C, d, m);
      if (L9(d)) return y(f, C, d, m);
      Ae(f, d);
    }
    return typeof d == "string" && d !== "" || typeof d == "number" ? (d = "" + d, C !== null && C.tag === 6 ? (n(f, C.sibling), C = l(C, d), C.return = f, f = C) : (n(f, C), C = a3(d, f.mode, m), C.return = f, f = C), s(f)) : n(f, C);
  }
  return N;
}
var g9 = B0(!0), T0 = B0(!1), C7 = z2(null), f7 = null, o9 = null, B8 = null;
function T8() {
  B8 = o9 = f7 = null;
}
function P8(e) {
  var t = C7.current;
  Y(C7), e._currentValue = t;
}
function X3(e, t, n) {
  for (; e !== null; ) {
    var r = e.alternate;
    if ((e.childLanes & t) !== t ? (e.childLanes |= t, r !== null && (r.childLanes |= t)) : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t), e === n) break;
    e = e.return;
  }
}
function d9(e, t) {
  f7 = e, B8 = o9 = null, e = e.dependencies, e !== null && e.firstContext !== null && (e.lanes & t && (x1 = !0), e.firstContext = null);
}
function R1(e) {
  var t = e._currentValue;
  if (B8 !== e) if (e = { context: e, memoizedValue: t, next: null }, o9 === null) {
    if (f7 === null) throw Error(x(308));
    o9 = e, f7.dependencies = { lanes: 0, firstContext: e };
  } else o9 = o9.next = e;
  return t;
}
var R2 = null;
function N8(e) {
  R2 === null ? R2 = [e] : R2.push(e);
}
function P0(e, t, n, r) {
  var l = t.interleaved;
  return l === null ? (n.next = n, N8(t)) : (n.next = l.next, l.next = n), t.interleaved = n, o2(e, r);
}
function o2(e, t) {
  e.lanes |= t;
  var n = e.alternate;
  for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null; ) e.childLanes |= t, n = e.alternate, n !== null && (n.childLanes |= t), n = e, e = e.return;
  return n.tag === 3 ? n.stateNode : null;
}
var f2 = !1;
function R8(e) {
  e.updateQueue = { baseState: e.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
}
function N0(e, t) {
  e = e.updateQueue, t.updateQueue === e && (t.updateQueue = { baseState: e.baseState, firstBaseUpdate: e.firstBaseUpdate, lastBaseUpdate: e.lastBaseUpdate, shared: e.shared, effects: e.effects });
}
function r2(e, t) {
  return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
}
function w2(e, t, n) {
  var r = e.updateQueue;
  if (r === null) return null;
  if (r = r.shared, V & 2) {
    var l = r.pending;
    return l === null ? t.next = t : (t.next = l.next, l.next = t), r.pending = t, o2(e, n);
  }
  return l = r.interleaved, l === null ? (t.next = t, N8(r)) : (t.next = l.next, l.next = t), r.interleaved = t, o2(e, n);
}
function Ge(e, t, n) {
  if (t = t.updateQueue, t !== null && (t = t.shared, (n & 4194240) !== 0)) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, y8(e, n);
  }
}
function O6(e, t) {
  var n = e.updateQueue, r = e.alternate;
  if (r !== null && (r = r.updateQueue, n === r)) {
    var l = null, i = null;
    if (n = n.firstBaseUpdate, n !== null) {
      do {
        var s = { eventTime: n.eventTime, lane: n.lane, tag: n.tag, payload: n.payload, callback: n.callback, next: null };
        i === null ? l = i = s : i = i.next = s, n = n.next;
      } while (n !== null);
      i === null ? l = i = t : i = i.next = t;
    } else l = i = t;
    n = { baseState: r.baseState, firstBaseUpdate: l, lastBaseUpdate: i, shared: r.shared, effects: r.effects }, e.updateQueue = n;
    return;
  }
  e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
}
function d7(e, t, n, r) {
  var l = e.updateQueue;
  f2 = !1;
  var i = l.firstBaseUpdate, s = l.lastBaseUpdate, u = l.shared.pending;
  if (u !== null) {
    l.shared.pending = null;
    var a = u, c = a.next;
    a.next = null, s === null ? i = c : s.next = c, s = a;
    var p = e.alternate;
    p !== null && (p = p.updateQueue, u = p.lastBaseUpdate, u !== s && (u === null ? p.firstBaseUpdate = c : u.next = c, p.lastBaseUpdate = a));
  }
  if (i !== null) {
    var h = l.baseState;
    s = 0, p = c = a = null, u = i;
    do {
      var v = u.lane, g = u.eventTime;
      if ((r & v) === v) {
        p !== null && (p = p.next = {
          eventTime: g,
          lane: 0,
          tag: u.tag,
          payload: u.payload,
          callback: u.callback,
          next: null
        });
        e: {
          var w = e, y = u;
          switch (v = t, g = n, y.tag) {
            case 1:
              if (w = y.payload, typeof w == "function") {
                h = w.call(g, h, v);
                break e;
              }
              h = w;
              break e;
            case 3:
              w.flags = w.flags & -65537 | 128;
            case 0:
              if (w = y.payload, v = typeof w == "function" ? w.call(g, h, v) : w, v == null) break e;
              h = _({}, h, v);
              break e;
            case 2:
              f2 = !0;
          }
        }
        u.callback !== null && u.lane !== 0 && (e.flags |= 64, v = l.effects, v === null ? l.effects = [u] : v.push(u));
      } else g = { eventTime: g, lane: v, tag: u.tag, payload: u.payload, callback: u.callback, next: null }, p === null ? (c = p = g, a = h) : p = p.next = g, s |= v;
      if (u = u.next, u === null) {
        if (u = l.shared.pending, u === null) break;
        v = u, u = v.next, v.next = null, l.lastBaseUpdate = v, l.shared.pending = null;
      }
    } while (!0);
    if (p === null && (a = h), l.baseState = a, l.firstBaseUpdate = c, l.lastBaseUpdate = p, t = l.shared.interleaved, t !== null) {
      l = t;
      do
        s |= l.lane, l = l.next;
      while (l !== t);
    } else i === null && (l.shared.lanes = 0);
    W2 |= s, e.lanes = s, e.memoizedState = h;
  }
}
function W6(e, t, n) {
  if (e = t.effects, t.effects = null, e !== null) for (t = 0; t < e.length; t++) {
    var r = e[t], l = r.callback;
    if (l !== null) {
      if (r.callback = null, r = n, typeof l != "function") throw Error(x(191, l));
      l.call(r);
    }
  }
}
var ve = {}, _1 = z2(ve), oe = z2(ve), se = z2(ve);
function Z2(e) {
  if (e === ve) throw Error(x(174));
  return e;
}
function Z8(e, t) {
  switch (X(se, t), X(oe, e), X(_1, ve), e = t.nodeType, e) {
    case 9:
    case 11:
      t = (t = t.documentElement) ? t.namespaceURI : E3(null, "");
      break;
    default:
      e = e === 8 ? t.parentNode : t, t = e.namespaceURI || null, e = e.tagName, t = E3(t, e);
  }
  Y(_1), X(_1, t);
}
function y9() {
  Y(_1), Y(oe), Y(se);
}
function R0(e) {
  Z2(se.current);
  var t = Z2(_1.current), n = E3(t, e.type);
  t !== n && (X(oe, e), X(_1, n));
}
function F8(e) {
  oe.current === e && (Y(_1), Y(oe));
}
var J = z2(0);
function p7(e) {
  for (var t = e; t !== null; ) {
    if (t.tag === 13) {
      var n = t.memoizedState;
      if (n !== null && (n = n.dehydrated, n === null || n.data === "$?" || n.data === "$!")) return t;
    } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
      if (t.flags & 128) return t;
    } else if (t.child !== null) {
      t.child.return = t, t = t.child;
      continue;
    }
    if (t === e) break;
    for (; t.sibling === null; ) {
      if (t.return === null || t.return === e) return null;
      t = t.return;
    }
    t.sibling.return = t.return, t = t.sibling;
  }
  return null;
}
var r3 = [];
function D8() {
  for (var e = 0; e < r3.length; e++) r3[e]._workInProgressVersionPrimary = null;
  r3.length = 0;
}
var Qe = u2.ReactCurrentDispatcher, l3 = u2.ReactCurrentBatchConfig, O2 = 0, b = null, l1 = null, o1 = null, h7 = !1, G9 = !1, ue = 0, Tn = 0;
function C1() {
  throw Error(x(321));
}
function V8(e, t) {
  if (t === null) return !1;
  for (var n = 0; n < t.length && n < e.length; n++) if (!H1(e[n], t[n])) return !1;
  return !0;
}
function U8(e, t, n, r, l, i) {
  if (O2 = i, b = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, Qe.current = e === null || e.memoizedState === null ? Zn : Fn, e = n(r, l), G9) {
    i = 0;
    do {
      if (G9 = !1, ue = 0, 25 <= i) throw Error(x(301));
      i += 1, o1 = l1 = null, t.updateQueue = null, Qe.current = Dn, e = n(r, l);
    } while (G9);
  }
  if (Qe.current = v7, t = l1 !== null && l1.next !== null, O2 = 0, o1 = l1 = b = null, h7 = !1, t) throw Error(x(300));
  return e;
}
function O8() {
  var e = ue !== 0;
  return ue = 0, e;
}
function q1() {
  var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  return o1 === null ? b.memoizedState = o1 = e : o1 = o1.next = e, o1;
}
function Z1() {
  if (l1 === null) {
    var e = b.alternate;
    e = e !== null ? e.memoizedState : null;
  } else e = l1.next;
  var t = o1 === null ? b.memoizedState : o1.next;
  if (t !== null) o1 = t, l1 = e;
  else {
    if (e === null) throw Error(x(310));
    l1 = e, e = { memoizedState: l1.memoizedState, baseState: l1.baseState, baseQueue: l1.baseQueue, queue: l1.queue, next: null }, o1 === null ? b.memoizedState = o1 = e : o1 = o1.next = e;
  }
  return o1;
}
function ae(e, t) {
  return typeof t == "function" ? t(e) : t;
}
function i3(e) {
  var t = Z1(), n = t.queue;
  if (n === null) throw Error(x(311));
  n.lastRenderedReducer = e;
  var r = l1, l = r.baseQueue, i = n.pending;
  if (i !== null) {
    if (l !== null) {
      var s = l.next;
      l.next = i.next, i.next = s;
    }
    r.baseQueue = l = i, n.pending = null;
  }
  if (l !== null) {
    i = l.next, r = r.baseState;
    var u = s = null, a = null, c = i;
    do {
      var p = c.lane;
      if ((O2 & p) === p) a !== null && (a = a.next = { lane: 0, action: c.action, hasEagerState: c.hasEagerState, eagerState: c.eagerState, next: null }), r = c.hasEagerState ? c.eagerState : e(r, c.action);
      else {
        var h = {
          lane: p,
          action: c.action,
          hasEagerState: c.hasEagerState,
          eagerState: c.eagerState,
          next: null
        };
        a === null ? (u = a = h, s = r) : a = a.next = h, b.lanes |= p, W2 |= p;
      }
      c = c.next;
    } while (c !== null && c !== i);
    a === null ? s = r : a.next = u, H1(r, t.memoizedState) || (x1 = !0), t.memoizedState = r, t.baseState = s, t.baseQueue = a, n.lastRenderedState = r;
  }
  if (e = n.interleaved, e !== null) {
    l = e;
    do
      i = l.lane, b.lanes |= i, W2 |= i, l = l.next;
    while (l !== e);
  } else l === null && (n.lanes = 0);
  return [t.memoizedState, n.dispatch];
}
function o3(e) {
  var t = Z1(), n = t.queue;
  if (n === null) throw Error(x(311));
  n.lastRenderedReducer = e;
  var r = n.dispatch, l = n.pending, i = t.memoizedState;
  if (l !== null) {
    n.pending = null;
    var s = l = l.next;
    do
      i = e(i, s.action), s = s.next;
    while (s !== l);
    H1(i, t.memoizedState) || (x1 = !0), t.memoizedState = i, t.baseQueue === null && (t.baseState = i), n.lastRenderedState = i;
  }
  return [i, r];
}
function Z0() {
}
function F0(e, t) {
  var n = b, r = Z1(), l = t(), i = !H1(r.memoizedState, l);
  if (i && (r.memoizedState = l, x1 = !0), r = r.queue, W8(U0.bind(null, n, r, e), [e]), r.getSnapshot !== t || i || o1 !== null && o1.memoizedState.tag & 1) {
    if (n.flags |= 2048, ce(9, V0.bind(null, n, r, l, t), void 0, null), s1 === null) throw Error(x(349));
    O2 & 30 || D0(n, t, l);
  }
  return l;
}
function D0(e, t, n) {
  e.flags |= 16384, e = { getSnapshot: t, value: n }, t = b.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, b.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
}
function V0(e, t, n, r) {
  t.value = n, t.getSnapshot = r, O0(t) && W0(e);
}
function U0(e, t, n) {
  return n(function() {
    O0(t) && W0(e);
  });
}
function O0(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !H1(e, n);
  } catch {
    return !0;
  }
}
function W0(e) {
  var t = o2(e, 1);
  t !== null && W1(t, e, 1, -1);
}
function H6(e) {
  var t = q1();
  return typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: ae, lastRenderedState: e }, t.queue = e, e = e.dispatch = Rn.bind(null, b, e), [t.memoizedState, e];
}
function ce(e, t, n, r) {
  return e = { tag: e, create: t, destroy: n, deps: r, next: null }, t = b.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, b.updateQueue = t, t.lastEffect = e.next = e) : (n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e)), e;
}
function H0() {
  return Z1().memoizedState;
}
function Ye(e, t, n, r) {
  var l = q1();
  b.flags |= e, l.memoizedState = ce(1 | t, n, void 0, r === void 0 ? null : r);
}
function A7(e, t, n, r) {
  var l = Z1();
  r = r === void 0 ? null : r;
  var i = void 0;
  if (l1 !== null) {
    var s = l1.memoizedState;
    if (i = s.destroy, r !== null && V8(r, s.deps)) {
      l.memoizedState = ce(t, n, i, r);
      return;
    }
  }
  b.flags |= e, l.memoizedState = ce(1 | t, n, i, r);
}
function I6(e, t) {
  return Ye(8390656, 8, e, t);
}
function W8(e, t) {
  return A7(2048, 8, e, t);
}
function I0(e, t) {
  return A7(4, 2, e, t);
}
function X0(e, t) {
  return A7(4, 4, e, t);
}
function G0(e, t) {
  if (typeof t == "function") return e = e(), t(e), function() {
    t(null);
  };
  if (t != null) return e = e(), t.current = e, function() {
    t.current = null;
  };
}
function Q0(e, t, n) {
  return n = n != null ? n.concat([e]) : null, A7(4, 4, G0.bind(null, t, e), n);
}
function H8() {
}
function Y0(e, t) {
  var n = Z1();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && V8(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
}
function q0(e, t) {
  var n = Z1();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && V8(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
}
function K0(e, t, n) {
  return O2 & 21 ? (H1(n, t) || (n = e0(), b.lanes |= n, W2 |= n, e.baseState = !0), t) : (e.baseState && (e.baseState = !1, x1 = !0), e.memoizedState = n);
}
function Pn(e, t) {
  var n = W;
  W = n !== 0 && 4 > n ? n : 4, e(!0);
  var r = l3.transition;
  l3.transition = {};
  try {
    e(!1), t();
  } finally {
    W = n, l3.transition = r;
  }
}
function J0() {
  return Z1().memoizedState;
}
function Nn(e, t, n) {
  var r = S2(e);
  if (n = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }, b0(e)) _0(t, n);
  else if (n = P0(e, t, n, r), n !== null) {
    var l = v1();
    W1(n, e, r, l), $0(n, t, r);
  }
}
function Rn(e, t, n) {
  var r = S2(e), l = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null };
  if (b0(e)) _0(t, l);
  else {
    var i = e.alternate;
    if (e.lanes === 0 && (i === null || i.lanes === 0) && (i = t.lastRenderedReducer, i !== null)) try {
      var s = t.lastRenderedState, u = i(s, n);
      if (l.hasEagerState = !0, l.eagerState = u, H1(u, s)) {
        var a = t.interleaved;
        a === null ? (l.next = l, N8(t)) : (l.next = a.next, a.next = l), t.interleaved = l;
        return;
      }
    } catch {
    } finally {
    }
    n = P0(e, t, l, r), n !== null && (l = v1(), W1(n, e, r, l), $0(n, t, r));
  }
}
function b0(e) {
  var t = e.alternate;
  return e === b || t !== null && t === b;
}
function _0(e, t) {
  G9 = h7 = !0;
  var n = e.pending;
  n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
}
function $0(e, t, n) {
  if (n & 4194240) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, y8(e, n);
  }
}
var v7 = { readContext: R1, useCallback: C1, useContext: C1, useEffect: C1, useImperativeHandle: C1, useInsertionEffect: C1, useLayoutEffect: C1, useMemo: C1, useReducer: C1, useRef: C1, useState: C1, useDebugValue: C1, useDeferredValue: C1, useTransition: C1, useMutableSource: C1, useSyncExternalStore: C1, useId: C1, unstable_isNewReconciler: !1 }, Zn = { readContext: R1, useCallback: function(e, t) {
  return q1().memoizedState = [e, t === void 0 ? null : t], e;
}, useContext: R1, useEffect: I6, useImperativeHandle: function(e, t, n) {
  return n = n != null ? n.concat([e]) : null, Ye(
    4194308,
    4,
    G0.bind(null, t, e),
    n
  );
}, useLayoutEffect: function(e, t) {
  return Ye(4194308, 4, e, t);
}, useInsertionEffect: function(e, t) {
  return Ye(4, 2, e, t);
}, useMemo: function(e, t) {
  var n = q1();
  return t = t === void 0 ? null : t, e = e(), n.memoizedState = [e, t], e;
}, useReducer: function(e, t, n) {
  var r = q1();
  return t = n !== void 0 ? n(t) : t, r.memoizedState = r.baseState = t, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: e, lastRenderedState: t }, r.queue = e, e = e.dispatch = Nn.bind(null, b, e), [r.memoizedState, e];
}, useRef: function(e) {
  var t = q1();
  return e = { current: e }, t.memoizedState = e;
}, useState: H6, useDebugValue: H8, useDeferredValue: function(e) {
  return q1().memoizedState = e;
}, useTransition: function() {
  var e = H6(!1), t = e[0];
  return e = Pn.bind(null, e[1]), q1().memoizedState = e, [t, e];
}, useMutableSource: function() {
}, useSyncExternalStore: function(e, t, n) {
  var r = b, l = q1();
  if (K) {
    if (n === void 0) throw Error(x(407));
    n = n();
  } else {
    if (n = t(), s1 === null) throw Error(x(349));
    O2 & 30 || D0(r, t, n);
  }
  l.memoizedState = n;
  var i = { value: n, getSnapshot: t };
  return l.queue = i, I6(U0.bind(
    null,
    r,
    i,
    e
  ), [e]), r.flags |= 2048, ce(9, V0.bind(null, r, i, n, t), void 0, null), n;
}, useId: function() {
  var e = q1(), t = s1.identifierPrefix;
  if (K) {
    var n = n2, r = t2;
    n = (r & ~(1 << 32 - O1(r) - 1)).toString(32) + n, t = ":" + t + "R" + n, n = ue++, 0 < n && (t += "H" + n.toString(32)), t += ":";
  } else n = Tn++, t = ":" + t + "r" + n.toString(32) + ":";
  return e.memoizedState = t;
}, unstable_isNewReconciler: !1 }, Fn = {
  readContext: R1,
  useCallback: Y0,
  useContext: R1,
  useEffect: W8,
  useImperativeHandle: Q0,
  useInsertionEffect: I0,
  useLayoutEffect: X0,
  useMemo: q0,
  useReducer: i3,
  useRef: H0,
  useState: function() {
    return i3(ae);
  },
  useDebugValue: H8,
  useDeferredValue: function(e) {
    var t = Z1();
    return K0(t, l1.memoizedState, e);
  },
  useTransition: function() {
    var e = i3(ae)[0], t = Z1().memoizedState;
    return [e, t];
  },
  useMutableSource: Z0,
  useSyncExternalStore: F0,
  useId: J0,
  unstable_isNewReconciler: !1
}, Dn = { readContext: R1, useCallback: Y0, useContext: R1, useEffect: W8, useImperativeHandle: Q0, useInsertionEffect: I0, useLayoutEffect: X0, useMemo: q0, useReducer: o3, useRef: H0, useState: function() {
  return o3(ae);
}, useDebugValue: H8, useDeferredValue: function(e) {
  var t = Z1();
  return l1 === null ? t.memoizedState = e : K0(t, l1.memoizedState, e);
}, useTransition: function() {
  var e = o3(ae)[0], t = Z1().memoizedState;
  return [e, t];
}, useMutableSource: Z0, useSyncExternalStore: F0, useId: J0, unstable_isNewReconciler: !1 };
function D1(e, t) {
  if (e && e.defaultProps) {
    t = _({}, t), e = e.defaultProps;
    for (var n in e) t[n] === void 0 && (t[n] = e[n]);
    return t;
  }
  return t;
}
function G3(e, t, n, r) {
  t = e.memoizedState, n = n(r, t), n = n == null ? t : _({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
}
var B7 = { isMounted: function(e) {
  return (e = e._reactInternals) ? X2(e) === e : !1;
}, enqueueSetState: function(e, t, n) {
  e = e._reactInternals;
  var r = v1(), l = S2(e), i = r2(r, l);
  i.payload = t, n != null && (i.callback = n), t = w2(e, i, l), t !== null && (W1(t, e, l, r), Ge(t, e, l));
}, enqueueReplaceState: function(e, t, n) {
  e = e._reactInternals;
  var r = v1(), l = S2(e), i = r2(r, l);
  i.tag = 1, i.payload = t, n != null && (i.callback = n), t = w2(e, i, l), t !== null && (W1(t, e, l, r), Ge(t, e, l));
}, enqueueForceUpdate: function(e, t) {
  e = e._reactInternals;
  var n = v1(), r = S2(e), l = r2(n, r);
  l.tag = 2, t != null && (l.callback = t), t = w2(e, l, r), t !== null && (W1(t, e, r, n), Ge(t, e, r));
} };
function X6(e, t, n, r, l, i, s) {
  return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, i, s) : t.prototype && t.prototype.isPureReactComponent ? !ne(n, r) || !ne(l, i) : !0;
}
function e4(e, t, n) {
  var r = !1, l = L2, i = t.contextType;
  return typeof i == "object" && i !== null ? i = R1(i) : (l = k1(t) ? V2 : p1.current, r = t.contextTypes, i = (r = r != null) ? v9(e, l) : L2), t = new t(n, i), e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null, t.updater = B7, e.stateNode = t, t._reactInternals = e, r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = l, e.__reactInternalMemoizedMaskedChildContext = i), t;
}
function G6(e, t, n, r) {
  e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && B7.enqueueReplaceState(t, t.state, null);
}
function Q3(e, t, n, r) {
  var l = e.stateNode;
  l.props = n, l.state = e.memoizedState, l.refs = {}, R8(e);
  var i = t.contextType;
  typeof i == "object" && i !== null ? l.context = R1(i) : (i = k1(t) ? V2 : p1.current, l.context = v9(e, i)), l.state = e.memoizedState, i = t.getDerivedStateFromProps, typeof i == "function" && (G3(e, t, i, n), l.state = e.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof l.getSnapshotBeforeUpdate == "function" || typeof l.UNSAFE_componentWillMount != "function" && typeof l.componentWillMount != "function" || (t = l.state, typeof l.componentWillMount == "function" && l.componentWillMount(), typeof l.UNSAFE_componentWillMount == "function" && l.UNSAFE_componentWillMount(), t !== l.state && B7.enqueueReplaceState(l, l.state, null), d7(e, n, l, r), l.state = e.memoizedState), typeof l.componentDidMount == "function" && (e.flags |= 4194308);
}
function x9(e, t) {
  try {
    var n = "", r = t;
    do
      n += ct(r), r = r.return;
    while (r);
    var l = n;
  } catch (i) {
    l = \`
Error generating stack: \` + i.message + \`
\` + i.stack;
  }
  return { value: e, source: t, stack: l, digest: null };
}
function s3(e, t, n) {
  return { value: e, source: null, stack: n ?? null, digest: t ?? null };
}
function Y3(e, t) {
  try {
    console.error(t.value);
  } catch (n) {
    setTimeout(function() {
      throw n;
    });
  }
}
var Vn = typeof WeakMap == "function" ? WeakMap : Map;
function t4(e, t, n) {
  n = r2(-1, n), n.tag = 3, n.payload = { element: null };
  var r = t.value;
  return n.callback = function() {
    g7 || (g7 = !0, r8 = r), Y3(e, t);
  }, n;
}
function n4(e, t, n) {
  n = r2(-1, n), n.tag = 3;
  var r = e.type.getDerivedStateFromError;
  if (typeof r == "function") {
    var l = t.value;
    n.payload = function() {
      return r(l);
    }, n.callback = function() {
      Y3(e, t);
    };
  }
  var i = e.stateNode;
  return i !== null && typeof i.componentDidCatch == "function" && (n.callback = function() {
    Y3(e, t), typeof r != "function" && (k2 === null ? k2 = /* @__PURE__ */ new Set([this]) : k2.add(this));
    var s = t.stack;
    this.componentDidCatch(t.value, { componentStack: s !== null ? s : "" });
  }), n;
}
function Q6(e, t, n) {
  var r = e.pingCache;
  if (r === null) {
    r = e.pingCache = new Vn();
    var l = /* @__PURE__ */ new Set();
    r.set(t, l);
  } else l = r.get(t), l === void 0 && (l = /* @__PURE__ */ new Set(), r.set(t, l));
  l.has(n) || (l.add(n), e = _n.bind(null, e, t, n), t.then(e, e));
}
function Y6(e) {
  do {
    var t;
    if ((t = e.tag === 13) && (t = e.memoizedState, t = t !== null ? t.dehydrated !== null : !0), t) return e;
    e = e.return;
  } while (e !== null);
  return null;
}
function q6(e, t, n, r, l) {
  return e.mode & 1 ? (e.flags |= 65536, e.lanes = l, e) : (e === t ? e.flags |= 65536 : (e.flags |= 128, n.flags |= 131072, n.flags &= -52805, n.tag === 1 && (n.alternate === null ? n.tag = 17 : (t = r2(-1, 1), t.tag = 2, w2(n, t, 1))), n.lanes |= 1), e);
}
var Un = u2.ReactCurrentOwner, x1 = !1;
function h1(e, t, n, r) {
  t.child = e === null ? T0(t, null, n, r) : g9(t, e.child, n, r);
}
function K6(e, t, n, r, l) {
  n = n.render;
  var i = t.ref;
  return d9(t, l), r = U8(e, t, n, r, i, l), n = O8(), e !== null && !x1 ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~l, s2(e, t, l)) : (K && n && M8(t), t.flags |= 1, h1(e, t, r, l), t.child);
}
function J6(e, t, n, r, l) {
  if (e === null) {
    var i = n.type;
    return typeof i == "function" && !J8(i) && i.defaultProps === void 0 && n.compare === null && n.defaultProps === void 0 ? (t.tag = 15, t.type = i, r4(e, t, i, r, l)) : (e = be(n.type, null, r, t, t.mode, l), e.ref = t.ref, e.return = t, t.child = e);
  }
  if (i = e.child, !(e.lanes & l)) {
    var s = i.memoizedProps;
    if (n = n.compare, n = n !== null ? n : ne, n(s, r) && e.ref === t.ref) return s2(e, t, l);
  }
  return t.flags |= 1, e = E2(i, r), e.ref = t.ref, e.return = t, t.child = e;
}
function r4(e, t, n, r, l) {
  if (e !== null) {
    var i = e.memoizedProps;
    if (ne(i, r) && e.ref === t.ref) if (x1 = !1, t.pendingProps = r = i, (e.lanes & l) !== 0) e.flags & 131072 && (x1 = !0);
    else return t.lanes = e.lanes, s2(e, t, l);
  }
  return q3(e, t, n, r, l);
}
function l4(e, t, n) {
  var r = t.pendingProps, l = r.children, i = e !== null ? e.memoizedState : null;
  if (r.mode === "hidden") if (!(t.mode & 1)) t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, X(u9, E1), E1 |= n;
  else {
    if (!(n & 1073741824)) return e = i !== null ? i.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }, t.updateQueue = null, X(u9, E1), E1 |= e, null;
    t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, r = i !== null ? i.baseLanes : n, X(u9, E1), E1 |= r;
  }
  else i !== null ? (r = i.baseLanes | n, t.memoizedState = null) : r = n, X(u9, E1), E1 |= r;
  return h1(e, t, l, n), t.child;
}
function i4(e, t) {
  var n = t.ref;
  (e === null && n !== null || e !== null && e.ref !== n) && (t.flags |= 512, t.flags |= 2097152);
}
function q3(e, t, n, r, l) {
  var i = k1(n) ? V2 : p1.current;
  return i = v9(t, i), d9(t, l), n = U8(e, t, n, r, i, l), r = O8(), e !== null && !x1 ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~l, s2(e, t, l)) : (K && r && M8(t), t.flags |= 1, h1(e, t, n, l), t.child);
}
function b6(e, t, n, r, l) {
  if (k1(n)) {
    var i = !0;
    u7(t);
  } else i = !1;
  if (d9(t, l), t.stateNode === null) qe(e, t), e4(t, n, r), Q3(t, n, r, l), r = !0;
  else if (e === null) {
    var s = t.stateNode, u = t.memoizedProps;
    s.props = u;
    var a = s.context, c = n.contextType;
    typeof c == "object" && c !== null ? c = R1(c) : (c = k1(n) ? V2 : p1.current, c = v9(t, c));
    var p = n.getDerivedStateFromProps, h = typeof p == "function" || typeof s.getSnapshotBeforeUpdate == "function";
    h || typeof s.UNSAFE_componentWillReceiveProps != "function" && typeof s.componentWillReceiveProps != "function" || (u !== r || a !== c) && G6(t, s, r, c), f2 = !1;
    var v = t.memoizedState;
    s.state = v, d7(t, r, s, l), a = t.memoizedState, u !== r || v !== a || w1.current || f2 ? (typeof p == "function" && (G3(t, n, p, r), a = t.memoizedState), (u = f2 || X6(t, n, u, r, v, a, c)) ? (h || typeof s.UNSAFE_componentWillMount != "function" && typeof s.componentWillMount != "function" || (typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount()), typeof s.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof s.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = a), s.props = r, s.state = a, s.context = c, r = u) : (typeof s.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
  } else {
    s = t.stateNode, N0(e, t), u = t.memoizedProps, c = t.type === t.elementType ? u : D1(t.type, u), s.props = c, h = t.pendingProps, v = s.context, a = n.contextType, typeof a == "object" && a !== null ? a = R1(a) : (a = k1(n) ? V2 : p1.current, a = v9(t, a));
    var g = n.getDerivedStateFromProps;
    (p = typeof g == "function" || typeof s.getSnapshotBeforeUpdate == "function") || typeof s.UNSAFE_componentWillReceiveProps != "function" && typeof s.componentWillReceiveProps != "function" || (u !== h || v !== a) && G6(t, s, r, a), f2 = !1, v = t.memoizedState, s.state = v, d7(t, r, s, l);
    var w = t.memoizedState;
    u !== h || v !== w || w1.current || f2 ? (typeof g == "function" && (G3(t, n, g, r), w = t.memoizedState), (c = f2 || X6(t, n, c, r, v, w, a) || !1) ? (p || typeof s.UNSAFE_componentWillUpdate != "function" && typeof s.componentWillUpdate != "function" || (typeof s.componentWillUpdate == "function" && s.componentWillUpdate(r, w, a), typeof s.UNSAFE_componentWillUpdate == "function" && s.UNSAFE_componentWillUpdate(r, w, a)), typeof s.componentDidUpdate == "function" && (t.flags |= 4), typeof s.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof s.componentDidUpdate != "function" || u === e.memoizedProps && v === e.memoizedState || (t.flags |= 4), typeof s.getSnapshotBeforeUpdate != "function" || u === e.memoizedProps && v === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = w), s.props = r, s.state = w, s.context = a, r = c) : (typeof s.componentDidUpdate != "function" || u === e.memoizedProps && v === e.memoizedState || (t.flags |= 4), typeof s.getSnapshotBeforeUpdate != "function" || u === e.memoizedProps && v === e.memoizedState || (t.flags |= 1024), r = !1);
  }
  return K3(e, t, n, r, i, l);
}
function K3(e, t, n, r, l, i) {
  i4(e, t);
  var s = (t.flags & 128) !== 0;
  if (!r && !s) return l && F6(t, n, !1), s2(e, t, i);
  r = t.stateNode, Un.current = t;
  var u = s && typeof n.getDerivedStateFromError != "function" ? null : r.render();
  return t.flags |= 1, e !== null && s ? (t.child = g9(t, e.child, null, i), t.child = g9(t, null, u, i)) : h1(e, t, u, i), t.memoizedState = r.state, l && F6(t, n, !0), t.child;
}
function o4(e) {
  var t = e.stateNode;
  t.pendingContext ? Z6(e, t.pendingContext, t.pendingContext !== t.context) : t.context && Z6(e, t.context, !1), Z8(e, t.containerInfo);
}
function _6(e, t, n, r, l) {
  return m9(), A8(l), t.flags |= 256, h1(e, t, n, r), t.child;
}
var J3 = { dehydrated: null, treeContext: null, retryLane: 0 };
function b3(e) {
  return { baseLanes: e, cachePool: null, transitions: null };
}
function s4(e, t, n) {
  var r = t.pendingProps, l = J.current, i = !1, s = (t.flags & 128) !== 0, u;
  if ((u = s) || (u = e !== null && e.memoizedState === null ? !1 : (l & 2) !== 0), u ? (i = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (l |= 1), X(J, l & 1), e === null)
    return I3(t), e = t.memoizedState, e !== null && (e = e.dehydrated, e !== null) ? (t.mode & 1 ? e.data === "$!" ? t.lanes = 8 : t.lanes = 1073741824 : t.lanes = 1, null) : (s = r.children, e = r.fallback, i ? (r = t.mode, i = t.child, s = { mode: "hidden", children: s }, !(r & 1) && i !== null ? (i.childLanes = 0, i.pendingProps = s) : i = N7(s, r, 0, null), e = D2(e, r, n, null), i.return = t, e.return = t, i.sibling = e, t.child = i, t.child.memoizedState = b3(n), t.memoizedState = J3, e) : I8(t, s));
  if (l = e.memoizedState, l !== null && (u = l.dehydrated, u !== null)) return On(e, t, s, r, u, l, n);
  if (i) {
    i = r.fallback, s = t.mode, l = e.child, u = l.sibling;
    var a = { mode: "hidden", children: r.children };
    return !(s & 1) && t.child !== l ? (r = t.child, r.childLanes = 0, r.pendingProps = a, t.deletions = null) : (r = E2(l, a), r.subtreeFlags = l.subtreeFlags & 14680064), u !== null ? i = E2(u, i) : (i = D2(i, s, n, null), i.flags |= 2), i.return = t, r.return = t, r.sibling = i, t.child = r, r = i, i = t.child, s = e.child.memoizedState, s = s === null ? b3(n) : { baseLanes: s.baseLanes | n, cachePool: null, transitions: s.transitions }, i.memoizedState = s, i.childLanes = e.childLanes & ~n, t.memoizedState = J3, r;
  }
  return i = e.child, e = i.sibling, r = E2(i, { mode: "visible", children: r.children }), !(t.mode & 1) && (r.lanes = n), r.return = t, r.sibling = null, e !== null && (n = t.deletions, n === null ? (t.deletions = [e], t.flags |= 16) : n.push(e)), t.child = r, t.memoizedState = null, r;
}
function I8(e, t) {
  return t = N7({ mode: "visible", children: t }, e.mode, 0, null), t.return = e, e.child = t;
}
function Be(e, t, n, r) {
  return r !== null && A8(r), g9(t, e.child, null, n), e = I8(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
}
function On(e, t, n, r, l, i, s) {
  if (n)
    return t.flags & 256 ? (t.flags &= -257, r = s3(Error(x(422))), Be(e, t, s, r)) : t.memoizedState !== null ? (t.child = e.child, t.flags |= 128, null) : (i = r.fallback, l = t.mode, r = N7({ mode: "visible", children: r.children }, l, 0, null), i = D2(i, l, s, null), i.flags |= 2, r.return = t, i.return = t, r.sibling = i, t.child = r, t.mode & 1 && g9(t, e.child, null, s), t.child.memoizedState = b3(s), t.memoizedState = J3, i);
  if (!(t.mode & 1)) return Be(e, t, s, null);
  if (l.data === "$!") {
    if (r = l.nextSibling && l.nextSibling.dataset, r) var u = r.dgst;
    return r = u, i = Error(x(419)), r = s3(i, r, void 0), Be(e, t, s, r);
  }
  if (u = (s & e.childLanes) !== 0, x1 || u) {
    if (r = s1, r !== null) {
      switch (s & -s) {
        case 4:
          l = 2;
          break;
        case 16:
          l = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          l = 32;
          break;
        case 536870912:
          l = 268435456;
          break;
        default:
          l = 0;
      }
      l = l & (r.suspendedLanes | s) ? 0 : l, l !== 0 && l !== i.retryLane && (i.retryLane = l, o2(e, l), W1(r, e, l, -1));
    }
    return K8(), r = s3(Error(x(421))), Be(e, t, s, r);
  }
  return l.data === "$?" ? (t.flags |= 128, t.child = e.child, t = $n.bind(null, e), l._reactRetry = t, null) : (e = i.treeContext, j1 = x2(l.nextSibling), L1 = t, K = !0, U1 = null, e !== null && (B1[T1++] = t2, B1[T1++] = n2, B1[T1++] = U2, t2 = e.id, n2 = e.overflow, U2 = t), t = I8(t, r.children), t.flags |= 4096, t);
}
function $6(e, t, n) {
  e.lanes |= t;
  var r = e.alternate;
  r !== null && (r.lanes |= t), X3(e.return, t, n);
}
function u3(e, t, n, r, l) {
  var i = e.memoizedState;
  i === null ? e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: r, tail: n, tailMode: l } : (i.isBackwards = t, i.rendering = null, i.renderingStartTime = 0, i.last = r, i.tail = n, i.tailMode = l);
}
function u4(e, t, n) {
  var r = t.pendingProps, l = r.revealOrder, i = r.tail;
  if (h1(e, t, r.children, n), r = J.current, r & 2) r = r & 1 | 2, t.flags |= 128;
  else {
    if (e !== null && e.flags & 128) e: for (e = t.child; e !== null; ) {
      if (e.tag === 13) e.memoizedState !== null && $6(e, n, t);
      else if (e.tag === 19) $6(e, n, t);
      else if (e.child !== null) {
        e.child.return = e, e = e.child;
        continue;
      }
      if (e === t) break e;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) break e;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
    r &= 1;
  }
  if (X(J, r), !(t.mode & 1)) t.memoizedState = null;
  else switch (l) {
    case "forwards":
      for (n = t.child, l = null; n !== null; ) e = n.alternate, e !== null && p7(e) === null && (l = n), n = n.sibling;
      n = l, n === null ? (l = t.child, t.child = null) : (l = n.sibling, n.sibling = null), u3(t, !1, l, n, i);
      break;
    case "backwards":
      for (n = null, l = t.child, t.child = null; l !== null; ) {
        if (e = l.alternate, e !== null && p7(e) === null) {
          t.child = l;
          break;
        }
        e = l.sibling, l.sibling = n, n = l, l = e;
      }
      u3(t, !0, n, null, i);
      break;
    case "together":
      u3(t, !1, null, null, void 0);
      break;
    default:
      t.memoizedState = null;
  }
  return t.child;
}
function qe(e, t) {
  !(t.mode & 1) && e !== null && (e.alternate = null, t.alternate = null, t.flags |= 2);
}
function s2(e, t, n) {
  if (e !== null && (t.dependencies = e.dependencies), W2 |= t.lanes, !(n & t.childLanes)) return null;
  if (e !== null && t.child !== e.child) throw Error(x(153));
  if (t.child !== null) {
    for (e = t.child, n = E2(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; ) e = e.sibling, n = n.sibling = E2(e, e.pendingProps), n.return = t;
    n.sibling = null;
  }
  return t.child;
}
function Wn(e, t, n) {
  switch (t.tag) {
    case 3:
      o4(t), m9();
      break;
    case 5:
      R0(t);
      break;
    case 1:
      k1(t.type) && u7(t);
      break;
    case 4:
      Z8(t, t.stateNode.containerInfo);
      break;
    case 10:
      var r = t.type._context, l = t.memoizedProps.value;
      X(C7, r._currentValue), r._currentValue = l;
      break;
    case 13:
      if (r = t.memoizedState, r !== null)
        return r.dehydrated !== null ? (X(J, J.current & 1), t.flags |= 128, null) : n & t.child.childLanes ? s4(e, t, n) : (X(J, J.current & 1), e = s2(e, t, n), e !== null ? e.sibling : null);
      X(J, J.current & 1);
      break;
    case 19:
      if (r = (n & t.childLanes) !== 0, e.flags & 128) {
        if (r) return u4(e, t, n);
        t.flags |= 128;
      }
      if (l = t.memoizedState, l !== null && (l.rendering = null, l.tail = null, l.lastEffect = null), X(J, J.current), r) break;
      return null;
    case 22:
    case 23:
      return t.lanes = 0, l4(e, t, n);
  }
  return s2(e, t, n);
}
var a4, _3, c4, C4;
a4 = function(e, t) {
  for (var n = t.child; n !== null; ) {
    if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);
    else if (n.tag !== 4 && n.child !== null) {
      n.child.return = n, n = n.child;
      continue;
    }
    if (n === t) break;
    for (; n.sibling === null; ) {
      if (n.return === null || n.return === t) return;
      n = n.return;
    }
    n.sibling.return = n.return, n = n.sibling;
  }
};
_3 = function() {
};
c4 = function(e, t, n, r) {
  var l = e.memoizedProps;
  if (l !== r) {
    e = t.stateNode, Z2(_1.current);
    var i = null;
    switch (n) {
      case "input":
        l = x3(e, l), r = x3(e, r), i = [];
        break;
      case "select":
        l = _({}, l, { value: void 0 }), r = _({}, r, { value: void 0 }), i = [];
        break;
      case "textarea":
        l = S3(e, l), r = S3(e, r), i = [];
        break;
      default:
        typeof l.onClick != "function" && typeof r.onClick == "function" && (e.onclick = o7);
    }
    j3(n, r);
    var s;
    n = null;
    for (c in l) if (!r.hasOwnProperty(c) && l.hasOwnProperty(c) && l[c] != null) if (c === "style") {
      var u = l[c];
      for (s in u) u.hasOwnProperty(s) && (n || (n = {}), n[s] = "");
    } else c !== "dangerouslySetInnerHTML" && c !== "children" && c !== "suppressContentEditableWarning" && c !== "suppressHydrationWarning" && c !== "autoFocus" && (K9.hasOwnProperty(c) ? i || (i = []) : (i = i || []).push(c, null));
    for (c in r) {
      var a = r[c];
      if (u = l != null ? l[c] : void 0, r.hasOwnProperty(c) && a !== u && (a != null || u != null)) if (c === "style") if (u) {
        for (s in u) !u.hasOwnProperty(s) || a && a.hasOwnProperty(s) || (n || (n = {}), n[s] = "");
        for (s in a) a.hasOwnProperty(s) && u[s] !== a[s] && (n || (n = {}), n[s] = a[s]);
      } else n || (i || (i = []), i.push(
        c,
        n
      )), n = a;
      else c === "dangerouslySetInnerHTML" ? (a = a ? a.__html : void 0, u = u ? u.__html : void 0, a != null && u !== a && (i = i || []).push(c, a)) : c === "children" ? typeof a != "string" && typeof a != "number" || (i = i || []).push(c, "" + a) : c !== "suppressContentEditableWarning" && c !== "suppressHydrationWarning" && (K9.hasOwnProperty(c) ? (a != null && c === "onScroll" && Q("scroll", e), i || u === a || (i = [])) : (i = i || []).push(c, a));
    }
    n && (i = i || []).push("style", n);
    var c = i;
    (t.updateQueue = c) && (t.flags |= 4);
  }
};
C4 = function(e, t, n, r) {
  n !== r && (t.flags |= 4);
};
function P9(e, t) {
  if (!K) switch (e.tailMode) {
    case "hidden":
      t = e.tail;
      for (var n = null; t !== null; ) t.alternate !== null && (n = t), t = t.sibling;
      n === null ? e.tail = null : n.sibling = null;
      break;
    case "collapsed":
      n = e.tail;
      for (var r = null; n !== null; ) n.alternate !== null && (r = n), n = n.sibling;
      r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
  }
}
function f1(e) {
  var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
  if (t) for (var l = e.child; l !== null; ) n |= l.lanes | l.childLanes, r |= l.subtreeFlags & 14680064, r |= l.flags & 14680064, l.return = e, l = l.sibling;
  else for (l = e.child; l !== null; ) n |= l.lanes | l.childLanes, r |= l.subtreeFlags, r |= l.flags, l.return = e, l = l.sibling;
  return e.subtreeFlags |= r, e.childLanes = n, t;
}
function Hn(e, t, n) {
  var r = t.pendingProps;
  switch (z8(t), t.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return f1(t), null;
    case 1:
      return k1(t.type) && s7(), f1(t), null;
    case 3:
      return r = t.stateNode, y9(), Y(w1), Y(p1), D8(), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (e === null || e.child === null) && (ze(t) ? t.flags |= 4 : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, U1 !== null && (o8(U1), U1 = null))), _3(e, t), f1(t), null;
    case 5:
      F8(t);
      var l = Z2(se.current);
      if (n = t.type, e !== null && t.stateNode != null) c4(e, t, n, r, l), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
      else {
        if (!r) {
          if (t.stateNode === null) throw Error(x(166));
          return f1(t), null;
        }
        if (e = Z2(_1.current), ze(t)) {
          r = t.stateNode, n = t.type;
          var i = t.memoizedProps;
          switch (r[J1] = t, r[ie] = i, e = (t.mode & 1) !== 0, n) {
            case "dialog":
              Q("cancel", r), Q("close", r);
              break;
            case "iframe":
            case "object":
            case "embed":
              Q("load", r);
              break;
            case "video":
            case "audio":
              for (l = 0; l < U9.length; l++) Q(U9[l], r);
              break;
            case "source":
              Q("error", r);
              break;
            case "img":
            case "image":
            case "link":
              Q(
                "error",
                r
              ), Q("load", r);
              break;
            case "details":
              Q("toggle", r);
              break;
            case "input":
              u6(r, i), Q("invalid", r);
              break;
            case "select":
              r._wrapperState = { wasMultiple: !!i.multiple }, Q("invalid", r);
              break;
            case "textarea":
              c6(r, i), Q("invalid", r);
          }
          j3(n, i), l = null;
          for (var s in i) if (i.hasOwnProperty(s)) {
            var u = i[s];
            s === "children" ? typeof u == "string" ? r.textContent !== u && (i.suppressHydrationWarning !== !0 && Me(r.textContent, u, e), l = ["children", u]) : typeof u == "number" && r.textContent !== "" + u && (i.suppressHydrationWarning !== !0 && Me(
              r.textContent,
              u,
              e
            ), l = ["children", "" + u]) : K9.hasOwnProperty(s) && u != null && s === "onScroll" && Q("scroll", r);
          }
          switch (n) {
            case "input":
              ye(r), a6(r, i, !0);
              break;
            case "textarea":
              ye(r), C6(r);
              break;
            case "select":
            case "option":
              break;
            default:
              typeof i.onClick == "function" && (r.onclick = o7);
          }
          r = l, t.updateQueue = r, r !== null && (t.flags |= 4);
        } else {
          s = l.nodeType === 9 ? l : l.ownerDocument, e === "http://www.w3.org/1999/xhtml" && (e = U5(n)), e === "http://www.w3.org/1999/xhtml" ? n === "script" ? (e = s.createElement("div"), e.innerHTML = "<script><\\/script>", e = e.removeChild(e.firstChild)) : typeof r.is == "string" ? e = s.createElement(n, { is: r.is }) : (e = s.createElement(n), n === "select" && (s = e, r.multiple ? s.multiple = !0 : r.size && (s.size = r.size))) : e = s.createElementNS(e, n), e[J1] = t, e[ie] = r, a4(e, t, !1, !1), t.stateNode = e;
          e: {
            switch (s = L3(n, r), n) {
              case "dialog":
                Q("cancel", e), Q("close", e), l = r;
                break;
              case "iframe":
              case "object":
              case "embed":
                Q("load", e), l = r;
                break;
              case "video":
              case "audio":
                for (l = 0; l < U9.length; l++) Q(U9[l], e);
                l = r;
                break;
              case "source":
                Q("error", e), l = r;
                break;
              case "img":
              case "image":
              case "link":
                Q(
                  "error",
                  e
                ), Q("load", e), l = r;
                break;
              case "details":
                Q("toggle", e), l = r;
                break;
              case "input":
                u6(e, r), l = x3(e, r), Q("invalid", e);
                break;
              case "option":
                l = r;
                break;
              case "select":
                e._wrapperState = { wasMultiple: !!r.multiple }, l = _({}, r, { value: void 0 }), Q("invalid", e);
                break;
              case "textarea":
                c6(e, r), l = S3(e, r), Q("invalid", e);
                break;
              default:
                l = r;
            }
            j3(n, l), u = l;
            for (i in u) if (u.hasOwnProperty(i)) {
              var a = u[i];
              i === "style" ? H5(e, a) : i === "dangerouslySetInnerHTML" ? (a = a ? a.__html : void 0, a != null && O5(e, a)) : i === "children" ? typeof a == "string" ? (n !== "textarea" || a !== "") && J9(e, a) : typeof a == "number" && J9(e, "" + a) : i !== "suppressContentEditableWarning" && i !== "suppressHydrationWarning" && i !== "autoFocus" && (K9.hasOwnProperty(i) ? a != null && i === "onScroll" && Q("scroll", e) : a != null && d8(e, i, a, s));
            }
            switch (n) {
              case "input":
                ye(e), a6(e, r, !1);
                break;
              case "textarea":
                ye(e), C6(e);
                break;
              case "option":
                r.value != null && e.setAttribute("value", "" + j2(r.value));
                break;
              case "select":
                e.multiple = !!r.multiple, i = r.value, i != null ? a9(e, !!r.multiple, i, !1) : r.defaultValue != null && a9(
                  e,
                  !!r.multiple,
                  r.defaultValue,
                  !0
                );
                break;
              default:
                typeof l.onClick == "function" && (e.onclick = o7);
            }
            switch (n) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                r = !!r.autoFocus;
                break e;
              case "img":
                r = !0;
                break e;
              default:
                r = !1;
            }
          }
          r && (t.flags |= 4);
        }
        t.ref !== null && (t.flags |= 512, t.flags |= 2097152);
      }
      return f1(t), null;
    case 6:
      if (e && t.stateNode != null) C4(e, t, e.memoizedProps, r);
      else {
        if (typeof r != "string" && t.stateNode === null) throw Error(x(166));
        if (n = Z2(se.current), Z2(_1.current), ze(t)) {
          if (r = t.stateNode, n = t.memoizedProps, r[J1] = t, (i = r.nodeValue !== n) && (e = L1, e !== null)) switch (e.tag) {
            case 3:
              Me(r.nodeValue, n, (e.mode & 1) !== 0);
              break;
            case 5:
              e.memoizedProps.suppressHydrationWarning !== !0 && Me(r.nodeValue, n, (e.mode & 1) !== 0);
          }
          i && (t.flags |= 4);
        } else r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r), r[J1] = t, t.stateNode = r;
      }
      return f1(t), null;
    case 13:
      if (Y(J), r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
        if (K && j1 !== null && t.mode & 1 && !(t.flags & 128)) A0(), m9(), t.flags |= 98560, i = !1;
        else if (i = ze(t), r !== null && r.dehydrated !== null) {
          if (e === null) {
            if (!i) throw Error(x(318));
            if (i = t.memoizedState, i = i !== null ? i.dehydrated : null, !i) throw Error(x(317));
            i[J1] = t;
          } else m9(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
          f1(t), i = !1;
        } else U1 !== null && (o8(U1), U1 = null), i = !0;
        if (!i) return t.flags & 65536 ? t : null;
      }
      return t.flags & 128 ? (t.lanes = n, t) : (r = r !== null, r !== (e !== null && e.memoizedState !== null) && r && (t.child.flags |= 8192, t.mode & 1 && (e === null || J.current & 1 ? i1 === 0 && (i1 = 3) : K8())), t.updateQueue !== null && (t.flags |= 4), f1(t), null);
    case 4:
      return y9(), _3(e, t), e === null && re(t.stateNode.containerInfo), f1(t), null;
    case 10:
      return P8(t.type._context), f1(t), null;
    case 17:
      return k1(t.type) && s7(), f1(t), null;
    case 19:
      if (Y(J), i = t.memoizedState, i === null) return f1(t), null;
      if (r = (t.flags & 128) !== 0, s = i.rendering, s === null) if (r) P9(i, !1);
      else {
        if (i1 !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null; ) {
          if (s = p7(e), s !== null) {
            for (t.flags |= 128, P9(i, !1), r = s.updateQueue, r !== null && (t.updateQueue = r, t.flags |= 4), t.subtreeFlags = 0, r = n, n = t.child; n !== null; ) i = n, e = r, i.flags &= 14680066, s = i.alternate, s === null ? (i.childLanes = 0, i.lanes = e, i.child = null, i.subtreeFlags = 0, i.memoizedProps = null, i.memoizedState = null, i.updateQueue = null, i.dependencies = null, i.stateNode = null) : (i.childLanes = s.childLanes, i.lanes = s.lanes, i.child = s.child, i.subtreeFlags = 0, i.deletions = null, i.memoizedProps = s.memoizedProps, i.memoizedState = s.memoizedState, i.updateQueue = s.updateQueue, i.type = s.type, e = s.dependencies, i.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }), n = n.sibling;
            return X(J, J.current & 1 | 2), t.child;
          }
          e = e.sibling;
        }
        i.tail !== null && e1() > w9 && (t.flags |= 128, r = !0, P9(i, !1), t.lanes = 4194304);
      }
      else {
        if (!r) if (e = p7(s), e !== null) {
          if (t.flags |= 128, r = !0, n = e.updateQueue, n !== null && (t.updateQueue = n, t.flags |= 4), P9(i, !0), i.tail === null && i.tailMode === "hidden" && !s.alternate && !K) return f1(t), null;
        } else 2 * e1() - i.renderingStartTime > w9 && n !== 1073741824 && (t.flags |= 128, r = !0, P9(i, !1), t.lanes = 4194304);
        i.isBackwards ? (s.sibling = t.child, t.child = s) : (n = i.last, n !== null ? n.sibling = s : t.child = s, i.last = s);
      }
      return i.tail !== null ? (t = i.tail, i.rendering = t, i.tail = t.sibling, i.renderingStartTime = e1(), t.sibling = null, n = J.current, X(J, r ? n & 1 | 2 : n & 1), t) : (f1(t), null);
    case 22:
    case 23:
      return q8(), r = t.memoizedState !== null, e !== null && e.memoizedState !== null !== r && (t.flags |= 8192), r && t.mode & 1 ? E1 & 1073741824 && (f1(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : f1(t), null;
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(x(156, t.tag));
}
function In(e, t) {
  switch (z8(t), t.tag) {
    case 1:
      return k1(t.type) && s7(), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 3:
      return y9(), Y(w1), Y(p1), D8(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
    case 5:
      return F8(t), null;
    case 13:
      if (Y(J), e = t.memoizedState, e !== null && e.dehydrated !== null) {
        if (t.alternate === null) throw Error(x(340));
        m9();
      }
      return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 19:
      return Y(J), null;
    case 4:
      return y9(), null;
    case 10:
      return P8(t.type._context), null;
    case 22:
    case 23:
      return q8(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var Te = !1, d1 = !1, Xn = typeof WeakSet == "function" ? WeakSet : Set, M = null;
function s9(e, t) {
  var n = e.ref;
  if (n !== null) if (typeof n == "function") try {
    n(null);
  } catch (r) {
    $(e, t, r);
  }
  else n.current = null;
}
function $3(e, t, n) {
  try {
    n();
  } catch (r) {
    $(e, t, r);
  }
}
var e5 = !1;
function Gn(e, t) {
  if (F3 = r7, e = v0(), L8(e)) {
    if ("selectionStart" in e) var n = { start: e.selectionStart, end: e.selectionEnd };
    else e: {
      n = (n = e.ownerDocument) && n.defaultView || window;
      var r = n.getSelection && n.getSelection();
      if (r && r.rangeCount !== 0) {
        n = r.anchorNode;
        var l = r.anchorOffset, i = r.focusNode;
        r = r.focusOffset;
        try {
          n.nodeType, i.nodeType;
        } catch {
          n = null;
          break e;
        }
        var s = 0, u = -1, a = -1, c = 0, p = 0, h = e, v = null;
        t: for (; ; ) {
          for (var g; h !== n || l !== 0 && h.nodeType !== 3 || (u = s + l), h !== i || r !== 0 && h.nodeType !== 3 || (a = s + r), h.nodeType === 3 && (s += h.nodeValue.length), (g = h.firstChild) !== null; )
            v = h, h = g;
          for (; ; ) {
            if (h === e) break t;
            if (v === n && ++c === l && (u = s), v === i && ++p === r && (a = s), (g = h.nextSibling) !== null) break;
            h = v, v = h.parentNode;
          }
          h = g;
        }
        n = u === -1 || a === -1 ? null : { start: u, end: a };
      } else n = null;
    }
    n = n || { start: 0, end: 0 };
  } else n = null;
  for (D3 = { focusedElem: e, selectionRange: n }, r7 = !1, M = t; M !== null; ) if (t = M, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null) e.return = t, M = e;
  else for (; M !== null; ) {
    t = M;
    try {
      var w = t.alternate;
      if (t.flags & 1024) switch (t.tag) {
        case 0:
        case 11:
        case 15:
          break;
        case 1:
          if (w !== null) {
            var y = w.memoizedProps, N = w.memoizedState, f = t.stateNode, C = f.getSnapshotBeforeUpdate(t.elementType === t.type ? y : D1(t.type, y), N);
            f.__reactInternalSnapshotBeforeUpdate = C;
          }
          break;
        case 3:
          var d = t.stateNode.containerInfo;
          d.nodeType === 1 ? d.textContent = "" : d.nodeType === 9 && d.documentElement && d.removeChild(d.documentElement);
          break;
        case 5:
        case 6:
        case 4:
        case 17:
          break;
        default:
          throw Error(x(163));
      }
    } catch (m) {
      $(t, t.return, m);
    }
    if (e = t.sibling, e !== null) {
      e.return = t.return, M = e;
      break;
    }
    M = t.return;
  }
  return w = e5, e5 = !1, w;
}
function Q9(e, t, n) {
  var r = t.updateQueue;
  if (r = r !== null ? r.lastEffect : null, r !== null) {
    var l = r = r.next;
    do {
      if ((l.tag & e) === e) {
        var i = l.destroy;
        l.destroy = void 0, i !== void 0 && $3(t, n, i);
      }
      l = l.next;
    } while (l !== r);
  }
}
function T7(e, t) {
  if (t = t.updateQueue, t = t !== null ? t.lastEffect : null, t !== null) {
    var n = t = t.next;
    do {
      if ((n.tag & e) === e) {
        var r = n.create;
        n.destroy = r();
      }
      n = n.next;
    } while (n !== t);
  }
}
function e8(e) {
  var t = e.ref;
  if (t !== null) {
    var n = e.stateNode;
    switch (e.tag) {
      case 5:
        e = n;
        break;
      default:
        e = n;
    }
    typeof t == "function" ? t(e) : t.current = e;
  }
}
function f4(e) {
  var t = e.alternate;
  t !== null && (e.alternate = null, f4(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && (delete t[J1], delete t[ie], delete t[O3], delete t[Mn], delete t[zn])), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
}
function d4(e) {
  return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function t5(e) {
  e: for (; ; ) {
    for (; e.sibling === null; ) {
      if (e.return === null || d4(e.return)) return null;
      e = e.return;
    }
    for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
      if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
      e.child.return = e, e = e.child;
    }
    if (!(e.flags & 2)) return e.stateNode;
  }
}
function t8(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6) e = e.stateNode, t ? n.nodeType === 8 ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (n.nodeType === 8 ? (t = n.parentNode, t.insertBefore(e, n)) : (t = n, t.appendChild(e)), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = o7));
  else if (r !== 4 && (e = e.child, e !== null)) for (t8(e, t, n), e = e.sibling; e !== null; ) t8(e, t, n), e = e.sibling;
}
function n8(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
  else if (r !== 4 && (e = e.child, e !== null)) for (n8(e, t, n), e = e.sibling; e !== null; ) n8(e, t, n), e = e.sibling;
}
var u1 = null, V1 = !1;
function c2(e, t, n) {
  for (n = n.child; n !== null; ) p4(e, t, n), n = n.sibling;
}
function p4(e, t, n) {
  if (b1 && typeof b1.onCommitFiberUnmount == "function") try {
    b1.onCommitFiberUnmount(S7, n);
  } catch {
  }
  switch (n.tag) {
    case 5:
      d1 || s9(n, t);
    case 6:
      var r = u1, l = V1;
      u1 = null, c2(e, t, n), u1 = r, V1 = l, u1 !== null && (V1 ? (e = u1, n = n.stateNode, e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n)) : u1.removeChild(n.stateNode));
      break;
    case 18:
      u1 !== null && (V1 ? (e = u1, n = n.stateNode, e.nodeType === 8 ? t3(e.parentNode, n) : e.nodeType === 1 && t3(e, n), ee(e)) : t3(u1, n.stateNode));
      break;
    case 4:
      r = u1, l = V1, u1 = n.stateNode.containerInfo, V1 = !0, c2(e, t, n), u1 = r, V1 = l;
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (!d1 && (r = n.updateQueue, r !== null && (r = r.lastEffect, r !== null))) {
        l = r = r.next;
        do {
          var i = l, s = i.destroy;
          i = i.tag, s !== void 0 && (i & 2 || i & 4) && $3(n, t, s), l = l.next;
        } while (l !== r);
      }
      c2(e, t, n);
      break;
    case 1:
      if (!d1 && (s9(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function")) try {
        r.props = n.memoizedProps, r.state = n.memoizedState, r.componentWillUnmount();
      } catch (u) {
        $(n, t, u);
      }
      c2(e, t, n);
      break;
    case 21:
      c2(e, t, n);
      break;
    case 22:
      n.mode & 1 ? (d1 = (r = d1) || n.memoizedState !== null, c2(e, t, n), d1 = r) : c2(e, t, n);
      break;
    default:
      c2(e, t, n);
  }
}
function n5(e) {
  var t = e.updateQueue;
  if (t !== null) {
    e.updateQueue = null;
    var n = e.stateNode;
    n === null && (n = e.stateNode = new Xn()), t.forEach(function(r) {
      var l = er.bind(null, e, r);
      n.has(r) || (n.add(r), r.then(l, l));
    });
  }
}
function F1(e, t) {
  var n = t.deletions;
  if (n !== null) for (var r = 0; r < n.length; r++) {
    var l = n[r];
    try {
      var i = e, s = t, u = s;
      e: for (; u !== null; ) {
        switch (u.tag) {
          case 5:
            u1 = u.stateNode, V1 = !1;
            break e;
          case 3:
            u1 = u.stateNode.containerInfo, V1 = !0;
            break e;
          case 4:
            u1 = u.stateNode.containerInfo, V1 = !0;
            break e;
        }
        u = u.return;
      }
      if (u1 === null) throw Error(x(160));
      p4(i, s, l), u1 = null, V1 = !1;
      var a = l.alternate;
      a !== null && (a.return = null), l.return = null;
    } catch (c) {
      $(l, t, c);
    }
  }
  if (t.subtreeFlags & 12854) for (t = t.child; t !== null; ) h4(t, e), t = t.sibling;
}
function h4(e, t) {
  var n = e.alternate, r = e.flags;
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      if (F1(t, e), Y1(e), r & 4) {
        try {
          Q9(3, e, e.return), T7(3, e);
        } catch (y) {
          $(e, e.return, y);
        }
        try {
          Q9(5, e, e.return);
        } catch (y) {
          $(e, e.return, y);
        }
      }
      break;
    case 1:
      F1(t, e), Y1(e), r & 512 && n !== null && s9(n, n.return);
      break;
    case 5:
      if (F1(t, e), Y1(e), r & 512 && n !== null && s9(n, n.return), e.flags & 32) {
        var l = e.stateNode;
        try {
          J9(l, "");
        } catch (y) {
          $(e, e.return, y);
        }
      }
      if (r & 4 && (l = e.stateNode, l != null)) {
        var i = e.memoizedProps, s = n !== null ? n.memoizedProps : i, u = e.type, a = e.updateQueue;
        if (e.updateQueue = null, a !== null) try {
          u === "input" && i.type === "radio" && i.name != null && D5(l, i), L3(u, s);
          var c = L3(u, i);
          for (s = 0; s < a.length; s += 2) {
            var p = a[s], h = a[s + 1];
            p === "style" ? H5(l, h) : p === "dangerouslySetInnerHTML" ? O5(l, h) : p === "children" ? J9(l, h) : d8(l, p, h, c);
          }
          switch (u) {
            case "input":
              w3(l, i);
              break;
            case "textarea":
              V5(l, i);
              break;
            case "select":
              var v = l._wrapperState.wasMultiple;
              l._wrapperState.wasMultiple = !!i.multiple;
              var g = i.value;
              g != null ? a9(l, !!i.multiple, g, !1) : v !== !!i.multiple && (i.defaultValue != null ? a9(
                l,
                !!i.multiple,
                i.defaultValue,
                !0
              ) : a9(l, !!i.multiple, i.multiple ? [] : "", !1));
          }
          l[ie] = i;
        } catch (y) {
          $(e, e.return, y);
        }
      }
      break;
    case 6:
      if (F1(t, e), Y1(e), r & 4) {
        if (e.stateNode === null) throw Error(x(162));
        l = e.stateNode, i = e.memoizedProps;
        try {
          l.nodeValue = i;
        } catch (y) {
          $(e, e.return, y);
        }
      }
      break;
    case 3:
      if (F1(t, e), Y1(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
        ee(t.containerInfo);
      } catch (y) {
        $(e, e.return, y);
      }
      break;
    case 4:
      F1(t, e), Y1(e);
      break;
    case 13:
      F1(t, e), Y1(e), l = e.child, l.flags & 8192 && (i = l.memoizedState !== null, l.stateNode.isHidden = i, !i || l.alternate !== null && l.alternate.memoizedState !== null || (Q8 = e1())), r & 4 && n5(e);
      break;
    case 22:
      if (p = n !== null && n.memoizedState !== null, e.mode & 1 ? (d1 = (c = d1) || p, F1(t, e), d1 = c) : F1(t, e), Y1(e), r & 8192) {
        if (c = e.memoizedState !== null, (e.stateNode.isHidden = c) && !p && e.mode & 1) for (M = e, p = e.child; p !== null; ) {
          for (h = M = p; M !== null; ) {
            switch (v = M, g = v.child, v.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                Q9(4, v, v.return);
                break;
              case 1:
                s9(v, v.return);
                var w = v.stateNode;
                if (typeof w.componentWillUnmount == "function") {
                  r = v, n = v.return;
                  try {
                    t = r, w.props = t.memoizedProps, w.state = t.memoizedState, w.componentWillUnmount();
                  } catch (y) {
                    $(r, n, y);
                  }
                }
                break;
              case 5:
                s9(v, v.return);
                break;
              case 22:
                if (v.memoizedState !== null) {
                  l5(h);
                  continue;
                }
            }
            g !== null ? (g.return = v, M = g) : l5(h);
          }
          p = p.sibling;
        }
        e: for (p = null, h = e; ; ) {
          if (h.tag === 5) {
            if (p === null) {
              p = h;
              try {
                l = h.stateNode, c ? (i = l.style, typeof i.setProperty == "function" ? i.setProperty("display", "none", "important") : i.display = "none") : (u = h.stateNode, a = h.memoizedProps.style, s = a != null && a.hasOwnProperty("display") ? a.display : null, u.style.display = W5("display", s));
              } catch (y) {
                $(e, e.return, y);
              }
            }
          } else if (h.tag === 6) {
            if (p === null) try {
              h.stateNode.nodeValue = c ? "" : h.memoizedProps;
            } catch (y) {
              $(e, e.return, y);
            }
          } else if ((h.tag !== 22 && h.tag !== 23 || h.memoizedState === null || h === e) && h.child !== null) {
            h.child.return = h, h = h.child;
            continue;
          }
          if (h === e) break e;
          for (; h.sibling === null; ) {
            if (h.return === null || h.return === e) break e;
            p === h && (p = null), h = h.return;
          }
          p === h && (p = null), h.sibling.return = h.return, h = h.sibling;
        }
      }
      break;
    case 19:
      F1(t, e), Y1(e), r & 4 && n5(e);
      break;
    case 21:
      break;
    default:
      F1(
        t,
        e
      ), Y1(e);
  }
}
function Y1(e) {
  var t = e.flags;
  if (t & 2) {
    try {
      e: {
        for (var n = e.return; n !== null; ) {
          if (d4(n)) {
            var r = n;
            break e;
          }
          n = n.return;
        }
        throw Error(x(160));
      }
      switch (r.tag) {
        case 5:
          var l = r.stateNode;
          r.flags & 32 && (J9(l, ""), r.flags &= -33);
          var i = t5(e);
          n8(e, i, l);
          break;
        case 3:
        case 4:
          var s = r.stateNode.containerInfo, u = t5(e);
          t8(e, u, s);
          break;
        default:
          throw Error(x(161));
      }
    } catch (a) {
      $(e, e.return, a);
    }
    e.flags &= -3;
  }
  t & 4096 && (e.flags &= -4097);
}
function Qn(e, t, n) {
  M = e, v4(e);
}
function v4(e, t, n) {
  for (var r = (e.mode & 1) !== 0; M !== null; ) {
    var l = M, i = l.child;
    if (l.tag === 22 && r) {
      var s = l.memoizedState !== null || Te;
      if (!s) {
        var u = l.alternate, a = u !== null && u.memoizedState !== null || d1;
        u = Te;
        var c = d1;
        if (Te = s, (d1 = a) && !c) for (M = l; M !== null; ) s = M, a = s.child, s.tag === 22 && s.memoizedState !== null ? i5(l) : a !== null ? (a.return = s, M = a) : i5(l);
        for (; i !== null; ) M = i, v4(i), i = i.sibling;
        M = l, Te = u, d1 = c;
      }
      r5(e);
    } else l.subtreeFlags & 8772 && i !== null ? (i.return = l, M = i) : r5(e);
  }
}
function r5(e) {
  for (; M !== null; ) {
    var t = M;
    if (t.flags & 8772) {
      var n = t.alternate;
      try {
        if (t.flags & 8772) switch (t.tag) {
          case 0:
          case 11:
          case 15:
            d1 || T7(5, t);
            break;
          case 1:
            var r = t.stateNode;
            if (t.flags & 4 && !d1) if (n === null) r.componentDidMount();
            else {
              var l = t.elementType === t.type ? n.memoizedProps : D1(t.type, n.memoizedProps);
              r.componentDidUpdate(l, n.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
            }
            var i = t.updateQueue;
            i !== null && W6(t, i, r);
            break;
          case 3:
            var s = t.updateQueue;
            if (s !== null) {
              if (n = null, t.child !== null) switch (t.child.tag) {
                case 5:
                  n = t.child.stateNode;
                  break;
                case 1:
                  n = t.child.stateNode;
              }
              W6(t, s, n);
            }
            break;
          case 5:
            var u = t.stateNode;
            if (n === null && t.flags & 4) {
              n = u;
              var a = t.memoizedProps;
              switch (t.type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  a.autoFocus && n.focus();
                  break;
                case "img":
                  a.src && (n.src = a.src);
              }
            }
            break;
          case 6:
            break;
          case 4:
            break;
          case 12:
            break;
          case 13:
            if (t.memoizedState === null) {
              var c = t.alternate;
              if (c !== null) {
                var p = c.memoizedState;
                if (p !== null) {
                  var h = p.dehydrated;
                  h !== null && ee(h);
                }
              }
            }
            break;
          case 19:
          case 17:
          case 21:
          case 22:
          case 23:
          case 25:
            break;
          default:
            throw Error(x(163));
        }
        d1 || t.flags & 512 && e8(t);
      } catch (v) {
        $(t, t.return, v);
      }
    }
    if (t === e) {
      M = null;
      break;
    }
    if (n = t.sibling, n !== null) {
      n.return = t.return, M = n;
      break;
    }
    M = t.return;
  }
}
function l5(e) {
  for (; M !== null; ) {
    var t = M;
    if (t === e) {
      M = null;
      break;
    }
    var n = t.sibling;
    if (n !== null) {
      n.return = t.return, M = n;
      break;
    }
    M = t.return;
  }
}
function i5(e) {
  for (; M !== null; ) {
    var t = M;
    try {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          var n = t.return;
          try {
            T7(4, t);
          } catch (a) {
            $(t, n, a);
          }
          break;
        case 1:
          var r = t.stateNode;
          if (typeof r.componentDidMount == "function") {
            var l = t.return;
            try {
              r.componentDidMount();
            } catch (a) {
              $(t, l, a);
            }
          }
          var i = t.return;
          try {
            e8(t);
          } catch (a) {
            $(t, i, a);
          }
          break;
        case 5:
          var s = t.return;
          try {
            e8(t);
          } catch (a) {
            $(t, s, a);
          }
      }
    } catch (a) {
      $(t, t.return, a);
    }
    if (t === e) {
      M = null;
      break;
    }
    var u = t.sibling;
    if (u !== null) {
      u.return = t.return, M = u;
      break;
    }
    M = t.return;
  }
}
var Yn = Math.ceil, m7 = u2.ReactCurrentDispatcher, X8 = u2.ReactCurrentOwner, N1 = u2.ReactCurrentBatchConfig, V = 0, s1 = null, n1 = null, a1 = 0, E1 = 0, u9 = z2(0), i1 = 0, Ce = null, W2 = 0, P7 = 0, G8 = 0, Y9 = null, y1 = null, Q8 = 0, w9 = 1 / 0, $1 = null, g7 = !1, r8 = null, k2 = null, Pe = !1, v2 = null, y7 = 0, q9 = 0, l8 = null, Ke = -1, Je = 0;
function v1() {
  return V & 6 ? e1() : Ke !== -1 ? Ke : Ke = e1();
}
function S2(e) {
  return e.mode & 1 ? V & 2 && a1 !== 0 ? a1 & -a1 : Bn.transition !== null ? (Je === 0 && (Je = e0()), Je) : (e = W, e !== 0 || (e = window.event, e = e === void 0 ? 16 : s0(e.type)), e) : 1;
}
function W1(e, t, n, r) {
  if (50 < q9) throw q9 = 0, l8 = null, Error(x(185));
  de(e, n, r), (!(V & 2) || e !== s1) && (e === s1 && (!(V & 2) && (P7 |= n), i1 === 4 && p2(e, a1)), S1(e, r), n === 1 && V === 0 && !(t.mode & 1) && (w9 = e1() + 500, z7 && A2()));
}
function S1(e, t) {
  var n = e.callbackNode;
  At(e, t);
  var r = n7(e, e === s1 ? a1 : 0);
  if (r === 0) n !== null && p6(n), e.callbackNode = null, e.callbackPriority = 0;
  else if (t = r & -r, e.callbackPriority !== t) {
    if (n != null && p6(n), t === 1) e.tag === 0 ? An(o5.bind(null, e)) : L0(o5.bind(null, e)), jn(function() {
      !(V & 6) && A2();
    }), n = null;
    else {
      switch (t0(r)) {
        case 1:
          n = g8;
          break;
        case 4:
          n = _5;
          break;
        case 16:
          n = t7;
          break;
        case 536870912:
          n = $5;
          break;
        default:
          n = t7;
      }
      n = E4(n, m4.bind(null, e));
    }
    e.callbackPriority = t, e.callbackNode = n;
  }
}
function m4(e, t) {
  if (Ke = -1, Je = 0, V & 6) throw Error(x(327));
  var n = e.callbackNode;
  if (p9() && e.callbackNode !== n) return null;
  var r = n7(e, e === s1 ? a1 : 0);
  if (r === 0) return null;
  if (r & 30 || r & e.expiredLanes || t) t = x7(e, r);
  else {
    t = r;
    var l = V;
    V |= 2;
    var i = y4();
    (s1 !== e || a1 !== t) && ($1 = null, w9 = e1() + 500, F2(e, t));
    do
      try {
        Jn();
        break;
      } catch (u) {
        g4(e, u);
      }
    while (!0);
    T8(), m7.current = i, V = l, n1 !== null ? t = 0 : (s1 = null, a1 = 0, t = i1);
  }
  if (t !== 0) {
    if (t === 2 && (l = T3(e), l !== 0 && (r = l, t = i8(e, l))), t === 1) throw n = Ce, F2(e, 0), p2(e, r), S1(e, e1()), n;
    if (t === 6) p2(e, r);
    else {
      if (l = e.current.alternate, !(r & 30) && !qn(l) && (t = x7(e, r), t === 2 && (i = T3(e), i !== 0 && (r = i, t = i8(e, i))), t === 1)) throw n = Ce, F2(e, 0), p2(e, r), S1(e, e1()), n;
      switch (e.finishedWork = l, e.finishedLanes = r, t) {
        case 0:
        case 1:
          throw Error(x(345));
        case 2:
          P2(e, y1, $1);
          break;
        case 3:
          if (p2(e, r), (r & 130023424) === r && (t = Q8 + 500 - e1(), 10 < t)) {
            if (n7(e, 0) !== 0) break;
            if (l = e.suspendedLanes, (l & r) !== r) {
              v1(), e.pingedLanes |= e.suspendedLanes & l;
              break;
            }
            e.timeoutHandle = U3(P2.bind(null, e, y1, $1), t);
            break;
          }
          P2(e, y1, $1);
          break;
        case 4:
          if (p2(e, r), (r & 4194240) === r) break;
          for (t = e.eventTimes, l = -1; 0 < r; ) {
            var s = 31 - O1(r);
            i = 1 << s, s = t[s], s > l && (l = s), r &= ~i;
          }
          if (r = l, r = e1() - r, r = (120 > r ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * Yn(r / 1960)) - r, 10 < r) {
            e.timeoutHandle = U3(P2.bind(null, e, y1, $1), r);
            break;
          }
          P2(e, y1, $1);
          break;
        case 5:
          P2(e, y1, $1);
          break;
        default:
          throw Error(x(329));
      }
    }
  }
  return S1(e, e1()), e.callbackNode === n ? m4.bind(null, e) : null;
}
function i8(e, t) {
  var n = Y9;
  return e.current.memoizedState.isDehydrated && (F2(e, t).flags |= 256), e = x7(e, t), e !== 2 && (t = y1, y1 = n, t !== null && o8(t)), e;
}
function o8(e) {
  y1 === null ? y1 = e : y1.push.apply(y1, e);
}
function qn(e) {
  for (var t = e; ; ) {
    if (t.flags & 16384) {
      var n = t.updateQueue;
      if (n !== null && (n = n.stores, n !== null)) for (var r = 0; r < n.length; r++) {
        var l = n[r], i = l.getSnapshot;
        l = l.value;
        try {
          if (!H1(i(), l)) return !1;
        } catch {
          return !1;
        }
      }
    }
    if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
    else {
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return !0;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
  }
  return !0;
}
function p2(e, t) {
  for (t &= ~G8, t &= ~P7, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
    var n = 31 - O1(t), r = 1 << n;
    e[n] = -1, t &= ~r;
  }
}
function o5(e) {
  if (V & 6) throw Error(x(327));
  p9();
  var t = n7(e, 0);
  if (!(t & 1)) return S1(e, e1()), null;
  var n = x7(e, t);
  if (e.tag !== 0 && n === 2) {
    var r = T3(e);
    r !== 0 && (t = r, n = i8(e, r));
  }
  if (n === 1) throw n = Ce, F2(e, 0), p2(e, t), S1(e, e1()), n;
  if (n === 6) throw Error(x(345));
  return e.finishedWork = e.current.alternate, e.finishedLanes = t, P2(e, y1, $1), S1(e, e1()), null;
}
function Y8(e, t) {
  var n = V;
  V |= 1;
  try {
    return e(t);
  } finally {
    V = n, V === 0 && (w9 = e1() + 500, z7 && A2());
  }
}
function H2(e) {
  v2 !== null && v2.tag === 0 && !(V & 6) && p9();
  var t = V;
  V |= 1;
  var n = N1.transition, r = W;
  try {
    if (N1.transition = null, W = 1, e) return e();
  } finally {
    W = r, N1.transition = n, V = t, !(V & 6) && A2();
  }
}
function q8() {
  E1 = u9.current, Y(u9);
}
function F2(e, t) {
  e.finishedWork = null, e.finishedLanes = 0;
  var n = e.timeoutHandle;
  if (n !== -1 && (e.timeoutHandle = -1, En(n)), n1 !== null) for (n = n1.return; n !== null; ) {
    var r = n;
    switch (z8(r), r.tag) {
      case 1:
        r = r.type.childContextTypes, r != null && s7();
        break;
      case 3:
        y9(), Y(w1), Y(p1), D8();
        break;
      case 5:
        F8(r);
        break;
      case 4:
        y9();
        break;
      case 13:
        Y(J);
        break;
      case 19:
        Y(J);
        break;
      case 10:
        P8(r.type._context);
        break;
      case 22:
      case 23:
        q8();
    }
    n = n.return;
  }
  if (s1 = e, n1 = e = E2(e.current, null), a1 = E1 = t, i1 = 0, Ce = null, G8 = P7 = W2 = 0, y1 = Y9 = null, R2 !== null) {
    for (t = 0; t < R2.length; t++) if (n = R2[t], r = n.interleaved, r !== null) {
      n.interleaved = null;
      var l = r.next, i = n.pending;
      if (i !== null) {
        var s = i.next;
        i.next = l, r.next = s;
      }
      n.pending = r;
    }
    R2 = null;
  }
  return e;
}
function g4(e, t) {
  do {
    var n = n1;
    try {
      if (T8(), Qe.current = v7, h7) {
        for (var r = b.memoizedState; r !== null; ) {
          var l = r.queue;
          l !== null && (l.pending = null), r = r.next;
        }
        h7 = !1;
      }
      if (O2 = 0, o1 = l1 = b = null, G9 = !1, ue = 0, X8.current = null, n === null || n.return === null) {
        i1 = 1, Ce = t, n1 = null;
        break;
      }
      e: {
        var i = e, s = n.return, u = n, a = t;
        if (t = a1, u.flags |= 32768, a !== null && typeof a == "object" && typeof a.then == "function") {
          var c = a, p = u, h = p.tag;
          if (!(p.mode & 1) && (h === 0 || h === 11 || h === 15)) {
            var v = p.alternate;
            v ? (p.updateQueue = v.updateQueue, p.memoizedState = v.memoizedState, p.lanes = v.lanes) : (p.updateQueue = null, p.memoizedState = null);
          }
          var g = Y6(s);
          if (g !== null) {
            g.flags &= -257, q6(g, s, u, i, t), g.mode & 1 && Q6(i, c, t), t = g, a = c;
            var w = t.updateQueue;
            if (w === null) {
              var y = /* @__PURE__ */ new Set();
              y.add(a), t.updateQueue = y;
            } else w.add(a);
            break e;
          } else {
            if (!(t & 1)) {
              Q6(i, c, t), K8();
              break e;
            }
            a = Error(x(426));
          }
        } else if (K && u.mode & 1) {
          var N = Y6(s);
          if (N !== null) {
            !(N.flags & 65536) && (N.flags |= 256), q6(N, s, u, i, t), A8(x9(a, u));
            break e;
          }
        }
        i = a = x9(a, u), i1 !== 4 && (i1 = 2), Y9 === null ? Y9 = [i] : Y9.push(i), i = s;
        do {
          switch (i.tag) {
            case 3:
              i.flags |= 65536, t &= -t, i.lanes |= t;
              var f = t4(i, a, t);
              O6(i, f);
              break e;
            case 1:
              u = a;
              var C = i.type, d = i.stateNode;
              if (!(i.flags & 128) && (typeof C.getDerivedStateFromError == "function" || d !== null && typeof d.componentDidCatch == "function" && (k2 === null || !k2.has(d)))) {
                i.flags |= 65536, t &= -t, i.lanes |= t;
                var m = n4(i, u, t);
                O6(i, m);
                break e;
              }
          }
          i = i.return;
        } while (i !== null);
      }
      w4(n);
    } catch (k) {
      t = k, n1 === n && n !== null && (n1 = n = n.return);
      continue;
    }
    break;
  } while (!0);
}
function y4() {
  var e = m7.current;
  return m7.current = v7, e === null ? v7 : e;
}
function K8() {
  (i1 === 0 || i1 === 3 || i1 === 2) && (i1 = 4), s1 === null || !(W2 & 268435455) && !(P7 & 268435455) || p2(s1, a1);
}
function x7(e, t) {
  var n = V;
  V |= 2;
  var r = y4();
  (s1 !== e || a1 !== t) && ($1 = null, F2(e, t));
  do
    try {
      Kn();
      break;
    } catch (l) {
      g4(e, l);
    }
  while (!0);
  if (T8(), V = n, m7.current = r, n1 !== null) throw Error(x(261));
  return s1 = null, a1 = 0, i1;
}
function Kn() {
  for (; n1 !== null; ) x4(n1);
}
function Jn() {
  for (; n1 !== null && !xt(); ) x4(n1);
}
function x4(e) {
  var t = S4(e.alternate, e, E1);
  e.memoizedProps = e.pendingProps, t === null ? w4(e) : n1 = t, X8.current = null;
}
function w4(e) {
  var t = e;
  do {
    var n = t.alternate;
    if (e = t.return, t.flags & 32768) {
      if (n = In(n, t), n !== null) {
        n.flags &= 32767, n1 = n;
        return;
      }
      if (e !== null) e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
      else {
        i1 = 6, n1 = null;
        return;
      }
    } else if (n = Hn(n, t, E1), n !== null) {
      n1 = n;
      return;
    }
    if (t = t.sibling, t !== null) {
      n1 = t;
      return;
    }
    n1 = t = e;
  } while (t !== null);
  i1 === 0 && (i1 = 5);
}
function P2(e, t, n) {
  var r = W, l = N1.transition;
  try {
    N1.transition = null, W = 1, bn(e, t, n, r);
  } finally {
    N1.transition = l, W = r;
  }
  return null;
}
function bn(e, t, n, r) {
  do
    p9();
  while (v2 !== null);
  if (V & 6) throw Error(x(327));
  n = e.finishedWork;
  var l = e.finishedLanes;
  if (n === null) return null;
  if (e.finishedWork = null, e.finishedLanes = 0, n === e.current) throw Error(x(177));
  e.callbackNode = null, e.callbackPriority = 0;
  var i = n.lanes | n.childLanes;
  if (Bt(e, i), e === s1 && (n1 = s1 = null, a1 = 0), !(n.subtreeFlags & 2064) && !(n.flags & 2064) || Pe || (Pe = !0, E4(t7, function() {
    return p9(), null;
  })), i = (n.flags & 15990) !== 0, n.subtreeFlags & 15990 || i) {
    i = N1.transition, N1.transition = null;
    var s = W;
    W = 1;
    var u = V;
    V |= 4, X8.current = null, Gn(e, n), h4(n, e), mn(D3), r7 = !!F3, D3 = F3 = null, e.current = n, Qn(n), wt(), V = u, W = s, N1.transition = i;
  } else e.current = n;
  if (Pe && (Pe = !1, v2 = e, y7 = l), i = e.pendingLanes, i === 0 && (k2 = null), Et(n.stateNode), S1(e, e1()), t !== null) for (r = e.onRecoverableError, n = 0; n < t.length; n++) l = t[n], r(l.value, { componentStack: l.stack, digest: l.digest });
  if (g7) throw g7 = !1, e = r8, r8 = null, e;
  return y7 & 1 && e.tag !== 0 && p9(), i = e.pendingLanes, i & 1 ? e === l8 ? q9++ : (q9 = 0, l8 = e) : q9 = 0, A2(), null;
}
function p9() {
  if (v2 !== null) {
    var e = t0(y7), t = N1.transition, n = W;
    try {
      if (N1.transition = null, W = 16 > e ? 16 : e, v2 === null) var r = !1;
      else {
        if (e = v2, v2 = null, y7 = 0, V & 6) throw Error(x(331));
        var l = V;
        for (V |= 4, M = e.current; M !== null; ) {
          var i = M, s = i.child;
          if (M.flags & 16) {
            var u = i.deletions;
            if (u !== null) {
              for (var a = 0; a < u.length; a++) {
                var c = u[a];
                for (M = c; M !== null; ) {
                  var p = M;
                  switch (p.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Q9(8, p, i);
                  }
                  var h = p.child;
                  if (h !== null) h.return = p, M = h;
                  else for (; M !== null; ) {
                    p = M;
                    var v = p.sibling, g = p.return;
                    if (f4(p), p === c) {
                      M = null;
                      break;
                    }
                    if (v !== null) {
                      v.return = g, M = v;
                      break;
                    }
                    M = g;
                  }
                }
              }
              var w = i.alternate;
              if (w !== null) {
                var y = w.child;
                if (y !== null) {
                  w.child = null;
                  do {
                    var N = y.sibling;
                    y.sibling = null, y = N;
                  } while (y !== null);
                }
              }
              M = i;
            }
          }
          if (i.subtreeFlags & 2064 && s !== null) s.return = i, M = s;
          else e: for (; M !== null; ) {
            if (i = M, i.flags & 2048) switch (i.tag) {
              case 0:
              case 11:
              case 15:
                Q9(9, i, i.return);
            }
            var f = i.sibling;
            if (f !== null) {
              f.return = i.return, M = f;
              break e;
            }
            M = i.return;
          }
        }
        var C = e.current;
        for (M = C; M !== null; ) {
          s = M;
          var d = s.child;
          if (s.subtreeFlags & 2064 && d !== null) d.return = s, M = d;
          else e: for (s = C; M !== null; ) {
            if (u = M, u.flags & 2048) try {
              switch (u.tag) {
                case 0:
                case 11:
                case 15:
                  T7(9, u);
              }
            } catch (k) {
              $(u, u.return, k);
            }
            if (u === s) {
              M = null;
              break e;
            }
            var m = u.sibling;
            if (m !== null) {
              m.return = u.return, M = m;
              break e;
            }
            M = u.return;
          }
        }
        if (V = l, A2(), b1 && typeof b1.onPostCommitFiberRoot == "function") try {
          b1.onPostCommitFiberRoot(S7, e);
        } catch {
        }
        r = !0;
      }
      return r;
    } finally {
      W = n, N1.transition = t;
    }
  }
  return !1;
}
function s5(e, t, n) {
  t = x9(n, t), t = t4(e, t, 1), e = w2(e, t, 1), t = v1(), e !== null && (de(e, 1, t), S1(e, t));
}
function $(e, t, n) {
  if (e.tag === 3) s5(e, e, n);
  else for (; t !== null; ) {
    if (t.tag === 3) {
      s5(t, e, n);
      break;
    } else if (t.tag === 1) {
      var r = t.stateNode;
      if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (k2 === null || !k2.has(r))) {
        e = x9(n, e), e = n4(t, e, 1), t = w2(t, e, 1), e = v1(), t !== null && (de(t, 1, e), S1(t, e));
        break;
      }
    }
    t = t.return;
  }
}
function _n(e, t, n) {
  var r = e.pingCache;
  r !== null && r.delete(t), t = v1(), e.pingedLanes |= e.suspendedLanes & n, s1 === e && (a1 & n) === n && (i1 === 4 || i1 === 3 && (a1 & 130023424) === a1 && 500 > e1() - Q8 ? F2(e, 0) : G8 |= n), S1(e, t);
}
function k4(e, t) {
  t === 0 && (e.mode & 1 ? (t = ke, ke <<= 1, !(ke & 130023424) && (ke = 4194304)) : t = 1);
  var n = v1();
  e = o2(e, t), e !== null && (de(e, t, n), S1(e, n));
}
function $n(e) {
  var t = e.memoizedState, n = 0;
  t !== null && (n = t.retryLane), k4(e, n);
}
function er(e, t) {
  var n = 0;
  switch (e.tag) {
    case 13:
      var r = e.stateNode, l = e.memoizedState;
      l !== null && (n = l.retryLane);
      break;
    case 19:
      r = e.stateNode;
      break;
    default:
      throw Error(x(314));
  }
  r !== null && r.delete(t), k4(e, n);
}
var S4;
S4 = function(e, t, n) {
  if (e !== null) if (e.memoizedProps !== t.pendingProps || w1.current) x1 = !0;
  else {
    if (!(e.lanes & n) && !(t.flags & 128)) return x1 = !1, Wn(e, t, n);
    x1 = !!(e.flags & 131072);
  }
  else x1 = !1, K && t.flags & 1048576 && M0(t, c7, t.index);
  switch (t.lanes = 0, t.tag) {
    case 2:
      var r = t.type;
      qe(e, t), e = t.pendingProps;
      var l = v9(t, p1.current);
      d9(t, n), l = U8(null, t, r, e, l, n);
      var i = O8();
      return t.flags |= 1, typeof l == "object" && l !== null && typeof l.render == "function" && l.$$typeof === void 0 ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, k1(r) ? (i = !0, u7(t)) : i = !1, t.memoizedState = l.state !== null && l.state !== void 0 ? l.state : null, R8(t), l.updater = B7, t.stateNode = l, l._reactInternals = t, Q3(t, r, e, n), t = K3(null, t, r, !0, i, n)) : (t.tag = 0, K && i && M8(t), h1(null, t, l, n), t = t.child), t;
    case 16:
      r = t.elementType;
      e: {
        switch (qe(e, t), e = t.pendingProps, l = r._init, r = l(r._payload), t.type = r, l = t.tag = nr(r), e = D1(r, e), l) {
          case 0:
            t = q3(null, t, r, e, n);
            break e;
          case 1:
            t = b6(null, t, r, e, n);
            break e;
          case 11:
            t = K6(null, t, r, e, n);
            break e;
          case 14:
            t = J6(null, t, r, D1(r.type, e), n);
            break e;
        }
        throw Error(x(
          306,
          r,
          ""
        ));
      }
      return t;
    case 0:
      return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : D1(r, l), q3(e, t, r, l, n);
    case 1:
      return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : D1(r, l), b6(e, t, r, l, n);
    case 3:
      e: {
        if (o4(t), e === null) throw Error(x(387));
        r = t.pendingProps, i = t.memoizedState, l = i.element, N0(e, t), d7(t, r, null, n);
        var s = t.memoizedState;
        if (r = s.element, i.isDehydrated) if (i = { element: r, isDehydrated: !1, cache: s.cache, pendingSuspenseBoundaries: s.pendingSuspenseBoundaries, transitions: s.transitions }, t.updateQueue.baseState = i, t.memoizedState = i, t.flags & 256) {
          l = x9(Error(x(423)), t), t = _6(e, t, r, n, l);
          break e;
        } else if (r !== l) {
          l = x9(Error(x(424)), t), t = _6(e, t, r, n, l);
          break e;
        } else for (j1 = x2(t.stateNode.containerInfo.firstChild), L1 = t, K = !0, U1 = null, n = T0(t, null, r, n), t.child = n; n; ) n.flags = n.flags & -3 | 4096, n = n.sibling;
        else {
          if (m9(), r === l) {
            t = s2(e, t, n);
            break e;
          }
          h1(e, t, r, n);
        }
        t = t.child;
      }
      return t;
    case 5:
      return R0(t), e === null && I3(t), r = t.type, l = t.pendingProps, i = e !== null ? e.memoizedProps : null, s = l.children, V3(r, l) ? s = null : i !== null && V3(r, i) && (t.flags |= 32), i4(e, t), h1(e, t, s, n), t.child;
    case 6:
      return e === null && I3(t), null;
    case 13:
      return s4(e, t, n);
    case 4:
      return Z8(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = g9(t, null, r, n) : h1(e, t, r, n), t.child;
    case 11:
      return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : D1(r, l), K6(e, t, r, l, n);
    case 7:
      return h1(e, t, t.pendingProps, n), t.child;
    case 8:
      return h1(e, t, t.pendingProps.children, n), t.child;
    case 12:
      return h1(e, t, t.pendingProps.children, n), t.child;
    case 10:
      e: {
        if (r = t.type._context, l = t.pendingProps, i = t.memoizedProps, s = l.value, X(C7, r._currentValue), r._currentValue = s, i !== null) if (H1(i.value, s)) {
          if (i.children === l.children && !w1.current) {
            t = s2(e, t, n);
            break e;
          }
        } else for (i = t.child, i !== null && (i.return = t); i !== null; ) {
          var u = i.dependencies;
          if (u !== null) {
            s = i.child;
            for (var a = u.firstContext; a !== null; ) {
              if (a.context === r) {
                if (i.tag === 1) {
                  a = r2(-1, n & -n), a.tag = 2;
                  var c = i.updateQueue;
                  if (c !== null) {
                    c = c.shared;
                    var p = c.pending;
                    p === null ? a.next = a : (a.next = p.next, p.next = a), c.pending = a;
                  }
                }
                i.lanes |= n, a = i.alternate, a !== null && (a.lanes |= n), X3(
                  i.return,
                  n,
                  t
                ), u.lanes |= n;
                break;
              }
              a = a.next;
            }
          } else if (i.tag === 10) s = i.type === t.type ? null : i.child;
          else if (i.tag === 18) {
            if (s = i.return, s === null) throw Error(x(341));
            s.lanes |= n, u = s.alternate, u !== null && (u.lanes |= n), X3(s, n, t), s = i.sibling;
          } else s = i.child;
          if (s !== null) s.return = i;
          else for (s = i; s !== null; ) {
            if (s === t) {
              s = null;
              break;
            }
            if (i = s.sibling, i !== null) {
              i.return = s.return, s = i;
              break;
            }
            s = s.return;
          }
          i = s;
        }
        h1(e, t, l.children, n), t = t.child;
      }
      return t;
    case 9:
      return l = t.type, r = t.pendingProps.children, d9(t, n), l = R1(l), r = r(l), t.flags |= 1, h1(e, t, r, n), t.child;
    case 14:
      return r = t.type, l = D1(r, t.pendingProps), l = D1(r.type, l), J6(e, t, r, l, n);
    case 15:
      return r4(e, t, t.type, t.pendingProps, n);
    case 17:
      return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : D1(r, l), qe(e, t), t.tag = 1, k1(r) ? (e = !0, u7(t)) : e = !1, d9(t, n), e4(t, r, l), Q3(t, r, l, n), K3(null, t, r, !0, e, n);
    case 19:
      return u4(e, t, n);
    case 22:
      return l4(e, t, n);
  }
  throw Error(x(156, t.tag));
};
function E4(e, t) {
  return b5(e, t);
}
function tr(e, t, n, r) {
  this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
}
function P1(e, t, n, r) {
  return new tr(e, t, n, r);
}
function J8(e) {
  return e = e.prototype, !(!e || !e.isReactComponent);
}
function nr(e) {
  if (typeof e == "function") return J8(e) ? 1 : 0;
  if (e != null) {
    if (e = e.$$typeof, e === h8) return 11;
    if (e === v8) return 14;
  }
  return 2;
}
function E2(e, t) {
  var n = e.alternate;
  return n === null ? (n = P1(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 14680064, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
}
function be(e, t, n, r, l, i) {
  var s = 2;
  if (r = e, typeof e == "function") J8(e) && (s = 1);
  else if (typeof e == "string") s = 5;
  else e: switch (e) {
    case _2:
      return D2(n.children, l, i, t);
    case p8:
      s = 8, l |= 8;
      break;
    case v3:
      return e = P1(12, n, t, l | 2), e.elementType = v3, e.lanes = i, e;
    case m3:
      return e = P1(13, n, t, l), e.elementType = m3, e.lanes = i, e;
    case g3:
      return e = P1(19, n, t, l), e.elementType = g3, e.lanes = i, e;
    case R5:
      return N7(n, l, i, t);
    default:
      if (typeof e == "object" && e !== null) switch (e.$$typeof) {
        case P5:
          s = 10;
          break e;
        case N5:
          s = 9;
          break e;
        case h8:
          s = 11;
          break e;
        case v8:
          s = 14;
          break e;
        case C2:
          s = 16, r = null;
          break e;
      }
      throw Error(x(130, e == null ? e : typeof e, ""));
  }
  return t = P1(s, n, t, l), t.elementType = e, t.type = r, t.lanes = i, t;
}
function D2(e, t, n, r) {
  return e = P1(7, e, r, t), e.lanes = n, e;
}
function N7(e, t, n, r) {
  return e = P1(22, e, r, t), e.elementType = R5, e.lanes = n, e.stateNode = { isHidden: !1 }, e;
}
function a3(e, t, n) {
  return e = P1(6, e, null, t), e.lanes = n, e;
}
function c3(e, t, n) {
  return t = P1(4, e.children !== null ? e.children : [], e.key, t), t.lanes = n, t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }, t;
}
function rr(e, t, n, r, l) {
  this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = X7(0), this.expirationTimes = X7(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = X7(0), this.identifierPrefix = r, this.onRecoverableError = l, this.mutableSourceEagerHydrationData = null;
}
function b8(e, t, n, r, l, i, s, u, a) {
  return e = new rr(e, t, n, u, a), t === 1 ? (t = 1, i === !0 && (t |= 8)) : t = 0, i = P1(3, null, null, t), e.current = i, i.stateNode = e, i.memoizedState = { element: r, isDehydrated: n, cache: null, transitions: null, pendingSuspenseBoundaries: null }, R8(i), e;
}
function lr(e, t, n) {
  var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return { $$typeof: b2, key: r == null ? null : "" + r, children: e, containerInfo: t, implementation: n };
}
function j4(e) {
  if (!e) return L2;
  e = e._reactInternals;
  e: {
    if (X2(e) !== e || e.tag !== 1) throw Error(x(170));
    var t = e;
    do {
      switch (t.tag) {
        case 3:
          t = t.stateNode.context;
          break e;
        case 1:
          if (k1(t.type)) {
            t = t.stateNode.__reactInternalMemoizedMergedChildContext;
            break e;
          }
      }
      t = t.return;
    } while (t !== null);
    throw Error(x(171));
  }
  if (e.tag === 1) {
    var n = e.type;
    if (k1(n)) return j0(e, n, t);
  }
  return t;
}
function L4(e, t, n, r, l, i, s, u, a) {
  return e = b8(n, r, !0, e, l, i, s, u, a), e.context = j4(null), n = e.current, r = v1(), l = S2(n), i = r2(r, l), i.callback = t ?? null, w2(n, i, l), e.current.lanes = l, de(e, l, r), S1(e, r), e;
}
function R7(e, t, n, r) {
  var l = t.current, i = v1(), s = S2(l);
  return n = j4(n), t.context === null ? t.context = n : t.pendingContext = n, t = r2(i, s), t.payload = { element: e }, r = r === void 0 ? null : r, r !== null && (t.callback = r), e = w2(l, t, s), e !== null && (W1(e, l, s, i), Ge(e, l, s)), s;
}
function w7(e) {
  if (e = e.current, !e.child) return null;
  switch (e.child.tag) {
    case 5:
      return e.child.stateNode;
    default:
      return e.child.stateNode;
  }
}
function u5(e, t) {
  if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
    var n = e.retryLane;
    e.retryLane = n !== 0 && n < t ? n : t;
  }
}
function _8(e, t) {
  u5(e, t), (e = e.alternate) && u5(e, t);
}
function ir() {
  return null;
}
var M4 = typeof reportError == "function" ? reportError : function(e) {
  console.error(e);
};
function $8(e) {
  this._internalRoot = e;
}
Z7.prototype.render = $8.prototype.render = function(e) {
  var t = this._internalRoot;
  if (t === null) throw Error(x(409));
  R7(e, t, null, null);
};
Z7.prototype.unmount = $8.prototype.unmount = function() {
  var e = this._internalRoot;
  if (e !== null) {
    this._internalRoot = null;
    var t = e.containerInfo;
    H2(function() {
      R7(null, e, null, null);
    }), t[i2] = null;
  }
};
function Z7(e) {
  this._internalRoot = e;
}
Z7.prototype.unstable_scheduleHydration = function(e) {
  if (e) {
    var t = l0();
    e = { blockedOn: null, target: e, priority: t };
    for (var n = 0; n < d2.length && t !== 0 && t < d2[n].priority; n++) ;
    d2.splice(n, 0, e), n === 0 && o0(e);
  }
};
function e6(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
}
function F7(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11 && (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "));
}
function a5() {
}
function or(e, t, n, r, l) {
  if (l) {
    if (typeof r == "function") {
      var i = r;
      r = function() {
        var c = w7(s);
        i.call(c);
      };
    }
    var s = L4(t, r, e, 0, null, !1, !1, "", a5);
    return e._reactRootContainer = s, e[i2] = s.current, re(e.nodeType === 8 ? e.parentNode : e), H2(), s;
  }
  for (; l = e.lastChild; ) e.removeChild(l);
  if (typeof r == "function") {
    var u = r;
    r = function() {
      var c = w7(a);
      u.call(c);
    };
  }
  var a = b8(e, 0, !1, null, null, !1, !1, "", a5);
  return e._reactRootContainer = a, e[i2] = a.current, re(e.nodeType === 8 ? e.parentNode : e), H2(function() {
    R7(t, a, n, r);
  }), a;
}
function D7(e, t, n, r, l) {
  var i = n._reactRootContainer;
  if (i) {
    var s = i;
    if (typeof l == "function") {
      var u = l;
      l = function() {
        var a = w7(s);
        u.call(a);
      };
    }
    R7(t, s, e, l);
  } else s = or(n, t, e, l, r);
  return w7(s);
}
n0 = function(e) {
  switch (e.tag) {
    case 3:
      var t = e.stateNode;
      if (t.current.memoizedState.isDehydrated) {
        var n = V9(t.pendingLanes);
        n !== 0 && (y8(t, n | 1), S1(t, e1()), !(V & 6) && (w9 = e1() + 500, A2()));
      }
      break;
    case 13:
      H2(function() {
        var r = o2(e, 1);
        if (r !== null) {
          var l = v1();
          W1(r, e, 1, l);
        }
      }), _8(e, 1);
  }
};
x8 = function(e) {
  if (e.tag === 13) {
    var t = o2(e, 134217728);
    if (t !== null) {
      var n = v1();
      W1(t, e, 134217728, n);
    }
    _8(e, 134217728);
  }
};
r0 = function(e) {
  if (e.tag === 13) {
    var t = S2(e), n = o2(e, t);
    if (n !== null) {
      var r = v1();
      W1(n, e, t, r);
    }
    _8(e, t);
  }
};
l0 = function() {
  return W;
};
i0 = function(e, t) {
  var n = W;
  try {
    return W = e, t();
  } finally {
    W = n;
  }
};
z3 = function(e, t, n) {
  switch (t) {
    case "input":
      if (w3(e, n), t = n.name, n.type === "radio" && t != null) {
        for (n = e; n.parentNode; ) n = n.parentNode;
        for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
          var r = n[t];
          if (r !== e && r.form === e.form) {
            var l = M7(r);
            if (!l) throw Error(x(90));
            F5(r), w3(r, l);
          }
        }
      }
      break;
    case "textarea":
      V5(e, n);
      break;
    case "select":
      t = n.value, t != null && a9(e, !!n.multiple, t, !1);
  }
};
G5 = Y8;
Q5 = H2;
var sr = { usingClientEntryPoint: !1, Events: [he, n9, M7, I5, X5, Y8] }, N9 = { findFiberByHostInstance: N2, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, ur = { bundleType: N9.bundleType, version: N9.version, rendererPackageName: N9.rendererPackageName, rendererConfig: N9.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: u2.ReactCurrentDispatcher, findHostInstanceByFiber: function(e) {
  return e = K5(e), e === null ? null : e.stateNode;
}, findFiberByHostInstance: N9.findFiberByHostInstance || ir, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
  var Ne = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!Ne.isDisabled && Ne.supportsFiber) try {
    S7 = Ne.inject(ur), b1 = Ne;
  } catch {
  }
}
z1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sr;
z1.createPortal = function(e, t) {
  var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!e6(t)) throw Error(x(200));
  return lr(e, t, null, n);
};
z1.createRoot = function(e, t) {
  if (!e6(e)) throw Error(x(299));
  var n = !1, r = "", l = M4;
  return t != null && (t.unstable_strictMode === !0 && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onRecoverableError !== void 0 && (l = t.onRecoverableError)), t = b8(e, 1, !1, null, null, n, !1, r, l), e[i2] = t.current, re(e.nodeType === 8 ? e.parentNode : e), new $8(t);
};
z1.findDOMNode = function(e) {
  if (e == null) return null;
  if (e.nodeType === 1) return e;
  var t = e._reactInternals;
  if (t === void 0)
    throw typeof e.render == "function" ? Error(x(188)) : (e = Object.keys(e).join(","), Error(x(268, e)));
  return e = K5(t), e = e === null ? null : e.stateNode, e;
};
z1.flushSync = function(e) {
  return H2(e);
};
z1.hydrate = function(e, t, n) {
  if (!F7(t)) throw Error(x(200));
  return D7(null, e, t, !0, n);
};
z1.hydrateRoot = function(e, t, n) {
  if (!e6(e)) throw Error(x(405));
  var r = n != null && n.hydratedSources || null, l = !1, i = "", s = M4;
  if (n != null && (n.unstable_strictMode === !0 && (l = !0), n.identifierPrefix !== void 0 && (i = n.identifierPrefix), n.onRecoverableError !== void 0 && (s = n.onRecoverableError)), t = L4(t, null, e, 1, n ?? null, l, !1, i, s), e[i2] = t.current, re(e), r) for (e = 0; e < r.length; e++) n = r[e], l = n._getVersion, l = l(n._source), t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [n, l] : t.mutableSourceEagerHydrationData.push(
    n,
    l
  );
  return new Z7(t);
};
z1.render = function(e, t, n) {
  if (!F7(t)) throw Error(x(200));
  return D7(null, e, t, !1, n);
};
z1.unmountComponentAtNode = function(e) {
  if (!F7(e)) throw Error(x(40));
  return e._reactRootContainer ? (H2(function() {
    D7(null, null, e, !1, function() {
      e._reactRootContainer = null, e[i2] = null;
    });
  }), !0) : !1;
};
z1.unstable_batchedUpdates = Y8;
z1.unstable_renderSubtreeIntoContainer = function(e, t, n, r) {
  if (!F7(n)) throw Error(x(200));
  if (e == null || e._reactInternals === void 0) throw Error(x(38));
  return D7(e, t, n, !1, r);
};
z1.version = "18.3.1-next-f1338f8080-20240426";
function z4() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(z4);
    } catch (e) {
      console.error(e);
    }
}
z4(), z5.exports = z1;
var A4 = z5.exports, B4, c5 = A4;
B4 = c5.createRoot, c5.hydrateRoot;
var t1 = function() {
  return t1 = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var l in t) Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
    }
    return e;
  }, t1.apply(this, arguments);
}, C5 = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, f5 = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, Re = {
  width: "20px",
  height: "20px",
  position: "absolute",
  zIndex: 1
}, ar = {
  top: t1(t1({}, C5), { top: "-5px" }),
  right: t1(t1({}, f5), { left: void 0, right: "-5px" }),
  bottom: t1(t1({}, C5), { top: void 0, bottom: "-5px" }),
  left: t1(t1({}, f5), { left: "-5px" }),
  topRight: t1(t1({}, Re), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: t1(t1({}, Re), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: t1(t1({}, Re), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: t1(t1({}, Re), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, cr = H.memo(function(e) {
  var t = e.onResizeStart, n = e.direction, r = e.children, l = e.replaceStyles, i = e.className, s = H.useCallback(function(c) {
    t(c, n);
  }, [t, n]), u = H.useCallback(function(c) {
    t(c, n);
  }, [t, n]), a = H.useMemo(function() {
    return t1(t1({ position: "absolute", userSelect: "none" }, ar[n]), l ?? {});
  }, [l, n]);
  return o.jsx("div", { className: i || void 0, style: a, onMouseDown: s, onTouchStart: u, children: r });
}), Cr = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, l) {
      r.__proto__ = l;
    } || function(r, l) {
      for (var i in l) Object.prototype.hasOwnProperty.call(l, i) && (r[i] = l[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), K1 = function() {
  return K1 = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var l in t) Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
    }
    return e;
  }, K1.apply(this, arguments);
}, fr = {
  width: "auto",
  height: "auto"
}, Ze = function(e, t, n) {
  return Math.max(Math.min(e, n), t);
}, d5 = function(e, t, n) {
  var r = Math.round(e / t);
  return r * t + n * (r - 1);
}, J2 = function(e, t) {
  return new RegExp(e, "i").test(t);
}, Fe = function(e) {
  return !!(e.touches && e.touches.length);
}, dr = function(e) {
  return !!((e.clientX || e.clientX === 0) && (e.clientY || e.clientY === 0));
}, p5 = function(e, t, n) {
  n === void 0 && (n = 0);
  var r = t.reduce(function(i, s, u) {
    return Math.abs(s - e) < Math.abs(t[i] - e) ? u : i;
  }, 0), l = Math.abs(t[r] - e);
  return n === 0 || l < n ? t[r] : e;
}, C3 = function(e) {
  return e = e.toString(), e === "auto" || e.endsWith("px") || e.endsWith("%") || e.endsWith("vh") || e.endsWith("vw") || e.endsWith("vmax") || e.endsWith("vmin") ? e : "".concat(e, "px");
}, De = function(e, t, n, r) {
  if (e && typeof e == "string") {
    if (e.endsWith("px"))
      return Number(e.replace("px", ""));
    if (e.endsWith("%")) {
      var l = Number(e.replace("%", "")) / 100;
      return t * l;
    }
    if (e.endsWith("vw")) {
      var l = Number(e.replace("vw", "")) / 100;
      return n * l;
    }
    if (e.endsWith("vh")) {
      var l = Number(e.replace("vh", "")) / 100;
      return r * l;
    }
  }
  return e;
}, pr = function(e, t, n, r, l, i, s) {
  return r = De(r, e.width, t, n), l = De(l, e.height, t, n), i = De(i, e.width, t, n), s = De(s, e.height, t, n), {
    maxWidth: typeof r > "u" ? void 0 : Number(r),
    maxHeight: typeof l > "u" ? void 0 : Number(l),
    minWidth: typeof i > "u" ? void 0 : Number(i),
    minHeight: typeof s > "u" ? void 0 : Number(s)
  };
}, hr = function(e) {
  return Array.isArray(e) ? e : [e, e];
}, vr = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "gridGap",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], h5 = "__resizable_base__", mr = (
  /** @class */
  function(e) {
    Cr(t, e);
    function t(n) {
      var r, l, i, s, u = e.call(this, n) || this;
      return u.ratio = 1, u.resizable = null, u.parentLeft = 0, u.parentTop = 0, u.resizableLeft = 0, u.resizableRight = 0, u.resizableTop = 0, u.resizableBottom = 0, u.targetLeft = 0, u.targetTop = 0, u.delta = {
        width: 0,
        height: 0
      }, u.appendBase = function() {
        if (!u.resizable || !u.window)
          return null;
        var a = u.parentNode;
        if (!a)
          return null;
        var c = u.window.document.createElement("div");
        return c.style.width = "100%", c.style.height = "100%", c.style.position = "absolute", c.style.transform = "scale(0, 0)", c.style.left = "0", c.style.flex = "0 0 100%", c.classList ? c.classList.add(h5) : c.className += h5, a.appendChild(c), c;
      }, u.removeBase = function(a) {
        var c = u.parentNode;
        c && c.removeChild(a);
      }, u.state = {
        isResizing: !1,
        width: (l = (r = u.propsSize) === null || r === void 0 ? void 0 : r.width) !== null && l !== void 0 ? l : "auto",
        height: (s = (i = u.propsSize) === null || i === void 0 ? void 0 : i.height) !== null && s !== void 0 ? s : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, u.onResizeStart = u.onResizeStart.bind(u), u.onMouseMove = u.onMouseMove.bind(u), u.onMouseUp = u.onMouseUp.bind(u), u;
    }
    return Object.defineProperty(t.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || fr;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
      get: function() {
        var n = 0, r = 0;
        if (this.resizable && this.window) {
          var l = this.resizable.offsetWidth, i = this.resizable.offsetHeight, s = this.resizable.style.position;
          s !== "relative" && (this.resizable.style.position = "relative"), n = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : l, r = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : i, this.resizable.style.position = s;
        }
        return { width: n, height: r };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sizeStyle", {
      get: function() {
        var n = this, r = this.props.size, l = function(u) {
          var a;
          if (typeof n.state[u] > "u" || n.state[u] === "auto")
            return "auto";
          if (n.propsSize && n.propsSize[u] && (!((a = n.propsSize[u]) === null || a === void 0) && a.toString().endsWith("%"))) {
            if (n.state[u].toString().endsWith("%"))
              return n.state[u].toString();
            var c = n.getParentSize(), p = Number(n.state[u].toString().replace("px", "")), h = p / c[u] * 100;
            return "".concat(h, "%");
          }
          return C3(n.state[u]);
        }, i = r && typeof r.width < "u" && !this.state.isResizing ? C3(r.width) : l("width"), s = r && typeof r.height < "u" && !this.state.isResizing ? C3(r.height) : l("height");
        return { width: i, height: s };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var n = this.appendBase();
      if (!n)
        return { width: 0, height: 0 };
      var r = !1, l = this.parentNode.style.flexWrap;
      l !== "wrap" && (r = !0, this.parentNode.style.flexWrap = "wrap"), n.style.position = "relative", n.style.minWidth = "100%", n.style.minHeight = "100%";
      var i = {
        width: n.offsetWidth,
        height: n.offsetHeight
      };
      return r && (this.parentNode.style.flexWrap = l), this.removeBase(n), i;
    }, t.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, t.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, t.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var n = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: n.flexBasis !== "auto" ? n.flexBasis : void 0
        });
      }
    }, t.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, t.prototype.createSizeForCssProperty = function(n, r) {
      var l = this.propsSize && this.propsSize[r];
      return this.state[r] === "auto" && this.state.original[r] === n && (typeof l > "u" || l === "auto") ? "auto" : n;
    }, t.prototype.calculateNewMaxFromBoundary = function(n, r) {
      var l = this.props.boundsByDirection, i = this.state.direction, s = l && J2("left", i), u = l && J2("top", i), a, c;
      if (this.props.bounds === "parent") {
        var p = this.parentNode;
        p && (a = s ? this.resizableRight - this.parentLeft : p.offsetWidth + (this.parentLeft - this.resizableLeft), c = u ? this.resizableBottom - this.parentTop : p.offsetHeight + (this.parentTop - this.resizableTop));
      } else this.props.bounds === "window" ? this.window && (a = s ? this.resizableRight : this.window.innerWidth - this.resizableLeft, c = u ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (a = s ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), c = u ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return a && Number.isFinite(a) && (n = n && n < a ? n : a), c && Number.isFinite(c) && (r = r && r < c ? r : c), { maxWidth: n, maxHeight: r };
    }, t.prototype.calculateNewSizeFromDirection = function(n, r) {
      var l = this.props.scale || 1, i = hr(this.props.resizeRatio || 1), s = i[0], u = i[1], a = this.state, c = a.direction, p = a.original, h = this.props, v = h.lockAspectRatio, g = h.lockAspectRatioExtraHeight, w = h.lockAspectRatioExtraWidth, y = p.width, N = p.height, f = g || 0, C = w || 0;
      return J2("right", c) && (y = p.width + (n - p.x) * s / l, v && (N = (y - C) / this.ratio + f)), J2("left", c) && (y = p.width - (n - p.x) * s / l, v && (N = (y - C) / this.ratio + f)), J2("bottom", c) && (N = p.height + (r - p.y) * u / l, v && (y = (N - f) * this.ratio + C)), J2("top", c) && (N = p.height - (r - p.y) * u / l, v && (y = (N - f) * this.ratio + C)), { newWidth: y, newHeight: N };
    }, t.prototype.calculateNewSizeFromAspectRatio = function(n, r, l, i) {
      var s = this.props, u = s.lockAspectRatio, a = s.lockAspectRatioExtraHeight, c = s.lockAspectRatioExtraWidth, p = typeof i.width > "u" ? 10 : i.width, h = typeof l.width > "u" || l.width < 0 ? n : l.width, v = typeof i.height > "u" ? 10 : i.height, g = typeof l.height > "u" || l.height < 0 ? r : l.height, w = a || 0, y = c || 0;
      if (u) {
        var N = (v - w) * this.ratio + y, f = (g - w) * this.ratio + y, C = (p - y) / this.ratio + w, d = (h - y) / this.ratio + w, m = Math.max(p, N), k = Math.min(h, f), j = Math.max(v, C), L = Math.min(g, d);
        n = Ze(n, m, k), r = Ze(r, j, L);
      } else
        n = Ze(n, p, h), r = Ze(r, v, g);
      return { newWidth: n, newHeight: r };
    }, t.prototype.setBoundingClientRect = function() {
      var n = 1 / (this.props.scale || 1);
      if (this.props.bounds === "parent") {
        var r = this.parentNode;
        if (r) {
          var l = r.getBoundingClientRect();
          this.parentLeft = l.left * n, this.parentTop = l.top * n;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var i = this.props.bounds.getBoundingClientRect();
        this.targetLeft = i.left * n, this.targetTop = i.top * n;
      }
      if (this.resizable) {
        var s = this.resizable.getBoundingClientRect(), u = s.left, a = s.top, c = s.right, p = s.bottom;
        this.resizableLeft = u * n, this.resizableRight = c * n, this.resizableTop = a * n, this.resizableBottom = p * n;
      }
    }, t.prototype.onResizeStart = function(n, r) {
      if (!(!this.resizable || !this.window)) {
        var l = 0, i = 0;
        if (n.nativeEvent && dr(n.nativeEvent) ? (l = n.nativeEvent.clientX, i = n.nativeEvent.clientY) : n.nativeEvent && Fe(n.nativeEvent) && (l = n.nativeEvent.touches[0].clientX, i = n.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var s = this.props.onResizeStart(n, r, this.resizable);
          if (s === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var u, a = this.window.getComputedStyle(this.resizable);
        if (a.flexBasis !== "auto") {
          var c = this.parentNode;
          if (c) {
            var p = this.window.getComputedStyle(c).flexDirection;
            this.flexDir = p.startsWith("row") ? "row" : "column", u = a.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var h = {
          original: {
            x: l,
            y: i,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: K1(K1({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(n.target).cursor || "auto" }),
          direction: r,
          flexBasis: u
        };
        this.setState(h);
      }
    }, t.prototype.onMouseMove = function(n) {
      var r = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && Fe(n))
          try {
            n.preventDefault(), n.stopPropagation();
          } catch {
          }
        var l = this.props, i = l.maxWidth, s = l.maxHeight, u = l.minWidth, a = l.minHeight, c = Fe(n) ? n.touches[0].clientX : n.clientX, p = Fe(n) ? n.touches[0].clientY : n.clientY, h = this.state, v = h.direction, g = h.original, w = h.width, y = h.height, N = this.getParentSize(), f = pr(N, this.window.innerWidth, this.window.innerHeight, i, s, u, a);
        i = f.maxWidth, s = f.maxHeight, u = f.minWidth, a = f.minHeight;
        var C = this.calculateNewSizeFromDirection(c, p), d = C.newHeight, m = C.newWidth, k = this.calculateNewMaxFromBoundary(i, s);
        this.props.snap && this.props.snap.x && (m = p5(m, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (d = p5(d, this.props.snap.y, this.props.snapGap));
        var j = this.calculateNewSizeFromAspectRatio(m, d, { width: k.maxWidth, height: k.maxHeight }, { width: u, height: a });
        if (m = j.newWidth, d = j.newHeight, this.props.grid) {
          var L = d5(m, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0), S = d5(d, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0), U = this.props.snapGap || 0, Z = U === 0 || Math.abs(L - m) <= U ? L : m, z = U === 0 || Math.abs(S - d) <= U ? S : d;
          m = Z, d = z;
        }
        var P = {
          width: m - g.width,
          height: d - g.height
        };
        if (this.delta = P, w && typeof w == "string") {
          if (w.endsWith("%")) {
            var A = m / N.width * 100;
            m = "".concat(A, "%");
          } else if (w.endsWith("vw")) {
            var D = m / this.window.innerWidth * 100;
            m = "".concat(D, "vw");
          } else if (w.endsWith("vh")) {
            var G = m / this.window.innerHeight * 100;
            m = "".concat(G, "vh");
          }
        }
        if (y && typeof y == "string") {
          if (y.endsWith("%")) {
            var A = d / N.height * 100;
            d = "".concat(A, "%");
          } else if (y.endsWith("vw")) {
            var D = d / this.window.innerWidth * 100;
            d = "".concat(D, "vw");
          } else if (y.endsWith("vh")) {
            var G = d / this.window.innerHeight * 100;
            d = "".concat(G, "vh");
          }
        }
        var O = {
          width: this.createSizeForCssProperty(m, "width"),
          height: this.createSizeForCssProperty(d, "height")
        };
        this.flexDir === "row" ? O.flexBasis = O.width : this.flexDir === "column" && (O.flexBasis = O.height);
        var I1 = this.state.width !== O.width, E = this.state.height !== O.height, T = this.state.flexBasis !== O.flexBasis, B = I1 || E || T;
        B && A4.flushSync(function() {
          r.setState(O);
        }), this.props.onResize && B && this.props.onResize(n, v, this.resizable, P);
      }
    }, t.prototype.onMouseUp = function(n) {
      var r, l, i = this.state, s = i.isResizing, u = i.direction;
      i.original, !(!s || !this.resizable) && (this.props.onResizeStop && this.props.onResizeStop(n, u, this.resizable, this.delta), this.props.size && this.setState({ width: (r = this.props.size.width) !== null && r !== void 0 ? r : "auto", height: (l = this.props.size.height) !== null && l !== void 0 ? l : "auto" }), this.unbindEvents(), this.setState({
        isResizing: !1,
        backgroundStyle: K1(K1({}, this.state.backgroundStyle), { cursor: "auto" })
      }));
    }, t.prototype.updateSize = function(n) {
      var r, l;
      this.setState({ width: (r = n.width) !== null && r !== void 0 ? r : "auto", height: (l = n.height) !== null && l !== void 0 ? l : "auto" });
    }, t.prototype.renderResizer = function() {
      var n = this, r = this.props, l = r.enable, i = r.handleStyles, s = r.handleClasses, u = r.handleWrapperStyle, a = r.handleWrapperClass, c = r.handleComponent;
      if (!l)
        return null;
      var p = Object.keys(l).map(function(h) {
        return l[h] !== !1 ? o.jsx(cr, { direction: h, onResizeStart: n.onResizeStart, replaceStyles: i && i[h], className: s && s[h], children: c && c[h] ? c[h] : null }, h) : null;
      });
      return o.jsx("div", { className: a, style: u, children: p });
    }, t.prototype.render = function() {
      var n = this, r = Object.keys(this.props).reduce(function(s, u) {
        return vr.indexOf(u) !== -1 || (s[u] = n.props[u]), s;
      }, {}), l = K1(K1(K1({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (l.flexBasis = this.state.flexBasis);
      var i = this.props.as || "div";
      return o.jsxs(i, K1({ style: l, className: this.props.className }, r, {
        // \`ref\` is after \`extendsProps\` to ensure this one wins over a version
        // passed in
        ref: function(s) {
          s && (n.resizable = s);
        },
        children: [this.state.isResizing && o.jsx("div", { style: this.state.backgroundStyle }), this.props.children, this.renderResizer()]
      }));
    }, t.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      gridGap: [0, 0],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, t;
  }(H.PureComponent)
);
const gr = {
  hungry: [
    "Your Geogotchi is hungry!",
    "Feed it by pressing the accept button",
    "Choose healthy food for better stats"
  ],
  happy: [
    "Your Geogotchi is happy!",
    "Play with it to maintain happiness",
    "Happy pets grow stronger"
  ],
  bored: [
    "Your Geogotchi is bored!",
    "Play a game by pressing accept",
    "Regular play keeps it entertained"
  ],
  tired: [
    "Your Geogotchi is tired!",
    "Make it sleep by pressing accept",
    "Rested pets stay healthy"
  ],
  growing: [
    "Your Geogotchi is growing!",
    "Help it grow by setting the time to the right value",
    ""
  ],
  sick: [
    "Your Geogotchi is sick!",
    "Take care of it to restore health",
    "Healthy pets live longer"
  ],
  dead: [
    "Your Geogotchi has passed away.",
    "You can start a new one anytime.",
    "Remember to take good care of it!"
  ]
}, yr = ({
  eventType: e,
  messageIndex: t
}) => {
  const n = gr[e] || ["Unknown event"], r = n[t % n.length];
  return /* @__PURE__ */ o.jsx("div", { style: { width: "100%", textAlign: "center", height: "100%" }, children: /* @__PURE__ */ o.jsx("p", { children: r }) });
}, R9 = 10, Z9 = 12, f3 = 12, xr = {
  I: [
    [0, 0, 0, 0],
    [1, 1, 1, 1],
    [0, 0, 0, 0],
    [0, 0, 0, 0]
  ],
  O: [
    [1, 1],
    [1, 1]
  ],
  T: [
    [0, 1, 0],
    [1, 1, 1],
    [0, 0, 0]
  ],
  S: [
    [0, 1, 1],
    [1, 1, 0],
    [0, 0, 0]
  ],
  Z: [
    [1, 1, 0],
    [0, 1, 1],
    [0, 0, 0]
  ],
  J: [
    [1, 0, 0],
    [1, 1, 1],
    [0, 0, 0]
  ],
  L: [
    [0, 0, 1],
    [1, 1, 1],
    [0, 0, 0]
  ]
}, wr = {
  I: "#0B455E",
  O: "#0B455E",
  T: "#0B455E",
  S: "#0B455E",
  Z: "#0B455E",
  J: "#0B455E",
  L: "#0B455E"
}, kr = ({
  onClose: e,
  initialSpeed: t = 400,
  speedIncrement: n = 100,
  highScore: r = 0,
  onLinesCleared: l
}) => {
  const [i, s] = H.useState(
    Array(Z9).fill(null).map(() => Array(R9).fill(null))
  ), [u, a] = H.useState(null), [c, p] = H.useState(null), [h, v] = H.useState(0), [g, w] = H.useState(!1), [y, N] = H.useState(t), f = H.useRef(null);
  H.useEffect(() => {
    p(C());
  }, []), H.useEffect(() => {
    h > 0 && (l == null || l(h));
  }, [h, l]);
  const C = () => {
    const z = ["I", "O", "T", "S", "Z", "J", "L"];
    return z[Math.floor(Math.random() * z.length)];
  }, d = H.useCallback(() => {
    if (!c) return null;
    const z = c, P = xr[z], A = {
      x: Math.floor(R9 / 2) - Math.floor(P[0].length / 2),
      y: 0
    };
    return p(C()), { shape: P, type: z, position: A };
  }, [c]), m = H.useCallback(
    (z, P) => {
      for (let A = 0; A < z.shape.length; A++)
        for (let D = 0; D < z.shape[A].length; D++)
          if (z.shape[A][D]) {
            const G = P.x + D, O = P.y + A;
            if (G < 0 || G >= R9 || O >= Z9 || O >= 0 && i[O][G])
              return !0;
          }
      return !1;
    },
    [i]
  ), k = H.useCallback(
    (z) => {
      const P = i.map((A) => [...A]);
      for (let A = 0; A < z.shape.length; A++)
        for (let D = 0; D < z.shape[A].length; D++)
          if (z.shape[A][D]) {
            const G = z.position.y + A, O = z.position.x + D;
            G >= 0 && (P[G][O] = z.type);
          }
      return s(P), P;
    },
    [i]
  ), j = H.useCallback(
    (z) => {
      const P = z.filter(
        (D) => D.some((G) => G === null)
      ), A = Z9 - P.length;
      if (A > 0) {
        const D = Array(A).fill(null).map(() => Array(R9).fill(null));
        s([...D, ...P]), v((G) => {
          const O = G + A;
          return O % 3 === 0 && N((I1) => Math.max(200, I1 - n)), O;
        });
      } else
        s(z);
    },
    [l, n]
  ), L = H.useCallback((z) => z.shape[0].map(
    (P, A) => z.shape.map((D) => D[A]).reverse()
  ), []), S = H.useCallback(
    (z) => {
      if (!u || g) return;
      let P = { ...u.position }, A = u.shape;
      switch (z) {
        case "left":
          P.x -= 1;
          break;
        case "right":
          P.x += 1;
          break;
        case "down":
          P.y += 1;
          break;
        case "rotate":
          A = L(u);
          break;
      }
      const D = {
        ...u,
        shape: A,
        position: P
      };
      if (!m(D, P))
        a(D);
      else if (z === "down") {
        const G = k(u);
        j(G);
        const O = d();
        O && m(O, O.position) ? (w(!0), setTimeout(() => e == null ? void 0 : e(!1), 1500)) : a(O);
      }
    },
    [
      u,
      g,
      m,
      k,
      j,
      d,
      L,
      e
    ]
  );
  H.useEffect(() => {
    const z = (P) => {
      if (!g)
        switch (P.key) {
          case "ArrowLeft":
            P.preventDefault(), S("left");
            break;
          case "ArrowRight":
            P.preventDefault(), S("right");
            break;
          case "ArrowDown":
            P.preventDefault(), S("down");
            break;
          case "ArrowUp":
            P.preventDefault(), S("rotate");
            break;
        }
    };
    return window.addEventListener("keydown", z), () => window.removeEventListener("keydown", z);
  }, [g, S]), H.useEffect(() => {
    if (g) {
      f.current && clearInterval(f.current);
      return;
    }
    if (!u) {
      a(d());
      return;
    }
    return f.current = setInterval(() => {
      S("down");
    }, y), () => {
      f.current && clearInterval(f.current);
    };
  }, [u, g, y, S, d]);
  const Z = (() => {
    const z = i.map((P) => [...P]);
    if (u) {
      for (let P = 0; P < u.shape.length; P++)
        for (let A = 0; A < u.shape[P].length; A++)
          if (u.shape[P][A]) {
            const D = u.position.y + P, G = u.position.x + A;
            D >= 0 && D < Z9 && G >= 0 && G < R9 && (z[D][G] = u.type);
          }
    }
    return z;
  })();
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        position: "relative"
      },
      children: [
        /* @__PURE__ */ o.jsx(
          "div",
          {
            style: {
              position: "absolute",
              top: "10%",
              right: "0",
              fontSize: "10px",
              fontWeight: "bold",
              color: "#0B455E",
              fontFamily: "monospace",
              background: "rgba(233, 246, 249, 1)",
              padding: "2px 6px",
              borderRadius: "4px",
              zIndex: 103243
            },
            children: h
          }
        ),
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            style: {
              position: "absolute",
              top: "10%",
              left: "0",
              fontSize: "10px",
              fontWeight: "bold",
              color: "#0B455E",
              fontFamily: "monospace",
              background: "rgba(233, 246, 249, 1)",
              padding: "2px 6px",
              borderRadius: "4px",
              zIndex: 103243
            },
            children: [
              "highscore : ",
              r
            ]
          }
        ),
        /* @__PURE__ */ o.jsxs("div", { style: { position: "relative" }, children: [
          /* @__PURE__ */ o.jsx(
            "div",
            {
              style: {
                display: "grid",
                gridTemplateRows: \`repeat(\${Z9}, \${f3}px)\`,
                gap: "1px",
                background: "#E8F4F8",
                padding: "4px",
                border: "2px solid #0B455E",
                borderRadius: "4px"
              },
              children: Z.map((z, P) => /* @__PURE__ */ o.jsx("div", { style: { display: "flex", gap: "1px" }, children: z.map((A, D) => /* @__PURE__ */ o.jsx(
                "div",
                {
                  style: {
                    width: \`\${f3}px\`,
                    height: \`\${f3}px\`,
                    backgroundColor: A ? wr[A] : "#BADEE4",
                    border: \`1px solid \${A ? "#0B455E" : "rgba(11, 69, 94, 0.2)"}\`,
                    borderRadius: "1px"
                  }
                },
                D
              )) }, P))
            }
          ),
          g && /* @__PURE__ */ o.jsx(
            "div",
            {
              style: {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(11, 69, 94, 0.8)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "4px"
              },
              children: /* @__PURE__ */ o.jsx(
                "div",
                {
                  style: {
                    color: "#E8F4F8",
                    fontFamily: "monospace",
                    fontSize: "12px",
                    fontWeight: "bold"
                  },
                  children: "GAME OVER"
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ o.jsx(
          "div",
          {
            style: {
              fontSize: "9px",
              color: "#0B455E",
              fontFamily: "monospace",
              textAlign: "center"
            },
            children: "â† â†’ â†‘ â†“"
          }
        )
      ]
    }
  );
}, Sr = ({
  eventType: e,
  onComplete: t,
  onBack: n,
  tetrisHighScore: r,
  onTetrisLinesCleared: l
}) => {
  const i = (s) => {
    s ? (console.log("Tetris completed successfully!"), t()) : (console.log("Tetris closed without completing"), n());
  };
  switch (e) {
    case "bored":
      return /* @__PURE__ */ o.jsx(
        kr,
        {
          onClose: i,
          highScore: r,
          onLinesCleared: l
        }
      );
    case "hungry":
      return /* @__PURE__ */ o.jsxs("div", { style: { textAlign: "center" }, children: [
        /* @__PURE__ */ o.jsx("p", { children: "Feeding your Geogotchi..." }),
        /* @__PURE__ */ o.jsx("button", { onClick: t, children: "Feed" })
      ] });
    case "tired":
      return /* @__PURE__ */ o.jsxs("div", { style: { textAlign: "center" }, children: [
        /* @__PURE__ */ o.jsx("p", { children: "Making your Geogotchi sleep..." }),
        /* @__PURE__ */ o.jsx("button", { onClick: t, children: "Sleep" })
      ] });
    case "happy":
      return /* @__PURE__ */ o.jsxs("div", { style: { textAlign: "center" }, children: [
        /* @__PURE__ */ o.jsx("p", { children: "Your Geogotchi is happy!" }),
        /* @__PURE__ */ o.jsx("button", { onClick: t, children: "Continue" })
      ] });
    case "growing":
      return /* @__PURE__ */ o.jsxs("div", { style: { textAlign: "center" }, children: [
        /* @__PURE__ */ o.jsx("p", { children: "Your Geogotchi is growing!" }),
        /* @__PURE__ */ o.jsx("button", { onClick: t, children: "Continue" })
      ] });
    case "sick":
      return /* @__PURE__ */ o.jsxs("div", { style: { textAlign: "center" }, children: [
        /* @__PURE__ */ o.jsx("p", { children: "Taking care of your sick Geogotchi..." }),
        /* @__PURE__ */ o.jsx("button", { onClick: t, children: "Heal" })
      ] });
    case "dead":
      return /* @__PURE__ */ o.jsxs("div", { style: { textAlign: "center" }, children: [
        /* @__PURE__ */ o.jsx("p", { children: "Your Geogotchi has passed away." }),
        /* @__PURE__ */ o.jsx("button", { onClick: t, children: "Start New" })
      ] });
    default:
      return /* @__PURE__ */ o.jsxs("div", { style: { textAlign: "center" }, children: [
        /* @__PURE__ */ o.jsx("p", { children: "Unknown event" }),
        /* @__PURE__ */ o.jsx("button", { onClick: n, children: "Back" })
      ] });
  }
};
class Er {
  constructor(t, n) {
    Q1(this, "intervalId", null);
    Q1(this, "isRunning", !1);
    this.intervalMinutes = t, this.onRandomEvent = n;
  }
  start() {
    if (this.isRunning) return;
    this.isRunning = !0;
    const t = this.intervalMinutes * 60 * 1e3;
    this.intervalId = window.setInterval(() => {
      this.onRandomEvent();
    }, t);
  }
  stop() {
    this.intervalId && (clearInterval(this.intervalId), this.intervalId = null, this.isRunning = !1);
  }
  updateInterval(t) {
    const n = this.isRunning;
    this.stop(), this.intervalMinutes = t, n && this.start();
  }
}
const jr = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "40",
    viewBox: "0 0 30 40",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsxs("g", { clipPath: "url(#clip0_64_523)", children: [
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M24.8426 14.6242C24.4207 13.9039 21.2496 11.5868 19.2117 10.6248C18.8275 10.4434 18.3608 10.4175 16.8533 10.2392C13.4002 9.83091 10.7061 10.0131 9.90521 10.2833C8.04965 10.9093 6.69268 12.2062 3.97404 15.2326C2.88909 16.4403 2.51895 17.3433 2.332 18.0631C2.09715 18.9673 2.0322 20.9492 2.0017 23.2544C1.97307 25.4185 2.30108 27.816 3.37657 29.6726C4.21568 31.1212 5.38667 32.5102 6.43654 33.328C7.03066 33.7908 7.71442 33.9113 8.32349 34.1018C9.22821 34.3848 11.6311 34.501 14.5917 34.5164C16.0591 34.524 18.0783 34.1159 20.7315 33.6175C22.8668 33.2164 24.1991 32.057 25.0826 30.9541C25.9766 29.8382 26.8289 27.8958 27.5325 25.6104C27.9275 24.3277 28.0637 22.7221 27.9525 21.5903C27.8548 20.5958 27.4168 19.7082 26.9279 18.8334C26.5571 18.1699 26.2148 17.3891 25.8985 16.4959C25.701 16.0876 25.5143 15.7332 25.3304 15.3229C25.2256 15.0615 25.0976 14.6922 24.8893 14.0821",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M13.5543 24.2595C13.6077 22.8475 13.7092 20.4853 13.8277 19.7708C13.9491 19.0384 14.0562 18.2468 14.1482 17.0117C14.1683 16.7417 14.2018 16.5783 14.1262 16.581C13.2074 16.6132 12.7095 18.098 12.0984 18.5258C11.9516 18.6286 11.8221 18.7557 11.836 18.7274C11.958 18.4793 13.0803 17.5049 14.4872 16.3949C14.9474 16.0318 15.0987 16.384 15.1865 16.6401C15.2742 16.8963 15.3465 17.1246 15.4148 17.3233C15.4831 17.522 15.5452 17.6842 15.7219 18.1146",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M13.2402 25.0652C15.8891 24.9589 18.9218 25.0034 19.8729 24.8982C20.0337 24.8804 19.9295 24.6025 19.782 24.3987C19.1614 23.5416 18.5808 23.2117 18.3627 23.0126C18.0021 22.6832 19.181 23.9487 19.9607 24.6983C20.1654 24.8951 20.3553 25.0667 20.4323 25.2377C20.5093 25.4088 20.4707 25.5707 20.3701 25.7261C19.9363 26.3959 19.1716 26.6504 18.441 26.9411C18.2549 26.9978 18.0908 27.0475 17.9242 27.1165C17.7576 27.1855 17.5935 27.2724 17.4244 27.3619",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M26.9201 23.2513C26.7485 23.2261 26.4438 23.213 26.0272 23.2255C25.6494 23.2627 25.2796 23.3131 24.9145 23.3693C24.7362 23.4007 24.5721 23.4379 24.25 23.5139",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M14.2217 12.7507C14.2465 12.5286 14.2875 12.1625 14.3382 11.6728C14.3607 11.4346 14.3765 11.2177 14.3988 11.0188C14.4211 10.82 14.4493 10.6458 14.4784 10.3516",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M2.80957 23.6231C2.9861 23.6105 3.16263 23.5979 3.76849 23.5738C4.37436 23.5498 5.40422 23.5147 6.46528 23.4785",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M13.8857 34.1733C13.8857 33.9478 13.8857 33.7223 13.8857 33.5106C13.8857 33.2989 13.8857 33.1078 13.8999 32.9109C13.914 32.714 13.9422 32.5172 14.0842 31.8936",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M6.77772 34.876C6.00033 36.2649 5.35348 37.0462 4.9432 37.6126C4.83566 37.7611 4.73454 37.9237 4.77297 37.9729C5.47297 38.8687 7.54998 38.1352 7.75124 38.1086C8.60266 37.9959 7.62331 35.9667 7.80179 35.6298C7.91159 35.4226 7.79416 36.2892 7.64872 36.5874C7.4859 36.9213 7.05464 37.0364 6.91546 37.0544C7.03605 36.7196 7.57053 36.1283 8.25591 35.5833C8.53689 35.3654 8.68218 35.2668 8.83187 35.1652",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M21.3799 34.7431C21.5896 35.5506 21.8709 36.3584 22.1957 37.0203C22.4121 37.4613 22.7613 37.6172 23.1079 37.6924C24.129 37.9139 25.6157 37.569 26.2408 37.3576C27.8759 36.8046 22.4359 34.7388 22.3454 34.4335C22.3016 34.286 22.4298 34.1282 22.5674 34.1279C23.4425 34.1263 23.6352 35.6852 23.7319 36.2361C23.4831 36.1459 23.1259 35.7431 22.865 35.3827C22.743 35.2101 22.642 35.0587 22.5379 34.8261",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M17.5 3.63398C18.1667 4.01888 18.1667 4.98113 17.5 5.36603L13.75 7.53109C13.0833 7.91599 12.25 7.43486 12.25 6.66506L12.25 2.33493C12.25 1.56513 13.0833 1.08401 13.75 1.46891L17.5 3.63398Z",
            fill: "#0B455E"
          }
        )
      ] }),
      /* @__PURE__ */ o.jsx("defs", { children: /* @__PURE__ */ o.jsx("clipPath", { id: "clip0_64_523", children: /* @__PURE__ */ o.jsx("rect", { width: "30", height: "40", fill: "white" }) }) })
    ]
  }
), Lr = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "40",
    viewBox: "0 0 30 40",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsxs("g", { clipPath: "url(#clip0_64_573)", children: [
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M24.8426 14.6242C24.4207 13.9039 21.2496 11.5868 19.2117 10.6248C18.8275 10.4434 18.3608 10.4175 16.8533 10.2392C13.4002 9.83091 10.7061 10.0131 9.90521 10.2833C8.04965 10.9093 6.69268 12.2062 3.97404 15.2326C2.88909 16.4403 2.51895 17.3433 2.332 18.0631C2.09715 18.9673 2.0322 20.9492 2.0017 23.2544C1.97307 25.4185 2.30108 27.816 3.37657 29.6726C4.21568 31.1212 5.38667 32.5102 6.43654 33.328C7.03066 33.7908 7.71442 33.9113 8.32349 34.1018C9.22821 34.3848 11.6311 34.501 14.5917 34.5164C16.0591 34.524 18.0783 34.1159 20.7315 33.6175C22.8668 33.2164 24.1991 32.057 25.0826 30.9541C25.9766 29.8382 26.8289 27.8958 27.5325 25.6104C27.9275 24.3277 28.0637 22.7221 27.9525 21.5903C27.8548 20.5958 27.4168 19.7082 26.9279 18.8334C26.5571 18.1699 26.2148 17.3891 25.8985 16.4959C25.701 16.0876 25.5143 15.7332 25.3304 15.3229C25.2256 15.0615 25.0976 14.6922 24.8893 14.0821",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M13.5543 24.2595C13.6077 22.8475 13.7092 20.4853 13.8277 19.7708C13.9491 19.0384 14.0562 18.2468 14.1482 17.0117C14.1683 16.7417 14.2018 16.5783 14.1262 16.581C13.2074 16.6132 12.7095 18.098 12.0984 18.5258C11.9516 18.6286 11.8221 18.7557 11.836 18.7274C11.958 18.4793 13.0803 17.5049 14.4872 16.3949C14.9474 16.0318 15.0987 16.384 15.1865 16.6401C15.2742 16.8963 15.3465 17.1246 15.4148 17.3233C15.4831 17.522 15.5452 17.6842 15.7219 18.1146",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M13.2402 25.0652C15.8891 24.9589 18.9218 25.0034 19.8729 24.8982C20.0337 24.8804 19.9295 24.6025 19.782 24.3987C19.1614 23.5416 18.5808 23.2117 18.3627 23.0126C18.0021 22.6832 19.181 23.9487 19.9607 24.6983C20.1654 24.8951 20.3553 25.0667 20.4323 25.2377C20.5093 25.4088 20.4707 25.5707 20.3701 25.7261C19.9363 26.3959 19.1716 26.6504 18.441 26.9411C18.2549 26.9978 18.0908 27.0475 17.9242 27.1165C17.7576 27.1855 17.5935 27.2724 17.4244 27.3619",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M26.9201 23.2513C26.7485 23.2261 26.4438 23.213 26.0272 23.2255C25.6494 23.2627 25.2796 23.3131 24.9145 23.3693C24.7362 23.4007 24.5721 23.4379 24.25 23.5139",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M14.2217 12.7507C14.2465 12.5286 14.2875 12.1625 14.3382 11.6728C14.3607 11.4346 14.3765 11.2177 14.3988 11.0188C14.4211 10.82 14.4493 10.6458 14.4784 10.3516",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M2.80957 23.6231C2.9861 23.6105 3.16263 23.5979 3.76849 23.5738C4.37436 23.5498 5.40422 23.5147 6.46528 23.4785",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M13.8857 34.1733C13.8857 33.9478 13.8857 33.7223 13.8857 33.5106C13.8857 33.2989 13.8857 33.1078 13.8999 32.9109C13.914 32.714 13.9422 32.5172 14.0842 31.8936",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M6.77772 34.876C6.00033 36.2649 5.35348 37.0462 4.9432 37.6126C4.83566 37.7611 4.73454 37.9237 4.77297 37.9729C5.47297 38.8687 7.54998 38.1352 7.75124 38.1086C8.60266 37.9959 7.62331 35.9667 7.80179 35.6298C7.91159 35.4226 7.79416 36.2892 7.64872 36.5874C7.4859 36.9213 7.05464 37.0364 6.91546 37.0544C7.03605 36.7196 7.57053 36.1283 8.25591 35.5833C8.53689 35.3654 8.68218 35.2668 8.83187 35.1652",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M21.3799 34.7431C21.5896 35.5506 21.8709 36.3584 22.1957 37.0203C22.4121 37.4613 22.7613 37.6172 23.1079 37.6924C24.129 37.9139 25.6157 37.569 26.2408 37.3576C27.8759 36.8046 22.4359 34.7388 22.3454 34.4335C22.3016 34.286 22.4298 34.1282 22.5674 34.1279C23.4425 34.1263 23.6352 35.6852 23.7319 36.2361C23.4831 36.1459 23.1259 35.7431 22.865 35.3827C22.743 35.2101 22.642 35.0587 22.5379 34.8261",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M15.5 3.63398C16.1667 4.01888 16.1667 4.98113 15.5 5.36603L11.75 7.53109C11.0833 7.91599 10.25 7.43486 10.25 6.66506L10.25 2.33493C10.25 1.56513 11.0833 1.08401 11.75 1.46891L15.5 3.63398Z",
            fill: "#0B455E"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M19.5 3.63398C20.1667 4.01888 20.1667 4.98113 19.5 5.36603L15.75 7.53109C15.0833 7.91599 14.25 7.43486 14.25 6.66506L14.25 2.33493C14.25 1.56513 15.0833 1.08401 15.75 1.46891L19.5 3.63398Z",
            fill: "#0B455E"
          }
        )
      ] }),
      /* @__PURE__ */ o.jsx("defs", { children: /* @__PURE__ */ o.jsx("clipPath", { id: "clip0_64_573", children: /* @__PURE__ */ o.jsx("rect", { width: "30", height: "40", fill: "white" }) }) })
    ]
  }
), Mr = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "40",
    viewBox: "0 0 30 40",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsxs("g", { clipPath: "url(#clip0_64_585)", children: [
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M24.8426 14.6242C24.4207 13.9039 21.2496 11.5868 19.2117 10.6248C18.8275 10.4434 18.3608 10.4175 16.8533 10.2392C13.4002 9.83091 10.7061 10.0131 9.90521 10.2833C8.04965 10.9093 6.69268 12.2062 3.97404 15.2326C2.88909 16.4403 2.51895 17.3433 2.332 18.0631C2.09715 18.9673 2.0322 20.9492 2.0017 23.2544C1.97307 25.4185 2.30108 27.816 3.37657 29.6726C4.21568 31.1212 5.38667 32.5102 6.43654 33.328C7.03066 33.7908 7.71442 33.9113 8.32349 34.1018C9.22821 34.3848 11.6311 34.501 14.5917 34.5164C16.0591 34.524 18.0783 34.1159 20.7315 33.6175C22.8668 33.2164 24.1991 32.057 25.0826 30.9541C25.9766 29.8382 26.8289 27.8958 27.5325 25.6104C27.9275 24.3277 28.0637 22.7221 27.9525 21.5903C27.8548 20.5958 27.4168 19.7082 26.9279 18.8334C26.5571 18.1699 26.2148 17.3891 25.8985 16.4959C25.701 16.0876 25.5143 15.7332 25.3304 15.3229C25.2256 15.0615 25.0976 14.6922 24.8893 14.0821",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M13.5543 24.2595C13.6077 22.8475 13.7092 20.4853 13.8277 19.7708C13.9491 19.0384 14.0562 18.2468 14.1482 17.0117C14.1683 16.7417 14.2018 16.5783 14.1262 16.581C13.2074 16.6132 12.7095 18.098 12.0984 18.5258C11.9516 18.6286 11.8221 18.7557 11.836 18.7274C11.958 18.4793 13.0803 17.5049 14.4872 16.3949C14.9474 16.0318 15.0987 16.384 15.1865 16.6401C15.2742 16.8963 15.3465 17.1246 15.4148 17.3233C15.4831 17.522 15.5452 17.6842 15.7219 18.1146",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M13.2402 25.0652C15.8891 24.9589 18.9218 25.0034 19.8729 24.8982C20.0337 24.8804 19.9295 24.6025 19.782 24.3987C19.1614 23.5416 18.5808 23.2117 18.3627 23.0126C18.0021 22.6832 19.181 23.9487 19.9607 24.6983C20.1654 24.8951 20.3553 25.0667 20.4323 25.2377C20.5093 25.4088 20.4707 25.5707 20.3701 25.7261C19.9363 26.3959 19.1716 26.6504 18.441 26.9411C18.2549 26.9978 18.0908 27.0475 17.9242 27.1165C17.7576 27.1855 17.5935 27.2724 17.4244 27.3619",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M26.9201 23.2513C26.7485 23.2261 26.4438 23.213 26.0272 23.2255C25.6494 23.2627 25.2796 23.3131 24.9145 23.3693C24.7362 23.4007 24.5721 23.4379 24.25 23.5139",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M14.2217 12.7507C14.2465 12.5286 14.2875 12.1625 14.3382 11.6728C14.3607 11.4346 14.3765 11.2177 14.3988 11.0188C14.4211 10.82 14.4493 10.6458 14.4784 10.3516",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M2.80957 23.6231C2.9861 23.6105 3.16263 23.5979 3.76849 23.5738C4.37436 23.5498 5.40422 23.5147 6.46528 23.4785",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M13.8857 34.1733C13.8857 33.9478 13.8857 33.7223 13.8857 33.5106C13.8857 33.2989 13.8857 33.1078 13.8999 32.9109C13.914 32.714 13.9422 32.5172 14.0842 31.8936",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M6.77772 34.876C6.00033 36.2649 5.35348 37.0462 4.9432 37.6126C4.83566 37.7611 4.73454 37.9237 4.77297 37.9729C5.47297 38.8687 7.54998 38.1352 7.75124 38.1086C8.60266 37.9959 7.62331 35.9667 7.80179 35.6298C7.91159 35.4226 7.79416 36.2892 7.64872 36.5874C7.4859 36.9213 7.05464 37.0364 6.91546 37.0544C7.03605 36.7196 7.57053 36.1283 8.25591 35.5833C8.53689 35.3654 8.68218 35.2668 8.83187 35.1652",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M21.3799 34.7431C21.5896 35.5506 21.8709 36.3584 22.1957 37.0203C22.4121 37.4613 22.7613 37.6172 23.1079 37.6924C24.129 37.9139 25.6157 37.569 26.2408 37.3576C27.8759 36.8046 22.4359 34.7388 22.3454 34.4335C22.3016 34.286 22.4298 34.1282 22.5674 34.1279C23.4425 34.1263 23.6352 35.6852 23.7319 36.2361C23.4831 36.1459 23.1259 35.7431 22.865 35.3827C22.743 35.2101 22.642 35.0587 22.5379 34.8261",
            stroke: "#0B455E",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M12.5 3.63398C13.1667 4.01888 13.1667 4.98113 12.5 5.36603L8.75 7.53109C8.08333 7.91599 7.25 7.43486 7.25 6.66506L7.25 2.33493C7.25 1.56513 8.08333 1.08401 8.75 1.46891L12.5 3.63398Z",
            fill: "#0B455E"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M17.5 3.63398C18.1667 4.01888 18.1667 4.98113 17.5 5.36603L13.75 7.53109C13.0833 7.91599 12.25 7.43486 12.25 6.66506L12.25 2.33493C12.25 1.56513 13.0833 1.08401 13.75 1.46891L17.5 3.63398Z",
            fill: "#0B455E"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M22.5 3.63398C23.1667 4.01888 23.1667 4.98113 22.5 5.36603L18.75 7.53109C18.0833 7.91599 17.25 7.43486 17.25 6.66506L17.25 2.33493C17.25 1.56513 18.0833 1.08401 18.75 1.46891L22.5 3.63398Z",
            fill: "#0B455E"
          }
        )
      ] }),
      /* @__PURE__ */ o.jsx("defs", { children: /* @__PURE__ */ o.jsx("clipPath", { id: "clip0_64_585", children: /* @__PURE__ */ o.jsx("rect", { width: "30", height: "40", fill: "white" }) }) })
    ]
  }
);
function zr(e, t) {
  const n = [jr, Lr, Mr], r = n[e], l = () => {
    t((i) => (i + 1) % n.length);
  };
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      onClick: l,
      style: {
        position: "absolute",
        width: "7%",
        right: "5%",
        // Adjust this value based on your clock's width
        top: "40%",
        zIndex: 3
      },
      children: /* @__PURE__ */ o.jsx(
        r,
        {
          style: {
            width: "100%",
            height: "auto",
            display: "block",
            position: "absolute",
            zIndex: 1e4
          }
        }
      )
    }
  );
}
const Ar = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "122",
    height: "101",
    viewBox: "0 0 122 101",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M114.1 31.9304C110.13 27.6004 105.2 24.7604 100.14 23.5004C98.8903 23.1904 97.9403 22.1904 97.7403 20.9204C97.7203 20.8204 97.7103 20.7104 97.6903 20.6104C95.6003 8.27041 83.3803 0.0503619 70.4003 2.25036C67.4603 2.75036 64.7303 3.74042 62.2903 5.12042C61.2103 5.73042 59.8603 5.65042 58.8503 4.93042C54.5503 1.87042 49.1003 0.030362 43.1803 0.000362028C29.1603 -0.069638 17.7403 10.0204 17.6803 22.5404C17.6803 23.0904 17.7003 23.6404 17.7403 24.1804C17.8503 25.6104 16.9403 26.9104 15.5903 27.4004C6.58027 30.6104 0.0502716 39.7704 0.000271552 50.6104C-0.0497284 61.8004 6.81027 71.2704 16.2403 74.2804C17.6203 74.7204 18.5203 75.9904 18.5203 77.4404C18.5203 77.4404 18.5203 77.4604 18.5203 77.4704C18.4603 89.9904 29.4903 100.19 43.1603 100.26C50.0803 100.29 56.3403 97.7204 60.8503 93.5604C61.9703 92.5304 63.6303 92.4303 64.8903 93.2903C70.2303 96.9203 77.2003 98.4604 84.3103 96.9904C96.0303 94.5704 104.19 84.7804 104.17 74.0804C104.17 72.6204 105.13 71.3404 106.54 70.9604C109.61 70.1204 112.46 68.6004 114.9 66.3704C124.13 57.9104 123.78 42.5104 114.11 31.9604L114.1 31.9304Z",
          fill: "#74C4D7"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M70.4891 62.7211C70.4891 52.1911 51.0391 50.9811 51.0391 58.1211C51.0391 65.2611 61.9691 62.7211 61.9691 62.7211C61.9691 62.7211 51.0391 59.9911 51.0391 67.3211C51.0391 74.6511 70.4891 73.2511 70.4891 62.7211Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M97.2011 45.6806C96.9511 44.0106 96.7511 42.1906 95.9311 40.6806C95.1111 39.1606 93.7211 37.8505 92.4411 36.7105C90.7111 35.1605 87.8211 33.5306 86.0111 33.1106C80.1311 31.7706 74.5811 36.5306 71.9411 41.2306C70.4911 43.8106 69.3611 46.9406 70.0211 49.9206C70.6611 52.8206 72.7411 55.3405 75.0211 57.1505C79.3811 60.6005 85.4211 62.0405 90.6011 59.6005C92.9111 58.5205 94.9411 56.6905 96.1711 54.4405C97.6711 51.7005 97.6611 48.6906 97.2011 45.6806Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M50.1894 45.6806C49.9394 44.0106 49.7394 42.1906 48.9194 40.6806C48.0994 39.1606 46.7094 37.8505 45.4294 36.7105C43.6994 35.1605 40.8094 33.5306 38.9994 33.1106C33.1194 31.7706 27.5694 36.5306 24.9294 41.2306C23.4794 43.8106 22.3494 46.9406 23.0094 49.9206C23.6494 52.8206 25.7294 55.3405 28.0094 57.1505C32.3694 60.6005 38.4094 62.0405 43.5894 59.6005C45.8994 58.5205 47.9294 56.6905 49.1594 54.4405C50.6594 51.7005 50.6494 48.6906 50.1894 45.6806Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_3814",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "22",
          y: "32",
          width: "29",
          height: "29",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M50.1894 45.6806C49.9394 44.0106 49.7394 42.1906 48.9194 40.6806C48.0994 39.1606 46.7094 37.8505 45.4294 36.7105C43.6994 35.1605 40.8094 33.5306 38.9994 33.1106C33.1194 31.7706 27.5694 36.5306 24.9294 41.2306C23.4794 43.8106 22.3494 46.9406 23.0094 49.9206C23.6494 52.8206 25.7294 55.3405 28.0094 57.1505C32.3694 60.6005 38.4094 62.0405 43.5894 59.6005C45.8994 58.5205 47.9294 56.6905 49.1594 54.4405C50.6594 51.7005 50.6494 48.6906 50.1894 45.6806Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_3814)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M24.8281 51.2002C24.9581 29.8702 60.8281 28.5802 62.3981 41.6202L50.4081 68.5302L27.6281 65.3802C27.6281 65.3802 24.7081 72.5302 24.8381 51.2002H24.8281Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_3814",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "69",
          y: "32",
          width: "29",
          height: "29",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M97.2011 45.6806C96.9511 44.0106 96.7511 42.1906 95.9311 40.6806C95.1111 39.1606 93.7211 37.8505 92.4411 36.7105C90.7111 35.1605 87.8211 33.5306 86.0111 33.1106C80.1311 31.7706 74.5811 36.5306 71.9411 41.2306C70.4911 43.8106 69.3611 46.9406 70.0211 49.9206C70.6611 52.8206 72.7411 55.3405 75.0211 57.1505C79.3811 60.6005 85.4211 62.0405 90.6011 59.6005C92.9111 58.5205 94.9411 56.6905 96.1711 54.4405C97.6711 51.7005 97.6611 48.6906 97.2011 45.6806Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_3814)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M71.8398 51.2002C71.9698 29.8702 107.84 28.5802 109.41 41.6202L97.4198 68.5302L74.6398 65.3802C74.6398 65.3802 71.7198 72.5302 71.8498 51.2002H71.8398Z",
          fill: "#0B455E"
        }
      ) })
    ]
  }
), Br = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "127",
    height: "111",
    viewBox: "0 0 127 111",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M126.287 58.1613C126.457 55.6713 126.397 53.1613 126.247 50.6613C126.117 48.6613 125.937 46.6513 125.247 44.7213C124.657 43.0713 123.647 41.5413 122.427 40.2113C119.787 37.3313 116.317 35.0512 112.707 33.3712C111.807 32.9512 110.897 32.5913 109.967 32.2313C109.127 31.9113 108.237 31.5813 107.977 30.6913C107.757 29.9513 107.837 29.1112 107.817 28.3612C107.787 27.5012 107.737 26.6413 107.657 25.7813C107.357 22.4313 106.687 19.0712 105.487 15.8712C102.977 9.14124 100.087 5.32125 92.9374 2.63125C89.1574 1.21125 85.2274 0.681268 81.2174 0.271268C77.7874 -0.0787321 74.4274 -0.118744 71.0174 0.321256C64.0574 1.21126 57.5574 4.39129 50.1474 8.42129C44.7374 4.42129 37.3574 2.85124 30.8774 5.05124C27.8174 6.09124 25.0374 7.92124 23.0374 10.3012C20.6974 13.0812 19.5874 16.5513 19.3874 20.0813C19.2074 23.2213 19.7774 26.3113 20.1274 29.4213C18.7374 29.9013 17.3174 30.2913 15.9074 30.7313C13.7574 31.3813 11.7274 32.4013 9.93741 33.6713C6.25741 36.2813 3.48743 39.9413 1.82743 43.9613C-1.94257 53.0813 0.497433 63.1013 5.70743 71.4713C8.19743 75.4813 11.2574 79.2013 14.9974 82.2713C14.3474 85.2313 13.9174 88.0912 14.7774 91.1112C15.9274 95.1612 18.7574 98.7313 22.2374 101.381C26.3574 104.511 31.4374 106.271 36.5074 107.431C39.1874 108.041 41.8974 108.491 44.6174 108.901C47.4074 109.321 50.2974 109.771 53.0874 109.281C58.0474 108.411 61.7574 105.121 65.0874 101.831C69.2674 104.851 73.9774 107.221 78.9774 108.741C84.1174 110.311 90.0574 111.471 95.3974 110.461C100.537 109.491 104.377 106.141 107.437 102.381C110.347 98.7913 112.567 94.6613 113.657 90.2313C114.747 85.8313 114.547 81.1013 112.517 76.9213C116.617 76.0113 120.217 73.7013 122.507 70.3813C125.017 66.7613 125.997 62.4313 126.287 58.1413V58.1613Z",
          fill: "#74C4D7"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M50.5778 64.8612C54.8778 67.5912 60.0378 68.6912 65.0678 67.9412C66.4778 67.7312 67.7578 67.5112 69.1878 67.5512C70.3978 67.5812 71.6078 67.4712 72.7778 67.1412C75.0978 66.4812 77.1578 65.1212 78.7878 63.3812C80.1078 61.9712 77.9878 59.8512 76.6678 61.2612C75.2378 62.7912 73.4878 63.9512 71.4178 64.4012C70.2778 64.6512 69.1578 64.5112 67.9978 64.5312C66.8378 64.5512 65.7878 64.8212 64.6778 64.9912C60.2978 65.7012 55.8078 64.6412 52.0878 62.2812C50.4578 61.2412 48.9478 63.8412 50.5778 64.8712V64.8612Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M102.887 38.942C101.847 37.902 100.237 36.662 98.4072 36.302C91.8372 34.982 85.2372 39.672 82.7772 45.852C81.5172 49.012 81.3673 52.632 82.2373 55.912C83.1073 59.202 85.1173 62.582 88.2673 64.122C91.4773 65.692 95.5173 65.782 98.9273 64.822C100.657 64.332 102.477 63.562 103.797 62.302C105.067 61.092 105.857 59.422 106.467 57.802C108.787 51.672 107.617 43.682 102.887 38.942Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M43.9166 38.942C42.8766 37.902 41.2665 36.662 39.4365 36.302C32.8665 34.982 26.2665 39.672 23.8065 45.852C22.5465 49.012 22.3966 52.632 23.2666 55.912C24.1366 59.202 26.1466 62.582 29.2966 64.122C32.5066 65.692 36.5466 65.782 39.9566 64.822C41.6866 64.332 43.5066 63.562 44.8266 62.302C46.0966 61.092 46.8865 59.422 47.4965 57.802C49.8165 51.672 48.6466 43.682 43.9166 38.942Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_3778",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "81",
          y: "36",
          width: "27",
          height: "30",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M102.887 38.942C101.847 37.902 100.237 36.662 98.4072 36.302C91.8372 34.982 85.2372 39.672 82.7772 45.852C81.5172 49.012 81.3673 52.632 82.2373 55.912C83.1073 59.202 85.1173 62.582 88.2673 64.122C91.4773 65.692 95.5173 65.782 98.9273 64.822C100.657 64.332 102.477 63.562 103.797 62.302C105.067 61.092 105.857 59.422 106.467 57.802C108.787 51.672 107.617 43.682 102.887 38.942Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_3778)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M86.9772 38.3723C85.8772 48.4723 86.2672 58.1523 88.7272 67.2223H114.087C114.087 67.2223 111.067 33.6423 111.107 33.3423C111.587 30.0523 87.5772 33.8823 86.9772 38.3723Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_3778",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "22",
          y: "36",
          width: "27",
          height: "30",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M43.9166 38.942C42.8766 37.902 41.2665 36.662 39.4365 36.302C32.8665 34.982 26.2665 39.672 23.8065 45.852C22.5465 49.012 22.3966 52.632 23.2666 55.912C24.1366 59.202 26.1466 62.582 29.2966 64.122C32.5066 65.692 36.5466 65.782 39.9566 64.822C41.6866 64.332 43.5066 63.562 44.8266 62.302C46.0966 61.092 46.8865 59.422 47.4965 57.802C49.8165 51.672 48.6466 43.682 43.9166 38.942Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_3778)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M28.0065 38.3723C26.9065 48.4723 27.2965 58.1523 29.7565 67.2223H55.1165C55.1165 67.2223 52.0965 33.6423 52.1365 33.3423C52.6165 30.0523 28.6065 33.8823 28.0065 38.3723Z",
          fill: "#0B455E"
        }
      ) })
    ]
  }
), Tr = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "152",
    height: "136",
    viewBox: "0 0 152 136",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M28.4668 60.4889C28.4668 60.4889 25.8569 46.139 39.2569 29.929C52.6569 13.719 96.8868 16.679 109.507 26.199C125.137 37.989 125.727 64.599 125.727 64.599L70.8269 81.679L28.4668 60.4989V60.4889Z",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M1.4475 49.629C7.2975 49.679 13.1275 50.019 18.9375 50.649C19.7475 50.739 20.4375 49.899 20.4375 49.149C20.4375 48.269 19.7475 47.739 18.9375 47.649C13.1275 47.019 7.2875 46.679 1.4475 46.629C-0.4825 46.609 -0.4825 49.609 1.4475 49.629Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M20.9473 10.509C24.5573 13.639 27.5473 17.3591 29.8073 21.5691C30.1873 22.2791 31.1773 22.509 31.8573 22.109C32.5773 21.689 32.7773 20.769 32.3973 20.059C30.0273 15.649 26.8473 11.669 23.0673 8.389C22.4573 7.859 21.5473 7.789 20.9473 8.389C20.4073 8.929 20.3373 9.97899 20.9473 10.509Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M57.5879 4.72904C57.8879 7.03904 58.3079 9.31914 58.8879 11.5791C59.0879 12.3391 59.9679 12.8691 60.7379 12.6291C61.5079 12.3891 61.9979 11.5991 61.7879 10.7791C61.5179 9.73909 61.2779 8.68907 61.0679 7.63907C60.9679 7.10907 60.8679 6.57911 60.7879 6.04911C60.7479 5.80911 60.7079 5.55912 60.6779 5.30912C60.6579 5.18912 60.6379 5.05912 60.6279 4.93912C60.6079 4.76912 60.6079 4.77915 60.6279 4.96915C60.6179 4.88915 60.6079 4.80915 60.5979 4.71915C60.5479 4.30915 60.4679 3.96909 60.1579 3.65909C59.8979 3.39909 59.4679 3.19915 59.0979 3.21915C58.3679 3.24915 57.4879 3.88915 57.5979 4.71915L57.5879 4.72904Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M92.0869 1.08858C91.3769 4.21859 90.8569 7.37856 90.4969 10.5586C90.4069 11.3386 91.2469 12.0886 91.9969 12.0586C92.8869 12.0186 93.4069 11.3986 93.4969 10.5586C93.8169 7.74856 94.3269 4.77851 94.9869 1.88851C95.1569 1.12851 94.7569 0.228536 93.9369 0.0385359C93.1769 -0.131464 92.2769 0.268585 92.0869 1.08858Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M149.946 36.2788C145.046 36.5188 140.146 36.5488 135.246 36.3688C133.316 36.2988 133.316 39.2988 135.246 39.3688C140.146 39.5488 145.046 39.5188 149.946 39.2788C151.866 39.1788 151.876 36.1788 149.946 36.2788Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M124.027 21.2892C126.767 17.5992 129.807 14.1493 133.097 10.9393C134.477 9.58926 132.357 7.46926 130.977 8.81926C127.507 12.2093 124.327 15.8792 121.437 19.7792C120.957 20.4292 121.327 21.4493 121.977 21.8293C122.737 22.2793 123.547 21.9392 124.027 21.2892Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M67.3183 45.9389C65.3083 41.4589 60.7383 38.6289 56.2883 39.2089C51.9083 39.7789 48.0783 43.5788 46.9583 48.3788C45.8183 53.2388 47.7083 58.5289 51.2683 61.4589C53.3583 63.1789 55.9583 63.8288 58.5083 63.8888C60.9083 63.9488 63.3083 63.6789 64.9983 61.5789C68.4183 57.3489 69.4783 51.1589 67.3183 45.9289V45.9389Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_3793",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "46",
          y: "39",
          width: "23",
          height: "25",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M67.3183 45.9389C65.3083 41.4589 60.7383 38.6289 56.2883 39.2089C51.9083 39.7789 48.0783 43.5788 46.9583 48.3788C45.8183 53.2388 47.7083 58.5289 51.2683 61.4589C53.3583 63.1789 55.9583 63.8288 58.5083 63.8888C60.9083 63.9488 63.3083 63.6789 64.9983 61.5789C68.4183 57.3489 69.4783 51.1589 67.3183 45.9289V45.9389Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_3793)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M61.0977 35.9492C64.0177 46.5692 65.2577 56.7791 65.0177 66.6091L44.3377 62.0092L43.9277 44.1492L61.0977 35.9592V35.9492Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M109.008 45.9389C106.998 41.4589 102.428 38.6289 97.9778 39.2089C93.5978 39.7789 89.7678 43.5788 88.6478 48.3788C87.5078 53.2388 89.3978 58.5289 92.9578 61.4589C95.0478 63.1789 97.6478 63.8288 100.198 63.8888C102.598 63.9488 104.998 63.6789 106.688 61.5789C110.108 57.3489 111.168 51.1589 109.008 45.9289V45.9389Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_3793",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "88",
          y: "39",
          width: "23",
          height: "25",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M109.008 45.9389C106.998 41.4589 102.428 38.6289 97.9778 39.2089C93.5978 39.7789 89.7678 43.5788 88.6478 48.3788C87.5078 53.2388 89.3978 58.5289 92.9578 61.4589C95.0478 63.1789 97.6478 63.8288 100.198 63.8888C102.598 63.9488 104.998 63.6789 106.688 61.5789C110.108 57.3489 111.168 51.1589 109.008 45.9289V45.9389Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_3793)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M102.789 35.9492C105.709 46.5692 106.949 56.7791 106.709 66.6091L86.0291 62.0092L85.6191 44.1492L102.789 35.9592V35.9492Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M143.436 88.459C143.236 87.789 142.686 87.279 142.126 86.839C139.926 85.109 137.246 83.9889 134.466 83.6389C135.586 79.3189 135.406 74.669 133.936 70.449C133.376 68.819 132.606 67.2389 131.496 65.9289C129.026 63.0289 124.796 61.7489 121.126 62.7889C119.936 63.1289 118.786 63.6889 117.556 63.6789C115.436 63.6689 113.746 62.0389 112.016 60.8089C106.476 56.8889 98.4761 56.8689 92.9161 60.7589C90.8161 62.2289 89.0761 64.1589 86.9861 65.6389C84.8861 67.1089 82.2061 68.109 79.7661 67.329C77.3561 66.569 75.7961 64.3189 73.8661 62.6789C70.2061 59.5589 65.2161 58.639 60.4761 57.819C57.2361 57.269 53.9261 56.7089 50.6661 57.1789C47.5261 57.6289 44.3961 59.219 42.7861 61.939C40.4561 61.489 38.2361 60.0389 35.9061 59.2889C31.5861 57.8989 26.7261 59.0189 22.9461 61.5189C19.1561 64.0089 16.3361 67.739 14.1161 71.699C11.2761 76.779 9.29609 82.5889 10.0561 88.3589C10.8161 94.1289 14.8461 99.709 20.5261 100.939C21.2461 101.089 22.0661 101.239 22.4561 101.849C22.7161 102.259 22.7161 102.769 22.7161 103.259C22.8161 110.689 27.0261 117.799 33.1561 122.019C39.2761 126.239 47.1061 127.659 54.4561 126.549C57.4961 126.089 60.8161 125.269 63.4661 126.819C64.5961 127.479 65.4561 128.499 66.4861 129.319C68.3661 130.819 70.7161 131.569 73.0261 132.229C82.1461 134.849 92.0261 136.509 101.016 133.499C110.006 130.489 117.576 121.479 116.086 112.109C121.896 115.449 129.666 113.119 134.396 108.379C139.126 103.639 141.446 97.039 143.256 90.589C143.456 89.889 143.646 89.149 143.436 88.459Z",
          fill: "#0B455E"
        }
      )
    ]
  }
), Pr = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "148",
    height: "104",
    viewBox: "0 0 148 104",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M55.023 84.22C54.953 82.36 33.673 79.79 35.403 83.49C36.923 86.74 38.113 90.13 38.973 93.62C39.323 95.06 39.8731 96.6701 39.5031 98.1501C39.3831 98.6501 39.363 98.76 38.923 98.95C38.603 99.09 38.223 99.15 37.883 99.24C36.953 99.51 36.053 99.79 35.073 99.79C33.533 99.79 33.163 101.74 34.333 102.54C36.863 104.28 40.0831 104 42.9931 103.95C46.4331 103.89 49.873 103.82 53.323 103.76C54.153 103.74 54.743 103.1 54.793 102.29C55.173 96.27 55.253 90.25 55.023 84.22Z",
          fill: "#74C4D7"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M95.2535 84.22C95.3235 82.36 116.604 79.79 114.874 83.49C113.354 86.74 112.163 90.13 111.303 93.62C110.953 95.06 110.403 96.6701 110.773 98.1501C110.893 98.6501 110.913 98.76 111.353 98.95C111.673 99.09 112.053 99.15 112.393 99.24C113.323 99.51 114.223 99.79 115.203 99.79C116.743 99.79 117.113 101.74 115.943 102.54C113.413 104.28 110.193 104 107.283 103.95C103.843 103.89 100.403 103.82 96.9535 103.76C96.1235 103.74 95.5335 103.1 95.4835 102.29C95.1035 96.27 95.0235 90.25 95.2535 84.22Z",
          fill: "#74C4D7"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M144.433 43.3196C140.523 37.4696 132.873 35.6796 125.963 34.3496C126.563 27.0596 125.283 19.5096 121.603 13.1896C117.923 6.86958 111.703 1.89957 104.533 0.459572C96.0426 -1.24043 87.3026 2.00958 79.8326 6.36958C73.1926 -0.200425 61.8226 0.129578 53.8926 5.05958C52.4426 5.95958 49.4927 8.41959 49.4927 8.41959C49.4927 8.41959 46.6327 7.77957 45.2327 7.79957C36.6327 7.93957 27.9726 11.3396 22.1526 17.6696C16.8426 23.4396 14.1726 31.6896 15.5126 39.3696C3.90263 44.7796 -2.66735 59.2696 1.03265 71.5596C1.63265 73.5396 2.47267 75.4696 3.74267 77.1096C6.97267 81.2596 12.4326 82.8896 17.5926 83.9296C24.1426 85.2596 30.7827 86.0296 37.4327 86.7296C65.7927 89.6996 95.0327 91.1496 122.293 82.7796C131.323 80.0096 140.773 75.4696 144.693 66.8796C145.983 64.0496 146.583 60.9496 146.913 57.8596C147.443 52.8696 147.223 47.4996 144.433 43.3196Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M61.843 43.8203C59.563 40.3403 53.043 35.8703 45.953 36.5003C43.693 36.7003 41.403 37.3803 39.693 38.8703C38.063 40.2903 37.0831 42.3103 36.3131 44.3303C35.0731 47.5803 34.263 51.0903 34.803 54.5203C35.343 57.9503 37.4531 61.2803 40.6831 62.5503C42.0031 63.0703 43.433 63.2303 44.843 63.3403C50.943 63.8103 57.423 63.3003 62.553 59.9603C63.053 59.6303 63.5531 59.2703 63.9331 58.8103C64.583 58.0203 64.853 56.9803 64.993 55.9603C65.573 51.7003 64.143 47.3003 61.863 43.8303L61.843 43.8203Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_3829",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "34",
          y: "36",
          width: "32",
          height: "28",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M61.843 43.8203C59.563 40.3403 53.043 35.8703 45.953 36.5003C43.693 36.7003 41.403 37.3803 39.693 38.8703C38.063 40.2903 37.0831 42.3103 36.3131 44.3303C35.0731 47.5803 34.263 51.0903 34.803 54.5203C35.343 57.9503 37.4531 61.2803 40.6831 62.5503C42.0031 63.0703 43.433 63.2303 44.843 63.3403C50.943 63.8103 57.423 63.3003 62.553 59.9603C63.053 59.6303 63.5531 59.2703 63.9331 58.8103C64.583 58.0203 64.853 56.9803 64.993 55.9603C65.573 51.7003 64.143 47.3003 61.863 43.8303L61.843 43.8203Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_3829)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M59.7433 38.4907C61.5333 47.2607 59.6233 57.0108 54.3533 67.6508L28.3633 62.1607L33.1133 33.0107L59.7333 38.5007L59.7433 38.4907Z",
          fill: "#74C4D7"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M88.1113 43.8203C90.3913 40.3403 96.9113 35.8703 104.001 36.5003C106.261 36.7003 108.551 37.3803 110.261 38.8703C111.891 40.2903 112.871 42.3103 113.641 44.3303C114.881 47.5803 115.691 51.0903 115.151 54.5203C114.611 57.9503 112.501 61.2803 109.271 62.5503C107.951 63.0703 106.521 63.2303 105.111 63.3403C99.0113 63.8103 92.5313 63.3003 87.4013 59.9603C86.9013 59.6303 86.4013 59.2703 86.0213 58.8103C85.3713 58.0203 85.1013 56.9803 84.9613 55.9603C84.3813 51.7003 85.8113 47.3003 88.0913 43.8303L88.1113 43.8203Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_3829",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "84",
          y: "36",
          width: "32",
          height: "28",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M88.1113 43.8203C90.3913 40.3403 96.9113 35.8703 104.001 36.5003C106.261 36.7003 108.551 37.3803 110.261 38.8703C111.891 40.2903 112.871 42.3103 113.641 44.3303C114.881 47.5803 115.691 51.0903 115.151 54.5203C114.611 57.9503 112.501 61.2803 109.271 62.5503C107.951 63.0703 106.521 63.2303 105.111 63.3403C99.0113 63.8103 92.5313 63.3003 87.4013 59.9603C86.9013 59.6303 86.4013 59.2703 86.0213 58.8103C85.3713 58.0203 85.1013 56.9803 84.9613 55.9603C84.3813 51.7003 85.8113 47.3003 88.0913 43.8303L88.1113 43.8203Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_3829)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M110.741 64.7001C112.531 55.9301 110.621 46.18 105.351 35.54L79.3613 41.0301L84.1113 70.1801L110.731 64.6901L110.741 64.7001Z",
          fill: "#74C4D7"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M60.3026 68.4202C59.8826 69.8602 59.2626 72.2202 60.7026 73.2702C61.9526 74.1902 63.7326 73.6302 64.9726 72.9802C66.4626 72.1902 67.5226 71.1602 69.3126 71.3502C71.2726 71.5602 73.2526 72.1202 75.1726 72.5702C75.8226 72.7202 76.5226 72.4702 76.8626 71.8802C77.6726 70.5002 78.5626 69.1902 79.5826 67.9602H77.4626C79.1626 69.3502 80.9726 70.6202 82.9526 71.6002C83.7926 72.0202 84.6626 72.4102 85.6226 72.1102C86.4326 71.8502 86.9526 71.1302 87.8126 71.0002C89.7126 70.7102 91.2226 72.3302 93.0526 72.5002C94.8826 72.6702 96.6526 71.4502 96.6226 69.5102C96.5926 67.5702 93.5926 67.5802 93.6226 69.5102C93.6226 69.6402 90.8026 68.4702 90.4126 68.3402C89.1726 67.9502 87.7527 67.8302 86.5027 68.2502C85.9027 68.4502 85.4726 68.8702 84.9126 69.1202C84.6526 69.2402 85.1426 69.4202 84.4826 69.0202C84.1626 68.8302 83.8227 68.6802 83.5027 68.5002C82.1227 67.7302 80.8226 66.8502 79.6026 65.8502C79.0226 65.3702 78.0426 65.1802 77.4826 65.8502C76.3026 67.2802 75.2326 68.7802 74.2926 70.3802L75.9826 69.6902C73.4426 69.0902 70.4426 68.0402 67.8226 68.3802C66.7226 68.5202 65.7526 69.0102 64.8126 69.5802C64.3426 69.8702 62.8126 71.1102 62.2326 70.6802L62.9226 71.5802C62.6526 70.9202 63.0226 69.8702 63.2126 69.2202C63.7526 67.3602 60.8626 66.5702 60.3226 68.4202H60.3026Z",
          fill: "#E8F3F6"
        }
      )
    ]
  }
), Nr = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "156",
    height: "121",
    viewBox: "0 0 156 121",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M125.224 114.145C124.374 113.595 123.464 113.105 122.694 112.445C121.694 111.595 120.874 110.865 120.664 109.625C120.214 106.985 120.564 104.145 120.434 101.465C120.304 98.8551 120.514 96.1952 119.944 93.6252C119.554 91.9052 106.574 94.5652 106.724 96.2552C107.144 101.085 107.644 105.915 108.214 110.735C108.354 111.935 108.504 113.145 108.664 114.345C108.784 115.295 108.774 116.415 109.244 117.275C110.124 118.925 112.904 119.565 114.574 119.955C116.654 120.435 118.824 120.565 120.944 120.315C122.774 120.095 125.044 119.745 126.424 118.395C128.054 116.805 126.744 115.125 125.234 114.145H125.224Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M39.0631 114.145C39.9131 113.595 40.8231 113.105 41.5931 112.445C42.5931 111.595 43.4131 110.865 43.6231 109.625C44.0731 106.985 43.723 104.145 43.853 101.465C43.983 98.8551 43.7731 96.1952 44.3431 93.6252C44.7331 91.9052 57.7131 94.5652 57.5631 96.2552C57.1431 101.085 56.6431 105.915 56.0731 110.735C55.9331 111.935 55.7831 113.145 55.6231 114.345C55.5031 115.295 55.513 116.415 55.043 117.275C54.163 118.925 51.3831 119.565 49.7131 119.955C47.6331 120.435 45.4631 120.565 43.3431 120.315C41.5131 120.095 39.2431 119.745 37.863 118.395C36.233 116.805 37.5431 115.125 39.0531 114.145H39.0631Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M154.643 46.7949C153.013 41.4549 149.553 36.6749 144.923 34.6149C144.143 34.2649 142.803 33.1749 142.803 33.1749C142.803 33.1749 142.373 31.1149 142.403 30.0449C142.723 19.7349 130.683 8.1449 124.193 6.3949C114.343 3.7449 107.323 4.0949 99.9929 12.0249C94.3929 5.0149 83.0129 -0.675119 74.7229 0.0648809C66.4229 0.804881 56.8629 6.18492 52.2929 14.1049C45.3729 8.69492 35.1229 12.8949 27.6629 17.2749C20.2029 21.6549 15.1529 30.9149 15.0129 40.4649C8.70292 41.7449 3.16292 47.0849 1.01292 53.9549C-1.13708 60.8249 0.202922 68.9549 4.39292 74.4749C6.32292 77.0149 11.7929 81.9049 11.7929 81.9049C11.7929 81.9049 9.3629 88.2648 14.3129 95.4048C24.1729 109.605 48.8529 104.185 48.8529 104.185C48.8529 104.185 61.5629 107.105 70.7829 107.725C94.6329 109.325 106.823 99.7349 106.823 99.7349C106.823 99.7349 109.883 99.7849 111.403 100.045C122.963 102.035 146.713 95.2849 146.053 81.4749C146.013 80.5549 146.193 78.7449 146.193 78.7449C146.193 78.7449 147.763 77.1249 148.713 76.5249C152.703 74.0349 154.533 68.6549 155.353 63.5649C156.253 57.9949 156.283 52.1449 154.643 46.7949Z",
          fill: "#74C4D7"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M61.4742 55.505C58.9542 46.245 51.1842 43.8651 49.3942 43.7751C47.6042 43.6851 44.8142 43.895 42.7142 44.755C37.8342 46.765 34.1942 51.185 32.3442 56.125C31.5042 58.385 30.9942 60.795 31.1842 63.195C31.3742 65.515 32.2042 67.745 33.2942 69.805C35.8342 74.635 38.8942 75.135 41.8442 75.505C45.4742 75.965 49.1742 76.4251 52.7542 75.7151C56.3442 75.0151 59.8642 72.9351 61.3442 69.5951C61.9042 68.3351 62.1542 66.9651 62.2942 65.6051C62.6442 62.2251 62.3642 58.775 61.4742 55.495V55.505Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_3846",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "31",
          y: "43",
          width: "32",
          height: "34",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M61.4742 55.505C58.9542 46.245 51.1842 43.8651 49.3942 43.7751C47.6042 43.6851 44.8142 43.895 42.7142 44.755C37.8342 46.765 34.1942 51.185 32.3442 56.125C31.5042 58.385 30.9942 60.795 31.1842 63.195C31.3742 65.515 32.2042 67.745 33.2942 69.805C35.8342 74.635 38.8942 75.135 41.8442 75.505C45.4742 75.965 49.1742 76.4251 52.7542 75.7151C56.3442 75.0151 59.8642 72.9351 61.3442 69.5951C61.9042 68.3351 62.1542 66.9651 62.2942 65.6051C62.6442 62.2251 62.3642 58.775 61.4742 55.495V55.505Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_3846)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M39.2138 44.5447C36.9938 59.1647 39.5838 71.9047 45.9138 83.1847L69.2638 79.0647L61.1938 36.3047L39.2138 44.5447Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M92.0327 55.505C94.5527 46.245 102.323 43.8651 104.113 43.7751C105.903 43.6851 108.693 43.895 110.793 44.755C115.673 46.765 119.313 51.185 121.163 56.125C122.003 58.385 122.513 60.795 122.323 63.195C122.133 65.515 121.303 67.745 120.213 69.805C117.673 74.635 114.613 75.135 111.663 75.505C108.033 75.965 104.333 76.4251 100.753 75.7151C97.1726 75.0051 93.6427 72.9351 92.1627 69.5951C91.6027 68.3351 91.3527 66.9651 91.2127 65.6051C90.8627 62.2251 91.1427 58.775 92.0327 55.495V55.505Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_3846",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "91",
          y: "43",
          width: "32",
          height: "34",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M92.0327 55.505C94.5527 46.245 102.323 43.8651 104.113 43.7751C105.903 43.6851 108.693 43.895 110.793 44.755C115.673 46.765 119.313 51.185 121.163 56.125C122.003 58.385 122.513 60.795 122.323 63.195C122.133 65.515 121.303 67.745 120.213 69.805C117.673 74.635 114.613 75.135 111.663 75.505C108.033 75.965 104.333 76.4251 100.753 75.7151C97.1726 75.0051 93.6427 72.9351 92.1627 69.5951C91.6027 68.3351 91.3527 66.9651 91.2127 65.6051C90.8627 62.2251 91.1427 58.775 92.0327 55.495V55.505Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_3846)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M114.292 44.5447C116.512 59.1647 113.922 71.9047 107.592 83.1847L84.2422 79.0647L92.3122 36.3047L114.292 44.5447Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M67.5019 70.1755C68.0419 72.0855 68.9319 74.0254 70.4719 75.3354C72.0119 76.6454 74.0719 77.3354 76.1619 76.9354C77.9419 76.5954 79.9319 75.7255 81.2119 74.4155C82.7719 72.8155 82.9319 70.6754 82.8319 68.5654C82.7919 67.7554 82.1719 67.0654 81.3319 67.0654C80.5519 67.0654 79.7919 67.7554 79.8319 68.5654C79.8919 69.8354 80.0219 71.3355 79.0919 72.2955C78.2119 73.2055 76.8019 73.7254 75.5719 73.9954C72.7519 74.6154 71.0519 71.6954 70.3919 69.3754C69.8719 67.5154 66.9719 68.3055 67.5019 70.1755Z",
          fill: "#0B455E"
        }
      )
    ]
  }
), Rr = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "151",
    height: "141",
    viewBox: "0 0 151 141",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M58.6823 137.227C57.0423 130.227 55.4823 123.217 54.0123 116.187C53.6223 114.347 44.7523 117.317 45.0623 118.067C46.6023 121.787 48.3223 125.577 49.3823 129.467C49.5423 130.037 49.9323 131.737 49.5723 132.287C49.2023 132.857 48.2523 133.447 47.6623 133.767C45.8523 134.757 43.7023 134.777 41.7923 135.557C40.9023 135.917 40.3823 136.837 40.9023 137.757C42.2823 140.247 45.2823 140.647 47.8723 140.697C51.1923 140.767 54.5223 140.197 57.6323 139.067C58.4123 138.787 58.8723 138.067 58.6823 137.227Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M90.5115 137.227C92.1515 130.227 93.7115 123.217 95.1815 116.187C95.5715 114.347 104.441 117.317 104.131 118.067C102.591 121.787 100.872 125.577 99.8115 129.467C99.6515 130.037 99.2615 131.737 99.6215 132.287C99.9915 132.857 100.942 133.447 101.532 133.767C103.342 134.757 105.492 134.777 107.402 135.557C108.292 135.917 108.812 136.837 108.292 137.757C106.912 140.247 103.911 140.647 101.321 140.697C98.0015 140.767 94.6715 140.197 91.5615 139.067C90.7815 138.787 90.3215 138.067 90.5115 137.227Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M131.672 81.6278C130.772 65.7777 124.842 43.8678 112.592 33.6878C100.342 23.5078 82.0419 20.9678 72.2719 20.8978C62.5019 20.8278 45.9719 23.6178 37.9719 29.1278C25.9219 37.4277 20.2519 52.3977 18.1319 66.8677C16.1619 80.3377 17.0119 95.1477 25.2419 105.998C32.8519 116.028 45.4219 120.938 57.6919 123.778C69.0819 126.418 89.8719 126.998 101.112 123.768C111.602 120.748 133.222 109.148 131.672 81.6278Z",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M69.141 1.4475C69.031 5.8775 70.071 10.2576 69.951 14.6876C69.901 16.6176 72.901 16.6176 72.951 14.6876C73.061 10.2576 72.021 5.8775 72.141 1.4475C72.191 -0.4825 69.191 -0.4825 69.141 1.4475Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M137.271 30.4478C134.031 32.9578 130.781 35.4578 127.541 37.9678C126.901 38.4578 126.561 39.2579 127.001 40.0179C127.371 40.6479 128.411 41.0579 129.051 40.5579C132.291 38.0479 135.541 35.5479 138.781 33.0379C139.421 32.5479 139.761 31.7478 139.321 30.9878C138.951 30.3578 137.911 29.9478 137.271 30.4478Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M149.043 96.2677C145.033 95.4377 141.013 94.5977 137.003 93.7677C136.213 93.6077 135.383 93.9978 135.153 94.8178C134.953 95.5578 135.403 96.4977 136.203 96.6677C140.213 97.4977 144.233 98.3377 148.243 99.1677C149.033 99.3277 149.863 98.9377 150.093 98.1177C150.293 97.3777 149.843 96.4377 149.043 96.2677Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M1.90213 106.918C5.79213 105.628 9.68211 104.348 13.5721 103.058C14.3421 102.808 14.8422 102.018 14.6222 101.208C14.4122 100.458 13.5521 99.9078 12.7721 100.158C8.88212 101.448 4.99214 102.728 1.10214 104.018C0.332137 104.268 -0.16785 105.058 0.0521495 105.868C0.262149 106.618 1.12213 107.168 1.90213 106.918Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M4.92092 39.9379C8.65092 41.6479 12.3709 43.3579 16.1009 45.0579C16.8409 45.3979 17.7209 45.2679 18.1509 44.5179C18.5309 43.8679 18.3509 42.8078 17.6109 42.4678C13.8809 40.7578 10.1609 39.0478 6.43093 37.3478C5.69093 37.0078 4.81088 37.1379 4.38088 37.8879C4.00088 38.5379 4.18092 39.5979 4.92092 39.9379Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M108.363 13.0077C108.073 14.0977 107.713 15.1777 107.283 16.2277C107.263 16.2777 107.243 16.3377 107.213 16.3877C107.293 16.2077 107.293 16.1877 107.233 16.3477C107.173 16.4877 107.113 16.6277 107.043 16.7677C106.933 17.0077 106.813 17.2577 106.693 17.4977C106.433 18.0177 106.163 18.5177 105.873 19.0177C105.483 19.6977 105.693 20.6878 106.413 21.0678C107.133 21.4478 108.043 21.2577 108.463 20.5277C109.683 18.4277 110.623 16.1578 111.243 13.8078C111.443 13.0478 110.993 12.1477 110.193 11.9577C109.393 11.7677 108.563 12.1977 108.343 13.0077H108.363Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M143.321 63.1578C143.191 63.2378 143.051 63.3078 142.911 63.3778C142.841 63.4078 142.771 63.4477 142.701 63.4777C142.871 63.4077 142.901 63.3978 142.801 63.4378C142.541 63.5378 142.281 63.6277 142.011 63.7077C141.511 63.8477 141.001 63.9478 140.491 64.0278C139.401 64.2078 138.301 64.3177 137.231 64.5877C136.471 64.7777 135.941 65.6778 136.181 66.4378C136.421 67.1978 137.211 67.6877 138.031 67.4877C139.141 67.2077 140.271 67.0978 141.401 66.9078C142.601 66.7078 143.771 66.3678 144.841 65.7678C145.521 65.3778 145.811 64.3877 145.381 63.7177C144.951 63.0477 144.061 62.7678 143.331 63.1778L143.321 63.1578Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M129.051 121.727C128.571 121.447 128.091 121.147 127.631 120.837C127.391 120.677 127.161 120.507 126.921 120.337C126.801 120.257 126.691 120.167 126.571 120.077C126.521 120.037 126.471 119.997 126.421 119.957L126.571 120.077C126.571 120.077 126.491 120.017 126.461 119.987C125.571 119.287 124.721 118.527 123.931 117.717C123.381 117.157 122.351 117.127 121.811 117.717C121.271 118.307 121.221 119.237 121.811 119.837C123.501 121.577 125.441 123.088 127.531 124.308C128.211 124.708 129.201 124.488 129.581 123.768C129.961 123.048 129.771 122.137 129.041 121.717L129.051 121.727Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M27.7315 127.278C27.8915 127.048 28.0615 126.818 28.2315 126.588C28.3115 126.478 28.3915 126.378 28.4715 126.268C28.1915 126.638 28.5015 126.238 28.5715 126.148C28.9315 125.708 29.3015 125.278 29.6815 124.858C30.4515 124.018 31.2715 123.238 32.1515 122.508C32.4315 122.278 32.5915 121.798 32.5915 121.448C32.5915 121.078 32.4315 120.638 32.1515 120.388C31.8715 120.138 31.4915 119.928 31.0915 119.948C30.6915 119.968 30.3515 120.118 30.0315 120.388C28.1615 121.948 26.5415 123.768 25.1515 125.768C24.9415 126.068 24.9015 126.578 25.0015 126.928C25.1015 127.278 25.3614 127.658 25.6914 127.828C26.4614 128.228 27.2615 127.978 27.7415 127.288L27.7315 127.278Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M2.26103 70.0277C3.39103 70.0177 4.52104 70.0676 5.64104 70.1976C5.68104 70.1976 6.12103 70.2476 5.76103 70.2076C5.89103 70.2176 6.02105 70.2477 6.15105 70.2677C6.45105 70.3177 6.75107 70.3677 7.05107 70.4277C7.60107 70.5377 8.15104 70.6577 8.70104 70.7977C9.46104 70.9977 10.3611 70.5477 10.5511 69.7477C10.7411 68.9477 10.3111 68.1177 9.50109 67.8977C7.15109 67.2877 4.70104 66.9877 2.27104 67.0177C1.49104 67.0277 0.731044 67.6977 0.771044 68.5177C0.811044 69.3377 1.43104 70.0277 2.27104 70.0177L2.26103 70.0277Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M32.8319 16.5082C33.2319 16.9082 33.622 17.3182 34.002 17.7482C34.182 17.9582 34.362 18.1682 34.542 18.3782C34.632 18.4882 34.7219 18.6082 34.8219 18.7182C34.8919 18.8082 35.1619 19.1882 34.9119 18.8382C35.5619 19.7682 36.222 20.6783 36.792 21.6683C37.182 22.3483 38.1719 22.6382 38.8419 22.2082C39.5119 21.7782 39.8019 20.8883 39.3819 20.1583C38.1719 18.0583 36.6719 16.1083 34.9519 14.3983C34.3919 13.8483 33.3819 13.7983 32.8319 14.3983C32.2819 14.9983 32.2419 15.9282 32.8319 16.5182V16.5082Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M109.101 70.3077C107.951 66.0777 105.481 61.0376 101.951 59.4976C98.4213 57.9576 92.0813 57.4577 87.8813 61.1677C83.6813 64.8777 81.9313 71.4176 82.3413 77.3276C82.5513 80.3976 83.2713 83.6477 85.4813 85.7877C88.3413 88.5677 92.7913 88.7076 96.7813 88.4676C99.7713 88.2876 102.951 87.8976 105.281 86.0176C106.271 85.2176 107.051 84.1777 107.681 83.0677C109.851 79.2577 110.251 74.5477 109.091 70.3177L109.101 70.3077Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_3863",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "82",
          y: "58",
          width: "28",
          height: "31",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M109.101 70.3077C107.951 66.0777 105.481 61.0376 101.951 59.4976C98.4213 57.9576 92.0813 57.4577 87.8813 61.1677C83.6813 64.8777 81.9313 71.4176 82.3413 77.3276C82.5513 80.3976 83.2713 83.6477 85.4813 85.7877C88.3413 88.5677 92.7913 88.7076 96.7813 88.4676C99.7713 88.2876 102.951 87.8976 105.281 86.0176C106.271 85.2176 107.051 84.1777 107.681 83.0677C109.851 79.2577 110.251 74.5477 109.091 70.3177L109.101 70.3077Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_3863)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M93.7225 55.6379C87.3925 65.9079 86.2725 78.648 88.1125 92.778L113.113 92.2679L109.743 54.418L93.7225 55.6379Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M36.6227 69.8975C37.7727 65.6675 40.2426 60.6275 43.7726 59.0875C47.3026 57.5475 53.6426 57.0475 57.8426 60.7575C62.0426 64.4675 63.7926 71.0075 63.3826 76.9175C63.1726 79.9875 62.4526 83.2375 60.2426 85.3775C57.3826 88.1575 52.9326 88.2976 48.9426 88.0576C45.9526 87.8776 42.7726 87.4875 40.4426 85.6075C39.4526 84.8075 38.6726 83.7675 38.0426 82.6575C35.8726 78.8475 35.4726 74.1375 36.6326 69.9075L36.6227 69.8975Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_3863",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "35",
          y: "57",
          width: "29",
          height: "32",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M36.6227 69.8975C37.7727 65.6675 40.2426 60.6275 43.7726 59.0875C47.3026 57.5475 53.6426 57.0475 57.8426 60.7575C62.0426 64.4675 63.7926 71.0075 63.3826 76.9175C63.1726 79.9875 62.4526 83.2375 60.2426 85.3775C57.3826 88.1575 52.9326 88.2976 48.9426 88.0576C45.9526 87.8776 42.7726 87.4875 40.4426 85.6075C39.4526 84.8075 38.6726 83.7675 38.0426 82.6575C35.8726 78.8475 35.4726 74.1375 36.6326 69.9075L36.6227 69.8975Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_3863)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M42.882 89.4174C38.942 78.0074 40.642 65.3373 45.532 51.9473L69.8121 57.9073L62.462 95.3973L42.882 89.4073V89.4174Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M60.5523 90.9876C61.5123 91.1576 62.3922 91.2276 63.3522 90.9976C64.2422 90.7876 65.0523 90.3276 65.7323 89.7276C66.9923 88.6276 67.7123 86.7776 67.5023 85.1176C67.4523 84.7076 67.3723 84.3677 67.0623 84.0577C66.8023 83.7977 66.3723 83.5976 66.0023 83.6176C65.6323 83.6376 65.2122 83.7577 64.9422 84.0577C64.6922 84.3277 64.4523 84.7376 64.5023 85.1176C64.5423 85.4676 64.5423 85.8076 64.5023 86.1476L64.5523 85.7476C64.5023 86.1176 64.4022 86.4777 64.2622 86.8177L64.4122 86.4576C64.3122 86.6776 64.2022 86.8876 64.0722 87.0876C64.0322 87.1476 63.9922 87.1976 63.9622 87.2476C63.8722 87.3876 64.2122 86.9476 64.0222 87.1676C63.9422 87.2576 63.8622 87.3476 63.7822 87.4276C63.7422 87.4676 63.5622 87.6676 63.5122 87.6676C63.5222 87.6676 63.8123 87.4576 63.6223 87.5776C63.5623 87.6176 63.5122 87.6577 63.4622 87.6877C63.2522 87.8277 63.0222 87.9376 62.7922 88.0376L63.1522 87.8876C62.8322 88.0176 62.5022 88.1076 62.1522 88.1576L62.5523 88.1076C62.2023 88.1576 61.8523 88.1576 61.4923 88.1076L61.8922 88.1576C61.7122 88.1276 61.5222 88.0977 61.3422 88.0677C60.9422 87.9977 60.5523 88.0076 60.1823 88.2176C59.8723 88.3976 59.5723 88.7576 59.4923 89.1176C59.3223 89.8476 59.7122 90.8176 60.5422 90.9676L60.5523 90.9876Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M64.8928 90.1576C68.7028 92.8576 74.1329 92.9276 78.0429 90.3976C78.7229 89.9576 79.0028 89.0675 78.5828 88.3475C78.1828 87.6675 77.2128 87.3676 76.5328 87.8076C73.4328 89.8176 69.4429 89.7176 66.4129 87.5676C65.7529 87.0976 64.7429 87.4475 64.3629 88.1075C63.9229 88.8575 64.2428 89.6876 64.9028 90.1576H64.8928Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M75.7423 85.8074L76.8523 87.3174C77.2423 87.8474 77.6323 88.3974 78.0623 88.8974C79.0323 90.0074 80.4823 90.6974 81.9623 90.3174C82.7223 90.1274 83.2523 89.2374 83.0123 88.4674C82.7723 87.6974 81.9823 87.2074 81.1623 87.4174C81.0923 87.4374 81.0223 87.4473 80.9523 87.4573L81.3523 87.4074C81.1823 87.4274 81.0223 87.4274 80.8523 87.4074L81.2523 87.4573C81.0623 87.4273 80.8723 87.3674 80.6923 87.2974L81.0523 87.4473C80.8523 87.3573 80.6623 87.2474 80.4823 87.1074L80.7823 87.3373C80.4423 87.0673 80.1623 86.7474 79.8923 86.4074L80.1223 86.7073C79.5023 85.9073 78.9223 85.0874 78.3223 84.2674C78.0823 83.9474 77.8323 83.6873 77.4223 83.5773C77.0623 83.4773 76.5823 83.5274 76.2623 83.7274C75.9423 83.9274 75.6623 84.2374 75.5723 84.6274C75.4823 85.0174 75.4923 85.4674 75.7223 85.7874L75.7423 85.8074Z",
          fill: "#0B455E"
        }
      )
    ]
  }
), Zr = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "165",
    height: "201",
    viewBox: "0 0 165 201",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M42.0077 158.57C40.9977 165.53 40.6077 172.47 40.2977 179.49C40.2277 181.08 40.0977 182.68 39.6677 184.22C39.4877 184.88 39.2977 185.74 38.7377 186.19C38.2077 186.61 37.3177 186.68 36.6877 186.82C33.2277 187.57 29.6977 187.82 26.1677 187.67C24.9077 187.62 24.1377 189.38 25.1077 190.23C26.5077 191.46 28.1577 192.14 29.9077 192.73C31.8977 193.4 33.9077 193.99 35.9477 194.5C37.9877 195.01 40.0377 195.44 42.1077 195.79C43.8477 196.08 46.1377 196.77 47.8977 196.37C49.5477 195.99 50.6377 194.13 51.5077 192.82C52.4577 191.39 53.2477 189.87 53.9377 188.3C55.3477 185.09 56.3377 181.74 57.3577 178.4C58.5277 174.55 59.7677 170.72 61.7977 167.23C62.7677 165.56 42.2877 156.69 42.0177 158.59L42.0077 158.57Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M136.138 174.9C134.038 170.25 131.798 165.66 129.408 161.15C129.118 160.6 128.318 160.25 127.718 160.46C124.248 161.65 120.488 162.31 117.248 160.17C113.978 158.01 110.998 155.26 107.928 152.81C106.438 151.62 98.8484 163.81 100.378 164.95C105.338 168.66 108.988 170.77 115.058 172.02C116.518 172.32 120.398 172.72 121.878 172.87C123.488 173.03 125.118 172.72 126.448 173.74C128.918 175.63 131.518 176.15 134.438 177.1C135.798 177.54 136.628 176 136.128 174.9H136.138Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M25.5386 112.31C16.8386 112.43 5.53856 113.27 1.30856 122.36C-0.181441 125.57 -1.1914 132.03 2.8486 133.93C4.9086 134.9 7.86857 134.28 10.0086 133.87C12.4786 133.39 14.8786 132.6 17.2786 131.84C22.4086 130.2 27.9586 128.58 33.1786 130.78C33.9286 131.1 34.8186 130.44 35.0286 129.73C35.2786 128.87 27.2185 112.29 25.5485 112.32L25.5386 112.31Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M118.17 112.31C126.87 112.43 138.17 113.27 142.4 122.36C143.89 125.57 144.9 132.03 140.86 133.93C138.8 134.9 135.84 134.28 133.7 133.87C131.23 133.39 128.83 132.6 126.43 131.84C121.3 130.2 115.75 128.58 110.53 130.78C109.78 131.1 108.89 130.44 108.68 129.73C108.43 128.87 116.49 112.29 118.16 112.32L118.17 112.31Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M163.35 11.74C163.12 11.57 162.83 11.48 162.46 11.49C157.24 11.73 152.01 11.96 146.79 12.2C134.24 12.77 121.7 13.34 109.15 13.91C93.97 14.6 78.78 15.29 63.6 15.97C50.47 16.57 37.34 17.16 24.21 17.76C17.83 18.05 11.42 18.21 5.03999 18.63C4.94999 18.63 4.85997 18.63 4.76997 18.64C4.05997 18.67 3.56995 19.09 3.31995 19.74C1.67995 24.12 0.0299571 28.64 0.00995709 33.38C-0.0100429 37.64 1.53995 41.56 3.18995 45.41C4.87995 49.35 6.51997 53.27 6.45997 57.63C6.39997 62.35 4.90995 66.9 3.93995 71.49C1.05995 85.05 3.63994 100.89 13.8699 110.9C16.4599 113.43 19.5099 115.13 22.4999 117.12C24.0299 118.14 25.53 119.39 26.27 121.12C27.11 123.07 27.04 125.3 27.09 127.37C27.29 134.73 27.66 142.38 30.27 149.34C31.53 152.68 33.29 155.82 35.73 158.44C38.51 161.41 42.0499 163.41 45.7399 165.03C52.5399 168.02 61.19 170.45 64.29 177.99C65.04 179.82 65.73 181.64 67.35 182.88C68.85 184.02 70.69 184.44 72.46 184.97C76.3 186.13 79.16 188.93 82.1 191.52C88.25 196.96 95.6699 200.37 103.93 200.86C105.98 200.98 108.03 200.9 110.06 200.64C110.92 200.53 111.9 199.75 111.51 198.74C110.57 196.33 110.62 193.64 110.31 191.07C109.88 187.47 109.43 183.88 109.14 180.26C108.57 173.23 108.09 165.97 110.38 159.17C111.4 156.13 112.86 153.22 113.35 150.03C113.59 148.46 113.58 146.92 113.29 145.36C112.96 143.61 112.25 141.95 111.82 140.22C110.15 133.46 113.83 126.86 117.73 121.61C121.84 116.08 126.27 110.97 129.43 104.79C130.93 101.86 132.43 98.74 132.89 95.45C133.37 92.01 131.98 88.67 132.79 85.25C133.54 82.09 135.3 79.29 137.08 76.62C138.93 73.84 140.82 71.09 142.52 68.21C145.79 62.66 148.53 56.66 149.35 50.22C149.58 48.39 149.66 46.55 149.53 44.71C149.4 42.92 148.77 41.07 149.99 39.53C151.04 38.2 152.46 37.15 153.61 35.9C154.69 34.73 155.69 33.48 156.63 32.19C160.72 26.55 163.19 19.89 163.95 12.98C164.02 12.36 163.75 11.94 163.34 11.73L163.35 11.74Z",
          fill: "#7DA2B4"
        }
      ),
      /* @__PURE__ */ o.jsxs("g", { opacity: "0.45", children: [
        /* @__PURE__ */ o.jsx(
          "mask",
          {
            id: "mask0_37_4067",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "11",
            width: "164",
            height: "190",
            children: /* @__PURE__ */ o.jsx(
              "path",
              {
                d: "M163.35 11.74C163.12 11.57 162.83 11.48 162.46 11.49C157.24 11.73 152.01 11.96 146.79 12.2C134.24 12.77 121.7 13.34 109.15 13.91C93.97 14.6 78.78 15.29 63.6 15.97C50.47 16.57 37.34 17.16 24.21 17.76C17.83 18.05 11.42 18.21 5.03999 18.63C4.94999 18.63 4.85997 18.63 4.76997 18.64C4.05997 18.67 3.56995 19.09 3.31995 19.74C1.67995 24.12 0.0299571 28.64 0.00995709 33.38C-0.0100429 37.64 1.53995 41.56 3.18995 45.41C4.87995 49.35 6.51997 53.27 6.45997 57.63C6.39997 62.35 4.90995 66.9 3.93995 71.49C1.05995 85.05 3.63994 100.89 13.8699 110.9C16.4599 113.43 19.5099 115.13 22.4999 117.12C24.0299 118.14 25.53 119.39 26.27 121.12C27.11 123.07 27.04 125.3 27.09 127.37C27.29 134.73 27.66 142.38 30.27 149.34C31.53 152.68 33.29 155.82 35.73 158.44C38.51 161.41 42.0499 163.41 45.7399 165.03C52.5399 168.02 61.19 170.45 64.29 177.99C65.04 179.82 65.73 181.64 67.35 182.88C68.85 184.02 70.69 184.44 72.46 184.97C76.3 186.13 79.16 188.93 82.1 191.52C88.25 196.96 95.6699 200.37 103.93 200.86C105.98 200.98 108.03 200.9 110.06 200.64C110.92 200.53 111.9 199.75 111.51 198.74C110.57 196.33 110.62 193.64 110.31 191.07C109.88 187.47 109.43 183.88 109.14 180.26C108.57 173.23 108.09 165.97 110.38 159.17C111.4 156.13 112.86 153.22 113.35 150.03C113.59 148.46 113.58 146.92 113.29 145.36C112.96 143.61 112.25 141.95 111.82 140.22C110.15 133.46 113.83 126.86 117.73 121.61C121.84 116.08 126.27 110.97 129.43 104.79C130.93 101.86 132.43 98.74 132.89 95.45C133.37 92.01 131.98 88.67 132.79 85.25C133.54 82.09 135.3 79.29 137.08 76.62C138.93 73.84 140.82 71.09 142.52 68.21C145.79 62.66 148.53 56.66 149.35 50.22C149.58 48.39 149.66 46.55 149.53 44.71C149.4 42.92 148.77 41.07 149.99 39.53C151.04 38.2 152.46 37.15 153.61 35.9C154.69 34.73 155.69 33.48 156.63 32.19C160.72 26.55 163.19 19.89 163.95 12.98C164.02 12.36 163.75 11.94 163.34 11.73L163.35 11.74Z",
                fill: "white"
              }
            )
          }
        ),
        /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_4067)", children: /* @__PURE__ */ o.jsx("g", { opacity: "0.61", children: /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M1.53907 47.9595C10.2891 52.5795 20.499 53.5195 30.139 54.9495C40.749 56.5195 51.3891 57.9295 62.0391 59.1895C81.6791 61.4995 101.679 63.9795 121.459 62.1595C132.139 61.1695 142.619 58.8195 152.449 54.4895C153.489 54.0295 153.369 52.3895 152.449 51.8995C147.069 49.0095 140.979 48.2695 134.949 48.3795C128.429 48.4895 121.889 49.2395 115.409 49.8895C101.519 51.2795 87.679 53.0995 73.859 54.9995C60.039 56.8995 46.5991 58.0695 33.7691 62.6095C27.8791 64.6995 22.1391 67.4595 17.0991 71.1695C12.7791 74.3495 8.73907 78.6295 8.53907 84.2995C8.33907 89.9696 12.169 95.2695 16.809 98.3595C21.889 101.75 28.0991 103.28 33.9191 104.85C46.8091 108.32 60.009 110.59 73.309 111.69C86.609 112.79 100.059 112.68 113.359 111.36C116.549 111.04 119.829 110.8 122.969 110.18C125.169 109.74 128.039 108.18 127.619 105.53C127.179 102.73 124.119 102.48 121.859 102.42C118.429 102.33 115.009 102.38 111.579 102.55C97.709 103.22 84.0091 105.73 70.4091 108.41C63.9191 109.69 57.2491 110.74 51.1491 113.41C45.7391 115.77 41.1191 119.56 36.9591 123.7C34.8691 125.78 32.8791 127.95 30.8991 130.13C30.0791 131.03 30.509 132.22 31.559 132.64C41.449 136.6 52.309 138.11 62.739 140.02C73.169 141.93 84.2291 143.7 95.0991 144.15C100.029 144.35 105.209 143.94 109.089 140.57C109.639 140.09 109.569 139.34 109.319 138.75C107.669 134.84 101.799 135.76 98.4791 135.84C93.5891 135.95 88.709 136.18 83.859 136.83C74.999 138.02 66.3891 140.79 59.3991 146.54C56.3591 149.04 53.699 152.09 51.799 155.55C50.869 157.24 50.109 159.04 49.579 160.9C49.009 162.9 48.439 165.21 49.749 167.04C50.809 168.52 52.649 169.13 54.389 169.4C56.769 169.77 59.219 169.85 61.619 170.02C66.929 170.4 72.239 170.67 77.559 170.84C83.279 171.02 89.029 171.21 94.749 170.96C100.049 170.72 105.319 169.87 110.069 167.4C111.239 166.79 110.909 165 109.709 164.66C99.4991 161.74 88.0191 163.81 79.5391 170.22C75.6291 173.17 71.1191 178.19 74.1491 183.34C77.1791 188.49 83.979 188.32 89.2691 188.42C96.8191 188.58 104.369 188.73 111.919 188.89C113.659 188.93 113.889 186.46 112.319 185.94C108.329 184.64 103.799 184.61 99.869 186.15C98.259 186.78 96.769 187.98 96.739 189.85C96.709 191.72 97.959 193.09 99.309 194.1C100.899 195.3 102.899 196.04 104.749 196.74C106.699 197.47 108.709 198.06 110.739 198.49C114.959 199.38 119.279 199.63 123.569 199.23C125.479 199.05 125.489 196.05 123.569 196.23C116.929 196.86 110.179 195.9 104.039 193.24C102.729 192.67 101.269 192.09 100.299 190.99C99.119 189.65 100.339 189.1 101.649 188.69C104.899 187.68 108.299 187.78 111.519 188.82L111.919 185.87C106.009 185.75 100.099 185.63 94.189 185.5C91.289 185.44 88.389 185.41 85.489 185.31C83.039 185.23 80.419 185.01 78.369 183.54C76.559 182.25 75.689 180.18 76.499 178.04C77.309 175.9 79.1591 174.26 80.8991 172.9C84.5591 170.03 88.899 168.08 93.439 167.07C98.549 165.93 103.879 166.08 108.919 167.52L108.559 164.78C100.879 168.77 91.5891 168.11 83.2091 167.96C78.4591 167.87 73.7191 167.71 68.9791 167.45C64.2391 167.19 59.679 167.11 55.119 166.46C53.599 166.25 51.7791 165.81 51.9591 163.94C52.1291 162.21 52.809 160.38 53.509 158.81C54.949 155.6 57.0691 152.77 59.5991 150.35C65.2091 144.98 72.469 141.98 79.999 140.47C84.879 139.49 89.849 139.12 94.809 138.93C97.249 138.84 99.699 138.79 102.139 138.75C103.679 138.73 106.009 138.55 106.729 140.25L106.959 138.43C103.739 141.22 99.1291 141.3 95.0991 141.13C89.8791 140.92 84.669 140.39 79.499 139.7C69.159 138.33 58.8891 136.33 48.6591 134.27C43.1191 133.15 37.609 131.84 32.359 129.73L33.0191 132.24C36.7891 128.11 40.589 123.9 45.059 120.51C49.849 116.87 55.2091 114.75 61.0291 113.39C66.8491 112.03 73.2791 110.87 79.4191 109.73C85.8891 108.53 92.3791 107.43 98.9091 106.65C105.439 105.87 111.749 105.41 118.189 105.39C119.739 105.39 121.299 105.39 122.839 105.46C123.379 105.49 124.949 105.5 124.519 106.25C124.089 107 122.599 107.23 121.859 107.35C120.289 107.61 118.689 107.78 117.109 107.96C104.689 109.42 92.1491 109.8 79.6591 109.13C67.1691 108.46 54.699 106.71 42.489 103.9C36.619 102.55 30.689 101.09 25.019 99.0495C19.929 97.2195 14.8591 94.3195 12.5391 89.1795C11.4691 86.7995 11.209 84.1695 12.019 81.6695C12.8291 79.1695 14.5791 77.1895 16.4691 75.4995C20.6491 71.7495 25.899 68.9795 31.059 66.8395C42.729 62.0095 55.409 60.5595 67.809 58.8395C80.209 57.1195 93.6291 55.2795 106.579 53.8295C113.119 53.0895 119.669 52.4395 126.229 51.8995C131.849 51.4295 137.629 50.9295 143.229 51.8995C145.929 52.3695 148.529 53.1895 150.949 54.4895V51.8995C133.599 59.5495 114.259 60.4495 95.5891 59.4095C85.8591 58.8595 76.169 57.8095 66.489 56.7095C56.009 55.5195 45.559 54.1795 35.119 52.6795C29.499 51.8695 23.859 51.0895 18.259 50.0895C13.019 49.1595 7.78902 47.8895 3.04902 45.3795C1.33902 44.4795 -0.170931 47.0695 1.53907 47.9695V47.9595Z",
            fill: "#0B455E"
          }
        ) }) })
      ] }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M103.1 51.6504C99.2298 51.6504 91.8498 53.5304 86.1598 58.3504C78.4098 64.9204 74.8198 72.3804 73.5198 75.4304C72.5998 77.5804 71.3698 82.0604 72.8798 85.1104C74.3898 88.1604 78.3198 90.7704 83.9998 90.4004C89.6698 90.0304 97.2698 88.4004 101.94 85.1604C108.97 80.2804 111.07 74.3204 111.35 71.0704C111.93 64.2704 112.1 51.6604 103.11 51.6604L103.1 51.6504Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_4067",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "72",
          y: "51",
          width: "40",
          height: "40",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M103.1 51.6504C99.2298 51.6504 91.8498 53.5304 86.1598 58.3504C78.4098 64.9204 74.8198 72.3804 73.5198 75.4304C72.5998 77.5804 71.3698 82.0604 72.8798 85.1104C74.3898 88.1604 78.3198 90.7704 83.9998 90.4004C89.6698 90.0304 97.2698 88.4004 101.94 85.1604C108.97 80.2804 111.07 74.3204 111.35 71.0704C111.93 64.2704 112.1 51.6604 103.11 51.6604L103.1 51.6504Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_4067)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M93.0085 47.0403C102.688 62.4203 102.688 80.2103 93.0085 100.4C93.0085 100.4 55.0785 97.1903 55.3985 96.7003C55.7185 96.2103 68.8985 59.2503 68.8985 59.2503L93.0085 47.0303V47.0403Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M24.6893 51.6504C28.5593 51.6504 35.9393 53.5304 41.6293 58.3504C49.3793 64.9204 52.9693 72.3804 54.2693 75.4304C55.1893 77.5804 56.4193 82.0604 54.9093 85.1104C53.3993 88.1604 49.4693 90.7704 43.7893 90.4004C38.1193 90.0304 30.5193 88.4004 25.8493 85.1604C18.8193 80.2804 16.7193 74.3204 16.4393 71.0704C15.8593 64.2704 15.6893 51.6604 24.6793 51.6604L24.6893 51.6504Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask2_37_4067",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "16",
          y: "51",
          width: "40",
          height: "40",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M24.6893 51.6504C28.5593 51.6504 35.9393 53.5304 41.6293 58.3504C49.3793 64.9204 52.9693 72.3804 54.2693 75.4304C55.1893 77.5804 56.4193 82.0604 54.9093 85.1104C53.3993 88.1604 49.4693 90.7704 43.7893 90.4004C38.1193 90.0304 30.5193 88.4004 25.8493 85.1604C18.8193 80.2804 16.7193 74.3204 16.4393 71.0704C15.8593 64.2704 15.6893 51.6604 24.6793 51.6604L24.6893 51.6504Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask2_37_4067)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M33.2007 45.0205C45.1307 58.7205 47.8707 76.3005 41.4207 97.7505C41.4207 97.7505 3.44068 100.421 3.69068 99.8905C3.94068 99.3605 6.45069 49.1905 6.45069 49.1905L33.1907 45.0205H33.2007Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M75.8376 42.7905C76.3076 42.2705 76.7976 41.7705 77.3176 41.3005C77.5776 41.0705 77.8476 40.8405 78.1176 40.6205C78.1776 40.5705 78.2376 40.5105 78.2976 40.4705C78.1276 40.5605 78.1876 40.5605 78.3176 40.4605C78.4476 40.3605 78.5976 40.2505 78.7376 40.1505C79.2976 39.7605 79.8676 39.3905 80.4676 39.0605C80.7776 38.8905 81.0876 38.7305 81.3976 38.5705C81.5576 38.4905 81.7176 38.4205 81.8776 38.3505C81.9476 38.3205 82.0176 38.2905 82.0876 38.2505C82.4476 38.0905 81.7976 38.3705 82.1576 38.2205C82.5176 38.0705 82.8376 37.9005 83.0576 37.5305C83.2476 37.2105 83.3276 36.7305 83.2076 36.3705C82.9776 35.6705 82.1376 35.0005 81.3576 35.3205C78.4476 36.5205 75.8176 38.3005 73.7076 40.6505C73.1876 41.2305 73.0876 42.2005 73.7076 42.7705C74.2776 43.2905 75.2676 43.3905 75.8276 42.7705L75.8376 42.7905Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M52.0396 41.9403C50.4896 40.4803 48.7096 39.2403 46.7896 38.3203C46.4196 38.1403 46.0396 38.0603 45.6296 38.1703C45.2796 38.2703 44.8996 38.5303 44.7296 38.8603C44.3796 39.5303 44.5096 40.5503 45.2696 40.9103C46.1596 41.3303 47.0296 41.8203 47.8496 42.3803C48.0496 42.5203 48.2496 42.6603 48.4496 42.8003C48.5396 42.8703 48.6396 42.9303 48.7196 43.0103C48.6796 42.9703 48.4596 42.8103 48.6196 42.9303C48.6796 42.9703 48.7296 43.0203 48.7896 43.0603C49.1796 43.3803 49.5596 43.7103 49.9196 44.0503C50.4896 44.5903 51.4796 44.6603 52.0396 44.0503C52.5996 43.4403 52.6496 42.5003 52.0396 41.9303V41.9403Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M45.6287 93.9396C44.7587 95.2496 44.8987 96.9196 45.7387 98.2096C46.7287 99.7296 48.4787 100.38 50.2387 100.37C52.1687 100.37 54.1487 99.7496 55.9487 99.0896C56.3787 98.9296 56.8088 98.7596 57.2288 98.5796C57.5688 98.4396 58.4087 98.2596 58.6287 97.9496L58.8388 97.8496L58.0087 97.5696C57.9987 97.6396 58.2587 97.9296 58.2987 97.9796C58.5587 98.3196 58.8288 98.6196 59.1488 98.8996C60.2587 99.8496 61.7387 100.37 63.2087 100.35C63.9087 100.35 64.5987 100.21 65.2487 99.9596C66.1187 99.6296 66.6287 99.0696 67.3787 98.5596C68.1587 98.0196 68.9088 98.6496 69.6588 99.0196C70.5088 99.4496 71.3687 99.7596 72.3187 99.8896C74.1587 100.14 75.9788 99.7596 77.7888 99.4696C78.8188 99.3096 79.8587 99.1996 80.8988 99.2796C81.9388 99.3596 82.9188 99.5496 83.8488 99.0396C85.5388 98.1196 85.5387 95.9296 84.1087 94.8396C82.5787 93.6696 81.0788 96.2696 82.5988 97.4296C82.7388 96.6296 82.5088 96.2896 81.9188 96.3896C81.7188 96.3696 81.5087 96.3396 81.3087 96.3196C80.8287 96.2696 80.3587 96.2296 79.8787 96.2496C79.0487 96.2696 78.2288 96.3896 77.4088 96.5096C75.7088 96.7596 73.8487 97.2796 72.1387 96.8096C70.4287 96.3396 69.0687 94.9396 67.1787 95.3496C65.7687 95.6596 65.0387 97.0896 63.6287 97.3096C62.4287 97.4896 61.3287 96.9996 60.6087 96.0496C59.3887 94.4196 58.1387 94.9196 56.4987 95.6496C54.7487 96.4196 52.7688 97.1396 50.8488 97.3296C49.9288 97.4196 47.1988 96.9896 48.2188 95.4496C49.2388 93.9096 46.6887 92.3296 45.6287 93.9396Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M163.449 10.0098C162.309 9.17984 152.529 4.47984 130.169 1.88984C110.359 -0.410162 79.9691 -0.880162 47.2191 1.99984C25.3991 3.91984 8.85906 12.1398 3.61906 19.2098C2.12906 21.2098 2.29911 24.7698 4.66911 26.1198C6.77911 27.3198 8.48908 27.4598 10.8291 27.6498C13.7991 27.8898 16.7691 28.0698 19.7491 28.1898C31.7991 28.6998 43.8691 28.3198 55.8991 27.4198C80.2091 25.6198 104.289 21.7498 128.469 18.8398C134.499 18.1098 140.539 17.4398 146.579 16.8798C149.639 16.5898 152.699 16.3398 155.759 16.1098C158.129 15.9398 160.979 16.1998 163.089 14.9198C164.989 13.7598 165.309 11.3798 163.429 10.0098H163.449Z",
          fill: "#0B455E"
        }
      )
    ]
  }
), Fr = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "190",
    height: "163",
    viewBox: "0 0 190 163",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M3.22015 82.2925C3.99015 80.7825 5.76019 79.6424 6.95019 78.4724C10.0502 75.4324 12.8702 72.1225 15.3702 68.5725C16.4702 67.0025 30.6402 80.4624 29.6602 81.9724C27.8002 84.8224 26.2402 83.9724 23.3302 85.7124C20.4202 87.4524 17.1402 87.8225 13.2402 88.8225C11.1502 89.3525 1.79015 85.1224 3.22015 82.3024V82.2925Z",
          fill: "#74C4D7"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M179.62 82.2924C178.85 80.7824 177.08 79.6424 175.89 78.4724C172.79 75.4324 169.97 72.1224 167.47 68.5724C166.37 67.0024 153.18 81.9724 153.18 81.9724C153.18 81.9724 156.6 83.9724 159.51 85.7124C162.42 87.4524 165.7 87.8224 169.6 88.8224C171.69 89.3524 181.05 85.1224 179.62 82.3024V82.2924Z",
          fill: "#74C4D7"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M171.9 135.202C168.32 127.792 166.89 119.542 165.51 111.432C163.54 99.8722 161.57 88.3123 159.59 76.7523L54.95 67.5723L21.46 82.9423C21.66 91.0623 23.42 99.0722 24.08 107.172C24.74 115.272 24.21 123.802 20.19 130.872C16.18 137.942 7.97 143.092 0 141.492C6.87 144.922 14.63 146.532 22.3 146.132C23.46 146.072 24.71 145.982 25.72 146.562C27.07 147.342 27.53 149.012 28.24 150.392C30.48 154.812 35.81 156.872 40.76 156.952C45.71 157.042 50.54 155.562 55.43 154.742C65.95 152.982 76.96 154.322 86.75 158.562C89.98 159.962 93.13 161.682 96.59 162.282C99.28 162.742 102.04 162.502 104.72 162.032C113.31 160.532 121.49 156.722 130.2 156.252C141.12 155.672 152.89 160.262 162.56 155.162C163.86 154.482 165.09 153.622 166.51 153.262C168.67 152.712 170.93 153.382 173.12 153.782C178.64 154.772 184.47 153.952 189.5 151.482C181.58 149.232 175.48 142.622 171.9 135.212V135.202Z",
          fill: "#74C4D7"
        }
      ),
      /* @__PURE__ */ o.jsx("g", { opacity: "0.61", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M39.0203 93.5925C38.1303 103.713 36.0603 113.683 32.8803 123.323C32.2803 125.163 35.1703 125.953 35.7703 124.123C39.0303 114.223 41.1003 103.973 42.0103 93.5925C42.1803 91.6725 39.1803 91.6825 39.0103 93.5925H39.0203Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx("g", { opacity: "0.61", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M50.6698 116.443C50.6698 121.413 50.0198 126.323 48.7298 131.113C48.2298 132.983 51.1198 133.773 51.6198 131.913C52.9698 126.873 53.6597 121.663 53.6597 116.443C53.6597 114.513 50.6597 114.513 50.6597 116.443H50.6698Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx("g", { opacity: "0.61", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M59.9787 85.2226C61.2787 91.0026 61.6287 96.9326 61.0687 102.823C60.9887 103.633 61.8087 104.323 62.5687 104.323C63.4487 104.323 63.9887 103.633 64.0687 102.823C64.6487 96.6626 64.2287 90.4525 62.8787 84.4225C62.4587 82.5425 59.5587 83.3326 59.9887 85.2226H59.9787Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx("g", { opacity: "0.61", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M71.0614 104.533C71.5414 117.663 71.4714 130.803 70.8614 143.933C70.7714 145.863 73.7714 145.863 73.8614 143.933C74.4714 130.813 74.5414 117.663 74.0614 104.533C73.9914 102.613 70.9914 102.603 71.0614 104.533Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx("g", { opacity: "0.61", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M94.6902 83.7122C96.5002 90.9422 97.6802 98.3122 98.2002 105.752C98.3302 107.672 101.34 107.682 101.2 105.752C100.66 98.0522 99.4502 90.4122 97.5802 82.9222C97.1102 81.0522 94.2202 81.8422 94.6902 83.7222V83.7122Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx("g", { opacity: "0.61", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M112.07 106.262C114.73 119.562 117.389 132.852 120.049 146.152C120.429 148.042 123.32 147.242 122.94 145.352C120.28 132.052 117.62 118.762 114.96 105.462C114.58 103.572 111.69 104.372 112.07 106.262Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx("g", { opacity: "0.61", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M134.01 122.302C135.28 124.982 136.31 127.542 137.26 130.452C137.5 131.192 138.31 131.762 139.11 131.502C139.85 131.262 140.42 130.452 140.16 129.652C139.17 126.622 137.98 123.662 136.61 120.782C136.27 120.072 135.2 119.832 134.56 120.242C133.83 120.712 133.66 121.532 134.02 122.292L134.01 122.302Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx("g", { opacity: "0.61", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M87.2887 112.643C87.6587 114.023 87.9887 115.413 88.2487 116.823C88.3087 117.163 88.3687 117.493 88.4187 117.833C88.4387 117.983 88.4687 118.143 88.4887 118.293C88.5087 118.393 88.5187 118.503 88.5387 118.603C88.5587 118.773 88.5687 118.803 88.5587 118.713C88.5487 118.613 88.5587 118.653 88.5687 118.823C88.5787 118.923 88.5987 119.023 88.6087 119.133C88.6287 119.283 88.6487 119.433 88.6587 119.593C88.6987 119.943 88.7287 120.303 88.7587 120.653C88.8287 121.433 89.3987 122.193 90.2587 122.153C91.0087 122.123 91.8287 121.493 91.7587 120.653C91.4987 117.683 90.9587 114.733 90.1787 111.863C89.9687 111.103 89.0988 110.563 88.3288 110.813C87.5588 111.063 87.0587 111.843 87.2787 112.663L87.2887 112.643Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx("g", { opacity: "0.61", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M102.371 135.572C102.741 136.952 103.071 138.342 103.331 139.752C103.391 140.092 103.451 140.422 103.501 140.762C103.521 140.912 103.551 141.072 103.571 141.222C103.591 141.322 103.601 141.432 103.621 141.532C103.641 141.702 103.651 141.732 103.641 141.642C103.631 141.542 103.641 141.582 103.651 141.752C103.661 141.852 103.681 141.952 103.691 142.062C103.711 142.212 103.731 142.362 103.741 142.522C103.781 142.872 103.811 143.232 103.841 143.582C103.911 144.362 104.481 145.122 105.341 145.082C106.091 145.052 106.911 144.422 106.841 143.582C106.581 140.612 106.041 137.662 105.261 134.792C105.051 134.032 104.181 133.492 103.411 133.742C102.641 133.992 102.141 134.772 102.361 135.592L102.371 135.572Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx("g", { opacity: "0.61", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M141.41 87.6525C144.08 96.3025 147.49 104.713 151.58 112.793C152.45 114.513 155.04 113.003 154.17 111.283C150.2 103.433 146.9 95.2725 144.31 86.8625C143.74 85.0225 140.85 85.8126 141.42 87.6626L141.41 87.6525Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx("g", { opacity: "0.61", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M154 129.752C154.82 131.692 155.64 133.632 156.45 135.582C156.61 135.962 156.77 136.262 157.14 136.482C157.46 136.672 157.94 136.752 158.3 136.632C158.66 136.512 159.01 136.292 159.2 135.942C159.39 135.592 159.5 135.152 159.35 134.782C158.53 132.842 157.71 130.902 156.9 128.952C156.74 128.572 156.58 128.272 156.21 128.052C155.89 127.862 155.41 127.782 155.05 127.902C154.69 128.022 154.34 128.242 154.15 128.592C153.96 128.942 153.85 129.382 154 129.752Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M171.27 65.4523C170.88 63.4823 170.4 61.4423 169.06 59.8723C168.07 58.7223 166.7 57.9123 165.33 57.1723C161.12 54.8923 156.7 52.9523 152.12 51.3823C154.31 48.4223 153.79 44.4423 152.85 40.9623C151 34.1023 147.87 27.5523 143.62 21.6823C136.02 11.1723 126.38 12.9723 121.33 13.2323C116.28 13.4923 107.45 14.9523 99.6898 19.6823C92.4098 -2.06774 66.8298 -0.267731 56.3298 0.282269C43.7099 0.942269 29.7098 13.9223 24.5598 23.6523C19.0198 34.1323 19.3598 42.1123 25.7598 52.2823C19.6198 51.6423 16.5298 54.8123 12.7998 59.4023C9.06982 63.9823 8.15982 70.4223 10.4898 75.7423C12.9998 81.4823 18.5298 86.5723 25.0898 87.6123C31.8298 88.6723 49.1098 87.9323 49.1098 87.9323C70.3498 88.1623 91.5998 88.3823 112.84 88.6123C127.39 88.7723 142.1 88.9023 156.28 85.8623C161.88 84.6623 167.91 82.5523 170.55 77.8023C172.62 74.0723 172.09 69.5923 171.27 65.4623V65.4523Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M135.23 47.8924C129.32 41.9024 110.36 41.7924 101.46 45.4224C98.0296 46.8224 94.3395 49.5924 93.8595 54.1224C93.5295 57.1724 94.8395 60.2224 96.7195 62.1724C98.5995 64.1224 100.97 65.1224 103.33 65.8224C112.36 68.5224 128.77 68.1624 134.33 64.1624C139.89 60.1524 140.12 52.8524 135.23 47.8924Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_4096",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "93",
          y: "42",
          width: "46",
          height: "26",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M135.23 47.8924C129.32 41.9024 110.36 41.7924 101.46 45.4224C98.0296 46.8224 94.3395 49.5924 93.8595 54.1224C93.5295 57.1724 94.8395 60.2224 96.7195 62.1724C98.5995 64.1224 100.97 65.1224 103.33 65.8224C112.36 68.5224 128.77 68.1624 134.33 64.1624C139.89 60.1524 140.12 52.8524 135.23 47.8924Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_4096)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M123.729 39.9023C130.889 49.9223 130.529 62.0223 125.069 75.5223L82.9492 69.0823L92.7392 39.9023H123.729Z",
          fill: "#74C4D7"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M37.3591 47.8924C43.2691 41.9024 62.2291 41.7924 71.1291 45.4224C74.5591 46.8224 78.2491 49.5924 78.7291 54.1224C79.0591 57.1724 77.7491 60.2224 75.8691 62.1724C73.9891 64.1224 71.6191 65.1224 69.2591 65.8224C60.2291 68.5224 43.8191 68.1624 38.2591 64.1624C32.6991 60.1524 32.4691 52.8524 37.3591 47.8924Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_4096",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "33",
          y: "42",
          width: "46",
          height: "26",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M37.3591 47.8924C43.2691 41.9024 62.2291 41.7924 71.1291 45.4224C74.5591 46.8224 78.2491 49.5924 78.7291 54.1224C79.0591 57.1724 77.7491 60.2224 75.8691 62.1724C73.9891 64.1224 71.6191 65.1224 69.2591 65.8224C60.2291 68.5224 43.8191 68.1624 38.2591 64.1624C32.6991 60.1524 32.4691 52.8524 37.3591 47.8924Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_4096)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M64.2097 39.9023C71.3697 49.9223 71.0097 62.0223 65.5497 75.5223L23.4297 69.0823L33.2197 39.9023H64.2097Z",
          fill: "#74C4D7"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M72.2104 69.252C70.9004 70.262 68.9904 72.212 69.7004 74.052C70.3504 75.752 72.5904 76.122 74.1804 76.212C76.1504 76.312 77.9304 75.662 79.6704 74.792C80.5204 74.362 81.3804 73.892 82.3604 73.932C83.4604 73.982 84.5004 74.602 85.4804 75.032C87.4104 75.882 89.3904 76.422 91.4904 76.632C93.3704 76.812 95.2604 76.872 96.7404 75.542C97.5304 74.832 97.9304 74.732 99.0004 75.032C99.8504 75.272 100.64 75.692 101.49 75.932C103.2 76.412 105.02 76.332 106.33 75.012C107.64 73.692 105.57 71.522 104.21 72.892C103.36 73.752 101.67 72.832 100.76 72.472C99.3804 71.932 97.8204 71.562 96.3904 72.132C95.6504 72.422 95.2604 72.982 94.6304 73.412C94.0404 73.812 93.2903 73.722 92.5903 73.692C90.9003 73.632 89.2404 73.282 87.6604 72.692C86.1704 72.132 84.7904 71.272 83.2004 71.012C81.5104 70.742 80.0304 71.272 78.5404 72.002C77.1304 72.702 75.8204 73.302 74.2004 73.192C73.7804 73.162 73.3704 73.102 72.9604 72.982C72.7804 72.952 72.6104 72.892 72.4504 72.812C72.2004 72.662 72.2604 72.792 72.6204 73.192C72.5604 73.182 74.1604 71.502 74.3404 71.362C74.9904 70.862 74.8604 69.772 74.3404 69.242C73.7104 68.602 72.8604 68.752 72.2204 69.242L72.2104 69.252Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M93.5412 37.4325C97.5312 37.5225 101.521 37.4525 105.501 37.2025C106.311 37.1525 107.001 36.5525 107.001 35.7025C107.001 34.9325 106.311 34.1525 105.501 34.2025C101.521 34.4425 97.5312 34.5225 93.5412 34.4325C91.6113 34.3925 91.6113 37.3925 93.5412 37.4325Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M68.6102 37.6419C71.2902 37.8719 73.9802 37.922 76.6702 37.792C77.4502 37.752 78.2102 37.132 78.1702 36.292C78.1402 35.512 77.5102 34.752 76.6702 34.792C73.9802 34.922 71.2902 34.8719 68.6102 34.6419C67.8302 34.5719 67.0802 35.3819 67.1102 36.1419C67.1502 37.0119 67.7702 37.5719 68.6102 37.6419Z",
          fill: "#E8F3F6"
        }
      )
    ]
  }
), Dr = ({ style: e }) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "177",
    height: "152",
    viewBox: "0 0 177 152",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M160.299 55.3578L167.859 51.1778C168.159 51.0178 168.469 50.8379 168.619 50.5479C168.739 50.3179 168.739 50.0478 168.729 49.7878C168.599 45.7078 168.469 41.6279 168.339 37.5479C170.859 41.2579 173.379 44.9578 175.899 48.6678C176.109 48.9778 176.329 49.3078 176.359 49.6678C176.399 50.1178 176.139 50.5378 175.889 50.9278C172.719 55.8478 169.179 60.5679 165.309 65.0479",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M24.47 54.0676C21.06 52.1676 18.03 49.5476 15.65 46.4376C15.48 46.2076 15.29 45.9676 15.01 45.8876C14.75 45.8076 14.47 45.9076 14.21 45.9976C9.46996 47.6676 4.74 49.3376 0 51.0076C2.81 52.3676 5.89 53.1376 9 53.2676C9.81 53.2976 10.67 53.3076 11.34 53.7576C11.79 54.0576 12.09 54.5176 12.38 54.9776C14.42 58.1876 16.22 61.5676 17.74 65.0576",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M34.9603 69.0576C29.4103 75.9876 24.2503 83.1576 19.4903 90.5376C25.7803 92.5476 32.2903 94.0777 38.9203 95.0777C31.0503 104.048 22.3903 112.458 13.0703 120.188C19.4303 130.448 26.5503 140.288 34.3703 149.628C32.8103 139.968 28.2403 123.638 28.2403 123.638C28.2403 123.638 27.5903 122.108 27.8703 121.338C28.0903 120.728 28.6503 120.258 29.1803 119.818C39.6303 111.328 50.0703 102.828 60.5203 94.3377C57.9703 91.6577 55.4203 88.9876 52.8603 86.3076C52.3703 85.7976 51.8703 85.2477 51.7303 84.5677C51.5803 83.8277 56.1303 79.2376 56.1303 79.2376C56.1303 79.2376 63.5303 70.6877 67.6803 64.5977",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M128.239 70.568C124.499 74.218 120.769 77.868 117.029 81.508C116.569 81.958 116.079 82.548 116.349 83.108C116.479 83.368 116.749 83.548 117.009 83.718C125.679 89.288 134.339 94.848 143.009 100.418C140.949 104.218 138.889 108.018 136.829 111.818C134.829 115.508 132.819 119.218 131.359 123.108C131.099 123.808 130.849 124.538 130.969 125.268C131.099 126.058 131.629 126.738 132.159 127.378C139.839 136.738 149.309 144.958 160.029 151.578C154.399 143.858 146.849 134.188 144.909 125.168C144.819 124.768 144.739 124.358 144.849 123.968C144.999 123.418 145.479 122.998 145.939 122.608C153.629 116.078 164.049 109.718 169.759 101.748C165.689 97.428 161.949 92.878 158.549 88.128C158.019 87.388 157.489 86.618 157.269 85.758C156.989 84.688 157.229 83.568 157.459 82.478C158.389 78.188 159.319 73.898 160.259 69.608C153.219 69.458 146.169 69.428 139.129 69.508",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M95.9199 69.0176C100.02 71.9376 103.95 75.0276 107.69 78.2776C108.13 78.6676 108.59 79.0876 108.68 79.6276C108.76 80.1176 108.52 80.5976 108.28 81.0576C104.7 87.9676 100.12 94.5176 94.6699 100.528C94.2899 100.948 93.8899 101.388 93.7599 101.898C93.6499 102.358 93.7599 102.828 93.8999 103.268C95.3699 107.888 99.3899 111.468 102.7 115.278C103.01 115.638 103.33 116.028 103.36 116.478C103.39 116.998 103.05 117.478 102.71 117.928C97.8499 124.428 92.9899 130.928 88.1399 137.428C84.0799 142.868 79.8099 148.478 73.4599 152.008C76.4399 142.588 79.4099 133.168 82.3899 123.748C82.5599 123.208 82.7299 122.658 82.6699 122.108C82.5899 121.448 82.1799 120.868 81.7799 120.308C77.2899 114.138 72.4199 108.168 67.1899 102.438C66.8699 102.088 66.5399 101.718 66.4799 101.278C66.4199 100.858 66.6199 100.438 66.8099 100.038C68.7399 96.0275 70.6599 92.0176 72.5899 87.9976C66.8099 85.0576 61.4499 81.5376 56.6699 77.5276",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M12.6196 63.0178C12.9996 61.1178 13.4696 59.1578 14.7896 57.6378C15.7596 56.5278 17.1096 55.7578 18.4496 55.0378C22.5796 52.8377 26.9196 50.9677 31.4096 49.4577C29.2696 46.6077 29.7696 42.7777 30.6896 39.4277C32.4996 32.8277 35.5796 26.5177 39.7396 20.8677C47.1996 10.7477 56.6496 12.4877 61.6096 12.7377C66.5696 12.9877 75.2196 14.3878 82.8496 18.9478C89.9896 -1.99225 115.08 -0.252238 125.39 0.267762C137.77 0.897762 151.51 13.3978 156.56 22.7578C162 32.8478 161.67 40.5277 155.38 50.3177C161.41 49.7077 164.44 52.7578 168.1 57.1678C171.76 61.5778 172.65 67.7777 170.37 72.8977C167.91 78.4177 162.49 83.3278 156.04 84.3177C149.43 85.3377 132.47 84.6177 132.47 84.6177C111.63 84.8377 90.7896 85.0578 69.9496 85.2678C55.6796 85.4178 41.2395 85.5477 27.3295 82.6277C21.8295 81.4677 15.9195 79.4477 13.3295 74.8777C11.2995 71.2878 11.8196 66.9777 12.6196 62.9977V63.0178Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M129.209 39.3775C122.029 34.9575 115.319 34.8275 112.289 35.4275C106.369 36.6075 101.699 42.3275 101.949 48.7875C102.129 53.5575 103.279 60.9975 115.089 65.3975C122.209 68.0475 133.709 65.9675 136.459 60.3975C139.209 54.8275 139.389 45.6375 129.189 39.3675L129.209 39.3775Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_3961",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "101",
          y: "35",
          width: "38",
          height: "32",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M129.209 39.3775C122.029 34.9575 115.319 34.8275 112.289 35.4275C106.369 36.6075 101.699 42.3275 101.949 48.7875C102.129 53.5575 103.279 60.9975 115.089 65.3975C122.209 68.0475 133.709 65.9675 136.459 60.3975C139.209 54.8375 139.389 45.6375 129.189 39.3675L129.209 39.3775Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_3961)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M120.95 30.1172C129.65 44.2472 132.6 58.9872 129.81 74.3372L87.2304 67.3872L87.1504 35.2572L120.95 30.1172Z",
          fill: "#FFD255"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M57.8992 39.3775C65.0792 34.9575 71.7892 34.8275 74.8192 35.4275C80.7392 36.6075 85.4092 42.3275 85.1592 48.7875C84.9792 53.5575 83.8292 60.9975 72.0192 65.3975C64.8992 68.0475 53.3992 65.9675 50.6492 60.3975C47.8992 54.8375 47.7192 45.6375 57.9192 39.3675L57.8992 39.3775Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_3961",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "49",
          y: "35",
          width: "37",
          height: "32",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M57.8992 39.3775C65.0792 34.9575 71.7892 34.8275 74.8192 35.4275C80.7392 36.6075 85.4092 42.3275 85.1592 48.7875C84.9792 53.5575 83.8292 60.9975 72.0192 65.3975C64.8992 68.0475 53.3992 65.9675 50.6492 60.3975C47.8992 54.8275 47.7192 45.6375 57.9192 39.3675L57.8992 39.3775Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_3961)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M69.7902 30.1172C78.4902 44.2472 81.4402 58.9872 78.6502 74.3372L36.0703 67.3872L35.9902 35.2572L69.7902 30.1172Z",
          fill: "#FFD255"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M101.961 32.7382C103.091 30.3682 104.281 27.8482 105.881 25.8082C106.651 24.8182 107.601 23.8282 108.601 23.1382C109.601 22.4482 110.791 21.8682 111.921 22.1982C113.781 22.7482 114.571 19.8482 112.721 19.3082C109.381 18.3282 106.131 20.8582 104.111 23.2582C102.091 25.6582 100.711 28.4182 99.3812 31.2182C99.0312 31.9482 99.1812 32.8382 99.9212 33.2682C100.571 33.6482 101.621 33.4682 101.971 32.7282L101.961 32.7382Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M86.1495 32.338C84.3895 28.178 81.5495 24.468 77.9995 21.678C77.3595 21.178 76.4995 21.058 75.8795 21.678C75.3595 22.198 75.2395 23.2981 75.8795 23.7981C79.3195 26.4981 81.8595 29.818 83.5595 33.848C83.8795 34.598 84.9795 34.7581 85.6095 34.3881C86.3795 33.9381 86.4595 33.088 86.1495 32.338Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M85.8498 58.0583C85.7598 58.3683 85.6497 58.6783 85.5297 58.9783L85.6798 58.6183C85.4898 59.0583 85.2598 59.4783 84.9998 59.8683C84.9398 59.9583 84.8698 60.0583 84.7998 60.1483C84.6498 60.3483 84.8398 60.1183 84.8698 60.0583C84.8398 60.1083 84.7898 60.1583 84.7498 60.2083C84.5998 60.3883 84.4397 60.5683 84.2697 60.7383C84.1097 60.8983 83.9397 61.0483 83.7697 61.1983C83.7197 61.2383 83.6698 61.2783 83.6198 61.3183C83.4798 61.4283 83.9197 61.0983 83.7197 61.2483C83.6297 61.3183 83.5398 61.3783 83.4398 61.4483C83.0398 61.7183 82.5997 61.9483 82.1497 62.1383L82.5098 61.9883C82.4198 62.0283 82.3198 62.0583 82.2298 62.0983C81.8598 62.2383 81.5397 62.4283 81.3297 62.7883C81.1397 63.1083 81.0598 63.5883 81.1798 63.9483C81.4098 64.6683 82.2397 65.2883 83.0297 64.9983C85.7697 63.9783 87.9298 61.7283 88.7298 58.8883C88.9398 58.1383 88.4698 57.2183 87.6798 57.0383C86.8898 56.8583 86.0597 57.2783 85.8297 58.0883L85.8498 58.0583Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M85.7013 63.2077C86.5513 64.6177 87.5813 65.9277 88.7913 67.0577C90.0013 68.1877 91.5013 69.4377 93.3113 69.4577C94.8513 69.4677 96.5513 68.8777 97.8513 68.0877C99.2213 67.2477 100.211 66.0977 100.821 64.6177C101.131 63.8677 100.491 62.9677 99.7713 62.7677C98.9113 62.5277 98.2313 63.0577 97.9213 63.8177C97.6113 64.5777 96.8813 65.1977 96.1013 65.6377C95.3213 66.0777 94.0713 66.6177 93.0913 66.4577C92.2013 66.3177 91.2413 65.2677 90.6213 64.6577C89.7213 63.7677 88.9513 62.7877 88.3013 61.7077C87.3113 60.0577 84.7113 61.5577 85.7113 63.2177L85.7013 63.2077Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M97.7187 60.5282C99.1887 62.9682 101.159 65.0382 103.489 66.6582C104.139 67.1082 105.179 66.7982 105.539 66.1182C105.949 65.3482 105.689 64.5482 104.999 64.0682C104.869 63.9782 104.739 63.8882 104.619 63.7982C104.559 63.7482 104.489 63.7082 104.429 63.6582C104.219 63.4982 104.429 63.6082 104.469 63.6882C104.419 63.5882 104.189 63.4682 104.099 63.3982C103.979 63.2982 103.859 63.1982 103.739 63.0982C103.269 62.6882 102.809 62.2482 102.389 61.7882C102.179 61.5582 101.969 61.3282 101.759 61.0882C101.659 60.9682 101.559 60.8482 101.459 60.7282C101.419 60.6782 101.379 60.6282 101.339 60.5782C101.599 60.8782 101.429 60.6982 101.369 60.6182C100.979 60.1082 100.619 59.5682 100.289 59.0182C99.8787 58.3482 98.9287 58.0382 98.2387 58.4782C97.5487 58.9182 97.2687 59.8082 97.6987 60.5282H97.7187Z",
          fill: "#E8F3F6"
        }
      )
    ]
  }
), Vr = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "192",
    height: "218",
    viewBox: "0 0 192 218",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M48.1599 109.15C43.9199 108.89 39.7599 108.01 35.7699 106.55C33.7699 105.82 31.9399 104.82 30.0099 103.95C28.2699 103.17 26.2699 102.82 24.5699 103.93C20.9199 106.3 23.5499 112.08 25.5299 114.73C28.0199 118.06 31.4599 120.22 35.2699 121.77C39.8699 123.64 45.0799 125.07 50.0799 124.87C52.6699 124.77 50.6399 109.31 48.1699 109.16L48.1599 109.15Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M141.01 109.15C145.25 108.89 149.41 108.01 153.4 106.55C155.4 105.82 157.23 104.82 159.16 103.95C160.9 103.17 162.9 102.82 164.6 103.93C168.25 106.3 165.62 112.08 163.64 114.73C161.15 118.06 157.71 120.22 153.9 121.77C149.3 123.64 144.09 125.07 139.09 124.87C136.5 124.77 138.53 109.31 141 109.16L141.01 109.15Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M117.799 14.88C115.439 12.52 111.589 12.52 109.229 14.88L103.919 20.19V8.49005C103.919 3.82005 100.099 0 95.4291 0C90.7591 0 86.9391 3.82005 86.9391 8.49005V20.19L81.6291 14.88C79.2691 12.52 75.4191 12.52 73.0591 14.88C70.6991 17.24 70.6991 21.09 73.0591 23.45L86.9391 37.33V57.83C86.9391 62.5 90.7591 66.32 95.4291 66.32C100.099 66.32 103.919 62.5 103.919 57.83V37.33L117.799 23.45C120.159 21.09 120.159 17.24 117.799 14.88Z",
          fill: "#B2CCDA"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M73.0493 203.06C75.4093 205.42 79.2593 205.42 81.6193 203.06L86.9293 197.75V209.45C86.9293 214.12 90.7493 217.94 95.4193 217.94C100.089 217.94 103.909 214.12 103.909 209.45V197.75L109.219 203.06C111.579 205.42 115.429 205.42 117.789 203.06C120.149 200.7 120.149 196.85 117.789 194.49L103.909 180.61V160.11C103.909 155.44 100.089 151.62 95.4193 151.62C90.7493 151.62 86.9293 155.44 86.9293 160.11V180.61L73.0493 194.49C70.6893 196.85 70.6893 200.7 73.0493 203.06Z",
          fill: "#B2CCDA"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M25.2095 42.5301C21.9895 43.3901 20.0595 46.7301 20.9195 49.9501L22.8595 57.2001L12.7295 51.3501C8.68953 49.0201 3.46949 50.4101 1.12949 54.4601C-1.20051 58.5001 0.189479 63.7201 4.23948 66.0601L14.3695 71.9101L7.11948 73.8501C3.89948 74.7101 1.96951 78.0501 2.82951 81.2701C3.68951 84.4901 7.02949 86.4201 10.2495 85.5601L29.2095 80.4801L46.9695 90.7301C51.0095 93.0601 56.2295 91.6701 58.5695 87.6201C60.9095 83.5701 59.5095 78.3601 55.4595 76.0201L37.6995 65.7701L32.6195 46.8101C31.7595 43.5901 28.4195 41.6601 25.1995 42.5201L25.2095 42.5301Z",
          fill: "#B2CCDA"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M165.798 175.371C169.018 174.511 170.948 171.17 170.088 167.95L168.148 160.7L178.278 166.551C182.318 168.881 187.538 167.49 189.878 163.44C192.218 159.39 190.818 154.18 186.768 151.84L176.638 145.991L183.888 144.051C187.108 143.191 189.038 139.85 188.178 136.63C187.318 133.41 183.978 131.48 180.758 132.34L161.798 137.421L144.038 127.171C139.998 124.841 134.778 126.23 132.438 130.28C130.108 134.32 131.498 139.54 135.548 141.88L153.308 152.13L158.388 171.09C159.248 174.31 162.588 176.24 165.808 175.38L165.798 175.371Z",
          fill: "#B2CCDA"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M2.90937 136.73C2.04937 139.95 3.97934 143.29 7.19934 144.15L14.4493 146.09L4.31934 151.94C0.279339 154.27 -1.12065 159.49 1.20935 163.54C3.53935 167.58 8.75933 168.98 12.8093 166.65L22.9393 160.8L20.9993 168.05C20.1393 171.27 22.0694 174.61 25.2894 175.47C28.5094 176.33 31.8494 174.4 32.7094 171.18L37.7894 152.22L55.5493 141.97C59.5893 139.64 60.9894 134.42 58.6594 130.37C56.3294 126.33 51.1093 124.93 47.0593 127.26L29.2993 137.51L10.3394 132.43C7.11936 131.57 3.77931 133.5 2.91931 136.72L2.90937 136.73Z",
          fill: "#B2CCDA"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M188.248 81.39C189.108 78.17 187.178 74.83 183.958 73.97L176.708 72.03L186.838 66.18C190.878 63.85 192.278 58.63 189.948 54.58C187.618 50.53 182.398 49.14 178.348 51.47L168.218 57.32L170.158 50.07C171.018 46.85 169.088 43.51 165.868 42.65C162.648 41.79 159.308 43.72 158.448 46.94L153.368 65.9L135.608 76.15C131.568 78.48 130.168 83.7 132.498 87.75C134.828 91.8 140.048 93.19 144.098 90.86L161.858 80.61L180.818 85.69C184.038 86.55 187.378 84.62 188.238 81.4L188.248 81.39Z",
          fill: "#B2CCDA"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M95.7302 159.29C123.521 159.29 146.05 136.761 146.05 108.97C146.05 81.1794 123.521 58.6504 95.7302 58.6504C67.9392 58.6504 45.4102 81.1794 45.4102 108.97C45.4102 136.761 67.9392 159.29 95.7302 159.29Z",
          fill: "#B2CCDA"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M127.181 103.54C123.481 95.2199 117.841 92.7399 111.371 94.3199C104.901 95.8999 104.001 103.49 104.181 109.17C104.321 113.6 106.501 117.84 109.721 120.88C112.941 123.92 120.971 125.73 125.991 121.92C131.011 118.11 130.881 111.87 127.181 103.55V103.54Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_3914",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "104",
          y: "93",
          width: "26",
          height: "32",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M127.181 103.54C123.481 95.2199 117.841 92.7399 111.371 94.3199C104.901 95.8999 104.001 103.49 104.181 109.17C104.321 113.6 106.501 117.84 109.721 120.88C112.941 123.92 120.971 125.73 125.991 121.92C131.011 118.11 130.881 111.87 127.181 103.55V103.54Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_3914)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M121.191 93.8696C125.251 105.16 124.751 117.4 121.191 130.29L98.2207 119.47L102.811 90.2695L121.191 93.8696Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M63.6695 103.54C67.3695 95.2199 73.0096 92.7399 79.4796 94.3199C85.9496 95.8999 86.8495 103.49 86.6695 109.17C86.5295 113.6 84.3496 117.84 81.1296 120.88C77.9096 123.92 69.8795 125.73 64.8595 121.92C59.8395 118.11 59.9695 111.87 63.6695 103.55V103.54Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_3914",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "60",
          y: "93",
          width: "27",
          height: "32",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M63.6695 103.54C67.3695 95.2199 73.0096 92.7399 79.4796 94.3199C85.9496 95.8999 86.8495 103.49 86.6695 109.17C86.5295 113.6 84.3496 117.84 81.1296 120.88C77.9096 123.92 69.8795 125.73 64.8595 121.92C59.8395 118.11 59.9695 111.87 63.6695 103.55V103.54Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_3914)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M69.6594 93.8696C65.5994 105.16 66.0994 117.4 69.6594 130.29L92.6294 119.47L88.0394 90.2695L69.6594 93.8696Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M86.9393 124.57C88.3793 127.84 92.0192 129.18 95.3592 129.32C97.1392 129.39 98.9793 129.23 100.589 128.43C102.119 127.68 103.249 126.34 104.289 125.03C104.799 124.4 104.909 123.53 104.289 122.91C103.769 122.39 102.679 122.27 102.169 122.91C101.389 123.88 100.589 124.95 99.5093 125.6C98.3493 126.3 96.9493 126.35 95.6293 126.32C93.1693 126.26 90.5993 125.46 89.5393 123.05C89.2093 122.31 88.1292 122.14 87.4892 122.51C86.7292 122.96 86.6193 123.82 86.9493 124.56L86.9393 124.57Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M103.739 83.8006C103.839 83.6306 103.939 83.4706 104.059 83.3206C103.969 83.4506 104.029 83.3606 104.089 83.2906C104.149 83.2206 104.219 83.1506 104.279 83.0806C104.429 82.9306 104.579 82.7806 104.749 82.6406C104.769 82.6206 104.989 82.4506 104.879 82.5306C104.769 82.6106 104.999 82.4506 105.019 82.4406C105.339 82.2206 105.679 82.0306 106.019 81.8506C106.479 81.6206 106.439 81.6406 106.949 81.4606C107.319 81.3306 107.699 81.2106 108.079 81.1106C108.279 81.0606 108.479 81.0106 108.679 80.9606C108.789 80.9306 108.909 80.9106 109.019 80.8906C109.039 80.8906 109.279 80.8606 109.139 80.8706C109.669 80.8306 109.909 80.8806 110.389 81.0206C110.869 81.1606 111.349 81.3406 111.819 81.5306C112.549 81.8206 113.499 81.2106 113.669 80.4806C113.869 79.6206 113.409 78.9406 112.619 78.6306C111.509 78.1906 110.349 77.7906 109.139 77.8706C108.079 77.9406 106.999 78.2606 106.009 78.6206C104.049 79.3406 102.239 80.4606 101.149 82.2906C100.739 82.9906 100.989 83.9406 101.689 84.3406C102.389 84.7406 103.329 84.5006 103.739 83.8006Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M89.0682 82.2901C87.9782 80.4601 86.1682 79.3401 84.2082 78.6201C83.2282 78.2601 82.1981 77.97 81.1681 77.88C79.9381 77.77 78.7281 78.19 77.6081 78.64C76.8581 78.94 76.3282 79.6401 76.5582 80.4901C76.7582 81.2101 77.6482 81.8401 78.4082 81.5401C79.2982 81.1901 80.1482 80.85 80.9982 80.88C81.1982 80.88 81.7282 81.0201 82.0782 81.1101C82.4782 81.2201 82.8882 81.3401 83.2782 81.4801C83.4682 81.5501 83.6482 81.62 83.8282 81.69C83.6782 81.63 83.7982 81.68 83.8782 81.71C83.9682 81.75 84.0582 81.7901 84.1482 81.8401C84.4982 82.0101 84.8382 82.2001 85.1582 82.4201C85.2382 82.4701 85.3182 82.53 85.3982 82.58C85.2682 82.49 85.3582 82.5501 85.4382 82.6101C85.5982 82.7501 85.7582 82.8901 85.9082 83.0401C85.9782 83.1101 86.0382 83.18 86.0982 83.25C86.1182 83.27 86.2882 83.4801 86.2082 83.3701C86.1282 83.2601 86.2881 83.49 86.2981 83.51C86.3681 83.61 86.4281 83.71 86.4881 83.82C86.8981 84.52 87.8382 84.7701 88.5382 84.3601C89.2382 83.9501 89.4882 83.0101 89.0782 82.3101L89.0682 82.2901Z",
          fill: "#0B455E"
        }
      )
    ]
  }
), Ur = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "156",
    height: "195",
    viewBox: "0 0 156 195",
    fill: "none",
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M154.641 113.496C153.081 112.626 148.821 113.616 147.101 113.436C145.181 113.246 142.991 113.156 141.101 112.816C136.741 112.026 132.071 109.646 127.901 108.146C125.541 107.296 127.551 123.596 129.961 123.676C134.011 123.816 138.071 123.946 142.121 124.086C145.501 124.196 149.561 124.676 152.111 121.936C153.971 119.926 157.911 115.326 154.651 113.506L154.641 113.496Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M8.07103 109.926C1.76103 119.446 -1.25892 131.796 0.491078 143.066C0.851079 145.356 1.07108 149.066 3.55108 150.096C5.85108 151.046 7.57108 148.286 8.99108 146.566C12.1811 142.696 12.201 136.926 15.821 134.276C17.711 132.896 9.44103 107.846 8.07103 109.926Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M32.9805 164.716C33.3605 169.406 33.5405 174.106 33.4805 178.816C33.4605 180.626 33.5904 182.576 32.1304 183.876C30.4504 185.376 28.8404 185.896 26.6204 185.576C25.4904 185.406 24.0305 186.056 24.1605 187.446C24.5505 191.776 28.1904 194.166 32.2204 194.726C34.4104 195.026 36.6105 194.976 38.7905 194.656C39.9805 194.486 41.1304 194.126 42.3204 193.936C43.3104 193.776 44.3104 194.106 45.2704 193.816C47.3804 193.176 47.5304 190.806 47.8104 188.986C48.1604 186.716 48.5205 184.436 48.9905 182.186C49.9305 177.636 51.4105 173.336 53.7305 169.306C54.9805 167.136 32.7604 162.206 32.9604 164.706L32.9805 164.716Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M113.07 164.716C112.69 169.406 112.51 174.106 112.57 178.816C112.59 180.626 112.46 182.576 113.92 183.876C115.6 185.376 117.21 185.896 119.43 185.576C120.56 185.406 122.02 186.056 121.89 187.446C121.5 191.776 117.86 194.166 113.83 194.726C111.64 195.026 109.44 194.976 107.26 194.656C106.07 194.486 104.92 194.126 103.73 193.936C102.74 193.776 101.74 194.106 100.78 193.816C98.6704 193.176 98.5204 190.806 98.2404 188.986C97.8904 186.716 97.5304 184.436 97.0604 182.186C96.1204 177.636 94.6404 173.336 92.3204 169.306C91.0704 167.136 113.29 162.206 113.09 164.706L113.07 164.716Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M131.932 119.417C125.852 96.9965 113.872 81.4265 106.202 72.3965C98.5319 63.3665 88.8119 46.2065 86.2719 37.6365C81.1419 20.3665 81.7319 2.08649 79.4519 0.156494C76.0419 -2.74351 39.0719 35.2565 23.5719 64.7265C8.0719 94.2065 1.93192 114.817 14.0319 145.827C20.0719 161.297 44.0919 178.086 69.5719 179.386C95.1619 180.696 122.212 166.457 127.162 158.427C137.042 142.407 133.782 126.226 131.932 119.406V119.417Z",
          fill: "#74C4D7"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M60.131 101.166C59.161 98.8964 55.651 93.1564 50.271 93.4064C44.891 93.6564 41.251 94.8464 37.871 99.4764C35.511 102.716 33.281 108.726 33.291 115.406C33.291 121.216 37.5511 126.606 42.9211 128.816C48.2911 131.026 54.791 130.046 59.401 126.526C61.051 125.266 62.2211 123.776 62.6711 120.716C63.6411 114.136 62.741 107.296 60.131 101.186V101.166Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_3893",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "33",
          y: "93",
          width: "31",
          height: "37",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M60.131 101.166C59.161 98.8964 55.651 93.1564 50.271 93.4064C44.891 93.6564 41.251 94.8464 37.871 99.4764C35.511 102.716 33.281 108.726 33.291 115.406C33.291 121.216 37.5511 126.606 42.9211 128.816C48.2911 131.026 54.791 130.046 59.401 126.526C61.051 125.266 62.2211 123.776 62.6711 120.716C63.6411 114.136 62.741 107.296 60.131 101.186V101.166Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_3893)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M49.3411 91.2361C39.3711 102.796 38.0011 116.206 44.1311 131.246L66.9711 132.776L62.2211 88.3262L49.3411 91.2361Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M83.6605 101.166C84.6305 98.8964 88.1405 93.1564 93.5205 93.4064C98.6405 93.6364 102.54 94.8464 105.92 99.4764C108.28 102.716 110.51 108.726 110.5 115.406C110.5 121.216 106.24 126.606 100.87 128.816C95.5004 131.026 89.0005 130.046 84.3905 126.526C82.7405 125.266 81.5704 123.776 81.1204 120.716C80.1504 114.136 81.0505 107.296 83.6605 101.186V101.166Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_3893",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "80",
          y: "93",
          width: "31",
          height: "37",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M83.6605 101.166C84.6305 98.8964 88.1405 93.1564 93.5205 93.4064C98.6405 93.6364 102.54 94.8464 105.92 99.4764C108.28 102.716 110.51 108.726 110.5 115.406C110.5 121.216 106.24 126.606 100.87 128.816C95.5004 131.026 89.0005 130.046 84.3905 126.526C82.7405 125.266 81.5704 123.776 81.1204 120.716C80.1504 114.136 81.0505 107.296 83.6605 101.186V101.166Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_3893)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M94.4406 91.2361C104.411 102.796 105.781 116.206 99.6506 131.246L76.8105 132.776L81.5605 88.3262L94.4406 91.2361Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M64.3821 132.537C65.0621 136.517 68.9121 139.367 72.9221 138.877C74.8121 138.647 77.1321 138.017 78.4721 136.567C79.8121 135.117 79.9921 133.027 79.9921 131.097C79.9921 129.167 76.9921 129.167 76.9921 131.097C76.9921 132.207 77.0621 133.557 76.3521 134.437C75.9921 134.887 75.4021 135.137 74.8621 135.327C74.1621 135.567 73.4221 135.807 72.6821 135.907C69.9821 136.277 67.7221 134.327 67.2821 131.737C67.1421 130.937 66.1621 130.487 65.4321 130.687C64.5821 130.917 64.2421 131.727 64.3821 132.537Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M82.3403 82.2469C82.3903 82.1669 82.4503 82.097 82.5003 82.017C82.6203 81.847 82.3303 82.2069 82.4703 82.0569C82.5803 81.9269 82.6903 81.7969 82.8003 81.6769C83.0403 81.4169 83.3103 81.177 83.5803 80.957C83.7403 80.827 83.2903 81.157 83.5903 80.957C83.6503 80.917 83.7103 80.867 83.7703 80.827C83.9103 80.737 84.0503 80.6469 84.2003 80.5569C84.3503 80.4669 84.4903 80.387 84.6503 80.317C84.7303 80.277 84.8203 80.237 84.9003 80.197C84.5603 80.327 85.0903 80.097 84.9003 80.197C85.2203 80.077 85.5403 79.967 85.8603 79.887C86.0203 79.847 86.1903 79.807 86.3503 79.777C86.4003 79.777 86.6003 79.7569 86.6303 79.7269C86.5903 79.7669 86.3303 79.7569 86.5703 79.7369C86.9303 79.7069 87.2803 79.687 87.6403 79.707C87.7803 79.707 88.0203 79.6869 88.1403 79.7469C88.0603 79.7069 87.8703 79.7069 88.0803 79.7469C88.1903 79.7669 88.3003 79.7869 88.4103 79.8069C89.1803 79.9669 90.0703 79.587 90.2603 78.757C90.4303 78.007 90.0303 77.0769 89.2103 76.9069C85.5803 76.1669 81.8203 77.697 79.7303 80.757C79.2903 81.407 79.5903 82.4469 80.2703 82.8069C81.0303 83.2069 81.8503 82.957 82.3203 82.267L82.3403 82.2469Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M65.1108 81.6967C64.1708 78.9267 61.4107 76.9067 58.4507 77.0567C57.6707 77.0967 56.9107 77.7167 56.9507 78.5567C56.9807 79.3367 57.6107 80.0967 58.4507 80.0567C58.7507 80.0367 59.0508 80.0567 59.3508 80.0867L58.9507 80.0366C59.1707 80.0666 59.3908 80.1066 59.6108 80.1666C59.7308 80.1966 59.8508 80.2367 59.9708 80.2767C60.0408 80.2967 60.4007 80.4467 60.1407 80.3367C59.8807 80.2267 60.2308 80.3866 60.3008 80.4166C60.4008 80.4666 60.5008 80.5267 60.6008 80.5767C60.7008 80.6267 60.7907 80.6967 60.8907 80.7567C61.0007 80.8367 61.3107 81.1166 60.9507 80.7866C61.1207 80.9366 61.2907 81.0767 61.4507 81.2467C61.5307 81.3267 61.6007 81.4067 61.6807 81.4967C61.7007 81.5267 61.7708 81.6367 61.8008 81.6367C61.7808 81.6367 61.5807 81.3467 61.7007 81.5167C61.8407 81.7067 61.9607 81.9067 62.0807 82.1167C62.1307 82.2067 62.2108 82.3166 62.2308 82.4166C62.2308 82.3866 62.0908 82.0767 62.1608 82.2667C62.1908 82.3367 62.2108 82.4066 62.2408 82.4766C62.4908 83.2166 63.2807 83.7867 64.0907 83.5267C64.8307 83.2867 65.4107 82.4767 65.1407 81.6767L65.1108 81.6967Z",
          fill: "#0B455E"
        }
      )
    ]
  }
), Or = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "198",
    height: "136",
    viewBox: "0 0 198 136",
    fill: "none",
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M64.8667 103.149C64.7067 102.319 44.5167 102.039 45.7967 103.589C49.5367 108.099 52.4467 113.179 54.7467 118.549C55.8767 121.179 57.0667 123.919 57.8467 126.679C58.0867 127.519 57.6967 127.629 57.0067 128.099C56.3967 128.509 55.7667 128.899 55.1267 129.249C53.8267 129.959 52.4367 130.499 51.0167 130.939C49.6067 131.369 49.7667 133.109 50.8067 133.809C52.7767 135.129 55.8167 135.289 58.1167 135.459C60.7067 135.649 63.2867 135.529 65.8467 135.099C66.7367 134.949 67.2867 134.379 67.3167 133.449C67.6067 123.289 66.7867 113.129 64.8667 103.149Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M134.337 102.919C134.527 102.089 154.717 102.439 153.387 103.949C149.517 108.339 146.447 113.329 143.987 118.629C142.777 121.229 141.507 123.919 140.647 126.659C140.387 127.489 140.767 127.609 141.447 128.099C142.037 128.529 142.657 128.939 143.287 129.309C144.567 130.059 145.937 130.639 147.337 131.119C148.727 131.599 148.517 133.329 147.457 133.989C145.447 135.249 142.407 135.309 140.107 135.419C137.507 135.529 134.937 135.329 132.387 134.819C131.507 134.639 130.967 134.049 130.967 133.129C130.987 122.969 132.117 112.839 134.337 102.919Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M194.088 68.2783C191.998 68.1483 189.748 68.5684 187.668 68.7984C183.408 69.2584 179.128 69.9283 175.088 71.3983C171.008 72.8783 167.208 75.0783 164.198 78.2383C162.818 79.6883 175.898 85.2684 177.138 84.0584C180.118 81.1484 183.608 78.9783 187.488 77.4883C189.378 76.7683 191.288 76.1183 193.108 75.2383C194.748 74.4483 196.918 73.3684 197.138 71.3284C197.338 69.4784 195.768 68.3884 194.098 68.2884L194.088 68.2783Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M29.587 73.6093C26.517 71.5293 22.9069 70.6292 19.2969 70.0192C14.9969 69.2992 10.6469 68.8292 6.29693 68.6392C4.62693 68.5692 2.27694 68.1092 0.93694 69.3692C-0.20306 70.4392 -0.213069 72.2493 0.426931 73.5693C1.91693 76.6193 6.07693 77.4493 8.98693 78.4593C13.3669 79.9893 17.7169 81.5792 21.7469 83.8992C23.4169 84.8592 31.247 74.7293 29.587 73.6093Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M189.007 85.6792C188.577 83.2792 188.047 80.7791 186.557 78.8691C185.467 77.4591 183.937 76.4792 182.417 75.5792C177.747 72.7992 172.847 70.4291 167.777 68.5091C170.197 64.8991 169.627 60.0491 168.587 55.7991C166.537 47.4391 163.067 39.4391 158.357 32.2891C149.937 19.4791 139.247 21.6691 133.647 21.9891C128.047 22.3091 118.267 24.0792 109.657 29.8592C107.097 21.4492 103.197 12.9892 96.2074 7.81917C89.9174 3.16917 81.9374 1.74916 74.2274 0.809157C67.8374 0.0291574 61.3073 -0.510891 54.9873 0.759109C41.2073 3.52911 29.8874 15.1391 25.7774 28.8691C21.6574 42.5991 24.2874 57.9492 31.3874 70.3392C24.5774 69.5592 17.4674 72.6891 13.3274 78.2791C9.18736 83.8691 8.18736 91.7192 10.7674 98.2092C13.5474 105.199 19.6774 111.419 26.9574 112.679C34.2374 113.939 53.5874 113.069 53.5874 113.069C77.1374 113.349 100.677 113.619 124.227 113.899C140.357 114.089 156.667 114.259 172.377 110.549C178.587 109.079 185.267 106.519 188.187 100.729C190.487 96.1792 189.887 90.7192 188.987 85.6792H189.007Z",
          fill: "#74C4D7"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M147.696 68.7388C147.376 64.4988 145.726 60.4788 143.926 56.6188C142.776 54.1488 139.446 49.1288 133.886 47.6188C128.326 46.1188 123.296 47.3089 121.366 48.2289C119.106 49.3089 117.356 51.2188 115.906 53.2588C112.506 58.0588 110.506 64.0089 111.106 69.8589C111.706 75.7189 115.136 81.3788 120.416 83.9888C126.346 86.9188 133.566 85.6988 139.546 82.8788C140.996 82.1988 142.416 81.4189 143.616 80.3489C146.796 77.5189 148.016 72.9689 147.696 68.7289V68.7388Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_3939",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "111",
          y: "46",
          width: "37",
          height: "40",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M147.696 68.7388C147.376 64.4988 145.726 60.4788 143.926 56.6188C142.776 54.1488 139.446 49.1288 133.886 47.6188C128.326 46.1188 123.296 47.3089 121.366 48.2289C119.106 49.3089 117.356 51.2188 115.906 53.2588C112.506 58.0588 110.506 64.0089 111.106 69.8589C111.706 75.7189 115.136 81.3788 120.416 83.9888C126.346 86.9188 133.566 85.6988 139.546 82.8788C140.996 82.1988 142.416 81.4189 143.616 80.3489C146.796 77.5189 148.016 72.9689 147.696 68.7289V68.7388Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_3939)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M137.775 45.9988C142.895 64.4588 143.295 79.3588 137.775 89.7788L101.695 82.1488L108.805 43.2988L137.765 45.9988H137.775Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M46.0572 68.7388C46.3772 64.4988 48.0272 60.4788 49.8272 56.6188C50.9772 54.1488 54.3072 49.1288 59.8672 47.6188C65.4272 46.1188 70.4572 47.3089 72.3872 48.2289C74.6472 49.3089 76.3973 51.2188 77.8473 53.2588C81.2473 58.0588 83.2472 64.0089 82.6472 69.8589C82.0472 75.7189 78.6172 81.3788 73.3372 83.9888C67.4072 86.9188 60.1872 85.6988 54.2072 82.8788C52.7572 82.1988 51.3372 81.4189 50.1372 80.3489C46.9572 77.5189 45.7372 72.9689 46.0572 68.7289V68.7388Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_3939",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "46",
          y: "46",
          width: "37",
          height: "40",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M46.0572 68.7388C46.3772 64.4988 48.0272 60.4788 49.8272 56.6188C50.9772 54.1488 54.3072 49.1288 59.8672 47.6188C65.4272 46.1188 70.4572 47.3089 72.3872 48.2289C74.6472 49.3089 76.3973 51.2188 77.8473 53.2588C81.2473 58.0588 83.2472 64.0089 82.6472 69.8589C82.0472 75.7189 78.6172 81.3788 73.3372 83.9888C67.4072 86.9188 60.1872 85.6988 54.2072 82.8788C52.7572 82.1988 51.3372 81.4189 50.1372 80.3489C46.9572 77.5189 45.7372 72.9689 46.0572 68.7289V68.7388Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_3939)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M55.9777 45.9988C50.8577 64.4588 50.4577 79.3588 55.9777 89.7788L92.0577 82.1488L84.9477 43.2988L55.9877 45.9988H55.9777Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M111.258 48.2691C111.558 46.2491 112.158 44.3691 113.088 42.6391C113.538 41.8091 114.028 40.9792 114.588 40.3592C115.218 39.6692 115.828 39.2591 116.628 39.2791C117.428 39.2991 118.128 38.5791 118.128 37.7791C118.128 36.9791 117.438 36.2891 116.628 36.2791C113.868 36.2291 112.018 38.4791 110.758 40.6591C109.498 42.8391 108.728 45.0792 108.368 47.4692C108.248 48.2692 108.568 49.0792 109.418 49.3192C110.128 49.5092 111.138 49.0791 111.268 48.2691H111.258Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M61.707 39.1089C65.077 38.6289 68.4871 39.3589 71.7871 39.9289C75.0871 40.4989 78.577 40.9488 82.017 40.3688C83.917 40.0488 83.1071 37.1589 81.2171 37.4789C77.8671 38.0489 74.4571 37.3689 71.1571 36.7889C67.8571 36.2089 64.3671 35.7189 60.9071 36.2189C60.0971 36.3389 59.6671 37.3489 59.8571 38.0689C60.0871 38.9289 60.907 39.2288 61.707 39.1188V39.1089Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M85.7168 83.7985C89.7068 83.2285 93.0668 80.3284 94.5368 76.6284C94.8268 75.8984 94.2168 74.9485 93.4868 74.7785C92.6168 74.5785 91.9568 75.0485 91.6368 75.8285C91.4968 76.1885 91.7768 75.5385 91.6068 75.8885C91.5668 75.9785 91.5268 76.0585 91.4868 76.1485C91.3968 76.3385 91.2968 76.5185 91.1968 76.6985C91.0068 77.0185 90.7868 77.4884 90.5068 77.7384C90.6468 77.6184 90.6068 77.6084 90.4968 77.7384C90.4368 77.8084 90.3768 77.8885 90.3168 77.9585C90.1768 78.1185 90.0368 78.2685 89.8868 78.4185C89.7368 78.5685 89.5868 78.7085 89.4368 78.8485C89.3668 78.9085 89.2968 78.9785 89.2168 79.0385C89.1868 79.0685 88.8868 79.3085 89.0568 79.1685C89.2268 79.0285 88.9668 79.2285 88.9368 79.2585C88.8468 79.3285 88.7468 79.3885 88.6568 79.4585C88.4968 79.5685 88.3368 79.6685 88.1768 79.7685C87.9968 79.8785 87.8168 79.9785 87.6268 80.0685C87.5268 80.1185 87.1768 80.3585 87.0668 80.3385C87.1768 80.3585 87.2968 80.2485 87.0668 80.3385C86.9768 80.3685 86.8868 80.4085 86.7968 80.4385C86.5868 80.5185 86.3668 80.5885 86.1468 80.6485C85.7468 80.7585 85.3368 80.8385 84.9168 80.8985C84.1368 81.0085 83.6368 82.0384 83.8668 82.7484C84.1468 83.5984 84.8768 83.9185 85.7168 83.7985Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M88.4267 82.8392C90.4267 85.9892 93.1767 89.1792 96.9867 89.9892C97.9267 90.1892 98.8968 90.2892 99.8468 90.3692C100.757 90.4392 101.697 90.5492 102.577 90.2392C104.467 89.5792 104.917 87.6792 104.957 85.8892C104.997 83.9592 101.997 83.9592 101.957 85.8892C101.947 86.4292 101.947 86.7992 101.747 87.3092C101.767 87.2592 101.607 87.4092 101.687 87.3792C101.477 87.4792 101.227 87.4592 100.987 87.4492C99.6167 87.4092 98.1767 87.2793 96.8667 86.8593C95.5567 86.4393 94.6168 85.6393 93.7068 84.7193C92.6868 83.6793 91.7868 82.5492 91.0068 81.3292C89.9768 79.7092 87.3768 81.2092 88.4168 82.8392H88.4267Z",
          fill: "#0B455E"
        }
      )
    ]
  }
), Wr = ({ style: e }) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "176",
    height: "164",
    viewBox: "0 0 176 164",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M126.9 158.477C125.53 157.657 123.38 156.627 122.62 155.827C121.03 154.157 121 140.187 120.75 134.517C120.66 132.407 104.7 134.647 104.76 136.667C104.88 140.577 105.48 143.447 106.36 147.257C107.76 153.327 107.2 156.397 108.56 159.737C109.22 161.357 110.54 161.657 112.11 161.977C114.12 162.387 116.14 162.767 118.19 162.977C121.28 163.297 125.51 163.627 127.5 160.727C128.01 159.987 127.63 158.907 126.91 158.477H126.9Z",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M50.9201 158.477C52.2901 157.657 54.4402 156.627 55.2002 155.827C56.7902 154.157 56.8202 140.187 57.0702 134.517C57.1602 132.407 73.1202 134.647 73.0602 136.667C72.9402 140.577 72.3402 143.447 71.4602 147.257C70.0602 153.327 70.6202 156.397 69.2602 159.737C68.6002 161.357 67.2802 161.657 65.7102 161.977C63.7002 162.387 61.6802 162.767 59.6302 162.977C56.5402 163.297 52.3102 163.627 50.3202 160.727C49.8102 159.987 50.1901 158.907 50.9101 158.477H50.9201Z",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M171.449 91.8669C168.389 89.8169 164.759 89.6469 161.429 91.1069C159.629 91.8969 157.999 93.0569 156.469 94.2769C154.909 95.5169 153.579 97.017 153.049 98.967C152.709 100.227 155.039 110.787 156.559 109.317C159.029 106.937 162.099 105.287 165.459 104.567C168.879 103.827 172.719 103.857 174.779 100.507C176.859 97.1269 174.249 93.7569 171.439 91.8669H171.449Z",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M9.53966 95.9969C11.9597 93.2269 15.4297 92.1169 19.0197 92.6669C20.9597 92.9569 22.8397 93.667 24.6297 94.437C26.4597 95.227 28.1296 96.327 29.1496 98.087C29.8096 99.217 30.2997 110.017 28.4397 108.987C25.4297 107.327 22.0397 106.537 18.6097 106.707C15.1097 106.877 11.4097 107.907 8.54967 105.207C5.65967 102.477 7.30965 98.5469 9.52965 95.9969H9.53966Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M23.2796 67.017C31.0396 38.597 50.0996 27.7371 68.3396 23.3271C86.5796 18.9171 107.36 23.9671 117.73 28.9671C140.19 39.8071 158.9 67.697 146.11 106.737C141.42 121.067 131.91 126.027 117.57 133.227C90.9796 146.567 56.3896 138.707 42.2196 129.347C28.0596 119.987 15.5096 95.427 23.2696 67.017H23.2796Z",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M158.951 89.5572C157.001 83.8172 151.471 64.6572 145.091 59.1872C139.081 54.0372 129.891 50.4972 114.281 54.7772C90.3705 61.3272 92.3206 86.5971 92.3206 86.5971C92.3206 86.5971 91.6506 85.5672 83.2006 86.2272C75.7706 86.7972 67.1505 95.5272 63.8505 98.2572C60.5505 100.987 55.6805 110.227 55.6805 110.227C55.6805 110.227 44.9106 106.107 40.8306 106.407C34.6506 106.857 29.7105 111.097 25.3105 115.107C21.9705 118.147 18.4505 121.477 17.6605 125.737C16.5105 131.857 22.3005 141.327 25.5905 143.897C28.8805 146.467 95.4906 145.217 130.451 145.417C138.951 145.467 141.751 145.267 148.311 140.317C152.191 137.397 154.591 133.157 156.441 128.877C161.811 116.427 163.261 102.347 158.931 89.5572H158.951Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M132.061 72.3569C129.001 68.9169 119.321 59.8569 108.361 66.0969C104.131 68.5069 100.571 72.307 99.0407 76.927C97.5107 81.547 98.2007 86.9969 101.311 90.7369C103.561 93.4369 106.821 95.087 110.151 96.207C115.471 98.007 121.291 98.647 126.731 97.267C128.551 96.807 130.331 96.1069 131.831 94.9769C134.611 92.8669 136.101 89.387 136.451 85.917C136.941 81.057 135.311 76.0169 132.061 72.3669V72.3569Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_4038",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "98",
          y: "63",
          width: "39",
          height: "36",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M132.061 72.3569C129.001 68.9169 119.321 59.8569 108.361 66.0969C104.131 68.5069 100.571 72.307 99.0407 76.927C97.5107 81.547 98.2007 86.9969 101.311 90.7369C103.561 93.4369 106.821 95.087 110.151 96.207C115.471 98.007 121.291 98.647 126.731 97.267C128.551 96.807 130.331 96.1069 131.831 94.9769C134.611 92.8669 136.101 89.387 136.451 85.917C136.941 81.057 135.311 76.0169 132.061 72.3669V72.3569Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_4038)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M110.511 61.4473C99.0508 75.6373 101.061 91.3472 111.491 108.017L146.041 109.327L141.621 62.9872L110.511 61.4473Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M39.8097 72.3569C42.8697 68.9169 52.5497 59.8569 63.5097 66.0969C67.7397 68.5069 71.2997 72.307 72.8297 76.927C74.3597 81.547 73.6697 86.9969 70.5597 90.7369C68.3097 93.4369 65.0497 95.087 61.7197 96.207C56.3997 98.007 50.5797 98.647 45.1397 97.267C43.3197 96.807 41.5397 96.1069 40.0397 94.9769C37.2597 92.8669 35.7697 89.387 35.4197 85.917C34.9297 81.057 36.5597 76.0169 39.8097 72.3669V72.3569Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_4038",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "35",
          y: "63",
          width: "39",
          height: "36",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M39.8097 72.3569C42.8697 68.9169 52.5497 59.8569 63.5097 66.0969C67.7397 68.5069 71.2997 72.307 72.8297 76.927C74.3597 81.547 73.6697 86.9969 70.5597 90.7369C68.3097 93.4369 65.0497 95.087 61.7197 96.207C56.3997 98.007 50.5797 98.647 45.1397 97.267C43.3197 96.807 41.5397 96.1069 40.0397 94.9769C37.2597 92.8669 35.7697 89.387 35.4197 85.917C34.9297 81.057 36.5597 76.0169 39.8097 72.3669V72.3569Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_4038)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M47.999 61.4473C36.539 75.6373 38.549 91.3472 48.979 108.017L83.529 109.327L79.109 62.9872L47.999 61.4473Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M76.7094 93.1471C76.9894 95.4871 78.2493 97.5571 80.4093 98.6171C82.5693 99.6771 84.9594 99.7171 87.2494 99.7571C89.5394 99.7971 92.1094 99.4672 94.0194 97.9372C95.7594 96.5372 96.7094 94.3571 96.1994 92.1471C95.7694 90.2671 92.8794 91.0572 93.3094 92.9472C93.5894 94.1572 92.6894 95.3272 91.6994 95.9272C90.2994 96.7872 88.5494 96.7971 86.9594 96.7571C84.3294 96.6871 80.1194 96.6071 79.6994 93.1571C79.5994 92.3571 79.0794 91.6571 78.1994 91.6571C77.4594 91.6571 76.5994 92.3471 76.6994 93.1571L76.7094 93.1471Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M102.9 49.3974C105.71 49.8874 108.54 50.1974 111.39 50.3074C112.17 50.3374 112.93 49.5974 112.89 48.8074C112.85 47.9674 112.23 47.3374 111.39 47.3074C110.06 47.2574 108.73 47.1674 107.41 47.0274C107.07 46.9874 106.74 46.9574 106.4 46.9174C106.24 46.8974 106.09 46.8773 105.93 46.8573C105.62 46.8173 106.05 46.8774 105.71 46.8274C105.04 46.7274 104.37 46.6274 103.7 46.5074C102.93 46.3774 102.05 46.7174 101.85 47.5574C101.68 48.2874 102.07 49.2574 102.9 49.4074V49.3974Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M70.6993 46.5068C69.2793 46.7568 68.3693 46.8868 66.9893 47.0268C65.6093 47.1668 64.3393 47.2569 63.0093 47.3069C62.2293 47.3369 61.4693 47.9769 61.5093 48.8069C61.5493 49.5969 62.1693 50.3369 63.0093 50.3069C65.8593 50.1969 68.6893 49.8868 71.4993 49.3968C72.2793 49.2668 72.7793 48.2668 72.5493 47.5468C72.2793 46.7068 71.5393 46.3568 70.6993 46.4968V46.5068Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M17.86 111.568C12.41 112.228 6.96 112.878 1.5 113.538C0.7 113.638 0 114.158 0 115.038C0 115.778 0.69 116.638 1.5 116.538C6.95 115.878 12.4 115.228 17.86 114.568C18.66 114.468 19.36 113.948 19.36 113.068C19.36 112.328 18.67 111.468 17.86 111.568Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M13.3392 68.4676C11.0792 68.2176 8.82923 67.9676 6.56923 67.7176C5.78923 67.6276 5.03923 68.4676 5.06923 69.2176C5.10923 70.1076 5.72923 70.6276 6.56923 70.7176C8.82923 70.9676 11.0792 71.2176 13.3392 71.4676C14.1192 71.5576 14.8692 70.7176 14.8392 69.9676C14.7992 69.0776 14.1792 68.5576 13.3392 68.4676Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M14.4191 32.0271C18.9891 34.3171 23.3492 36.9871 27.4592 40.0071C28.1092 40.4871 29.1292 40.1172 29.5092 39.4672C29.9592 38.7072 29.6291 37.8971 28.9691 37.4171C24.8591 34.3871 20.4992 31.7171 15.9292 29.4371C15.2092 29.0771 14.3092 29.2471 13.8792 29.9771C13.4892 30.6471 13.6891 31.6671 14.4191 32.0271Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M51.7496 16.1477C52.6296 17.3377 53.5196 18.5277 54.3996 19.7077C54.6396 20.0277 54.8896 20.2876 55.2996 20.3976C55.6596 20.4976 56.1397 20.4476 56.4597 20.2476C56.7797 20.0476 57.0596 19.7376 57.1496 19.3476C57.2396 18.9576 57.2296 18.5077 56.9996 18.1877C56.1196 16.9977 55.2296 15.8076 54.3496 14.6276C54.1096 14.3076 53.8597 14.0477 53.4497 13.9377C53.0897 13.8377 52.6096 13.8877 52.2896 14.0877C51.9696 14.2877 51.6896 14.5976 51.5996 14.9876C51.5096 15.3776 51.5196 15.8277 51.7496 16.1477Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M84.0886 1.89729C84.9286 6.47729 85.2086 11.1373 84.9986 15.7873C84.9086 17.7173 87.9086 17.7173 87.9986 15.7873C88.2286 10.8673 87.8686 5.94724 86.9886 1.09724C86.8386 0.297241 85.8786 -0.152686 85.1386 0.0473139C84.2986 0.277314 83.9486 1.09729 84.0886 1.89729Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M115.8 13.7072C115.61 14.5772 115.37 15.4472 115.06 16.2772C114.99 16.4772 114.91 16.6772 114.83 16.8772C114.77 17.0272 114.78 16.9872 114.87 16.7772C114.85 16.8372 114.82 16.8872 114.8 16.9472C114.76 17.0272 114.73 17.1172 114.69 17.1972C114.5 17.6172 114.29 18.0272 114.07 18.4372C113.69 19.1272 113.88 20.1071 114.61 20.4871C115.34 20.8671 116.26 20.6872 116.66 19.9472C117.59 18.2372 118.3 16.3971 118.7 14.4871C118.86 13.7171 118.47 12.8272 117.65 12.6372C116.9 12.4672 115.98 12.8672 115.8 13.6872V13.7072Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M154.849 35.0875C151.029 37.4775 147.17 39.7975 143.26 42.0475C141.59 43.0175 143.1 45.6075 144.77 44.6375C148.67 42.3875 152.539 40.0675 156.359 37.6775C157.989 36.6575 156.489 34.0575 154.849 35.0875Z",
          fill: "#0B455E"
        }
      )
    ]
  }
), Hr = ({ style: e }) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "181",
    height: "153",
    viewBox: "0 0 181 153",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M55.2097 131.822C54.3597 132.422 54.3098 133.492 54.7398 134.382C55.7298 136.422 56.9497 138.542 57.5797 140.732C57.9097 141.862 59.2997 146.392 59.3397 146.692C58.9897 146.902 58.2697 147.242 57.9997 147.402C57.3397 147.792 55.9597 147.802 55.3097 148.192C54.6497 148.582 54.4097 149.602 54.6397 150.322C54.9097 151.162 55.6497 151.332 56.3897 151.582C59.1197 152.502 61.1498 152.412 63.9198 152.472C65.0898 152.492 67.2498 152.252 68.2798 151.532C69.3598 150.772 69.8098 149.312 69.9898 148.032C70.3698 145.272 70.1097 142.392 70.3697 139.652C70.6297 136.912 70.3798 134.412 70.7998 131.692C71.1598 129.352 55.9298 131.312 55.2198 131.822H55.2097Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M121.411 131.822C122.261 132.422 122.311 133.492 121.881 134.382C120.891 136.422 119.671 138.542 119.041 140.732C118.711 141.862 117.321 146.392 117.281 146.692C117.631 146.902 118.351 147.242 118.621 147.402C119.281 147.792 120.661 147.802 121.311 148.192C121.971 148.582 122.211 149.602 121.981 150.322C121.711 151.162 120.971 151.332 120.231 151.582C117.501 152.502 115.471 152.412 112.701 152.472C111.531 152.492 109.371 152.252 108.341 151.532C107.261 150.772 106.811 149.312 106.631 148.032C106.251 145.272 106.511 142.392 106.251 139.652C105.991 136.912 106.241 134.412 105.821 131.692C105.461 129.352 120.691 131.312 121.401 131.822H121.411Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M180.319 93.9621C179.939 92.9821 179.109 92.4521 178.039 92.6721C175.519 93.1821 173.369 94.5421 171.019 95.4821C168.409 96.5221 165.619 96.8621 162.829 96.6921C157.199 96.3521 152.009 93.8221 147.279 90.9221C145.239 89.6721 142.239 102.912 144.509 103.282C148.649 103.962 152.329 105.312 156.479 105.982C160.289 106.602 164.449 107.492 168.309 107.712C171.629 107.902 174.879 107.002 177.089 104.392C179.189 101.902 181.609 97.2621 180.319 93.9621Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M28.3499 97.5411C26.0899 99.1211 23.8199 100.691 21.5599 102.271C19.4499 103.741 17.2299 105.201 15.35 106.971C11.17 110.911 16.84 116.421 19.79 119.021C20.68 119.811 21.4399 120.811 22.3499 121.561C22.4599 121.651 22.51 121.801 22.54 121.871C22.47 121.981 22.3899 122.091 22.3399 122.171C21.9599 122.761 21.5399 123.301 21.0699 123.821C20.3399 124.621 19.36 125.301 19.18 126.441C18.99 127.611 19.7299 128.701 20.8499 129.021C23.03 129.641 26.1099 128.771 28.1599 128.001C30.1799 127.241 32.64 126.191 33.55 124.071C34.67 121.441 31.7 118.141 30.6 115.741C30.28 115.051 29.9299 114.371 29.5599 113.711C29.4599 113.541 29.3599 113.371 29.2599 113.201C29.4399 113.051 29.6299 112.911 29.8099 112.761C30.9999 111.841 33.6299 110.971 34.8999 110.181C36.8799 108.951 30.3299 96.1711 28.3699 97.5411H28.3499Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M25.8696 62.7821C33.6496 34.3121 52.7496 23.4221 71.0296 19.0021C89.3096 14.5821 110.14 19.6421 120.53 24.6521C143.04 35.5121 161.78 63.4621 148.97 102.582C144.27 116.942 134.74 121.912 120.37 129.122C93.7196 142.492 59.0596 134.612 44.8696 125.232C30.6796 115.852 18.0996 91.2421 25.8796 62.7721L25.8696 62.7821Z",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M148.539 115.622C150.969 114.122 147.649 104.851 143.369 102.171C136.449 97.8514 131.809 96.8514 123.689 97.5514C113.549 98.4114 101.079 108.112 101.079 108.112C101.079 108.112 91.8492 99.8215 85.5292 99.3415C82.5692 99.1215 79.6392 100.032 76.8792 101.142C68.8892 104.392 61.6592 109.522 55.9692 116.002C55.3492 116.712 53.8593 117.851 53.8593 117.851C53.8593 117.851 45.8392 114.291 42.5292 114.101C40.8592 114.011 34.2192 114.221 31.7892 116.291C29.3592 118.371 26.5992 121.132 26.2492 127.612C26.0592 131.072 28.9193 136.731 31.6693 138.841C34.1693 140.761 37.4792 141.181 40.6192 141.461C52.4892 142.511 64.4492 142.612 76.3392 141.742C79.7292 141.492 86.4492 142.252 86.4492 142.252C86.4492 142.252 89.8092 143.802 91.5192 144.512C97.0892 146.842 103.489 146.291 109.279 144.561C115.069 142.841 120.459 140.012 126.069 137.782C127.099 137.372 129.269 136.892 129.269 136.892C129.269 136.892 132.179 137.242 133.599 137.622C136.959 138.522 140.429 139.001 143.909 139.061C145.269 139.081 146.659 139.041 147.939 138.601C151.339 137.441 153.189 133.782 153.969 130.272C155.649 122.722 151.519 115.591 148.519 115.591L148.539 115.622Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M107.701 55.3614C110.391 52.5614 114.751 51.7114 118.481 52.7714C122.211 53.8314 125.331 56.5814 127.381 59.8714C129.431 63.1714 130.511 66.9913 131.131 70.8213C131.611 73.8013 131.821 76.9013 131.021 79.8213C129.781 84.2913 126.081 87.9414 121.671 89.3814C117.251 90.8214 112.251 90.1014 108.261 87.7214C107.291 87.1414 106.351 86.4513 105.671 85.5513C104.411 83.8913 104.101 81.7214 103.901 79.6414C103.221 72.4914 103.041 60.2214 107.711 55.3714L107.701 55.3614Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask0_37_4007",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "103",
          y: "52",
          width: "29",
          height: "39",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M107.701 55.3614C110.391 52.5614 114.751 51.7114 118.481 52.7714C122.211 53.8314 125.331 56.5814 127.381 59.8714C129.431 63.1714 130.511 66.9913 131.131 70.8213C131.611 73.8013 131.821 76.9013 131.021 79.8213C129.781 84.2913 126.081 87.9414 121.671 89.3814C117.251 90.8214 112.251 90.1014 108.261 87.7214C107.291 87.1414 106.351 86.4513 105.671 85.5513C104.411 83.8913 104.101 81.7214 103.901 79.6414C103.221 72.4914 103.041 60.2214 107.711 55.3714L107.701 55.3614Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask0_37_4007)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M115.241 48.5016C104.871 63.7616 105.781 80.1915 115.241 97.2915L142.551 95.9515L135.341 45.1416L115.241 48.5016Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M70.0999 55.3614C67.4099 52.5614 63.0498 51.7114 59.3198 52.7714C55.5798 53.8314 52.4699 56.5814 50.4199 59.8714C48.3699 63.1714 47.2899 66.9913 46.6699 70.8213C46.1899 73.8013 45.9799 76.9013 46.7799 79.8213C48.0199 84.2913 51.7198 87.9414 56.1298 89.3814C60.5498 90.8214 65.5499 90.1014 69.5399 87.7214C70.5099 87.1414 71.4498 86.4513 72.1298 85.5513C73.3898 83.8913 73.6999 81.7214 73.8999 79.6414C74.5799 72.4914 74.7599 60.2214 70.0899 55.3714L70.0999 55.3614Z",
          fill: "#E8F3F6"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "mask",
        {
          id: "mask1_37_4007",
          style: { maskType: "luminance" },
          maskUnits: "userSpaceOnUse",
          x: "46",
          y: "52",
          width: "29",
          height: "39",
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              d: "M70.0999 55.3614C67.4099 52.5614 63.0498 51.7114 59.3198 52.7714C55.5798 53.8314 52.4699 56.5814 50.4199 59.8714C48.3699 63.1714 47.2899 66.9913 46.6699 70.8213C46.1899 73.8013 45.9799 76.9013 46.7799 79.8213C48.0199 84.2913 51.7198 87.9414 56.1298 89.3814C60.5498 90.8214 65.5499 90.1014 69.5399 87.7214C70.5099 87.1414 71.4498 86.4513 72.1298 85.5513C73.3898 83.8913 73.6999 81.7214 73.8999 79.6414C74.5799 72.4914 74.7599 60.2214 70.0899 55.3714L70.0999 55.3614Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ o.jsx("g", { mask: "url(#mask1_37_4007)", children: /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M59.0085 49.5212C48.6385 64.7812 49.5485 81.2112 59.0085 98.3112L86.3185 96.9712L79.1086 46.1611L59.0085 49.5212Z",
          fill: "#0B455E"
        }
      ) }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M103.081 36.9318C103.871 36.6518 104.661 36.3818 105.491 36.2618L105.091 36.3118C105.511 36.2618 105.931 36.2518 106.361 36.3018L105.961 36.2518C106.291 36.3018 106.611 36.3818 106.931 36.5118L106.571 36.3618C106.701 36.4218 106.821 36.4818 106.941 36.5518C107.621 36.9418 108.611 36.7318 108.991 36.0118C109.371 35.2918 109.181 34.3818 108.451 33.9618C106.491 32.8218 104.281 33.3418 102.281 34.0518C101.911 34.1818 101.591 34.3918 101.381 34.7418C101.191 35.0618 101.111 35.5419 101.231 35.9019C101.471 36.6319 102.281 37.2318 103.081 36.9518V36.9318Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M74.661 34.042C72.661 33.332 70.4511 32.812 68.4911 33.952C67.8111 34.342 67.511 35.3221 67.951 36.0021C68.391 36.6821 69.281 36.962 70.001 36.542C70.121 36.472 70.241 36.412 70.371 36.352L70.011 36.5021C70.321 36.3721 70.641 36.2921 70.981 36.2421L70.581 36.292C71.001 36.242 71.431 36.252 71.851 36.302L71.451 36.2521C72.281 36.3721 73.071 36.642 73.861 36.922C74.601 37.182 75.531 36.6221 75.711 35.8721C75.901 35.0321 75.461 34.3021 74.661 34.0221V34.042Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M82.2502 82.8721C82.2202 82.9521 82.1902 83.0221 82.1702 83.1021C82.0703 83.3921 82.3302 82.772 82.2002 83.042C82.1402 83.172 82.0702 83.312 82.0102 83.442C81.8702 83.702 81.7202 83.962 81.5402 84.202C81.5002 84.252 81.4503 84.3121 81.4202 84.3621C81.6302 84.0021 81.5302 84.222 81.4502 84.312C81.3502 84.442 81.2402 84.562 81.1302 84.682C80.9302 84.902 80.7102 85.102 80.4802 85.292C80.4302 85.332 80.2402 85.482 80.4402 85.322C80.6402 85.162 80.4103 85.3421 80.3603 85.3721C80.2403 85.4621 80.1203 85.5421 79.9903 85.6221C79.7403 85.7821 79.4802 85.922 79.2102 86.052C79.1102 86.092 78.8402 86.1821 79.2702 86.0321C79.1902 86.0621 79.1202 86.0921 79.0402 86.1221C78.9102 86.1721 78.7902 86.2121 78.6602 86.2521C78.3502 86.3421 78.0302 86.412 77.7102 86.462C77.3602 86.512 76.9802 86.8621 76.8102 87.1521C76.6202 87.4721 76.5402 87.952 76.6602 88.312C76.7802 88.672 77.0002 89.022 77.3502 89.212C77.7302 89.412 78.0802 89.4321 78.5102 89.3621C81.5702 88.8921 84.1402 86.562 85.1502 83.682C85.4102 82.942 84.8602 82.012 84.1002 81.832C83.2602 81.642 82.5302 82.0821 82.2502 82.8821V82.8721Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M82.0315 87.9315C83.9815 90.2115 87.5115 90.8016 90.3515 90.6416C91.9615 90.5516 93.6215 90.2615 95.0915 89.5615C96.4115 88.9315 97.4015 87.8015 98.3215 86.6915C98.8415 86.0715 98.9315 85.1815 98.3215 84.5715C97.7915 84.0415 96.7215 83.9415 96.2015 84.5715C95.5215 85.3915 94.8315 86.2815 93.8915 86.8115C92.8615 87.3915 91.5115 87.5716 90.3515 87.6416C88.2715 87.7516 85.6015 87.5015 84.1515 85.8015C83.6215 85.1815 82.5715 85.2615 82.0315 85.8015C81.4215 86.4115 81.5015 87.3015 82.0315 87.9215V87.9315Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M94.7701 83.532C96.4001 84.972 98.1901 86.2518 100.1 87.2918C100.79 87.6718 101.77 87.4819 102.15 86.7519C102.53 86.0219 102.35 85.1019 101.61 84.7019C100.72 84.2119 99.8601 83.6819 99.0401 83.1019C98.8401 82.9619 98.6501 82.8219 98.4501 82.6819C98.3501 82.6119 98.2601 82.5419 98.1601 82.4619C98.1201 82.4319 98.0902 82.4119 98.0502 82.3819L98.2101 82.5019C98.2101 82.5019 98.1101 82.4319 98.0701 82.3919C97.6701 82.0719 97.2701 81.742 96.8901 81.402C96.3001 80.882 95.3401 80.782 94.7701 81.402C94.2501 81.972 94.1401 82.9719 94.7701 83.5219V83.532Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M88.1304 1.50149C88.4904 4.24149 88.0604 6.95144 88.1304 9.69143C88.1504 10.4714 88.8104 11.2314 89.6304 11.1914C90.4504 11.1514 91.1504 10.5314 91.1304 9.69143C91.0604 6.95144 91.4904 4.23149 91.1304 1.50149C91.0304 0.731494 90.5104 -0.0385061 89.6304 0.00149391C88.9104 0.0314939 88.0204 0.671494 88.1304 1.50149Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M164.69 44.4214C164.38 44.6514 164.06 44.8614 163.72 45.0414C163.64 45.0814 163.56 45.1214 163.47 45.1614C163.35 45.2114 163.31 45.2214 163.45 45.1614C163.28 45.2214 163.12 45.2814 162.95 45.3414C162.25 45.5614 161.54 45.6814 160.82 45.8014C159.25 46.0614 157.73 46.3915 156.35 47.2215C155.68 47.6215 155.37 48.5915 155.81 49.2715C156.25 49.9515 157.14 50.2414 157.86 49.8114C158.03 49.7114 158.2 49.6115 158.37 49.5215C158.46 49.4815 158.54 49.4415 158.63 49.4015C158.49 49.4715 158.56 49.4315 158.66 49.3915C159 49.2615 159.35 49.1514 159.71 49.0614C160.42 48.8814 161.15 48.7715 161.88 48.6515C163.42 48.3915 164.94 47.9715 166.2 47.0115C166.82 46.5415 167.21 45.6914 166.74 44.9614C166.34 44.3414 165.36 43.9214 164.69 44.4214Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M12.6098 47.1616C13.3398 47.4616 14.0797 47.7516 14.8097 48.0516C15.1397 48.1816 15.4697 48.3216 15.8097 48.4516C15.9997 48.5316 16.1897 48.6016 16.3697 48.6816C16.4597 48.7216 16.5597 48.7616 16.6497 48.8016C16.5497 48.7616 16.5497 48.7616 16.6497 48.8016C18.0597 49.4016 19.4398 50.0417 20.7898 50.7717C21.4798 51.1417 22.4497 50.9616 22.8397 50.2316C23.2297 49.5016 23.0398 48.5816 22.2998 48.1816C19.4398 46.6416 16.4098 45.4917 13.4098 44.2717C12.6798 43.9717 11.7297 44.5916 11.5597 45.3216C11.3597 46.1916 11.8298 46.8516 12.6098 47.1716V47.1616Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M142.401 3.93124C142.291 4.08124 142.181 4.23131 142.081 4.38131C141.921 4.60131 142.231 4.19123 142.051 4.42123C141.961 4.53123 141.881 4.6413 141.791 4.7413C141.431 5.1913 141.051 5.63125 140.681 6.07125C139.741 7.16125 138.781 8.23124 137.821 9.30124C135.761 11.5912 133.681 13.8512 131.671 16.1812C130.861 17.1212 130.041 18.0813 129.331 19.1013C128.871 19.7713 129.211 20.7713 129.871 21.1513C130.621 21.5913 131.461 21.2813 131.921 20.6113C132.031 20.4613 132.141 20.3112 132.241 20.1612C132.401 19.9412 132.091 20.3513 132.271 20.1213C132.361 20.0113 132.441 19.9012 132.531 19.8012C132.891 19.3512 133.271 18.9113 133.641 18.4713C134.581 17.3813 135.541 16.3113 136.501 15.2413C138.561 12.9513 140.641 10.6913 142.651 8.36129C143.461 7.42129 144.281 6.46125 144.991 5.44125C145.451 4.77125 145.111 3.77132 144.451 3.39132C143.701 2.95132 142.861 3.26124 142.401 3.93124Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M179.511 83.6415C176.871 83.4415 174.231 83.5115 171.591 83.2815C168.101 82.9815 164.561 82.3015 161.391 80.7815C159.661 79.9515 158.131 82.5315 159.881 83.3715C163.391 85.0615 167.171 85.8615 171.031 86.2315C173.851 86.5015 176.691 86.4315 179.511 86.6415C181.441 86.7815 181.431 83.7815 179.511 83.6415Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M1.49005 87.5022C4.35005 87.7122 7.29 87.2622 10.12 86.8622C12.95 86.4622 15.66 86.1122 18.21 85.1322C18.97 84.8422 19.49 84.1222 19.26 83.2822C19.06 82.5622 18.17 81.9422 17.41 82.2322C14.93 83.1822 12.16 83.5521 9.54004 83.9321C6.92004 84.3121 4.16 84.6822 1.5 84.4922C0.69 84.4322 0 85.2222 0 85.9922C0 86.8522 0.69 87.4322 1.5 87.4922L1.49005 87.5022Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M33.9602 5.44127C35.3702 8.38127 37.1802 11.1713 38.9802 13.8813C40.0302 15.4713 41.1302 17.0314 42.3102 18.5314C43.1402 19.5814 44.0202 20.6614 45.1402 21.4014C46.7502 22.4714 48.2602 19.8713 46.6502 18.8113C46.5602 18.7513 46.2702 18.5012 46.6102 18.7912C46.5102 18.7012 46.4102 18.6214 46.3102 18.5314C46.1102 18.3514 45.9202 18.1513 45.7302 17.9513C45.2302 17.4213 44.7702 16.8514 44.3202 16.2814C43.4002 15.1014 42.2702 13.4513 41.3402 12.0513C39.6202 9.44126 37.8902 6.76126 36.5302 3.93126C36.1802 3.20126 35.1402 3.01134 34.4802 3.39134C33.7302 3.83134 33.5902 4.71127 33.9402 5.44127H33.9602Z",
          fill: "#0B455E"
        }
      )
    ]
  }
), Ir = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "168",
    height: "163",
    viewBox: "0 0 168 163",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M25.1156 104.507C21.8756 107.767 18.4856 110.868 14.9456 113.788C14.1856 114.408 13.2856 115.428 12.3156 115.688C11.6256 115.868 10.8456 115.618 10.1856 115.438C8.73556 115.058 7.18556 114.527 5.69556 115.017C3.93556 115.587 2.9656 117.347 3.0456 119.147C3.1356 121.127 4.50559 122.828 5.84559 124.178C7.13559 125.478 8.80558 126.618 10.7156 126.558C12.8956 126.488 15.1056 124.997 17.0356 124.097C22.0656 121.747 27.0856 119.398 32.1156 117.048C33.8356 116.248 26.4956 103.137 25.1256 104.507H25.1156Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M141.566 104.507C144.806 107.767 148.196 110.868 151.736 113.788C152.496 114.408 153.396 115.428 154.366 115.688C155.056 115.868 155.836 115.618 156.496 115.438C157.946 115.058 159.496 114.527 160.986 115.017C162.746 115.587 163.716 117.347 163.636 119.147C163.546 121.127 162.176 122.828 160.836 124.178C159.546 125.478 157.876 126.618 155.966 126.558C153.786 126.488 151.576 124.997 149.646 124.097C144.616 121.747 139.596 119.398 134.566 117.048C132.846 116.248 140.186 103.137 141.556 104.507H141.566Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M120.505 157.577C119.115 157.257 115.695 157.477 116.185 156.657C120.335 149.567 119.275 140.547 115.195 133.567C114.335 132.087 99.0747 135.787 100.505 137.087C103.515 139.857 105.815 143.607 106.085 147.767C106.215 149.817 105.895 151.907 105.065 153.797C104.655 154.727 100.755 160.407 103.205 161.547C104.875 162.327 108.395 162.497 110.695 162.567C112.995 162.637 120.825 162.287 121.565 159.407C121.765 158.647 121.255 157.727 120.515 157.557L120.505 157.577Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M45.3361 157.577C46.7261 157.257 50.1461 157.477 49.6561 156.657C45.5061 149.567 46.5661 140.547 50.6461 133.567C51.5061 132.087 66.7661 135.787 65.3361 137.087C62.3261 139.857 60.0261 143.607 59.7561 147.767C59.6261 149.817 59.9461 151.907 60.7761 153.797C61.1861 154.727 65.0861 160.407 62.6361 161.547C60.9661 162.327 57.4461 162.497 55.1461 162.567C52.8461 162.637 45.0161 162.287 44.2761 159.407C44.0761 158.647 44.5861 157.727 45.3261 157.557L45.3361 157.577Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M19.8763 87.118C22.0863 69.588 30.3663 45.708 44.7563 35.338C59.1463 24.968 79.6663 23.558 90.5263 24.238C101.386 24.918 119.526 29.288 127.986 36.018C140.726 46.158 145.886 63.228 147.116 79.468C148.266 94.588 146.186 110.958 136.216 122.378C126.986 132.938 112.646 137.418 98.8063 139.628C85.9563 141.678 62.8163 140.728 50.5863 136.278C39.1663 132.118 16.0463 117.568 19.8863 87.128L19.8763 87.118Z",
          fill: "#FFD255"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M152.126 62.8378C151.256 61.6978 135.816 59.9478 132.086 59.4778C122.036 58.2078 111.826 57.0578 101.816 58.6378C94.4256 59.7978 92.1356 62.6278 82.6456 62.6278C73.1556 62.6278 65.5856 59.4678 61.5656 59.2178C46.6856 58.3178 16.6756 63.5178 15.8856 63.9278C15.0956 64.3378 13.3856 70.5178 14.2456 71.6178C15.1056 72.7178 17.6157 72.2578 19.6757 72.1078C18.0157 81.0378 22.6456 89.8978 24.5556 91.2578C26.2056 92.4378 38.0056 94.3479 49.4156 93.9379C56.0356 93.7079 61.1256 93.1378 66.3956 89.1178C71.6556 85.0978 76.8656 77.3979 76.2256 70.8079C80.9056 71.5379 85.6756 71.7079 90.4056 71.3079C90.1456 75.6779 92.0157 85.1979 96.3657 88.8079C102.696 94.0579 136.966 99.8378 145.316 87.6378C149.806 81.0778 149.176 76.1079 148.436 68.1879C149.856 68.6279 152.226 68.2879 152.596 67.3279C152.966 66.3679 153.026 64.0179 152.126 62.8279V62.8378Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M72.067 91.7381C71.877 92.1181 71.667 92.488 71.417 92.848C71.397 92.878 71.197 93.1681 71.307 93.0081C71.417 92.8481 71.207 93.1281 71.187 93.1581C71.047 93.3181 70.907 93.4781 70.757 93.6381C70.457 93.9481 70.137 94.2381 69.807 94.4981C69.977 94.3681 69.847 94.4581 69.747 94.5281C69.657 94.5881 69.567 94.648 69.477 94.708C69.297 94.828 69.117 94.9381 68.927 95.0481C68.737 95.1581 68.547 95.258 68.357 95.348C68.277 95.388 68.197 95.418 68.127 95.458C67.747 95.638 68.407 95.3581 68.007 95.5081C67.607 95.6581 67.237 95.7781 66.847 95.8681C66.637 95.9181 66.427 95.9481 66.217 95.9981C66.037 96.0381 66.467 95.9781 66.167 95.9981C66.057 96.0081 65.957 96.0181 65.847 96.0281C65.397 96.0581 64.947 96.0581 64.497 96.0281C63.717 95.9681 62.967 96.7581 62.997 97.5281C63.037 98.3981 63.657 98.9581 64.497 99.0281C68.607 99.3581 72.817 96.9581 74.647 93.2681C74.997 92.5681 74.857 91.608 74.107 91.218C73.427 90.858 72.427 91.0081 72.057 91.7581L72.067 91.7381Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M69.3666 97.6379C69.9966 98.7579 70.8566 99.738 71.8366 100.568C72.8166 101.398 73.8966 102.228 75.0966 102.748C76.2966 103.268 77.7265 103.538 79.0665 103.148C80.2265 102.808 81.3465 102.018 81.8265 100.888C82.1465 100.148 82.0466 99.2779 81.2866 98.8379C80.6566 98.4679 79.5566 98.6279 79.2366 99.3779C79.1966 99.4779 79.1466 99.578 79.0966 99.678C79.0866 99.708 78.9266 99.928 79.0266 99.798C79.1366 99.658 78.8765 99.938 78.8865 99.938C78.8065 100.028 78.7565 100.038 78.8865 99.9579C78.8165 100.008 78.7366 100.058 78.6666 100.098C78.6666 100.098 78.3166 100.268 78.4866 100.198C78.6366 100.138 78.3766 100.228 78.3466 100.238C78.2366 100.268 78.1265 100.298 78.0165 100.328C77.8565 100.348 77.8765 100.358 78.0165 100.328C77.9065 100.328 77.7866 100.348 77.6766 100.348C77.5866 100.348 77.4966 100.348 77.4066 100.348C77.3166 100.348 77.3166 100.348 77.4066 100.348L77.2366 100.318C76.7066 100.198 76.4465 100.098 76.0165 99.8779C74.3865 99.0079 72.8566 97.7079 71.9766 96.1379C71.5766 95.4279 70.6166 95.1979 69.9266 95.5979C69.2366 95.9979 68.9865 96.938 69.3865 97.648L69.3666 97.6379Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M99.1562 46.3678C99.3262 46.0078 99.5262 45.6579 99.7462 45.3279C99.7562 45.3079 99.9162 45.0778 99.8362 45.1978C99.7562 45.3178 99.9262 45.0979 99.9362 45.0779C100.076 44.9179 100.216 44.7578 100.366 44.6078C100.496 44.4778 100.636 44.3478 100.786 44.2278C100.856 44.1578 100.936 44.0978 100.816 44.1978C100.906 44.1278 101.006 44.0578 101.106 43.9878C101.436 43.7578 101.786 43.5678 102.156 43.3978C102.016 43.4678 102.086 43.4278 102.186 43.3878C102.286 43.3478 102.386 43.3178 102.486 43.2778C102.686 43.2078 102.886 43.1578 103.096 43.1078C103.226 43.0778 103.356 43.0578 103.486 43.0278C103.746 42.9778 103.296 43.0478 103.556 43.0178C103.766 42.9978 103.976 42.9878 104.186 42.9778C104.426 42.9778 104.656 42.9778 104.896 42.9978C104.966 42.9978 105.136 43.0178 104.966 42.9978C105.066 43.0078 105.176 43.0278 105.276 43.0478C105.506 43.0878 105.736 43.1477 105.966 43.2177C106.066 43.2477 106.166 43.2778 106.266 43.3178C106.296 43.3278 106.606 43.4478 106.416 43.3678C107.136 43.6778 108.056 43.6079 108.466 42.8279C108.806 42.1879 108.696 41.1078 107.926 40.7778C105.766 39.8578 103.336 39.6777 101.136 40.5977C99.1662 41.4177 97.4962 42.9078 96.5762 44.8578C96.2462 45.5678 96.3562 46.5078 97.1162 46.9078C97.7862 47.2578 98.8162 47.1278 99.1662 46.3678H99.1562Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M75.2755 46.6275C75.1855 44.2675 73.2855 42.4475 71.0455 41.9775C68.8055 41.5075 66.4355 42.2375 64.0855 42.2075C63.3055 42.2075 62.5455 42.9075 62.5855 43.7075C62.6255 44.5075 63.2455 45.1975 64.0855 45.2075C66.0055 45.2275 67.8655 44.7176 69.7855 44.8076C69.9755 44.8276 70.0155 44.8276 69.9055 44.8076C70.0155 44.8276 70.1355 44.8475 70.2455 44.8675C70.4755 44.9175 70.6855 44.9776 70.9055 45.0476C71.0855 45.1176 71.1255 45.1276 70.9955 45.0776C71.0855 45.1176 71.1655 45.1675 71.2455 45.2075C71.2955 45.2375 71.7255 45.5475 71.5255 45.3775C71.6755 45.4975 71.8055 45.6376 71.9355 45.7776C72.0455 45.9076 72.0555 45.9176 71.9655 45.8076C72.0155 45.8876 72.0655 45.9676 72.1155 46.0476C72.1655 46.1276 72.2055 46.2076 72.2455 46.2976C72.1855 46.1576 72.1755 46.1676 72.2455 46.3276C72.2755 46.4176 72.2955 46.5075 72.3055 46.5975C72.2855 46.4275 72.2755 46.4375 72.2855 46.6175C72.3155 47.3975 72.9555 48.1575 73.7855 48.1175C74.5755 48.0775 75.3155 47.4575 75.2855 46.6175L75.2755 46.6275Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M71.4656 1.4475C71.2556 6.9375 71.5055 12.7775 73.1855 18.0475C73.7655 19.8775 76.6656 19.0974 76.0756 17.2474C74.4656 12.2074 74.2556 6.6875 74.4656 1.4475C74.5356 -0.4825 71.5356 -0.4825 71.4656 1.4475Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M152.445 25.398C149.695 26.548 147.445 28.628 145.315 30.658C144.205 31.718 143.125 32.7979 142.015 33.8579C141.505 34.3479 140.995 34.828 140.475 35.288C140.215 35.518 139.955 35.7479 139.685 35.9679C139.565 36.0679 139.455 36.158 139.335 36.258C139.255 36.328 139.255 36.318 139.355 36.248C139.285 36.308 139.205 36.358 139.125 36.418C138.475 36.898 138.145 37.7179 138.585 38.4679C138.965 39.1079 139.985 39.488 140.635 39.008C142.955 37.298 144.945 35.178 147.015 33.188C148.105 32.138 149.215 31.098 150.395 30.138C150.805 29.808 151.305 29.4379 151.815 29.0979C152.075 28.9279 152.345 28.7579 152.625 28.6079C152.755 28.5379 152.885 28.468 153.025 28.398C153.075 28.368 153.525 28.168 153.245 28.288C153.995 27.978 154.525 27.298 154.295 26.438C154.105 25.728 153.205 25.078 152.445 25.388V25.398Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M167.197 106.667C163.347 104.067 158.717 103.187 154.417 101.597C153.657 101.317 152.777 101.907 152.567 102.647C152.337 103.487 152.847 104.207 153.617 104.497C157.677 105.997 162.037 106.807 165.677 109.267C166.347 109.717 167.337 109.397 167.727 108.727C168.157 107.987 167.867 107.127 167.187 106.677L167.197 106.667Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M9.666 134.738C13.986 132.958 17.306 129.648 20.986 126.958C21.636 126.478 21.966 125.658 21.526 124.908C21.146 124.268 20.136 123.888 19.476 124.368C15.996 126.908 12.836 130.208 8.86601 131.848C8.11601 132.158 7.58596 132.848 7.81596 133.698C8.00596 134.408 8.906 135.058 9.666 134.748V134.738Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M3.89546 54.1272C7.47546 56.8872 11.9155 58.0072 15.9855 59.8072C16.7255 60.1372 17.5955 60.0272 18.0355 59.2672C18.4055 58.6272 18.2454 57.5471 17.4954 57.2171C13.4254 55.4171 8.98547 54.2872 5.40547 51.5372C4.76547 51.0472 3.72549 51.4372 3.35549 52.0772C2.90549 52.8472 3.24546 53.6372 3.89546 54.1272Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M114.437 10.798C114.437 10.858 114.427 10.9279 114.427 10.9879C114.427 11.1679 114.497 10.6079 114.437 10.8679C114.407 11.0079 114.377 11.148 114.347 11.278C114.267 11.598 114.157 11.8979 114.037 12.2079C113.957 12.4179 114.027 12.308 114.057 12.168C114.037 12.248 113.987 12.328 113.957 12.398C113.887 12.558 113.817 12.7179 113.737 12.8679C113.577 13.2079 113.397 13.5379 113.227 13.8679C112.607 15.0379 111.887 16.168 111.367 17.398C111.197 17.788 111.097 18.128 111.217 18.558C111.317 18.908 111.577 19.2879 111.907 19.4579C112.557 19.7979 113.627 19.688 113.957 18.918C114.507 17.628 115.277 16.438 115.927 15.198C116.647 13.828 117.367 12.368 117.457 10.788C117.507 10.008 116.737 9.25798 115.957 9.28798C115.107 9.32798 114.507 9.94798 114.457 10.788L114.437 10.798Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M166.037 67.1676C164.587 67.7676 162.947 68.0076 161.407 68.2576C160.967 68.3276 160.517 68.3975 160.077 68.4575C160.027 68.4575 159.597 68.5175 159.977 68.4675C159.877 68.4775 159.777 68.4976 159.677 68.5076C159.457 68.5376 159.247 68.5575 159.027 68.5875C158.327 68.6675 157.627 68.7376 156.927 68.7776C156.147 68.8176 155.387 69.4376 155.427 70.2776C155.457 71.0576 156.087 71.8176 156.927 71.7776C158.657 71.6876 160.377 71.4476 162.077 71.1676C163.657 70.9176 165.347 70.6776 166.837 70.0576C167.557 69.7576 168.157 69.0475 167.887 68.2075C167.667 67.5175 166.817 66.8376 166.037 67.1576V67.1676Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M139.895 137.937C139.455 137.647 139.025 137.347 138.605 137.027L138.905 137.257C137.725 136.337 136.655 135.267 135.735 134.087L135.965 134.387C135.915 134.327 135.865 134.257 135.825 134.197C135.575 133.877 135.335 133.617 134.925 133.507C134.565 133.407 134.085 133.457 133.765 133.657C133.445 133.857 133.165 134.167 133.075 134.557C132.985 134.947 132.985 135.397 133.225 135.717C134.665 137.607 136.365 139.227 138.365 140.517C139.025 140.947 140.055 140.677 140.415 139.977C140.805 139.227 140.585 138.377 139.875 137.927L139.895 137.937Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M39.5556 145.838C40.0056 144.898 40.5356 144.008 41.1356 143.158C41.2056 143.058 41.2756 142.968 41.3456 142.878C41.3856 142.818 41.4356 142.758 41.4756 142.698C41.4356 142.738 41.2756 142.948 41.4056 142.798C41.5656 142.588 41.7356 142.388 41.9056 142.188C42.2456 141.788 42.6056 141.408 42.9856 141.038C43.5456 140.488 43.5756 139.458 42.9856 138.918C42.3956 138.378 41.4656 138.328 40.8656 138.918C39.2756 140.478 37.9356 142.318 36.9756 144.318C36.7956 144.688 36.7156 145.068 36.8256 145.478C36.9256 145.828 37.1856 146.208 37.5156 146.378C38.1856 146.728 39.2056 146.598 39.5656 145.838H39.5556Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M1.9056 99.2472C2.1556 99.1972 2.41561 99.1471 2.66561 99.1071C2.74561 99.0971 3.18562 99.0071 2.79562 99.0871C2.91562 99.0671 3.03559 99.0572 3.14559 99.0472C3.63559 98.9972 4.13557 98.9672 4.62557 98.9472C5.11557 98.9272 5.61562 98.9471 6.11562 98.9771C6.35562 98.9871 6.59558 99.0072 6.82558 99.0372C6.94558 99.0472 7.06562 99.0672 7.17562 99.0772C7.34562 99.0972 7.33558 99.0972 7.13558 99.0772C7.21558 99.0872 7.29557 99.0971 7.37557 99.1071C7.78557 99.1671 8.15561 99.1771 8.53561 98.9571C8.84561 98.7771 9.14561 98.4172 9.22561 98.0572C9.38561 97.3472 9.00562 96.3371 8.17562 96.2071C5.80562 95.8471 3.45561 95.8871 1.10561 96.3571C0.335613 96.5071 -0.174435 97.4671 0.0555647 98.2071C0.325565 99.0271 1.0756 99.4172 1.9056 99.2572V99.2472Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M27.4969 23.0174C28.4569 25.0374 29.9069 26.8074 31.3569 28.4974C32.0069 29.2574 32.6869 29.9974 33.3569 30.7374C33.6369 31.0474 33.9169 31.3574 34.1969 31.6774C34.3069 31.7974 34.4069 31.9274 34.5169 32.0474C34.5969 32.1474 34.9769 32.6274 34.6369 32.1874C35.1069 32.8074 35.9469 33.1973 36.6869 32.7273C37.2969 32.3273 37.7369 31.3474 37.2269 30.6774C36.1269 29.2374 34.8469 27.9573 33.6569 26.5873C33.3069 26.1873 32.9669 25.7774 32.6269 25.3674C32.4469 25.1474 32.2769 24.9273 32.0969 24.7073C32.2769 24.9373 31.9969 24.5774 31.9869 24.5674C31.9069 24.4574 31.8169 24.3473 31.7369 24.2273C31.1169 23.3673 30.5369 22.4774 30.0769 21.5174C29.7369 20.8074 28.6669 20.5673 28.0269 20.9773C27.2969 21.4473 27.1269 22.2674 27.4869 23.0274L27.4969 23.0174Z",
          fill: "#0B455E"
        }
      )
    ]
  }
), Xr = ({ style: e }) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "114",
    height: "81",
    viewBox: "0 0 114 81",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M107.622 38.6087C103.302 26.9286 95.8219 16.1786 85.4019 9.34865C73.4419 1.49865 58.5119 -0.69135 44.2319 0.17865C37.2019 0.60865 29.9519 1.82865 24.1619 5.82865C15.2419 11.9987 11.6719 23.3587 9.6419 34.0187C7.2019 46.8287 8.0119 62.8487 6.6019 65.6587C5.1919 68.4687 1.9519 71.8186 0.531901 74.7086C-0.888099 77.5986 0.811901 78.3587 2.3919 79.2287C3.9719 80.0987 10.8119 80.1087 12.6119 80.0986C46.1519 79.8287 79.6819 78.2486 113.092 75.3587C113.252 62.8987 111.932 50.2887 107.612 38.6087H107.622Z",
          fill: "#7DA2B4"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M42.9826 28.4886C36.6426 36.4086 30.5626 44.5486 24.7626 52.8786C23.6626 54.4686 26.2526 55.9686 27.3526 54.3886C33.0026 46.2686 38.9226 38.3286 45.1026 30.6086C46.3026 29.1186 44.1926 26.9786 42.9826 28.4886Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M21.0222 37.0294C28.6822 41.6794 36.3422 46.3294 44.0022 50.9794C45.6522 51.9794 47.1622 49.3894 45.5122 48.3894C37.8522 43.7394 30.1922 39.0894 22.5322 34.4394C20.8822 33.4394 19.3722 36.0294 21.0222 37.0294Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M68.2439 32C74.8439 36.48 85.1307 43.0787 91.7307 47.5587C93.3307 48.6487 94.8307 46.0487 93.2407 44.9687C86.6407 40.4887 76.3539 33.89 69.7539 29.41C68.1539 28.32 66.6539 30.92 68.2439 32Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M85.8428 27.1291C79.3228 34.2191 72.8028 41.2991 66.2828 48.3891C64.9728 49.8091 67.0928 51.9391 68.4028 50.5091C74.9228 43.4191 81.4428 36.3391 87.9628 29.2491C89.2728 27.8291 87.1528 25.6991 85.8428 27.1291Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M63.262 19.5195C65.002 22.3195 67.922 24.3795 71.182 24.9795C71.952 25.1195 72.832 24.7695 73.032 23.9295C73.202 23.1995 72.812 22.2395 71.982 22.0795C71.632 22.0195 71.282 21.9395 70.942 21.8395C70.772 21.7895 70.602 21.7395 70.432 21.6795C70.292 21.6295 70.072 21.4895 69.932 21.4895C70.002 21.4895 70.182 21.5995 69.992 21.5195C69.912 21.4795 69.832 21.4495 69.752 21.4095C69.592 21.3295 69.432 21.2495 69.272 21.1695C68.962 20.9995 68.652 20.8195 68.362 20.6195C68.232 20.5295 68.102 20.4395 67.972 20.3395C67.682 20.1295 68.142 20.4795 67.972 20.3395C67.902 20.2795 67.832 20.2295 67.762 20.1695C67.492 19.9395 67.232 19.6995 66.982 19.4495C66.862 19.3195 66.742 19.1895 66.622 19.0595C66.532 18.9595 66.402 18.7095 66.282 18.6495C66.342 18.6795 66.442 18.8695 66.322 18.6995C66.272 18.6295 66.222 18.5595 66.162 18.4795C66.052 18.3195 65.942 18.1595 65.842 17.9895C65.432 17.3195 64.482 16.9995 63.792 17.4495C63.102 17.8995 62.812 18.7895 63.252 19.4995L63.262 19.5195Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M33.542 26.009C34.832 25.489 35.9819 24.829 37.0719 23.969C38.0719 23.189 38.9219 22.259 39.6719 21.229C39.8919 20.929 39.912 20.409 39.8219 20.069C39.7319 19.729 39.462 19.339 39.132 19.169C38.782 18.989 38.362 18.889 37.972 19.019C37.582 19.149 37.3219 19.379 37.0719 19.709C37.0319 19.769 36.9919 19.819 36.9419 19.879C36.8419 20.019 37.182 19.579 36.992 19.809C36.912 19.909 36.8319 20.009 36.7519 20.099C36.5819 20.299 36.4019 20.499 36.2119 20.689C35.8319 21.079 35.422 21.439 34.992 21.789C34.842 21.909 35.252 21.599 35.092 21.709C35.032 21.749 34.9819 21.789 34.9219 21.839C34.8119 21.919 34.692 21.999 34.582 22.079C34.362 22.229 34.132 22.369 33.902 22.499C33.672 22.629 33.442 22.759 33.202 22.879C33.072 22.939 32.9519 22.999 32.8219 23.059C32.7719 23.079 32.7219 23.109 32.6719 23.129C32.3819 23.259 33.012 22.989 32.722 23.109C32.342 23.259 32.0419 23.429 31.8219 23.799C31.6319 24.119 31.552 24.599 31.672 24.959C31.792 25.319 32.012 25.669 32.362 25.859C32.712 26.049 33.152 26.159 33.522 26.009H33.542Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M47.5613 67.019C60.3113 64.809 73.2313 63.789 86.1713 63.929C88.1013 63.949 88.1013 60.949 86.1713 60.929C72.9613 60.789 59.7713 61.879 46.7613 64.129C44.8613 64.459 45.6713 67.349 47.5613 67.019Z",
          fill: "#0B455E"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M73.4629 63.0889C73.5329 64.0889 73.6129 65.1189 74.0529 66.0189C74.8329 67.6289 76.8029 68.5489 78.5429 68.1189C80.2829 67.6889 81.5929 65.9589 81.5429 64.1689",
          fill: "#0B455E"
        }
      )
    ]
  }
), Gr = ({ style: e }) => /* @__PURE__ */ o.jsx(
  "svg",
  {
    style: e,
    xmlns: "http://www.w3.org/2000/svg",
    width: "175",
    height: "186",
    viewBox: "0 0 175 186",
    fill: "none",
    children: /* @__PURE__ */ o.jsx(
      "path",
      {
        d: "M37.451 0C34.4948 4.53551 35.9729 9.93456 26.1356 10.6697C36.0896 11.3893 35.156 17.0957 34.028 23.8523C36.7509 19.5774 36.2841 13.696 45.5418 13.5949C38.6958 10.1135 37.451 5.12676 37.451 0ZM149.983 9.28107C146.91 15.4425 145.821 22.4325 133.451 24.743C146.093 24.2763 147.26 31.7486 146.754 40.4073C149.789 33.9502 149.283 23.4594 159.941 25.7816C150.8 22.4208 150.722 15.7304 149.983 9.28107ZM88.213 11.5449C70.2032 11.5449 42.4689 40.8351 28.4656 80.55C31.3051 81.7559 34.028 83.234 36.6342 84.9455C38.5791 83.8953 40.6796 83.3896 42.819 83.3507C45.1917 83.3118 47.5645 83.8564 49.7817 84.8677C54.1772 86.8904 58.067 90.7024 60.7509 95.9148C63.4349 101.088 64.4074 106.728 63.7072 111.824C63.1237 116.064 61.3344 120.07 58.3004 122.832C60.5565 127.928 63.7461 132.907 67.6748 137.186C71.8369 141.737 76.8158 145.51 82.4171 147.96C83.2287 144.565 85.1582 141.542 87.8956 139.376C90.6329 137.21 94.019 136.028 97.5096 136.019H97.5485C100.835 136.026 104.035 137.075 106.69 139.014C112.057 132.207 116.842 125.438 119.565 118.164C117.971 116.63 116.776 114.611 116.1 112.31C115.424 110.008 115.291 107.506 115.714 105.056C116.286 101.727 117.852 98.681 120.128 96.4695C122.404 94.2579 125.239 93.0264 128.122 92.9974C128.737 92.9947 129.348 93.0467 129.951 93.153C131.325 93.3867 132.642 93.9 133.84 94.67C132.829 90.5468 131.273 86.657 125.01 85.2178C132.829 85.14 133.179 81.0168 134.696 75.9601C135.863 82.845 135.98 86.0736 144.109 87.0071C135.707 89.6522 136.058 91.5971 135.007 95.5258C136.777 97.0246 138.126 99.0924 138.902 101.497C139.678 103.902 139.852 106.549 139.403 109.14C139.251 110.014 139.029 110.873 138.741 111.707C142.087 112.563 146.093 112.874 150.216 112.68C151.967 112.563 153.756 112.369 155.507 112.057C148.466 57.289 110.696 11.5449 88.213 11.5449ZM4.09207 21.4367C4.87781 27.6176 2.90179 31.4724 0 34.5726C4.43049 34.0669 7.30894 31.0562 12.2645 37.2954C8.88431 31.0834 13.731 29.8231 17.5197 26.0617C13.412 26.1628 8.36697 27.5982 4.09207 21.4367ZM88.174 23.9923H88.213C96.4661 23.9923 104.381 27.2708 110.217 33.1067C116.053 38.9425 119.331 46.8576 119.331 55.1107C119.331 63.3638 116.053 71.2789 110.217 77.1148C104.381 82.9506 96.4661 86.2291 88.213 86.2291C79.9598 86.2291 72.0447 82.9506 66.2089 77.1148C60.3731 71.2789 57.0945 63.3638 57.0945 55.1107C57.0945 46.8643 60.3677 38.9551 66.1951 33.1204C72.0226 27.2857 79.9277 24.0026 88.174 23.9923ZM88.213 30.216L81.9893 45.7752L63.3182 55.1107L81.9893 59.7785L88.213 80.0055L94.4366 59.7785L113.108 55.1107L94.4366 45.7752L88.213 30.216ZM159.357 46.0086C160.408 51.2987 165.231 54.1383 158.696 61.5289C166.32 55.1107 169.627 59.8563 173.516 65.4965C172.505 60.5176 168.071 56.6278 174.644 50.0929C167.293 52.3879 162.936 49.665 159.357 46.0086ZM1.73485 54.0605C5.30958 59.7007 14.12 65.3409 4.90504 73.5095C13.237 68.4528 18.5232 72.576 24.0195 76.0379C21.1333 69.7753 17.1035 67.4414 23.0393 56.3555C15.5048 66.5079 8.19193 59.8563 1.73485 54.0605ZM26.3223 87.0849C22.2224 100.505 19.7524 114.975 19.7524 129.795C19.7524 146.404 33.639 165.815 53.9827 176.862C54.2463 176.289 54.5583 175.743 54.9162 175.228C55.9823 173.714 57.4308 172.496 59.1628 171.656C60.8947 170.817 62.8694 170.377 64.9519 170.366C68.4136 170.355 71.9877 171.528 75.0265 173.672C77.0792 175.115 78.8128 176.948 80.0794 179.014C81.346 181.08 82.108 183.317 82.3005 185.536C84.2454 185.73 86.2291 185.808 88.213 185.808C97.8597 185.808 107.117 183.708 115.519 180.207C111.902 178.768 108.79 176.862 106.028 174.605C103.228 172.349 100.855 169.782 98.7154 167.098C98.3271 167.126 97.9378 167.139 97.5485 167.137C94.1231 167.133 90.795 165.998 88.0802 163.909C85.3655 161.82 83.4159 158.894 82.5338 155.584C74.7153 152.784 67.9471 147.883 62.5014 141.931C58.1448 137.186 54.6051 131.74 52.0378 126.1C48.8092 126.8 45.3862 126.294 42.3522 124.855C40.2128 123.882 38.1901 122.482 36.3619 120.693C37.3732 127.383 40.2128 131.895 49.1593 131.701C37.1398 135.474 38.4235 139.986 36.0896 146.482C34.5726 140.181 32.3554 134.268 24.2101 131.312C32.9389 131.312 34.3003 125.516 35.4283 119.759C33.8724 118.048 32.511 116.064 31.344 113.847C28.6601 108.673 27.6876 103.033 28.3878 97.9375C28.7768 94.9812 29.7881 92.1028 31.3829 89.73C29.7881 88.7186 28.0766 87.824 26.3223 87.0849ZM134.852 117.853C132.33 120.238 129.16 121.425 126.022 121.16C122.716 129.678 117.231 137.224 111.396 144.46C112.525 146.662 113.111 149.103 113.108 151.578C113.108 154.202 112.445 156.783 111.18 159.082C109.915 161.38 108.089 163.322 105.873 164.725C107.312 166.359 108.829 167.876 110.463 169.199C114.275 172.31 118.748 174.605 124.777 175.578C143.837 164.336 156.673 145.782 156.673 129.795C156.673 126.216 156.518 122.638 156.246 119.098C154.378 119.37 152.472 119.526 150.605 119.643C145.121 119.954 139.636 119.487 134.852 117.853ZM126.1 133.101C133.335 139.87 137.263 136.408 143.059 133.101C138.08 140.414 135.396 143.487 142.009 151.422C130.69 145.821 130.456 149.244 124.31 152.356C127.539 146.754 131.506 141.309 126.1 133.101ZM51.6099 140.959C53.3992 147.182 54.5662 152.745 64.1351 154.534C53.1269 156.946 55.4219 162.314 54.0994 168.537C51.7655 160.33 48.4981 153.717 39.1625 155.234C51.0264 150.955 49.5483 147.532 51.6099 140.959Z",
        fill: "#0B455E"
      }
    )
  }
), Qr = {
  smallCloud: Ar,
  mediumCloud: Br,
  mediumSun: Tr,
  largeStormCloud: Pr,
  largeCloud: Nr,
  largeSun: Rr,
  veryLargeTornado: Zr,
  veryLargeCloud: Or,
  veryLargeDroplet: Ur,
  veryLargeRainCloud: Fr,
  veryLargeSnow: Vr,
  veryLargeSun: Ir,
  veryLargeSunAboveCloud: Hr,
  veryLargeThunderCloud: Dr,
  veryLargeSunBehindCloud: Wr,
  egg: Gr,
  dead: Xr
}, Yr = "data:image/png;base64,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", qr = ({
  style: e
}) => /* @__PURE__ */ o.jsx(
  "svg",
  {
    style: e,
    xmlns: "http://www.w3.org/2000/svg",
    width: "52",
    height: "79",
    viewBox: "0 0 52 79",
    fill: "none",
    children: /* @__PURE__ */ o.jsx(
      "path",
      {
        d: "M25.7581 3.63254C13.8993 3.63254 4.25207 12.8426 4.25207 24.1615C4.25207 35.483 13.8993 44.6917 25.7581 44.6917C37.6198 44.6917 47.2694 35.483 47.2694 24.1615C47.2694 12.8426 37.6198 3.63254 25.7581 3.63254ZM25.7581 48.327C11.8041 48.327 0.449279 37.4841 0.449279 24.1615C0.449279 10.8415 11.8041 0 25.7581 0C39.7162 0 51.0699 10.8415 51.0699 24.1615C51.0699 37.4841 39.7162 48.327 25.7581 48.327ZM40.8625 79L30.9593 69.5509L21.0544 79L11.1489 69.5509L2.49005 77.8114L0 75.4373L11.1489 64.8024L21.0544 74.2473L30.9593 64.8024L40.8596 74.2473L49.5079 65.9868L52 68.366L40.8625 79Z",
        fill: "#0B455E"
      }
    )
  }
), Kr = ({
  style: e
}) => /* @__PURE__ */ o.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", style: e, children: /* @__PURE__ */ o.jsxs("g", { fill: "#303193", "fill-rule": "evenodd", children: [
  /* @__PURE__ */ o.jsx("path", { d: "M19.55 1.915c-9.914 0-17.98 8.065-17.98 17.977 0 9.915 8.066 17.981 17.98 17.981 9.913 0 17.979-8.066 17.979-17.98 0-9.913-8.066-17.978-17.98-17.978m0 37.529C8.77 39.444 0 30.673 0 19.892 0 9.114 8.77.345 19.55.345c10.78 0 19.55 8.769 19.55 19.547 0 10.78-8.77 19.552-19.55 19.552" }),
  /* @__PURE__ */ o.jsx("path", { d: "M1.637 24.45l-.151-.001v-1.326l.151.002A3.216 3.216 0 0 0 4.85 19.91a3.216 3.216 0 0 0-3.435-3.204l-.082-1.323a4.543 4.543 0 0 1 4.843 4.528 4.543 4.543 0 0 1-4.538 4.539zm35.858 0a4.543 4.543 0 0 1-4.538-4.539 4.543 4.543 0 0 1 4.843-4.527l-.082 1.323a3.216 3.216 0 0 0-3.436 3.204 3.216 3.216 0 0 0 3.213 3.214l.151-.002v1.326l-.151.002zm-34.05 2.613a7.11 7.11 0 0 1-1.441-.145l.268-1.298a5.833 5.833 0 0 0 7-5.709 5.834 5.834 0 0 0-7.058-5.696l-.28-1.296a7.169 7.169 0 0 1 1.51-.16c3.945 0 7.154 3.208 7.154 7.152s-3.209 7.152-7.153 7.152zm32.241 0c-3.944 0-7.152-3.208-7.152-7.152a7.16 7.16 0 0 1 8.664-6.992l-.281 1.296a5.833 5.833 0 0 0-7.058 5.696 5.833 5.833 0 0 0 7.002 5.709l.267 1.298a7.146 7.146 0 0 1-1.442.145zM17.601 11.962a14.114 14.114 0 0 1 1.965 4.302 14.099 14.099 0 0 1 1.963-4.302 16.944 16.944 0 0 0-1.963-2.881 16.956 16.956 0 0 0-1.965 2.88zm4.605 1.406a12.762 12.762 0 0 0-1.787 6.526c0 2.373.653 4.607 1.792 6.524a16.662 16.662 0 0 0-.005-13.05zm-5.282 0a16.645 16.645 0 0 0-.005 13.05 12.737 12.737 0 0 0 1.792-6.524c0-2.377-.65-4.61-1.787-6.527zm.67 14.455c.556 1.03 1.217 2 1.971 2.891a16.896 16.896 0 0 0 1.97-2.89 14.11 14.11 0 0 1-1.97-4.309 14.129 14.129 0 0 1-1.97 4.308zm-5.973 9.49l-.353-1.278a16.654 16.654 0 0 0 7.396-4.336 18.234 18.234 0 0 1-1.942-2.722c-2.4 2.858-5.912 4.765-9.886 5.026l-.087-1.324c3.793-.248 7.121-2.151 9.298-4.975a18.056 18.056 0 0 1-1.404-4.134c-1.483 3.866-5.234 6.618-9.616 6.618-.528 0-1.056-.04-1.569-.12l.204-1.31c.446.069.906.104 1.365.104 4.945 0 8.968-4.022 8.968-8.968 0-4.945-4.023-8.969-8.968-8.969-.46 0-.919.035-1.365.105l-.204-1.31c.513-.08 1.041-.12 1.57-.12 4.382 0 8.134 2.753 9.616 6.621a18.075 18.075 0 0 1 1.409-4.14 12.78 12.78 0 0 0-9.408-4.979L6.72 5.78a14.093 14.093 0 0 1 10.009 5.03 18.285 18.285 0 0 1 1.935-2.713 16.65 16.65 0 0 0-7.298-4.316l.361-1.276a17.969 17.969 0 0 1 7.838 4.62 17.976 17.976 0 0 1 7.839-4.62l.36 1.276a16.657 16.657 0 0 0-7.298 4.316A18.285 18.285 0 0 1 22.4 10.81a14.093 14.093 0 0 1 10.01-5.03l.075 1.323a12.78 12.78 0 0 0-9.408 4.98 18.061 18.061 0 0 1 1.409 4.142c1.481-3.87 5.234-6.625 9.618-6.625.527 0 1.054.04 1.568.12l-.205 1.311a8.86 8.86 0 0 0-1.363-.105c-4.945 0-8.968 4.024-8.968 8.97 0 4.945 4.023 8.967 8.968 8.967.459 0 .917-.035 1.363-.104l.205 1.31c-.514.08-1.041.12-1.568.12-4.383 0-8.135-2.754-9.617-6.621-.301 1.442-.776 2.83-1.404 4.136 2.176 2.825 5.504 4.728 9.297 4.976l-.086 1.324c-3.975-.261-7.486-2.167-9.887-5.026a18.257 18.257 0 0 1-1.941 2.722 16.667 16.667 0 0 0 7.396 4.336l-.353 1.278a17.982 17.982 0 0 1-7.945-4.642 17.975 17.975 0 0 1-7.944 4.642z" }),
  /* @__PURE__ */ o.jsx("path", { d: "M.79 20.642h37.557v-1.5H.79z" })
] }) }), Jr = (e) => /* @__PURE__ */ o.jsx("img", { src: Yr, alt: "KNMI Logo", style: e.style });
function br(e, t) {
  const n = [qr, Kr, Jr], r = n[e], l = () => {
    t((i) => (i + 1) % n.length);
  };
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      onClick: l,
      style: {
        width: "10%",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center"
      },
      children: /* @__PURE__ */ o.jsx(
        r,
        {
          style: {
            width: "100%",
            height: "auto",
            display: "block"
          }
        }
      )
    }
  );
}
const Ve = ({ style: e }) => /* @__PURE__ */ o.jsx(
  "svg",
  {
    fill: "#0B455E",
    style: e,
    xmlns: "http://www.w3.org/2000/svg",
    width: "608",
    height: "7",
    viewBox: "0 0 608 7",
    children: /* @__PURE__ */ o.jsx("path", { d: "M591.461 6.74294C589.261 6.74294 587.194 5.90203 585.638 4.3774V4.35383C584.538 3.29288 583.084 2.70347 581.543 2.70347C580.003 2.70347 578.533 3.29288 577.441 4.36955C575.877 5.89418 573.81 6.73508 571.61 6.73508C569.409 6.73508 567.342 5.89418 565.786 4.36955V4.34597C564.686 3.28502 563.232 2.6956 561.692 2.6956C560.151 2.6956 558.682 3.28502 557.589 4.36169C556.025 5.88632 553.958 6.72722 551.758 6.72722C549.558 6.72722 547.491 5.88632 545.935 4.36169V4.33812C544.834 3.27717 543.38 2.68774 541.84 2.68774C540.3 2.68774 538.83 3.27716 537.738 4.35383C536.174 5.87846 534.107 6.71937 531.906 6.71937C529.706 6.71937 527.639 5.87846 526.083 4.35383V4.33025C524.983 3.2693 523.529 2.67988 521.988 2.67988C520.448 2.67988 518.979 3.2693 517.886 4.34597C516.322 5.8706 514.255 6.7115 512.055 6.7115C509.854 6.7115 507.787 5.8706 506.231 4.34597V4.3224C505.131 3.26145 503.677 2.67203 502.137 2.67203C500.597 2.67203 499.127 3.26145 498.035 4.33812C496.471 5.86275 494.404 6.70365 492.203 6.70365C490.003 6.70365 487.936 5.86275 486.38 4.33812V4.31454C485.28 3.25359 483.826 2.66417 482.285 2.66417C480.745 2.66417 479.275 3.25358 478.183 4.33025C476.619 5.85488 474.552 6.69579 472.352 6.69579C470.151 6.69579 468.084 5.85488 466.528 4.33025V4.30668C465.428 3.24572 463.974 2.65631 462.434 2.65631C460.893 2.65631 459.424 3.24573 458.331 4.3224C456.767 5.84703 454.701 6.68792 452.5 6.68792C450.3 6.68792 448.233 5.84703 446.677 4.3224V4.29882C445.576 3.23787 444.122 2.64845 442.582 2.64845C441.042 2.64845 439.572 3.23787 438.48 4.31454C436.916 5.83917 434.849 6.68007 432.648 6.68007C430.448 6.68007 428.381 5.83917 426.825 4.31454V4.29097C425.725 3.23002 424.271 2.64059 422.73 2.64059C421.19 2.64059 419.721 3.23001 418.628 4.30668C417.064 5.8313 414.997 6.67221 412.797 6.67221C410.596 6.67221 408.529 5.8313 406.973 4.30668V4.2831C405.873 3.22215 404.419 2.63273 402.879 2.63273C401.339 2.63273 399.869 3.22215 398.777 4.29882C397.213 5.82345 395.146 6.66435 392.945 6.66435C390.745 6.66435 388.678 5.82345 387.114 4.29882V4.27525C386.014 3.21429 384.56 2.62487 383.019 2.62487C381.479 2.62487 380.009 3.2143 378.917 4.29097C377.353 5.8156 375.286 6.65649 373.086 6.65649C370.885 6.65649 368.818 5.8156 367.262 4.29097V4.26738C366.162 3.20643 364.708 2.61702 363.168 2.61702C361.628 2.61702 360.158 3.20643 359.066 4.2831C357.502 5.80773 355.435 6.64864 353.234 6.64864C351.034 6.64864 348.967 5.80773 347.411 4.2831V4.25953C346.311 3.19857 344.857 2.60916 343.316 2.60916C341.776 2.60916 340.306 3.19858 339.214 4.27525C337.65 5.79987 335.583 6.64077 333.383 6.64077C331.182 6.64077 329.115 5.79987 327.559 4.27525V4.25167C326.459 3.19072 325.005 2.6013 323.465 2.6013C321.924 2.6013 320.455 3.19071 319.362 4.26738C317.798 5.79201 315.732 6.63292 313.531 6.63292C311.331 6.63292 309.264 5.79201 307.708 4.26738V4.2438C306.607 3.18285 305.153 2.59344 303.613 2.59344C302.073 2.59344 300.603 3.18286 299.511 4.25953C297.947 5.78415 295.88 6.62505 293.679 6.62505C291.479 6.62505 289.412 5.78415 287.856 4.25953V4.23595C286.756 3.175 285.302 2.58558 283.762 2.58558C282.221 2.58558 280.752 3.175 279.659 4.25167C278.095 5.7763 276.028 6.6172 273.828 6.6172C271.627 6.6172 269.56 5.7763 268.004 4.25167V4.2281C266.904 3.16714 265.45 2.57772 263.91 2.57772C262.37 2.57772 260.9 3.16713 259.808 4.2438C258.244 5.76843 256.177 6.60934 253.976 6.60934C251.776 6.60934 249.709 5.76843 248.153 4.2438V4.22023C247.053 3.15928 245.599 2.56986 244.058 2.56986C242.518 2.56986 241.048 3.15928 239.956 4.23595C238.392 5.76058 236.325 6.60148 234.125 6.60148C231.924 6.60148 229.857 5.76058 228.301 4.23595V4.21237C227.201 3.15142 225.747 2.562 224.207 2.562C222.666 2.562 221.197 3.15142 220.104 4.2281C218.54 5.75272 216.474 6.59362 214.273 6.59362C212.073 6.59362 210.006 5.75272 208.45 4.2281V4.20452C207.349 3.14357 205.895 2.55414 204.355 2.55414C202.815 2.55414 201.345 3.14356 200.253 4.22023C198.689 5.74486 196.622 6.58577 194.421 6.58577C192.221 6.58577 190.154 5.74486 188.598 4.22023V4.19665C187.498 3.1357 186.044 2.54628 184.504 2.54628C182.963 2.54628 181.494 3.1357 180.401 4.21237C178.837 5.737 176.77 6.5779 174.57 6.5779C172.369 6.5779 170.302 5.737 168.746 4.21237V4.1888C167.646 3.12785 166.192 2.53842 164.652 2.53842C163.112 2.53842 161.642 3.12785 160.55 4.20452C158.986 5.72915 156.919 6.57004 154.718 6.57004C152.518 6.57004 150.451 5.72915 148.895 4.20452V4.18093C147.795 3.11998 146.341 2.53057 144.8 2.53057C143.26 2.53057 141.79 3.11998 140.698 4.19665C139.134 5.72128 137.067 6.56219 134.867 6.56219C132.666 6.56219 130.599 5.72128 129.043 4.19665V4.17308C127.943 3.11212 126.489 2.52271 124.949 2.52271C123.408 2.52271 121.939 3.11213 120.846 4.1888C119.282 5.71343 117.216 6.55432 115.015 6.55432C112.815 6.55432 110.748 5.71343 109.192 4.1888V4.16522C108.091 3.10427 106.637 2.51485 105.097 2.51485C103.557 2.51485 102.087 3.10426 100.995 4.18093C99.4309 5.70556 97.364 6.54647 95.1635 6.54647C92.963 6.54647 90.8961 5.70556 89.34 4.18093V4.15736C88.2398 3.0964 86.7859 2.50699 85.2455 2.50699C83.7052 2.50699 82.2356 3.09641 81.1432 4.17308C79.5793 5.6977 77.5124 6.5386 75.3119 6.5386C73.1114 6.5386 71.0445 5.6977 69.4884 4.17308V4.1495C68.3882 3.08855 66.9343 2.49913 65.394 2.49913C63.8536 2.49913 62.384 3.08855 61.2916 4.16522C59.7277 5.68985 57.6608 6.53075 55.4603 6.53075C53.2598 6.53075 51.1929 5.68985 49.6368 4.16522V4.14165C48.5366 3.08069 47.0827 2.49127 45.5424 2.49127C44.002 2.49127 42.5324 3.08069 41.44 4.15736C39.8761 5.68198 37.8092 6.52289 35.6087 6.52289C33.4082 6.52289 31.3413 5.68198 29.7853 4.15736V4.13378C28.685 3.07283 27.2311 2.48341 25.6908 2.48341C24.1504 2.48341 22.6808 3.07283 21.5884 4.1495C20.0245 5.67413 17.9576 6.51503 15.7571 6.51503C13.5566 6.51503 11.4897 5.67413 9.93366 4.1495V4.12593C8.83341 3.06497 7.37951 2.47556 5.83917 2.47556C4.29882 2.47556 2.82921 3.06498 1.73682 4.14165L0 2.37339C1.56392 0.8409 3.63867 0 5.83917 0C8.03966 0 10.1066 0.840904 11.6626 2.36553V2.38911C12.7629 3.45006 14.2168 4.03948 15.7571 4.03948C17.2975 4.03948 18.7671 3.45006 19.8595 2.37339C21.4234 0.848759 23.4903 0.00786058 25.6908 0.00786058C27.8913 0.00786058 29.9581 0.848759 31.5142 2.37339V2.39697C32.6145 3.45792 34.0684 4.04733 35.6087 4.04733C37.149 4.04733 38.6187 3.45792 39.711 2.38125C41.275 0.85662 43.3419 0.0157152 45.5424 0.0157152C47.7429 0.0157152 49.8097 0.85662 51.3658 2.38125V2.40482C52.4661 3.46578 53.9199 4.0552 55.4603 4.0552C57.0006 4.0552 58.4703 3.46578 59.5626 2.38911C61.1266 0.86448 63.1935 0.0235758 65.394 0.0235758C67.5944 0.0235758 69.6613 0.86448 71.2174 2.38911V2.41268C72.3176 3.47364 73.7715 4.06305 75.3119 4.06305C76.8522 4.06305 78.3219 3.47364 79.4142 2.39697C80.9782 0.872341 83.0451 0.0314363 85.2455 0.0314363C87.446 0.0314363 89.5129 0.872341 91.069 2.39697V2.42054C92.1692 3.4815 93.6231 4.07091 95.1635 4.07091C96.7038 4.07091 98.1734 3.48149 99.2658 2.40482C100.83 0.880195 102.897 0.0392969 105.097 0.0392969C107.298 0.0392969 109.365 0.880195 110.921 2.40482V2.4284C112.021 3.48935 113.475 4.07877 115.015 4.07877C116.555 4.07877 118.025 3.48935 119.117 2.41268C120.681 0.888056 122.748 0.0471515 124.949 0.0471515C127.149 0.0471515 129.216 0.888056 130.772 2.41268V2.43626C131.872 3.49721 133.326 4.08663 134.867 4.08663C136.407 4.08663 137.877 3.49721 138.969 2.42054C140.533 0.895917 142.6 0.0550121 144.8 0.0550121C147.001 0.0550121 149.068 0.895917 150.624 2.42054V2.44412C151.724 3.50507 153.178 4.09449 154.718 4.09449C156.259 4.09449 157.728 3.50507 158.821 2.4284C160.385 0.903771 162.451 0.0628727 164.652 0.0628727C166.852 0.0628727 168.919 0.903771 170.475 2.4284V2.45198C171.576 3.51293 173.03 4.10235 174.57 4.10235C176.11 4.10235 177.58 3.51293 178.672 2.43626C180.236 0.911632 182.303 0.0707273 184.504 0.0707273C186.704 0.0707273 188.771 0.911632 190.327 2.43626V2.45984C191.427 3.52079 192.881 4.1102 194.421 4.1102C195.962 4.1102 197.431 3.52079 198.524 2.44412C200.088 0.919492 202.155 0.0785879 204.355 0.0785879C206.556 0.0785879 208.622 0.919492 210.179 2.44412V2.4677C211.279 3.52865 212.733 4.11807 214.273 4.11807C215.813 4.11807 217.283 3.52865 218.375 2.45198C219.939 0.927353 222.006 0.0864484 224.207 0.0864484C226.407 0.0864484 228.474 0.927353 230.03 2.45198V2.47556C231.13 3.53651 232.584 4.12593 234.125 4.12593C235.665 4.12593 237.135 3.53651 238.227 2.45984C239.791 0.935207 241.858 0.094309 244.058 0.094309C246.259 0.094309 248.326 0.935207 249.882 2.45984V2.48341C250.982 3.54436 252.436 4.13378 253.976 4.13378C255.517 4.13378 256.986 3.54437 258.079 2.4677C259.642 0.943068 261.709 0.102164 263.91 0.102164C266.11 0.102164 268.177 0.943068 269.733 2.4677V2.49127C270.834 3.55222 272.287 4.14165 273.828 4.14165C275.368 4.14165 276.838 3.55223 277.93 2.47556C279.494 0.950929 281.561 0.110024 283.762 0.110024C285.962 0.110024 288.029 0.950929 289.585 2.47556V2.49913C290.685 3.56008 292.139 4.1495 293.679 4.1495C295.22 4.1495 296.689 3.56008 297.782 2.48341C299.346 0.958783 301.413 0.117885 303.613 0.117885C305.814 0.117885 307.88 0.958783 309.437 2.48341V2.50699C310.537 3.56795 311.991 4.15736 313.531 4.15736C315.071 4.15736 316.541 3.56794 317.633 2.49127C319.197 0.966644 321.264 0.125739 323.465 0.125739C325.665 0.125739 327.732 0.966644 329.288 2.49127V2.51485C330.388 3.5758 331.842 4.16522 333.383 4.16522C334.923 4.16522 336.393 3.5758 337.485 2.49913C339.049 0.974504 341.116 0.1336 343.316 0.1336C345.517 0.1336 347.584 0.974504 349.14 2.49913V2.52271C350.24 3.58366 351.694 4.17308 353.234 4.17308C354.775 4.17308 356.244 3.58366 357.337 2.50699C358.9 0.982365 360.967 0.141461 363.168 0.141461C365.368 0.141461 367.435 0.982365 368.991 2.50699V2.53057C370.092 3.59152 371.545 4.18093 373.086 4.18093C374.626 4.18093 376.096 3.59152 377.188 2.51485C378.752 0.99022 380.819 0.149321 383.019 0.149321C385.22 0.149321 387.287 0.99022 388.843 2.51485V2.53842C389.943 3.59938 391.397 4.1888 392.937 4.1888C394.478 4.1888 395.947 3.59938 397.04 2.52271C398.604 0.99808 400.671 0.157176 402.871 0.157176C405.072 0.157176 407.138 0.99808 408.694 2.52271V2.54628C409.795 3.60724 411.249 4.19665 412.789 4.19665C414.329 4.19665 415.799 3.60724 416.891 2.53057C418.455 1.00594 420.522 0.165036 422.723 0.165036C424.923 0.165036 426.99 1.00594 428.546 2.53057V2.55414C429.646 3.6151 431.1 4.20452 432.641 4.20452C434.181 4.20452 435.651 3.61509 436.743 2.53842C438.307 1.0138 440.374 0.172897 442.574 0.172897C444.775 0.172897 446.842 1.0138 448.398 2.53842V2.562C449.498 3.62296 450.952 4.21237 452.492 4.21237C454.033 4.21237 455.502 3.62295 456.595 2.54628C458.158 1.02166 460.225 0.180751 462.426 0.180751C464.626 0.180751 466.693 1.02166 468.249 2.54628V2.56986C469.35 3.63081 470.803 4.22023 472.344 4.22023C473.884 4.22023 475.354 3.63081 476.446 2.55414C478.01 1.02952 480.077 0.188612 482.277 0.188612C484.478 0.188612 486.545 1.02952 488.101 2.55414V2.57772C489.201 3.63867 490.655 4.2281 492.195 4.2281C493.736 4.2281 495.205 3.63867 496.298 2.562C497.862 1.03738 499.929 0.196473 502.129 0.196473C504.33 0.196473 506.396 1.03738 507.952 2.562V2.58558C509.053 3.64653 510.507 4.23595 512.047 4.23595C513.587 4.23595 515.057 3.64653 516.149 2.56986C517.713 1.04523 519.78 0.204333 521.981 0.204333C524.181 0.204333 526.248 1.04523 527.804 2.56986V2.59344C528.904 3.65439 530.358 4.2438 531.899 4.2438C533.439 4.2438 534.909 3.65439 536.001 2.57772C537.565 1.05309 539.632 0.212188 541.832 0.212188C544.033 0.212188 546.1 1.05309 547.656 2.57772V2.6013C548.756 3.66225 550.21 4.25167 551.75 4.25167C553.291 4.25167 554.76 3.66225 555.852 2.58558C557.416 1.06095 559.483 0.220048 561.684 0.220048C563.884 0.220048 565.951 1.06095 567.507 2.58558V2.60916C568.607 3.67011 570.061 4.25953 571.602 4.25953C573.142 4.25953 574.612 3.67011 575.704 2.59344C577.268 1.06881 579.335 0.227909 581.535 0.227909C583.736 0.227909 585.803 1.06881 587.359 2.59344V2.61702C588.459 3.67797 589.913 4.26738 591.453 4.26738C592.994 4.26738 594.463 3.67797 595.556 2.6013C597.12 1.07667 599.187 0.23577 601.387 0.23577C603.587 0.23577 605.654 1.07667 607.21 2.6013L605.482 4.36955C604.389 3.30074 602.935 2.71132 601.387 2.71132C599.839 2.71132 598.377 3.30073 597.285 4.3774C595.721 5.90203 593.654 6.74294 591.453 6.74294H591.461Z" })
  }
), _r = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsxs("g", { clipPath: "url(#clip0_47_4879)", children: [
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M2.63033 1.41752C1.98315 2.00506 2.60382 10.7651 3.96664 12.3863C5.32946 14.0076 7.14287 14.7365 7.48081 17.4422C7.81876 20.148 5.11079 23.9184 5.45315 26.4033C5.79551 28.8881 8.29586 29.955 10.138 29.955C11.9801 29.955 13.7847 28.6275 13.2899 25.0913C12.7951 21.555 11.1054 19.1099 11.0082 17.1264C10.9111 15.1429 14.0652 14.1357 14.931 10.9904C15.7969 7.84508 14.8714 0.333008 13.619 0.333008C11.1673 0.333008 13.4357 8.54747 11.4875 8.36856C9.5394 8.18965 10.1645 0.333008 8.77958 0.333008C7.39467 0.333008 8.43722 7.90913 6.88003 7.67279C5.32283 7.43645 5.08208 -0.811142 2.63033 1.41752Z",
            fill: "#0B455E"
          }
        ),
        /* @__PURE__ */ o.jsx(
          "path",
          {
            d: "M22.3967 21.6839C22.0345 20.6547 20.4221 19.5017 18.7942 18.8169C17.1663 18.1322 19.7374 3.47696 21.7937 1.24829C23.8501 -0.980368 25.2152 0.223419 26.2047 1.42058C26.79 2.1296 26.9468 11.8659 27.1942 19.3294C27.3643 24.4825 27.9651 28.1469 27.1942 28.6703C25.3079 29.9558 23.3531 30.4528 22.0522 29.2711C20.1659 27.5571 22.9291 23.1859 22.399 21.6839H22.3967Z",
            fill: "#0B455E"
          }
        )
      ] }),
      /* @__PURE__ */ o.jsx("defs", { children: /* @__PURE__ */ o.jsx("clipPath", { id: "clip0_47_4879", children: /* @__PURE__ */ o.jsx("rect", { width: "30", height: "30", fill: "white" }) }) })
    ]
  }
), $r = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M4.33301 13.9163C4.66497 13.9163 7.28995 13.3386 11.225 12.4633C13.1241 12.0409 13.7877 12.1385 14.1479 12.1913C14.4936 12.2419 13.4743 14.7756 11.1718 19.005C8.79551 23.3698 6.98017 25.3833 6.73758 25.7108C6.04938 26.6399 5.28729 27.5592 5.21581 27.8029C5.13346 28.0835 7.3592 27.225 10.4349 26.2723C12.8308 25.7194 14.084 25.5073 14.8921 25.4449C15.4929 25.4173 16.481 25.3979 17.9044 25.1798",
          stroke: "#0B455E",
          strokeWidth: "2.85714",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M17.1904 15.6641C17.4894 15.6465 21.3438 14.6071 24.8994 13.589C25.252 13.488 25.2048 13.839 25.0893 14.1423C24.0271 16.9316 19.7941 20.772 20.0476 21.0713C22.1653 20.7885 24.462 19.3845 25.3837 19.1809C25.6426 19.1226 25.9197 19.0384 26.4761 18.7676",
          stroke: "#0B455E",
          strokeWidth: "2.85714",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M20.7617 5.12807C21.0664 5.03109 22.0847 4.54969 23.3378 3.98397C23.9401 3.71206 24.7364 3.60483 25.4569 3.57154C25.7077 3.55995 25.6965 3.95443 25.5466 4.51445C24.837 7.16714 22.6924 8.80295 22.5474 9.28557C22.6197 9.43675 24.9914 8.70102 25.4569 8.57129C25.9223 8.44155 26.9377 8.08279 27.5474 7.857",
          stroke: "#0B455E",
          strokeWidth: "2.85714",
          strokeLinecap: "round"
        }
      )
    ]
  }
), el = ({
  style: e
}) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    style: e,
    children: [
      /* @__PURE__ */ o.jsx("circle", { cx: "14.6431", cy: "14.6431", r: "11.7857", fill: "#0B455E" }),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M7.66695 16.5C7.66695 16.5 6.66695 21.5 14.667 21.5C22.667 21.5 21.667 16.5 21.667 16.5",
          stroke: "#E8F3F6",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M12.8574 11.8574C12.8574 11.8574 11.9 9.00028 9.64314 9.00028C7.3863 9.00028 6.42885 11.8574 6.42885 11.8574",
          stroke: "#E8F3F6",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M23.5713 11.8574C23.5713 11.8574 22.6138 9.00028 20.357 9.00028C18.1002 9.00028 17.1427 11.8574 17.1427 11.8574",
          stroke: "#E8F3F6",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), d3 = ({
  icon: e,
  eventStats: t,
  type: n,
  eventAppearances: r,
  color: l,
  percentage: i
}) => {
  const u = t[n] + 5, a = r[n] + 5, c = a === 0 ? 100 : Math.max(
    0,
    Math.min(100, u / a * 100)
  ), p = Math.max(
    0,
    Math.min(100, i ?? c)
  );
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "2px",
        width: "25%"
      },
      children: [
        /* @__PURE__ */ o.jsx(
          e,
          {
            style: {
              width: "20px",
              height: "20px",
              flexShrink: 0
            }
          }
        ),
        /* @__PURE__ */ o.jsx(
          "div",
          {
            style: {
              flex: 1,
              height: "12px",
              background: "#D0D0D0",
              borderRadius: "4px",
              overflow: "hidden",
              border: "1px solid #0B455E"
            },
            children: /* @__PURE__ */ o.jsx(
              "div",
              {
                style: {
                  width: \`\${p}%\`,
                  height: "100%",
                  background: l,
                  transition: "width 0.3s ease"
                }
              }
            )
          }
        )
      ]
    }
  );
}, tl = ({
  eventStats: e,
  eventAppearances: t,
  statusBarValues: n
}) => /* @__PURE__ */ o.jsx("div", { style: { width: "100%" }, children: /* @__PURE__ */ o.jsxs(
  "div",
  {
    style: {
      display: "flex",
      justifyContent: "space-around",
      width: "100%",
      paddingTop: "2px"
    },
    children: [
      /* @__PURE__ */ o.jsx(
        d3,
        {
          icon: _r,
          eventStats: e,
          type: "hungry",
          eventAppearances: t,
          color: "#4CAF50",
          percentage: n == null ? void 0 : n.hungry
        }
      ),
      /* @__PURE__ */ o.jsx(
        d3,
        {
          icon: el,
          type: "bored",
          eventStats: e,
          eventAppearances: t,
          color: "#2196F3",
          percentage: n == null ? void 0 : n.bored
        }
      ),
      /* @__PURE__ */ o.jsx(
        d3,
        {
          icon: $r,
          type: "tired",
          eventStats: e,
          eventAppearances: t,
          color: "#9C27B0",
          percentage: n == null ? void 0 : n.tired
        }
      )
    ]
  }
) }), Ue = {
  pluginVersion: "0.0.1",
  schemaVersion: 1,
  tetrisHighScore: 0,
  statusBars: {
    hungry: 100,
    bored: 100,
    tired: 100
  },
  currentLogoIndex: 0
}, v5 = 5, nl = (e) => Math.max(0, Math.min(100, e)), p3 = (e, t) => {
  const n = e + v5, r = t + v5;
  return r === 0 ? 100 : nl(n / r * 100);
}, rl = (e, t) => ({
  hungry: p3(e.hungry, t.hungry),
  bored: p3(e.bored, t.bored),
  tired: p3(e.tired, t.tired)
}), T4 = (e, t) => !!e && !!t && e.hungry === t.hungry && e.bored === t.bored && e.tired === t.tired;
function ll(e, t) {
  const n = H.useRef(null);
  return H.useEffect(() => (n.current = new Er(e, t), n.current.start(), () => {
    var r;
    (r = n.current) == null || r.stop();
  }), [e, t]), n.current;
}
const il = ({
  tetrisHighScore: e,
  currentLogoIndex: t,
  statusBars: n,
  onTetrisLinesCleared: r,
  onCurrentLogoIndexChange: l,
  onStatusBarsChange: i
}) => {
  const [s, u] = I.useState(null), [a, c] = I.useState(!1), [p, h] = I.useState(!1), [v, g] = I.useState(0), [w, y] = I.useState(!1), [N, f] = I.useState(
    t ?? 0
  ), C = I.useCallback(
    (R) => {
      f((B2) => {
        const Y2 = typeof R == "function" ? R(B2) : R;
        return Y2 !== B2 && (l == null || l(Y2)), Y2;
      });
    },
    [l]
  ), d = [
    "bored",
    "hungry",
    "tired",
    "happy",
    "growing",
    "sick",
    "dead"
  ], [m, k] = I.useState({
    bored: 0,
    hungry: 0,
    tired: 0,
    happy: 0,
    growing: 0,
    sick: 0,
    dead: 0
  }), [j, L] = I.useState({
    bored: 0,
    hungry: 0,
    tired: 0,
    happy: 0,
    growing: 0,
    sick: 0,
    dead: 0
  }), S = Object.entries(m).filter(([R]) => R !== "sick").reduce((R, [, B2]) => R + B2, 0), [U, Z] = I.useState(0), [z, P] = I.useState(0), [A, D] = I.useState(), [G, O] = I.useState(!1), [I1, E] = I.useState(!1), T = I.useMemo(
    () => rl(m, j),
    [m, j]
  ), B = () => ["#0B455E", "#303193", "#BADEE4"][N], q = () => (console.log("Determining SVG type with stats:", m), m.dead ? "dead" : m.growing === 1 ? "smallCloud" : m.growing === 2 ? z / 2 <= S ? "mediumSun" : "mediumCloud" : m.growing === 3 ? A[2] === "mediumSun" ? z / 2 <= S ? "largeSun" : "largeCloud" : z / 2 <= S ? "largeCloud" : "largeStormCloud" : m.growing === 4 ? A[3] === "largeStormCloud" ? z / 2 <= S ? Math.random() < 0.5 ? "veryLargeThunderCloud" : "veryLargeSnow" : Math.random() < 0.5 ? "veryLargeTornado" : "veryLargeRainCloud" : A[3] === "largeCloud" ? z / 2 >= S ? Math.random() < 0.5 ? "veryLargeSnow" : "veryLargeDroplet" : Math.random() < 0.5 ? "veryLargeDroplet" : "veryLargeCloud" : z / 2 <= S ? Math.random() < 0.5 ? "veryLargeSun" : "veryLargeSunAboveCloud" : Math.random() < 0.5 ? "veryLargeCloud" : "veryLargeSunBehindCloud" : "egg"), G2 = Qr[(() => {
    if (!A) return "egg";
    if (m.dead) return "dead";
    const R = Object.keys(A).map(Number), B2 = Math.max(...R);
    return A[B2];
  })()];
  I.useEffect(() => {
    A != null && A[m.growing] || D((R) => ({
      ...R,
      [m.growing]: q()
    }));
  }, [m.growing]), I.useEffect(() => {
    t === void 0 || t === N || f(t);
  }, [t, N]);
  const X1 = I.useRef(T);
  I.useEffect(() => {
    i && (T4(X1.current, T) || (X1.current = T, i(T)));
  }, [T, i]);
  const j9 = H.useCallback(() => {
    if (console.log("Handling random event with stats:", m.dead), m.dead) return;
    if (a || p) {
      if (G) {
        s === "sick" ? t6() : V7(), O(!1), s !== "happy" && (E(!0), setTimeout(() => {
          E(!1), u(null), g(0);
        }, 2e3));
        return;
      }
      O(!0), console.log("Event already active, skipping...");
      return;
    }
    y(!0), setTimeout(() => y(!1), 500);
    const R = z < 10 * m.growing || m.growing === 4 ? d.filter((G1) => G1 !== "growing") : d, Y2 = ((S + 1) / (z + 1) > 0.5 || z < 6 ? R.filter((G1) => G1 !== "sick") : R).filter((G1) => G1 !== "dead");
    let q2 = Y2[Math.floor(Math.random() * Y2.length)];
    m.sick === 2 && q2 === "sick" && (k((G1) => ({
      ...G1,
      dead: 1
    })), c(!1)), q2 = Math.random() > 0.8 && m.growing !== 4 ? "growing" : q2, u(m.dead ? "dead" : q2), L((G1) => ({
      ...G1,
      [q2]: G1[q2] + 1
    })), c(!0);
  }, [a, p, I1, G]);
  ll(
    ((R) => {
      switch (R) {
        case 0:
          return 30;
        case 1:
          return 5;
        case 2:
          return 0.05;
        default:
          return 30;
      }
    })(U),
    j9
  );
  const Q2 = () => {
    a ? g((R) => R + 1) : console.log("next");
  }, P4 = () => {
    a ? (c(!1), h(!0)) : console.log("Selected selected");
  }, N4 = () => {
    E(!1), O(!1), g(0), u("bored"), c(!1), h(!0);
  }, V7 = () => {
    if (a) {
      c(!1), P(z + 1);
      return;
    }
    if (p) {
      h(!1), P(z + 1);
      return;
    }
    console.log("Back pressed");
  }, t6 = () => {
    h(!1), g(0), k((R) => ({
      ...R,
      [s]: R[s] + 1
    })), P(z + 1), console.log("Event completed!");
  };
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      style: {
        position: "relative",
        width: "100%",
        height: "100%",
        aspectRatio: "6 / 7",
        background: N === 2 ? "#154273" : "#BADEE4",
        borderRadius: "50%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "2%",
        boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3), 0 8px 20px rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(255, 255, 255, 0.3)"
      },
      className: w ? "buzz handle" : "handle",
      children: [
        /* @__PURE__ */ o.jsx(
          "div",
          {
            style: {
              paddingTop: "4%",
              justifyContent: "center",
              display: "flex",
              width: "100%",
              height: "14%"
            },
            children: br(N, C)
          }
        ),
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            style: {
              marginTop: "5%",
              position: "relative",
              width: "69%",
              minWidth: "125px",
              flexShrink: 0,
              aspectRatio: "4 / 3",
              background: "#E8F4F8",
              border: "2px solid #0B455E",
              borderRadius: "20px",
              display: "flex",
              flexDirection: "column",
              // Changed to column
              alignItems: "center",
              justifyContent: "flex-start",
              // Align to top
              overflow: "hidden",
              zIndex: 1
            },
            children: [
              /* @__PURE__ */ o.jsx(
                tl,
                {
                  eventStats: m,
                  eventAppearances: j,
                  statusBarValues: n
                }
              ),
              /* @__PURE__ */ o.jsx(
                "div",
                {
                  style: {
                    position: "relative",
                    zIndex: 2,
                    width: "100%",
                    flex: 1,
                    // Takes remaining space
                    alignContent: "center",
                    display: "flex",
                    justifyContent: "center"
                  },
                  children: I1 ? /* @__PURE__ */ o.jsx("div", { style: { textAlign: "center", width: "60%" }, children: /* @__PURE__ */ o.jsx(
                    "p",
                    {
                      style: {
                        color: "#0B455E",
                        fontFamily: "monospace",
                        fontSize: "14px",
                        fontWeight: "bold"
                      },
                      children: "Too Slow! ðŸ˜ž"
                    }
                  ) }) : p && s ? /* @__PURE__ */ o.jsx(
                    Sr,
                    {
                      eventType: s,
                      onComplete: t6,
                      onBack: V7,
                      tetrisHighScore: e,
                      onTetrisLinesCleared: r
                    }
                  ) : a && s ? /* @__PURE__ */ o.jsx(yr, { eventType: s, messageIndex: v }) : /* @__PURE__ */ o.jsx(
                    G2,
                    {
                      style: {
                        width: "40%",
                        height: "auto",
                        display: "block",
                        animation: "bounce 2s ease-in-out infinite"
                      }
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ o.jsx(
          "button",
          {
            onClick: N4,
            "aria-label": "Start tetris",
            style: {
              position: "absolute",
              width: "7%",
              left: "5%",
              top: "40%",
              zIndex: 3,
              aspectRatio: "1",
              borderRadius: "50%",
              background: B(),
              border: "2px solid #0B455E",
              color: "#0B455E",
              fontFamily: "monospace",
              fontSize: "12px",
              fontWeight: "bold",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              transition: "transform 0.1s"
            },
            onMouseDown: (R) => R.currentTarget.style.transform = "scale(0.9)",
            onMouseUp: (R) => R.currentTarget.style.transform = "scale(1)",
            onMouseLeave: (R) => R.currentTarget.style.transform = "scale(1)",
            children: "T"
          }
        ),
        zr(U, Z),
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            style: {
              position: "absolute",
              top: "50%",
              left: 0,
              right: 0,
              display: "flex",
              flexDirection: "column",
              gap: "3px"
            },
            children: [
              /* @__PURE__ */ o.jsx(
                Ve,
                {
                  style: {
                    width: "100%",
                    height: "auto",
                    display: "block",
                    fill: B()
                  }
                }
              ),
              /* @__PURE__ */ o.jsx(
                Ve,
                {
                  style: {
                    width: "100%",
                    height: "auto",
                    display: "block",
                    fill: B()
                  }
                }
              ),
              /* @__PURE__ */ o.jsx(
                Ve,
                {
                  style: {
                    width: "100%",
                    height: "auto",
                    display: "block",
                    fill: B()
                  }
                }
              ),
              /* @__PURE__ */ o.jsx(
                Ve,
                {
                  style: {
                    width: "100%",
                    height: "auto",
                    display: "block",
                    fill: B()
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            style: {
              display: "flex",
              gap: "50%",
              width: "80%",
              justifyContent: "center",
              marginTop: "auto"
            },
            children: [
              /* @__PURE__ */ o.jsx(
                "button",
                {
                  onClick: Q2,
                  style: {
                    width: "13.5%",
                    aspectRatio: "1",
                    borderRadius: "50%",
                    background: B(),
                    border: "none",
                    cursor: "pointer",
                    transition: "transform 0.1s"
                  },
                  onMouseDown: (R) => R.currentTarget.style.transform = "scale(0.9)",
                  onMouseUp: (R) => R.currentTarget.style.transform = "scale(1)",
                  onMouseLeave: (R) => R.currentTarget.style.transform = "scale(1)"
                }
              ),
              /* @__PURE__ */ o.jsx(
                "button",
                {
                  onClick: V7,
                  style: {
                    width: "13.5%",
                    aspectRatio: "1",
                    borderRadius: "50%",
                    background: B(),
                    border: "none",
                    cursor: "pointer",
                    transition: "transform 0.1s"
                  },
                  onMouseDown: (R) => R.currentTarget.style.transform = "scale(0.9)",
                  onMouseUp: (R) => R.currentTarget.style.transform = "scale(1)",
                  onMouseLeave: (R) => R.currentTarget.style.transform = "scale(1)"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ o.jsx(
          "div",
          {
            style: {
              display: "flex",
              width: "80%",
              justifyContent: "center",
              paddingBottom: "6%"
            },
            children: /* @__PURE__ */ o.jsx(
              "button",
              {
                onClick: P4,
                style: {
                  width: "13.5%",
                  aspectRatio: "1",
                  borderRadius: "50%",
                  background: B(),
                  border: "none",
                  cursor: "pointer",
                  transition: "transform 0.1s"
                },
                onMouseDown: (R) => R.currentTarget.style.transform = "scale(0.9)",
                onMouseUp: (R) => R.currentTarget.style.transform = "scale(1)",
                onMouseLeave: (R) => R.currentTarget.style.transform = "scale(1)"
              }
            )
          }
        )
      ]
    }
  );
}, ol = ({ instance: e }) => {
  const [t, n] = I.useState(), [r, l] = I.useState(Ue), i = I.useCallback(
    (a) => {
      l((c) => {
        if (a <= c.tetrisHighScore)
          return c;
        const p = { ...c, tetrisHighScore: a };
        return e && e.setPluginState(
          p
        ), console.log("[MetaGotchi] Updated tetris high score", a), p;
      });
    },
    [e]
  ), s = I.useCallback(
    (a) => {
      l((c) => {
        if (T4(c.statusBars, a))
          return c;
        const p = { ...c, statusBars: a };
        return e && e.setPluginState(
          p
        ), p;
      });
    },
    [e]
  ), u = I.useCallback(
    (a) => {
      l((c) => {
        if (c.currentLogoIndex === a)
          return c;
        const p = { ...c, currentLogoIndex: a };
        return e && e.setPluginState(
          p
        ), p;
      });
    },
    [e]
  );
  return I.useEffect(() => {
    var p;
    if (!e) return;
    const a = (p = e == null ? void 0 : e.onPluginStateChange) == null ? void 0 : p.call(
      e,
      (h) => {
        if (h && Object.keys(h).length > 0) {
          const v = h, g = {
            ...Ue,
            ...v,
            statusBars: {
              ...Ue.statusBars,
              ...v.statusBars
            }
          };
          v.schemaVersion < 1 && console.warn("[MetaGotchi] Migrating data from old schemaâ€¦"), console.log("Received plugin state update in MetaGotchi", v), l(g);
        }
      }
    ), c = e.getPluginState();
    return (!c || Object.keys(c).length === 0) && e.setPluginState(
      Ue
    ), () => {
      a();
    };
  }, [e]), I.useEffect(() => {
    if (!e) {
      window.console.log(
        "timeslider-lite-plugin: plugin instance not available"
      );
      return;
    }
    window.console.log(
      "timeslider-lite-plugin: [React Component] Setting up counter state subscription"
    ), e.onStateChange("time", (a) => {
      window.console.log(
        "timeslider-lite-plugin: [React Component] Received counter state:",
        a
      ), n(new Date(a.time));
    });
  }, [e]), /* @__PURE__ */ o.jsx(
    mr,
    {
      defaultSize: {
        width: 400,
        height: 466
      },
      minWidth: 200,
      minHeight: 250,
      maxWidth: 600,
      maxHeight: 700,
      lockAspectRatio: 6 / 7,
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !1,
        bottomRight: !1,
        bottomLeft: !1,
        topLeft: !1
      },
      children: /* @__PURE__ */ o.jsx(
        il,
        {
          value: t,
          instance: e,
          tetrisHighScore: r.tetrisHighScore,
          currentLogoIndex: r.currentLogoIndex,
          statusBars: r.statusBars,
          onTetrisLinesCleared: i,
          onCurrentLogoIndexChange: u,
          onStatusBarsChange: s
        }
      )
    }
  );
}, sl = (e, t) => {
  const n = B4(e);
  return n.render(/* @__PURE__ */ o.jsx(ol, { instance: t })), { unmount: () => n.unmount() };
};
class ul {
  constructor(t) {
    Q1(this, "plugin");
    Q1(this, "api", null);
    Q1(this, "_pluginState", {});
    Q1(this, "pluginStateCallbacks", /* @__PURE__ */ new Set());
    this.plugin = t;
  }
  /**
   * Set the plugin API (called by PluginManager when registering)
   */
  setAPI(t) {
    this.api = t;
  }
  /**
   * Subscribe to state changes for a scope
   */
  onStateChange(t, n) {
    if (!this.api) {
      console.warn(
        \`[GeoWebPluginInstance] Cannot subscribe to \${t}: API not set\`
      );
      return;
    }
    this.api.onStateChange(t, n);
  }
  /**
   * Send an event for a scope
   */
  sendEvent(t, n) {
    if (!this.api) {
      console.warn(
        \`[GeoWebPluginInstance] Cannot send event to \${t}: API not set\`
      );
      return;
    }
    this.api.sendEvent(t, n);
  }
  // ---------------------------------------------------------------------------
  // Plugin state API (per-instance opaque data)
  // ---------------------------------------------------------------------------
  /**
   * Get the current plugin state
   */
  getPluginState() {
    return this._pluginState;
  }
  /**
   * Set the plugin state.
   * Notifies all registered callbacks (plugin + host).
   */
  setPluginState(t) {
    this._pluginState = { ...t }, console.log(
      \`[GeoWebPluginInstance] Plugin state updated for "\${this.plugin.name}"\`
    );
    for (const n of this.pluginStateCallbacks)
      n(this._pluginState);
  }
  /**
   * Subscribe to plugin state changes.
   * The callback is called immediately with the current state, and again
   * whenever {@link setPluginState} is called.
   *
   * @returns An unsubscribe function.
   */
  onPluginStateChange(t) {
    return this.pluginStateCallbacks.add(t), t(this._pluginState), () => {
      this.pluginStateCallbacks.delete(t);
    };
  }
}
let al = 0;
class cl extends ul {
  constructor(n, r) {
    super(r);
    Q1(this, "id", 0);
    Q1(this, "target");
    Q1(this, "mountHandle");
    this.id = al++, this.target = n, this.mountHandle = sl(n, this);
  }
  dispose() {
    this.mountHandle.unmount();
  }
}
const Cl = () => {
  const e = {
    name: "Metagotchi",
    version: "0.0.1",
    type: "view",
    scopes: ["time"],
    createInstance(t) {
      return new cl(t, e);
    }
  };
  return e;
}, fl = Cl(), pl = { plugin: fl };
window.pluginModule = pl;`;
export default demoMetagotchiPlugin;
